(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bvJM2", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.7";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});


class $79d4162018af1528$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root;
        this.render();
    }
    render() {
        let icon = document.querySelector('.burger');
        icon.addEventListener('click', (e)=>{
            icon.classList.toggle('is-active');
            this.root.classList.toggle('is-open');
        });
    }
}


var $77e0898a05762ba3$exports = {};
"object" == typeof navigator && function(e, t) {
    $77e0898a05762ba3$exports = t();
}($77e0898a05762ba3$exports, function() {
    "use strict";
    function e(e, t, i) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var s = i.call(e, t || "default");
                    if ("object" != typeof s) return s;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === t ? String : Number)(e);
            }(e, "string");
            return "symbol" == typeof t ? t : String(t);
        }(t)) in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function t(e, t) {
        for(var i = 0; i < t.length; i++){
            var s = t[i];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
        }
    }
    function i(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function s(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            t && (s = s.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), i.push.apply(i, s);
        }
        return i;
    }
    function n(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function(t) {
                i(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    var a = {
        addCSS: !0,
        thumbWidth: 15,
        watch: !0
    };
    var l = function(e) {
        return null != e ? e.constructor : null;
    }, r = function(e, t) {
        return !!(e && t && e instanceof t);
    }, o = function(e) {
        return null == e;
    }, c = function(e) {
        return l(e) === Object;
    }, u = function(e) {
        return l(e) === String;
    }, h = function(e) {
        return Array.isArray(e);
    }, d = function(e) {
        return r(e, NodeList);
    }, m = {
        nullOrUndefined: o,
        object: c,
        number: function(e) {
            return l(e) === Number && !Number.isNaN(e);
        },
        string: u,
        boolean: function(e) {
            return l(e) === Boolean;
        },
        function: function(e) {
            return l(e) === Function;
        },
        array: h,
        nodeList: d,
        element: function(e) {
            return r(e, Element);
        },
        event: function(e) {
            return r(e, Event);
        },
        empty: function(e) {
            return o(e) || (u(e) || h(e) || d(e)) && !e.length || c(e) && !Object.keys(e).length;
        }
    };
    function p(e, t) {
        if (1 > t) {
            var i = function(e) {
                var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
            }(t);
            return parseFloat(e.toFixed(i));
        }
        return Math.round(e / t) * t;
    }
    var g = function() {
        function e(t, i) {
            (function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            })(this, e), m.element(t) ? this.element = t : m.string(t) && (this.element = document.querySelector(t)), m.element(this.element) && m.empty(this.element.rangeTouch) && (this.config = n({}, a, {}, i), this.init());
        }
        return function(e, i, s) {
            i && t(e.prototype, i), s && t(e, s);
        }(e, [
            {
                key: "init",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
                }
            },
            {
                key: "listeners",
                value: function(e) {
                    var t = this, i = e ? "addEventListener" : "removeEventListener";
                    [
                        "touchstart",
                        "touchmove",
                        "touchend"
                    ].forEach(function(e) {
                        t.element[i](e, function(e) {
                            return t.set(e);
                        }, !1);
                    });
                }
            },
            {
                key: "get",
                value: function(t) {
                    if (!e.enabled || !m.event(t)) return null;
                    var i, s = t.target, n = t.changedTouches[0], a = parseFloat(s.getAttribute("min")) || 0, l = parseFloat(s.getAttribute("max")) || 100, r = parseFloat(s.getAttribute("step")) || 1, o = s.getBoundingClientRect(), c = 100 / o.width * (this.config.thumbWidth / 2) / 100;
                    return 0 > (i = 100 / o.width * (n.clientX - o.left)) ? i = 0 : 100 < i && (i = 100), 50 > i ? i -= (100 - 2 * i) * c : 50 < i && (i += 2 * (i - 50) * c), a + p(i / 100 * (l - a), r);
                }
            },
            {
                key: "set",
                value: function(t) {
                    e.enabled && m.event(t) && !t.target.disabled && (t.preventDefault(), t.target.value = this.get(t), function(e, t) {
                        if (e && t) {
                            var i = new Event(t, {
                                bubbles: !0
                            });
                            e.dispatchEvent(i);
                        }
                    }(t.target, "touchend" === t.type ? "change" : "input"));
                }
            }
        ], [
            {
                key: "setup",
                value: function(t) {
                    var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, s = null;
                    if (m.empty(t) || m.string(t) ? s = Array.from(document.querySelectorAll(m.string(t) ? t : 'input[type="range"]')) : m.element(t) ? s = [
                        t
                    ] : m.nodeList(t) ? s = Array.from(t) : m.array(t) && (s = t.filter(m.element)), m.empty(s)) return null;
                    var l = n({}, a, {}, i);
                    if (m.string(t) && l.watch) {
                        var r = new MutationObserver(function(i) {
                            Array.from(i).forEach(function(i) {
                                Array.from(i.addedNodes).forEach(function(i) {
                                    m.element(i) && function(e, t) {
                                        return (function() {
                                            return Array.from(document.querySelectorAll(t)).includes(this);
                                        }).call(e, t);
                                    }(i, t) && new e(i, l);
                                });
                            });
                        });
                        r.observe(document.body, {
                            childList: !0,
                            subtree: !0
                        });
                    }
                    return s.map(function(t) {
                        return new e(t, i);
                    });
                }
            },
            {
                key: "enabled",
                get: function() {
                    return "ontouchstart" in document.documentElement;
                }
            }
        ]), e;
    }();
    const f = (e)=>null != e ? e.constructor : null, y = (e, t)=>Boolean(e && t && e instanceof t), b = (e)=>null == e, v = (e)=>f(e) === Object, w = (e)=>f(e) === String, T = (e)=>"function" == typeof e, k = (e)=>Array.isArray(e), C = (e)=>y(e, NodeList), A = (e)=>b(e) || (w(e) || k(e) || C(e)) && !e.length || v(e) && !Object.keys(e).length;
    var S = {
        nullOrUndefined: b,
        object: v,
        number: (e)=>f(e) === Number && !Number.isNaN(e),
        string: w,
        boolean: (e)=>f(e) === Boolean,
        function: T,
        array: k,
        weakMap: (e)=>y(e, WeakMap),
        nodeList: C,
        element: (e)=>null !== e && "object" == typeof e && 1 === e.nodeType && "object" == typeof e.style && "object" == typeof e.ownerDocument,
        textNode: (e)=>f(e) === Text,
        event: (e)=>y(e, Event),
        keyboardEvent: (e)=>y(e, KeyboardEvent),
        cue: (e)=>y(e, window.TextTrackCue) || y(e, window.VTTCue),
        track: (e)=>y(e, TextTrack) || !b(e) && w(e.kind),
        promise: (e)=>y(e, Promise) && T(e.then),
        url: (e)=>{
            if (y(e, window.URL)) return !0;
            if (!w(e)) return !1;
            let t = e;
            e.startsWith("http://") && e.startsWith("https://") || (t = `http://${e}`);
            try {
                return !A(new URL(t).hostname);
            } catch (e) {
                return !1;
            }
        },
        empty: A
    };
    const E = (()=>{
        const e = document.createElement("span"), t = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend"
        }, i = Object.keys(t).find((t)=>void 0 !== e.style[t]);
        return !!S.string(i) && t[i];
    })();
    function P(e, t) {
        setTimeout(()=>{
            try {
                e.hidden = !0, e.offsetHeight, e.hidden = !1;
            } catch (e) {}
        }, t);
    }
    var M = {
        isIE: Boolean(window.document.documentMode),
        isEdge: /Edge/g.test(navigator.userAgent),
        isWebKit: "WebkitAppearance" in document.documentElement.style && !/Edge/g.test(navigator.userAgent),
        isIPhone: /iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1,
        isIPadOS: "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1,
        isIos: /iPad|iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1
    };
    function N(e, t) {
        return t.split(".").reduce((e, t)=>e && e[t], e);
    }
    function x(e = {}, ...t) {
        if (!t.length) return e;
        const i = t.shift();
        return S.object(i) ? (Object.keys(i).forEach((t)=>{
            S.object(i[t]) ? (Object.keys(e).includes(t) || Object.assign(e, {
                [t]: {}
            }), x(e[t], i[t])) : Object.assign(e, {
                [t]: i[t]
            });
        }), x(e, ...t)) : e;
    }
    function L(e, t) {
        const i = e.length ? e : [
            e
        ];
        Array.from(i).reverse().forEach((e, i)=>{
            const s = i > 0 ? t.cloneNode(!0) : t, n = e.parentNode, a = e.nextSibling;
            s.appendChild(e), a ? n.insertBefore(s, a) : n.appendChild(s);
        });
    }
    function I(e, t) {
        S.element(e) && !S.empty(t) && Object.entries(t).filter(([, e])=>!S.nullOrUndefined(e)).forEach(([t, i])=>e.setAttribute(t, i));
    }
    function $(e, t, i) {
        const s = document.createElement(e);
        return S.object(t) && I(s, t), S.string(i) && (s.innerText = i), s;
    }
    function _(e, t, i, s) {
        S.element(t) && t.appendChild($(e, i, s));
    }
    function O(e) {
        S.nodeList(e) || S.array(e) ? Array.from(e).forEach(O) : S.element(e) && S.element(e.parentNode) && e.parentNode.removeChild(e);
    }
    function j(e) {
        if (!S.element(e)) return;
        let { length: t } = e.childNodes;
        for(; t > 0;)e.removeChild(e.lastChild), t -= 1;
    }
    function q(e, t) {
        return S.element(t) && S.element(t.parentNode) && S.element(e) ? (t.parentNode.replaceChild(e, t), e) : null;
    }
    function D(e, t) {
        if (!S.string(e) || S.empty(e)) return {};
        const i = {}, s = x({}, t);
        return e.split(",").forEach((e)=>{
            const t = e.trim(), n = t.replace(".", ""), a = t.replace(/[[\]]/g, "").split("="), [l] = a, r = a.length > 1 ? a[1].replace(/["']/g, "") : "";
            switch(t.charAt(0)){
                case ".":
                    S.string(s.class) ? i.class = `${s.class} ${n}` : i.class = n;
                    break;
                case "#":
                    i.id = t.replace("#", "");
                    break;
                case "[":
                    i[l] = r;
            }
        }), x(s, i);
    }
    function H(e, t) {
        if (!S.element(e)) return;
        let i = t;
        S.boolean(i) || (i = !e.hidden), e.hidden = i;
    }
    function R(e, t, i) {
        if (S.nodeList(e)) return Array.from(e).map((e)=>R(e, t, i));
        if (S.element(e)) {
            let s = "toggle";
            return void 0 !== i && (s = i ? "add" : "remove"), e.classList[s](t), e.classList.contains(t);
        }
        return !1;
    }
    function F(e, t) {
        return S.element(e) && e.classList.contains(t);
    }
    function V(e, t) {
        const { prototype: i } = Element;
        return (i.matches || i.webkitMatchesSelector || i.mozMatchesSelector || i.msMatchesSelector || function() {
            return Array.from(document.querySelectorAll(t)).includes(this);
        }).call(e, t);
    }
    function U(e) {
        return this.elements.container.querySelectorAll(e);
    }
    function B(e) {
        return this.elements.container.querySelector(e);
    }
    function W(e = null, t = !1) {
        S.element(e) && e.focus({
            preventScroll: !0,
            focusVisible: t
        });
    }
    const z = {
        "audio/ogg": "vorbis",
        "audio/wav": "1",
        "video/webm": "vp8, vorbis",
        "video/mp4": "avc1.42E01E, mp4a.40.2",
        "video/ogg": "theora"
    }, K = {
        audio: "canPlayType" in document.createElement("audio"),
        video: "canPlayType" in document.createElement("video"),
        check (e, t) {
            const i = K[e] || "html5" !== t;
            return {
                api: i,
                ui: i && K.rangeInput
            };
        },
        pip: !(M.isIPhone || !S.function($("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || $("video").disablePictureInPicture)),
        airplay: S.function(window.WebKitPlaybackTargetAvailabilityEvent),
        playsinline: "playsInline" in document.createElement("video"),
        mime (e) {
            if (S.empty(e)) return !1;
            const [t] = e.split("/");
            let i = e;
            if (!this.isHTML5 || t !== this.type) return !1;
            Object.keys(z).includes(i) && (i += `; codecs="${z[e]}"`);
            try {
                return Boolean(i && this.media.canPlayType(i).replace(/no/, ""));
            } catch (e) {
                return !1;
            }
        },
        textTracks: "textTracks" in document.createElement("video"),
        rangeInput: (()=>{
            const e = document.createElement("input");
            return e.type = "range", "range" === e.type;
        })(),
        touch: "ontouchstart" in document.documentElement,
        transitions: !1 !== E,
        reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches
    }, Y = (()=>{
        let e = !1;
        try {
            const t = Object.defineProperty({}, "passive", {
                get: ()=>(e = !0, null)
            });
            window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
        } catch (e) {}
        return e;
    })();
    function Q(e, t, i, s = !1, n = !0, a = !1) {
        if (!e || !("addEventListener" in e) || S.empty(t) || !S.function(i)) return;
        const l = t.split(" ");
        let r = a;
        Y && (r = {
            passive: n,
            capture: a
        }), l.forEach((t)=>{
            this && this.eventListeners && s && this.eventListeners.push({
                element: e,
                type: t,
                callback: i,
                options: r
            }), e[s ? "addEventListener" : "removeEventListener"](t, i, r);
        });
    }
    function X(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !0, s, n);
    }
    function J(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !1, s, n);
    }
    function G(e, t = "", i, s = !0, n = !1) {
        const a = (...l)=>{
            J(e, t, a, s, n), i.apply(this, l);
        };
        Q.call(this, e, t, a, !0, s, n);
    }
    function Z(e, t = "", i = !1, s = {}) {
        if (!S.element(e) || S.empty(t)) return;
        const n = new CustomEvent(t, {
            bubbles: i,
            detail: {
                ...s,
                plyr: this
            }
        });
        e.dispatchEvent(n);
    }
    function ee() {
        this && this.eventListeners && (this.eventListeners.forEach((e)=>{
            const { element: t, type: i, callback: s, options: n } = e;
            t.removeEventListener(i, s, n);
        }), this.eventListeners = []);
    }
    function te() {
        return new Promise((e)=>this.ready ? setTimeout(e, 0) : X.call(this, this.elements.container, "ready", e)).then(()=>{});
    }
    function ie(e) {
        S.promise(e) && e.then(null, ()=>{});
    }
    function se(e) {
        return S.array(e) ? e.filter((t, i)=>e.indexOf(t) === i) : e;
    }
    function ne(e, t) {
        return S.array(e) && e.length ? e.reduce((e, i)=>Math.abs(i - t) < Math.abs(e - t) ? i : e) : null;
    }
    function ae(e) {
        return !(!window || !window.CSS) && window.CSS.supports(e);
    }
    const le = [
        [
            1,
            1
        ],
        [
            4,
            3
        ],
        [
            3,
            4
        ],
        [
            5,
            4
        ],
        [
            4,
            5
        ],
        [
            3,
            2
        ],
        [
            2,
            3
        ],
        [
            16,
            10
        ],
        [
            10,
            16
        ],
        [
            16,
            9
        ],
        [
            9,
            16
        ],
        [
            21,
            9
        ],
        [
            9,
            21
        ],
        [
            32,
            9
        ],
        [
            9,
            32
        ]
    ].reduce((e, [t, i])=>({
            ...e,
            [t / i]: [
                t,
                i
            ]
        }), {});
    function re(e) {
        if (!(S.array(e) || S.string(e) && e.includes(":"))) return !1;
        return (S.array(e) ? e : e.split(":")).map(Number).every(S.number);
    }
    function oe(e) {
        if (!S.array(e) || !e.every(S.number)) return null;
        const [t, i] = e, s = (e, t)=>0 === t ? e : s(t, e % t), n = s(t, i);
        return [
            t / n,
            i / n
        ];
    }
    function ce(e) {
        const t = (e)=>re(e) ? e.split(":").map(Number) : null;
        let i = t(e);
        if (null === i && (i = t(this.config.ratio)), null === i && !S.empty(this.embed) && S.array(this.embed.ratio) && ({ ratio: i } = this.embed), null === i && this.isHTML5) {
            const { videoWidth: e, videoHeight: t } = this.media;
            i = [
                e,
                t
            ];
        }
        return oe(i);
    }
    function ue(e) {
        if (!this.isVideo) return {};
        const { wrapper: t } = this.elements, i = ce.call(this, e);
        if (!S.array(i)) return {};
        const [s, n] = oe(i), a = 100 / s * n;
        if (ae(`aspect-ratio: ${s}/${n}`) ? t.style.aspectRatio = `${s}/${n}` : t.style.paddingBottom = `${a}%`, this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            const e = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10), i = (e - a) / (e / 50);
            this.fullscreen.active ? t.style.paddingBottom = null : this.media.style.transform = `translateY(-${i}%)`;
        } else this.isHTML5 && t.classList.add(this.config.classNames.videoFixedRatio);
        return {
            padding: a,
            ratio: i
        };
    }
    function he(e, t, i = .05) {
        const s = e / t, n = ne(Object.keys(le), s);
        return Math.abs(n - s) <= i ? le[n] : [
            e,
            t
        ];
    }
    const de = {
        getSources () {
            if (!this.isHTML5) return [];
            return Array.from(this.media.querySelectorAll("source")).filter((e)=>{
                const t = e.getAttribute("type");
                return !!S.empty(t) || K.mime.call(this, t);
            });
        },
        getQualityOptions () {
            return this.config.quality.forced ? this.config.quality.options : de.getSources.call(this).map((e)=>Number(e.getAttribute("size"))).filter(Boolean);
        },
        setup () {
            if (!this.isHTML5) return;
            const e = this;
            e.options.speed = e.config.speed.options, S.empty(this.config.ratio) || ue.call(e), Object.defineProperty(e.media, "quality", {
                get () {
                    const t = de.getSources.call(e).find((t)=>t.getAttribute("src") === e.source);
                    return t && Number(t.getAttribute("size"));
                },
                set (t) {
                    if (e.quality !== t) {
                        if (e.config.quality.forced && S.function(e.config.quality.onChange)) e.config.quality.onChange(t);
                        else {
                            const i = de.getSources.call(e).find((e)=>Number(e.getAttribute("size")) === t);
                            if (!i) return;
                            const { currentTime: s, paused: n, preload: a, readyState: l, playbackRate: r } = e.media;
                            e.media.src = i.getAttribute("src"), ("none" !== a || l) && (e.once("loadedmetadata", ()=>{
                                e.speed = r, e.currentTime = s, n || ie(e.play());
                            }), e.media.load());
                        }
                        Z.call(e, e.media, "qualitychange", !1, {
                            quality: t
                        });
                    }
                }
            });
        },
        cancelRequests () {
            this.isHTML5 && (O(de.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
        }
    };
    function me(e, ...t) {
        return S.empty(e) ? e : e.toString().replace(/{(\d+)}/g, (e, i)=>t[i].toString());
    }
    const pe = (e = "", t = "", i = "")=>e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), i.toString()), ge = (e = "")=>e.toString().replace(/\w\S*/g, (e)=>e.charAt(0).toUpperCase() + e.slice(1).toLowerCase());
    function fe(e = "") {
        let t = e.toString();
        return t = function(e = "") {
            let t = e.toString();
            return t = pe(t, "-", " "), t = pe(t, "_", " "), t = ge(t), pe(t, " ", "");
        }(t), t.charAt(0).toLowerCase() + t.slice(1);
    }
    function ye(e) {
        const t = document.createElement("div");
        return t.appendChild(e), t.innerHTML;
    }
    const be = {
        pip: "PIP",
        airplay: "AirPlay",
        html5: "HTML5",
        vimeo: "Vimeo",
        youtube: "YouTube"
    }, ve = {
        get (e = "", t = {}) {
            if (S.empty(e) || S.empty(t)) return "";
            let i = N(t.i18n, e);
            if (S.empty(i)) return Object.keys(be).includes(e) ? be[e] : "";
            const s = {
                "{seektime}": t.seekTime,
                "{title}": t.title
            };
            return Object.entries(s).forEach(([e, t])=>{
                i = pe(i, e, t);
            }), i;
        }
    };
    class we {
        constructor(t){
            e(this, "get", (e)=>{
                if (!we.supported || !this.enabled) return null;
                const t = window.localStorage.getItem(this.key);
                if (S.empty(t)) return null;
                const i = JSON.parse(t);
                return S.string(e) && e.length ? i[e] : i;
            }), e(this, "set", (e)=>{
                if (!we.supported || !this.enabled) return;
                if (!S.object(e)) return;
                let t = this.get();
                S.empty(t) && (t = {}), x(t, e);
                try {
                    window.localStorage.setItem(this.key, JSON.stringify(t));
                } catch (e) {}
            }), this.enabled = t.config.storage.enabled, this.key = t.config.storage.key;
        }
        static get supported() {
            try {
                if (!("localStorage" in window)) return !1;
                const e = "___test";
                return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
            } catch (e) {
                return !1;
            }
        }
    }
    function Te(e, t = "text") {
        return new Promise((i, s)=>{
            try {
                const s = new XMLHttpRequest;
                if (!("withCredentials" in s)) return;
                s.addEventListener("load", ()=>{
                    if ("text" === t) try {
                        i(JSON.parse(s.responseText));
                    } catch (e) {
                        i(s.responseText);
                    }
                    else i(s.response);
                }), s.addEventListener("error", ()=>{
                    throw new Error(s.status);
                }), s.open("GET", e, !0), s.responseType = t, s.send();
            } catch (e) {
                s(e);
            }
        });
    }
    function ke(e, t) {
        if (!S.string(e)) return;
        const i = "cache", s = S.string(t);
        let n = !1;
        const a = ()=>null !== document.getElementById(t), l = (e, t)=>{
            e.innerHTML = t, s && a() || document.body.insertAdjacentElement("afterbegin", e);
        };
        if (!s || !a()) {
            const a = we.supported, r = document.createElement("div");
            if (r.setAttribute("hidden", ""), s && r.setAttribute("id", t), a) {
                const e = window.localStorage.getItem(`${i}-${t}`);
                if (n = null !== e, n) {
                    const t = JSON.parse(e);
                    l(r, t.content);
                }
            }
            Te(e).then((e)=>{
                if (!S.empty(e)) {
                    if (a) try {
                        window.localStorage.setItem(`${i}-${t}`, JSON.stringify({
                            content: e
                        }));
                    } catch (e) {}
                    l(r, e);
                }
            }).catch(()=>{});
        }
    }
    const Ce = (e)=>Math.trunc(e / 60 / 60 % 60, 10), Ae = (e)=>Math.trunc(e / 60 % 60, 10), Se = (e)=>Math.trunc(e % 60, 10);
    function Ee(e = 0, t = !1, i = !1) {
        if (!S.number(e)) return Ee(void 0, t, i);
        const s = (e)=>`0${e}`.slice(-2);
        let n = Ce(e);
        const a = Ae(e), l = Se(e);
        return n = t || n > 0 ? `${n}:` : "", `${i && e > 0 ? "-" : ""}${n}${s(a)}:${s(l)}`;
    }
    const Pe = {
        getIconUrl () {
            const e = new URL(this.config.iconUrl, window.location), t = window.location.host ? window.location.host : window.top.location.host, i = e.host !== t || M.isIE && !window.svg4everybody;
            return {
                url: this.config.iconUrl,
                cors: i
            };
        },
        findElements () {
            try {
                return this.elements.controls = B.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = {
                    play: U.call(this, this.config.selectors.buttons.play),
                    pause: B.call(this, this.config.selectors.buttons.pause),
                    restart: B.call(this, this.config.selectors.buttons.restart),
                    rewind: B.call(this, this.config.selectors.buttons.rewind),
                    fastForward: B.call(this, this.config.selectors.buttons.fastForward),
                    mute: B.call(this, this.config.selectors.buttons.mute),
                    pip: B.call(this, this.config.selectors.buttons.pip),
                    airplay: B.call(this, this.config.selectors.buttons.airplay),
                    settings: B.call(this, this.config.selectors.buttons.settings),
                    captions: B.call(this, this.config.selectors.buttons.captions),
                    fullscreen: B.call(this, this.config.selectors.buttons.fullscreen)
                }, this.elements.progress = B.call(this, this.config.selectors.progress), this.elements.inputs = {
                    seek: B.call(this, this.config.selectors.inputs.seek),
                    volume: B.call(this, this.config.selectors.inputs.volume)
                }, this.elements.display = {
                    buffer: B.call(this, this.config.selectors.display.buffer),
                    currentTime: B.call(this, this.config.selectors.display.currentTime),
                    duration: B.call(this, this.config.selectors.display.duration)
                }, S.element(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`)), !0;
            } catch (e) {
                return this.debug.warn("It looks like there is a problem with your custom controls HTML", e), this.toggleNativeControls(!0), !1;
            }
        },
        createIcon (e, t) {
            const i = "http://www.w3.org/2000/svg", s = Pe.getIconUrl.call(this), n = `${s.cors ? "" : s.url}#${this.config.iconPrefix}`, a = document.createElementNS(i, "svg");
            I(a, x(t, {
                "aria-hidden": "true",
                focusable: "false"
            }));
            const l = document.createElementNS(i, "use"), r = `${n}-${e}`;
            return "href" in l && l.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), l.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", r), a.appendChild(l), a;
        },
        createLabel (e, t = {}) {
            const i = ve.get(e, this.config);
            return $("span", {
                ...t,
                class: [
                    t.class,
                    this.config.classNames.hidden
                ].filter(Boolean).join(" ")
            }, i);
        },
        createBadge (e) {
            if (S.empty(e)) return null;
            const t = $("span", {
                class: this.config.classNames.menu.value
            });
            return t.appendChild($("span", {
                class: this.config.classNames.menu.badge
            }, e)), t;
        },
        createButton (e, t) {
            const i = x({}, t);
            let s = fe(e);
            const n = {
                element: "button",
                toggle: !1,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
            };
            switch([
                "element",
                "icon",
                "label"
            ].forEach((e)=>{
                Object.keys(i).includes(e) && (n[e] = i[e], delete i[e]);
            }), "button" !== n.element || Object.keys(i).includes("type") || (i.type = "button"), Object.keys(i).includes("class") ? i.class.split(" ").some((e)=>e === this.config.classNames.control) || x(i, {
                class: `${i.class} ${this.config.classNames.control}`
            }) : i.class = this.config.classNames.control, e){
                case "play":
                    n.toggle = !0, n.label = "play", n.labelPressed = "pause", n.icon = "play", n.iconPressed = "pause";
                    break;
                case "mute":
                    n.toggle = !0, n.label = "mute", n.labelPressed = "unmute", n.icon = "volume", n.iconPressed = "muted";
                    break;
                case "captions":
                    n.toggle = !0, n.label = "enableCaptions", n.labelPressed = "disableCaptions", n.icon = "captions-off", n.iconPressed = "captions-on";
                    break;
                case "fullscreen":
                    n.toggle = !0, n.label = "enterFullscreen", n.labelPressed = "exitFullscreen", n.icon = "enter-fullscreen", n.iconPressed = "exit-fullscreen";
                    break;
                case "play-large":
                    i.class += ` ${this.config.classNames.control}--overlaid`, s = "play", n.label = "play", n.icon = "play";
                    break;
                default:
                    S.empty(n.label) && (n.label = s), S.empty(n.icon) && (n.icon = e);
            }
            const a = $(n.element);
            return n.toggle ? (a.appendChild(Pe.createIcon.call(this, n.iconPressed, {
                class: "icon--pressed"
            })), a.appendChild(Pe.createIcon.call(this, n.icon, {
                class: "icon--not-pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.labelPressed, {
                class: "label--pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.label, {
                class: "label--not-pressed"
            }))) : (a.appendChild(Pe.createIcon.call(this, n.icon)), a.appendChild(Pe.createLabel.call(this, n.label))), x(i, D(this.config.selectors.buttons[s], i)), I(a, i), "play" === s ? (S.array(this.elements.buttons[s]) || (this.elements.buttons[s] = []), this.elements.buttons[s].push(a)) : this.elements.buttons[s] = a, a;
        },
        createRange (e, t) {
            const i = $("input", x(D(this.config.selectors.inputs[e]), {
                type: "range",
                min: 0,
                max: 100,
                step: .01,
                value: 0,
                autocomplete: "off",
                role: "slider",
                "aria-label": ve.get(e, this.config),
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": 0
            }, t));
            return this.elements.inputs[e] = i, Pe.updateRangeFill.call(this, i), g.setup(i), i;
        },
        createProgress (e, t) {
            const i = $("progress", x(D(this.config.selectors.display[e]), {
                min: 0,
                max: 100,
                value: 0,
                role: "progressbar",
                "aria-hidden": !0
            }, t));
            if ("volume" !== e) {
                i.appendChild($("span", null, "0"));
                const t = {
                    played: "played",
                    buffer: "buffered"
                }[e], s = t ? ve.get(t, this.config) : "";
                i.innerText = `% ${s.toLowerCase()}`;
            }
            return this.elements.display[e] = i, i;
        },
        createTime (e, t) {
            const i = D(this.config.selectors.display[e], t), s = $("div", x(i, {
                class: `${i.class ? i.class : ""} ${this.config.classNames.display.time} `.trim(),
                "aria-label": ve.get(e, this.config),
                role: "timer"
            }), "00:00");
            return this.elements.display[e] = s, s;
        },
        bindMenuItemShortcuts (e, t) {
            X.call(this, e, "keydown keyup", (i)=>{
                if (![
                    " ",
                    "ArrowUp",
                    "ArrowDown",
                    "ArrowRight"
                ].includes(i.key)) return;
                if (i.preventDefault(), i.stopPropagation(), "keydown" === i.type) return;
                const s = V(e, '[role="menuitemradio"]');
                if (!s && [
                    " ",
                    "ArrowRight"
                ].includes(i.key)) Pe.showMenuPanel.call(this, t, !0);
                else {
                    let t;
                    " " !== i.key && ("ArrowDown" === i.key || s && "ArrowRight" === i.key ? (t = e.nextElementSibling, S.element(t) || (t = e.parentNode.firstElementChild)) : (t = e.previousElementSibling, S.element(t) || (t = e.parentNode.lastElementChild)), W.call(this, t, !0));
                }
            }, !1), X.call(this, e, "keyup", (e)=>{
                "Return" === e.key && Pe.focusFirstMenuItem.call(this, null, !0);
            });
        },
        createMenuItem ({ value: e, list: t, type: i, title: s, badge: n = null, checked: a = !1 }) {
            const l = D(this.config.selectors.inputs[i]), r = $("button", x(l, {
                type: "button",
                role: "menuitemradio",
                class: `${this.config.classNames.control} ${l.class ? l.class : ""}`.trim(),
                "aria-checked": a,
                value: e
            })), o = $("span");
            o.innerHTML = s, S.element(n) && o.appendChild(n), r.appendChild(o), Object.defineProperty(r, "checked", {
                enumerable: !0,
                get: ()=>"true" === r.getAttribute("aria-checked"),
                set (e) {
                    e && Array.from(r.parentNode.children).filter((e)=>V(e, '[role="menuitemradio"]')).forEach((e)=>e.setAttribute("aria-checked", "false")), r.setAttribute("aria-checked", e ? "true" : "false");
                }
            }), this.listeners.bind(r, "click keyup", (t)=>{
                if (!S.keyboardEvent(t) || " " === t.key) {
                    switch(t.preventDefault(), t.stopPropagation(), r.checked = !0, i){
                        case "language":
                            this.currentTrack = Number(e);
                            break;
                        case "quality":
                            this.quality = e;
                            break;
                        case "speed":
                            this.speed = parseFloat(e);
                    }
                    Pe.showMenuPanel.call(this, "home", S.keyboardEvent(t));
                }
            }, i, !1), Pe.bindMenuItemShortcuts.call(this, r, i), t.appendChild(r);
        },
        formatTime (e = 0, t = !1) {
            if (!S.number(e)) return e;
            return Ee(e, Ce(this.duration) > 0, t);
        },
        updateTimeDisplay (e = null, t = 0, i = !1) {
            S.element(e) && S.number(t) && (e.innerText = Pe.formatTime(t, i));
        },
        updateVolume () {
            this.supported.ui && (S.element(this.elements.inputs.volume) && Pe.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), S.element(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || 0 === this.volume));
        },
        setRange (e, t = 0) {
            S.element(e) && (e.value = t, Pe.updateRangeFill.call(this, e));
        },
        updateProgress (e) {
            if (!this.supported.ui || !S.event(e)) return;
            let t = 0;
            const i = (e, t)=>{
                const i = S.number(t) ? t : 0, s = S.element(e) ? e : this.elements.display.buffer;
                if (S.element(s)) {
                    s.value = i;
                    const e = s.getElementsByTagName("span")[0];
                    S.element(e) && (e.childNodes[0].nodeValue = i);
                }
            };
            if (e) switch(e.type){
                case "timeupdate":
                case "seeking":
                case "seeked":
                    s = this.currentTime, n = this.duration, t = 0 === s || 0 === n || Number.isNaN(s) || Number.isNaN(n) ? 0 : (s / n * 100).toFixed(2), "timeupdate" === e.type && Pe.setRange.call(this, this.elements.inputs.seek, t);
                    break;
                case "playing":
                case "progress":
                    i(this.elements.display.buffer, 100 * this.buffered);
            }
            var s, n;
        },
        updateRangeFill (e) {
            const t = S.event(e) ? e.target : e;
            if (S.element(t) && "range" === t.getAttribute("type")) {
                if (V(t, this.config.selectors.inputs.seek)) {
                    t.setAttribute("aria-valuenow", this.currentTime);
                    const e = Pe.formatTime(this.currentTime), i = Pe.formatTime(this.duration), s = ve.get("seekLabel", this.config);
                    t.setAttribute("aria-valuetext", s.replace("{currentTime}", e).replace("{duration}", i));
                } else if (V(t, this.config.selectors.inputs.volume)) {
                    const e = 100 * t.value;
                    t.setAttribute("aria-valuenow", e), t.setAttribute("aria-valuetext", `${e.toFixed(1)}%`);
                } else t.setAttribute("aria-valuenow", t.value);
                (M.isWebKit || M.isIPadOS) && t.style.setProperty("--value", t.value / t.max * 100 + "%");
            }
        },
        updateSeekTooltip (e) {
            var t, i;
            if (!this.config.tooltips.seek || !S.element(this.elements.inputs.seek) || !S.element(this.elements.display.seekTooltip) || 0 === this.duration) return;
            const s = this.elements.display.seekTooltip, n = `${this.config.classNames.tooltip}--visible`, a = (e)=>R(s, n, e);
            if (this.touch) return void a(!1);
            let l = 0;
            const r = this.elements.progress.getBoundingClientRect();
            if (S.event(e)) l = 100 / r.width * (e.pageX - r.left);
            else {
                if (!F(s, n)) return;
                l = parseFloat(s.style.left, 10);
            }
            l < 0 ? l = 0 : l > 100 && (l = 100);
            const o = this.duration / 100 * l;
            s.innerText = Pe.formatTime(o);
            const c = null === (t = this.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e })=>e === Math.round(o));
            c && s.insertAdjacentHTML("afterbegin", `${c.label}<br>`), s.style.left = `${l}%`, S.event(e) && [
                "mouseenter",
                "mouseleave"
            ].includes(e.type) && a("mouseenter" === e.type);
        },
        timeUpdate (e) {
            const t = !S.element(this.elements.display.duration) && this.config.invertTime;
            Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, t ? this.duration - this.currentTime : this.currentTime, t), e && "timeupdate" === e.type && this.media.seeking || Pe.updateProgress.call(this, e);
        },
        durationUpdate () {
            if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
            if (this.duration >= 2 ** 32) return H(this.elements.display.currentTime, !0), void H(this.elements.progress, !0);
            S.element(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
            const e = S.element(this.elements.display.duration);
            !e && this.config.displayDuration && this.paused && Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), e && Pe.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), this.config.markers.enabled && Pe.setMarkers.call(this), Pe.updateSeekTooltip.call(this);
        },
        toggleMenuButton (e, t) {
            H(this.elements.settings.buttons[e], !t);
        },
        updateSetting (e, t, i) {
            const s = this.elements.settings.panels[e];
            let n = null, a = t;
            if ("captions" === e) n = this.currentTrack;
            else {
                if (n = S.empty(i) ? this[e] : i, S.empty(n) && (n = this.config[e].default), !S.empty(this.options[e]) && !this.options[e].includes(n)) return void this.debug.warn(`Unsupported value of '${n}' for ${e}`);
                if (!this.config[e].options.includes(n)) return void this.debug.warn(`Disabled value of '${n}' for ${e}`);
            }
            if (S.element(a) || (a = s && s.querySelector('[role="menu"]')), !S.element(a)) return;
            this.elements.settings.buttons[e].querySelector(`.${this.config.classNames.menu.value}`).innerHTML = Pe.getLabel.call(this, e, n);
            const l = a && a.querySelector(`[value="${n}"]`);
            S.element(l) && (l.checked = !0);
        },
        getLabel (e, t) {
            switch(e){
                case "speed":
                    return 1 === t ? ve.get("normal", this.config) : `${t}&times;`;
                case "quality":
                    if (S.number(t)) {
                        const e = ve.get(`qualityLabel.${t}`, this.config);
                        return e.length ? e : `${t}p`;
                    }
                    return ge(t);
                case "captions":
                    return xe.getLabel.call(this);
                default:
                    return null;
            }
        },
        setQualityMenu (e) {
            if (!S.element(this.elements.settings.panels.quality)) return;
            const t = "quality", i = this.elements.settings.panels.quality.querySelector('[role="menu"]');
            S.array(e) && (this.options.quality = se(e).filter((e)=>this.config.quality.options.includes(e)));
            const s = !S.empty(this.options.quality) && this.options.quality.length > 1;
            if (Pe.toggleMenuButton.call(this, t, s), j(i), Pe.checkMenu.call(this), !s) return;
            const n = (e)=>{
                const t = ve.get(`qualityBadge.${e}`, this.config);
                return t.length ? Pe.createBadge.call(this, t) : null;
            };
            this.options.quality.sort((e, t)=>{
                const i = this.config.quality.options;
                return i.indexOf(e) > i.indexOf(t) ? 1 : -1;
            }).forEach((e)=>{
                Pe.createMenuItem.call(this, {
                    value: e,
                    list: i,
                    type: t,
                    title: Pe.getLabel.call(this, "quality", e),
                    badge: n(e)
                });
            }), Pe.updateSetting.call(this, t, i);
        },
        setCaptionsMenu () {
            if (!S.element(this.elements.settings.panels.captions)) return;
            const e = "captions", t = this.elements.settings.panels.captions.querySelector('[role="menu"]'), i = xe.getTracks.call(this), s = Boolean(i.length);
            if (Pe.toggleMenuButton.call(this, e, s), j(t), Pe.checkMenu.call(this), !s) return;
            const n = i.map((e, i)=>({
                    value: i,
                    checked: this.captions.toggled && this.currentTrack === i,
                    title: xe.getLabel.call(this, e),
                    badge: e.language && Pe.createBadge.call(this, e.language.toUpperCase()),
                    list: t,
                    type: "language"
                }));
            n.unshift({
                value: -1,
                checked: !this.captions.toggled,
                title: ve.get("disabled", this.config),
                list: t,
                type: "language"
            }), n.forEach(Pe.createMenuItem.bind(this)), Pe.updateSetting.call(this, e, t);
        },
        setSpeedMenu () {
            if (!S.element(this.elements.settings.panels.speed)) return;
            const e = "speed", t = this.elements.settings.panels.speed.querySelector('[role="menu"]');
            this.options.speed = this.options.speed.filter((e)=>e >= this.minimumSpeed && e <= this.maximumSpeed);
            const i = !S.empty(this.options.speed) && this.options.speed.length > 1;
            Pe.toggleMenuButton.call(this, e, i), j(t), Pe.checkMenu.call(this), i && (this.options.speed.forEach((i)=>{
                Pe.createMenuItem.call(this, {
                    value: i,
                    list: t,
                    type: e,
                    title: Pe.getLabel.call(this, "speed", i)
                });
            }), Pe.updateSetting.call(this, e, t));
        },
        checkMenu () {
            const { buttons: e } = this.elements.settings, t = !S.empty(e) && Object.values(e).some((e)=>!e.hidden);
            H(this.elements.settings.menu, !t);
        },
        focusFirstMenuItem (e, t = !1) {
            if (this.elements.settings.popup.hidden) return;
            let i = e;
            S.element(i) || (i = Object.values(this.elements.settings.panels).find((e)=>!e.hidden));
            const s = i.querySelector('[role^="menuitem"]');
            W.call(this, s, t);
        },
        toggleMenu (e) {
            const { popup: t } = this.elements.settings, i = this.elements.buttons.settings;
            if (!S.element(t) || !S.element(i)) return;
            const { hidden: s } = t;
            let n = s;
            if (S.boolean(e)) n = e;
            else if (S.keyboardEvent(e) && "Escape" === e.key) n = !1;
            else if (S.event(e)) {
                const s = S.function(e.composedPath) ? e.composedPath()[0] : e.target, a = t.contains(s);
                if (a || !a && e.target !== i && n) return;
            }
            i.setAttribute("aria-expanded", n), H(t, !n), R(this.elements.container, this.config.classNames.menu.open, n), n && S.keyboardEvent(e) ? Pe.focusFirstMenuItem.call(this, null, !0) : n || s || W.call(this, i, S.keyboardEvent(e));
        },
        getMenuSize (e) {
            const t = e.cloneNode(!0);
            t.style.position = "absolute", t.style.opacity = 0, t.removeAttribute("hidden"), e.parentNode.appendChild(t);
            const i = t.scrollWidth, s = t.scrollHeight;
            return O(t), {
                width: i,
                height: s
            };
        },
        showMenuPanel (e = "", t = !1) {
            const i = this.elements.container.querySelector(`#plyr-settings-${this.id}-${e}`);
            if (!S.element(i)) return;
            const s = i.parentNode, n = Array.from(s.children).find((e)=>!e.hidden);
            if (K.transitions && !K.reducedMotion) {
                s.style.width = `${n.scrollWidth}px`, s.style.height = `${n.scrollHeight}px`;
                const e = Pe.getMenuSize.call(this, i), t = (e)=>{
                    e.target === s && [
                        "width",
                        "height"
                    ].includes(e.propertyName) && (s.style.width = "", s.style.height = "", J.call(this, s, E, t));
                };
                X.call(this, s, E, t), s.style.width = `${e.width}px`, s.style.height = `${e.height}px`;
            }
            H(n, !0), H(i, !1), Pe.focusFirstMenuItem.call(this, i, t);
        },
        setDownloadUrl () {
            const e = this.elements.buttons.download;
            S.element(e) && e.setAttribute("href", this.download);
        },
        create (e) {
            const { bindMenuItemShortcuts: t, createButton: i, createProgress: s, createRange: n, createTime: a, setQualityMenu: l, setSpeedMenu: r, showMenuPanel: o } = Pe;
            this.elements.controls = null, S.array(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(i.call(this, "play-large"));
            const c = $("div", D(this.config.selectors.controls.wrapper));
            this.elements.controls = c;
            const u = {
                class: "plyr__controls__item"
            };
            return se(S.array(this.config.controls) ? this.config.controls : []).forEach((l)=>{
                if ("restart" === l && c.appendChild(i.call(this, "restart", u)), "rewind" === l && c.appendChild(i.call(this, "rewind", u)), "play" === l && c.appendChild(i.call(this, "play", u)), "fast-forward" === l && c.appendChild(i.call(this, "fast-forward", u)), "progress" === l) {
                    const t = $("div", {
                        class: `${u.class} plyr__progress__container`
                    }), i = $("div", D(this.config.selectors.progress));
                    if (i.appendChild(n.call(this, "seek", {
                        id: `plyr-seek-${e.id}`
                    })), i.appendChild(s.call(this, "buffer")), this.config.tooltips.seek) {
                        const e = $("span", {
                            class: this.config.classNames.tooltip
                        }, "00:00");
                        i.appendChild(e), this.elements.display.seekTooltip = e;
                    }
                    this.elements.progress = i, t.appendChild(this.elements.progress), c.appendChild(t);
                }
                if ("current-time" === l && c.appendChild(a.call(this, "currentTime", u)), "duration" === l && c.appendChild(a.call(this, "duration", u)), "mute" === l || "volume" === l) {
                    let { volume: t } = this.elements;
                    if (S.element(t) && c.contains(t) || (t = $("div", x({}, u, {
                        class: `${u.class} plyr__volume`.trim()
                    })), this.elements.volume = t, c.appendChild(t)), "mute" === l && t.appendChild(i.call(this, "mute")), "volume" === l && !M.isIos && !M.isIPadOS) {
                        const i = {
                            max: 1,
                            step: .05,
                            value: this.config.volume
                        };
                        t.appendChild(n.call(this, "volume", x(i, {
                            id: `plyr-volume-${e.id}`
                        })));
                    }
                }
                if ("captions" === l && c.appendChild(i.call(this, "captions", u)), "settings" === l && !S.empty(this.config.settings)) {
                    const s = $("div", x({}, u, {
                        class: `${u.class} plyr__menu`.trim(),
                        hidden: ""
                    }));
                    s.appendChild(i.call(this, "settings", {
                        "aria-haspopup": !0,
                        "aria-controls": `plyr-settings-${e.id}`,
                        "aria-expanded": !1
                    }));
                    const n = $("div", {
                        class: "plyr__menu__container",
                        id: `plyr-settings-${e.id}`,
                        hidden: ""
                    }), a = $("div"), l = $("div", {
                        id: `plyr-settings-${e.id}-home`
                    }), r = $("div", {
                        role: "menu"
                    });
                    l.appendChild(r), a.appendChild(l), this.elements.settings.panels.home = l, this.config.settings.forEach((i)=>{
                        const s = $("button", x(D(this.config.selectors.buttons.settings), {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                            role: "menuitem",
                            "aria-haspopup": !0,
                            hidden: ""
                        }));
                        t.call(this, s, i), X.call(this, s, "click", ()=>{
                            o.call(this, i, !1);
                        });
                        const n = $("span", null, ve.get(i, this.config)), l = $("span", {
                            class: this.config.classNames.menu.value
                        });
                        l.innerHTML = e[i], n.appendChild(l), s.appendChild(n), r.appendChild(s);
                        const c = $("div", {
                            id: `plyr-settings-${e.id}-${i}`,
                            hidden: ""
                        }), u = $("button", {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--back`
                        });
                        u.appendChild($("span", {
                            "aria-hidden": !0
                        }, ve.get(i, this.config))), u.appendChild($("span", {
                            class: this.config.classNames.hidden
                        }, ve.get("menuBack", this.config))), X.call(this, c, "keydown", (e)=>{
                            "ArrowLeft" === e.key && (e.preventDefault(), e.stopPropagation(), o.call(this, "home", !0));
                        }, !1), X.call(this, u, "click", ()=>{
                            o.call(this, "home", !1);
                        }), c.appendChild(u), c.appendChild($("div", {
                            role: "menu"
                        })), a.appendChild(c), this.elements.settings.buttons[i] = s, this.elements.settings.panels[i] = c;
                    }), n.appendChild(a), s.appendChild(n), c.appendChild(s), this.elements.settings.popup = n, this.elements.settings.menu = s;
                }
                if ("pip" === l && K.pip && c.appendChild(i.call(this, "pip", u)), "airplay" === l && K.airplay && c.appendChild(i.call(this, "airplay", u)), "download" === l) {
                    const e = x({}, u, {
                        element: "a",
                        href: this.download,
                        target: "_blank"
                    });
                    this.isHTML5 && (e.download = "");
                    const { download: t } = this.config.urls;
                    !S.url(t) && this.isEmbed && x(e, {
                        icon: `logo-${this.provider}`,
                        label: this.provider
                    }), c.appendChild(i.call(this, "download", e));
                }
                "fullscreen" === l && c.appendChild(i.call(this, "fullscreen", u));
            }), this.isHTML5 && l.call(this, de.getQualityOptions.call(this)), r.call(this), c;
        },
        inject () {
            if (this.config.loadSprite) {
                const e = Pe.getIconUrl.call(this);
                e.cors && ke(e.url, "sprite-plyr");
            }
            this.id = Math.floor(1e4 * Math.random());
            let e = null;
            this.elements.controls = null;
            const t = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
            };
            let i = !0;
            S.function(this.config.controls) && (this.config.controls = this.config.controls.call(this, t)), this.config.controls || (this.config.controls = []), S.element(this.config.controls) || S.string(this.config.controls) ? e = this.config.controls : (e = Pe.create.call(this, {
                id: this.id,
                seektime: this.config.seekTime,
                speed: this.speed,
                quality: this.quality,
                captions: xe.getLabel.call(this)
            }), i = !1);
            let s;
            i && S.string(this.config.controls) && (e = ((e)=>{
                let i = e;
                return Object.entries(t).forEach(([e, t])=>{
                    i = pe(i, `{${e}}`, t);
                }), i;
            })(e)), S.string(this.config.selectors.controls.container) && (s = document.querySelector(this.config.selectors.controls.container)), S.element(s) || (s = this.elements.container);
            if (s[S.element(e) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", e), S.element(this.elements.controls) || Pe.findElements.call(this), !S.empty(this.elements.buttons)) {
                const e = (e)=>{
                    const t = this.config.classNames.controlPressed;
                    e.setAttribute("aria-pressed", "false"), Object.defineProperty(e, "pressed", {
                        configurable: !0,
                        enumerable: !0,
                        get: ()=>F(e, t),
                        set (i = !1) {
                            R(e, t, i), e.setAttribute("aria-pressed", i ? "true" : "false");
                        }
                    });
                };
                Object.values(this.elements.buttons).filter(Boolean).forEach((t)=>{
                    S.array(t) || S.nodeList(t) ? Array.from(t).filter(Boolean).forEach(e) : e(t);
                });
            }
            if (M.isEdge && P(s), this.config.tooltips.controls) {
                const { classNames: e, selectors: t } = this.config, i = `${t.controls.wrapper} ${t.labels} .${e.hidden}`, s = U.call(this, i);
                Array.from(s).forEach((e)=>{
                    R(e, this.config.classNames.hidden, !1), R(e, this.config.classNames.tooltip, !0);
                });
            }
        },
        setMediaMetadata () {
            try {
                "mediaSession" in navigator && (navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: this.config.mediaMetadata.title,
                    artist: this.config.mediaMetadata.artist,
                    album: this.config.mediaMetadata.album,
                    artwork: this.config.mediaMetadata.artwork
                }));
            } catch (e) {}
        },
        setMarkers () {
            var e, t;
            if (!this.duration || this.elements.markers) return;
            const i = null === (e = this.config.markers) || void 0 === e || null === (t = e.points) || void 0 === t ? void 0 : t.filter(({ time: e })=>e > 0 && e < this.duration);
            if (null == i || !i.length) return;
            const s = document.createDocumentFragment(), n = document.createDocumentFragment();
            let a = null;
            const l = `${this.config.classNames.tooltip}--visible`, r = (e)=>R(a, l, e);
            i.forEach((e)=>{
                const t = $("span", {
                    class: this.config.classNames.marker
                }, ""), i = e.time / this.duration * 100 + "%";
                a && (t.addEventListener("mouseenter", ()=>{
                    e.label || (a.style.left = i, a.innerHTML = e.label, r(!0));
                }), t.addEventListener("mouseleave", ()=>{
                    r(!1);
                })), t.addEventListener("click", ()=>{
                    this.currentTime = e.time;
                }), t.style.left = i, n.appendChild(t);
            }), s.appendChild(n), this.config.tooltips.seek || (a = $("span", {
                class: this.config.classNames.tooltip
            }, ""), s.appendChild(a)), this.elements.markers = {
                points: n,
                tip: a
            }, this.elements.progress.appendChild(s);
        }
    };
    function Me(e, t = !0) {
        let i = e;
        if (t) {
            const e = document.createElement("a");
            e.href = i, i = e.href;
        }
        try {
            return new URL(i);
        } catch (e) {
            return null;
        }
    }
    function Ne(e) {
        const t = new URLSearchParams;
        return S.object(e) && Object.entries(e).forEach(([e, i])=>{
            t.set(e, i);
        }), t;
    }
    const xe = {
        setup () {
            if (!this.supported.ui) return;
            if (!this.isVideo || this.isYouTube || this.isHTML5 && !K.textTracks) return void (S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this));
            var e, t;
            if (S.element(this.elements.captions) || (this.elements.captions = $("div", D(this.config.selectors.captions)), this.elements.captions.setAttribute("dir", "auto"), e = this.elements.captions, t = this.elements.wrapper, S.element(e) && S.element(t) && t.parentNode.insertBefore(e, t.nextSibling)), M.isIE && window.URL) {
                const e = this.media.querySelectorAll("track");
                Array.from(e).forEach((e)=>{
                    const t = e.getAttribute("src"), i = Me(t);
                    null !== i && i.hostname !== window.location.href.hostname && [
                        "http:",
                        "https:"
                    ].includes(i.protocol) && Te(t, "blob").then((t)=>{
                        e.setAttribute("src", window.URL.createObjectURL(t));
                    }).catch(()=>{
                        O(e);
                    });
                });
            }
            const i = se((navigator.languages || [
                navigator.language || navigator.userLanguage || "en"
            ]).map((e)=>e.split("-")[0]));
            let s = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
            "auto" === s && ([s] = i);
            let n = this.storage.get("captions");
            if (S.boolean(n) || ({ active: n } = this.config.captions), Object.assign(this.captions, {
                toggled: !1,
                active: n,
                language: s,
                languages: i
            }), this.isHTML5) {
                const e = this.config.captions.update ? "addtrack removetrack" : "removetrack";
                X.call(this, this.media.textTracks, e, xe.update.bind(this));
            }
            setTimeout(xe.update.bind(this), 0);
        },
        update () {
            const e = xe.getTracks.call(this, !0), { active: t, language: i, meta: s, currentTrackNode: n } = this.captions, a = Boolean(e.find((e)=>e.language === i));
            this.isHTML5 && this.isVideo && e.filter((e)=>!s.get(e)).forEach((e)=>{
                this.debug.log("Track added", e), s.set(e, {
                    default: "showing" === e.mode
                }), "showing" === e.mode && (e.mode = "hidden"), X.call(this, e, "cuechange", ()=>xe.updateCues.call(this));
            }), (a && this.language !== i || !e.includes(n)) && (xe.setLanguage.call(this, i), xe.toggle.call(this, t && a)), this.elements && R(this.elements.container, this.config.classNames.captions.enabled, !S.empty(e)), S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this);
        },
        toggle (e, t = !0) {
            if (!this.supported.ui) return;
            const { toggled: i } = this.captions, s = this.config.classNames.captions.active, n = S.nullOrUndefined(e) ? !i : e;
            if (n !== i) {
                if (t || (this.captions.active = n, this.storage.set({
                    captions: n
                })), !this.language && n && !t) {
                    const e = xe.getTracks.call(this), t = xe.findTrack.call(this, [
                        this.captions.language,
                        ...this.captions.languages
                    ], !0);
                    return this.captions.language = t.language, void xe.set.call(this, e.indexOf(t));
                }
                this.elements.buttons.captions && (this.elements.buttons.captions.pressed = n), R(this.elements.container, s, n), this.captions.toggled = n, Pe.updateSetting.call(this, "captions"), Z.call(this, this.media, n ? "captionsenabled" : "captionsdisabled");
            }
            setTimeout(()=>{
                n && this.captions.toggled && (this.captions.currentTrackNode.mode = "hidden");
            });
        },
        set (e, t = !0) {
            const i = xe.getTracks.call(this);
            if (-1 !== e) {
                if (S.number(e)) {
                    if (e in i) {
                        if (this.captions.currentTrack !== e) {
                            this.captions.currentTrack = e;
                            const s = i[e], { language: n } = s || {};
                            this.captions.currentTrackNode = s, Pe.updateSetting.call(this, "captions"), t || (this.captions.language = n, this.storage.set({
                                language: n
                            })), this.isVimeo && this.embed.enableTextTrack(n), Z.call(this, this.media, "languagechange");
                        }
                        xe.toggle.call(this, !0, t), this.isHTML5 && this.isVideo && xe.updateCues.call(this);
                    } else this.debug.warn("Track not found", e);
                } else this.debug.warn("Invalid caption argument", e);
            } else xe.toggle.call(this, !1, t);
        },
        setLanguage (e, t = !0) {
            if (!S.string(e)) return void this.debug.warn("Invalid language argument", e);
            const i = e.toLowerCase();
            this.captions.language = i;
            const s = xe.getTracks.call(this), n = xe.findTrack.call(this, [
                i
            ]);
            xe.set.call(this, s.indexOf(n), t);
        },
        getTracks (e = !1) {
            return Array.from((this.media || {}).textTracks || []).filter((t)=>!this.isHTML5 || e || this.captions.meta.has(t)).filter((e)=>[
                    "captions",
                    "subtitles"
                ].includes(e.kind));
        },
        findTrack (e, t = !1) {
            const i = xe.getTracks.call(this), s = (e)=>Number((this.captions.meta.get(e) || {}).default), n = Array.from(i).sort((e, t)=>s(t) - s(e));
            let a;
            return e.every((e)=>(a = n.find((t)=>t.language === e), !a)), a || (t ? n[0] : void 0);
        },
        getCurrentTrack () {
            return xe.getTracks.call(this)[this.currentTrack];
        },
        getLabel (e) {
            let t = e;
            return !S.track(t) && K.textTracks && this.captions.toggled && (t = xe.getCurrentTrack.call(this)), S.track(t) ? S.empty(t.label) ? S.empty(t.language) ? ve.get("enabled", this.config) : e.language.toUpperCase() : t.label : ve.get("disabled", this.config);
        },
        updateCues (e) {
            if (!this.supported.ui) return;
            if (!S.element(this.elements.captions)) return void this.debug.warn("No captions element to render to");
            if (!S.nullOrUndefined(e) && !Array.isArray(e)) return void this.debug.warn("updateCues: Invalid input", e);
            let t = e;
            if (!t) {
                const e = xe.getCurrentTrack.call(this);
                t = Array.from((e || {}).activeCues || []).map((e)=>e.getCueAsHTML()).map(ye);
            }
            const i = t.map((e)=>e.trim()).join("\n");
            if (i !== this.elements.captions.innerHTML) {
                j(this.elements.captions);
                const e = $("span", D(this.config.selectors.caption));
                e.innerHTML = i, this.elements.captions.appendChild(e), Z.call(this, this.media, "cuechange");
            }
        }
    }, Le = {
        enabled: !0,
        title: "",
        debug: !1,
        autoplay: !1,
        autopause: !0,
        playsinline: !0,
        seekTime: 10,
        volume: 1,
        muted: !1,
        duration: null,
        displayDuration: !0,
        invertTime: !0,
        toggleInvert: !0,
        ratio: null,
        clickToPlay: !0,
        hideControls: !0,
        resetOnEnd: !1,
        disableContextMenu: !0,
        loadSprite: !0,
        iconPrefix: "plyr",
        iconUrl: "https://cdn.plyr.io/3.7.8/plyr.svg",
        blankVideo: "https://cdn.plyr.io/static/blank.mp4",
        quality: {
            default: 576,
            options: [
                4320,
                2880,
                2160,
                1440,
                1080,
                720,
                576,
                480,
                360,
                240
            ],
            forced: !1,
            onChange: null
        },
        loop: {
            active: !1
        },
        speed: {
            selected: 1,
            options: [
                .5,
                .75,
                1,
                1.25,
                1.5,
                1.75,
                2,
                4
            ]
        },
        keyboard: {
            focused: !0,
            global: !1
        },
        tooltips: {
            controls: !1,
            seek: !0
        },
        captions: {
            active: !1,
            language: "auto",
            update: !1
        },
        fullscreen: {
            enabled: !0,
            fallback: !0,
            iosNative: !1
        },
        storage: {
            enabled: !0,
            key: "plyr"
        },
        controls: [
            "play-large",
            "play",
            "progress",
            "current-time",
            "mute",
            "volume",
            "captions",
            "settings",
            "pip",
            "airplay",
            "fullscreen"
        ],
        settings: [
            "captions",
            "quality",
            "speed"
        ],
        i18n: {
            restart: "Restart",
            rewind: "Rewind {seektime}s",
            play: "Play",
            pause: "Pause",
            fastForward: "Forward {seektime}s",
            seek: "Seek",
            seekLabel: "{currentTime} of {duration}",
            played: "Played",
            buffered: "Buffered",
            currentTime: "Current time",
            duration: "Duration",
            volume: "Volume",
            mute: "Mute",
            unmute: "Unmute",
            enableCaptions: "Enable captions",
            disableCaptions: "Disable captions",
            download: "Download",
            enterFullscreen: "Enter fullscreen",
            exitFullscreen: "Exit fullscreen",
            frameTitle: "Player for {title}",
            captions: "Captions",
            settings: "Settings",
            pip: "PIP",
            menuBack: "Go back to previous menu",
            speed: "Speed",
            normal: "Normal",
            quality: "Quality",
            loop: "Loop",
            start: "Start",
            end: "End",
            all: "All",
            reset: "Reset",
            disabled: "Disabled",
            enabled: "Enabled",
            advertisement: "Ad",
            qualityBadge: {
                2160: "4K",
                1440: "HD",
                1080: "HD",
                720: "HD",
                576: "SD",
                480: "SD"
            }
        },
        urls: {
            download: null,
            vimeo: {
                sdk: "https://player.vimeo.com/api/player.js",
                iframe: "https://player.vimeo.com/video/{0}?{1}",
                api: "https://vimeo.com/api/oembed.json?url={0}"
            },
            youtube: {
                sdk: "https://www.youtube.com/iframe_api",
                api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"
            },
            googleIMA: {
                sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
            }
        },
        listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null
        },
        events: [
            "ended",
            "progress",
            "stalled",
            "playing",
            "waiting",
            "canplay",
            "canplaythrough",
            "loadstart",
            "loadeddata",
            "loadedmetadata",
            "timeupdate",
            "volumechange",
            "play",
            "pause",
            "error",
            "seeking",
            "seeked",
            "emptied",
            "ratechange",
            "cuechange",
            "download",
            "enterfullscreen",
            "exitfullscreen",
            "captionsenabled",
            "captionsdisabled",
            "languagechange",
            "controlshidden",
            "controlsshown",
            "ready",
            "statechange",
            "qualitychange",
            "adsloaded",
            "adscontentpause",
            "adscontentresume",
            "adstarted",
            "adsmidpoint",
            "adscomplete",
            "adsallcomplete",
            "adsimpression",
            "adsclick"
        ],
        selectors: {
            editable: "input, textarea, select, [contenteditable]",
            container: ".plyr",
            controls: {
                container: null,
                wrapper: ".plyr__controls"
            },
            labels: "[data-plyr]",
            buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
            },
            inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
            },
            display: {
                currentTime: ".plyr__time--current",
                duration: ".plyr__time--duration",
                buffer: ".plyr__progress__buffer",
                loop: ".plyr__progress__loop",
                volume: ".plyr__volume--display"
            },
            progress: ".plyr__progress",
            captions: ".plyr__captions",
            caption: ".plyr__caption"
        },
        classNames: {
            type: "plyr--{0}",
            provider: "plyr--{0}",
            video: "plyr__video-wrapper",
            embed: "plyr__video-embed",
            videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
            embedContainer: "plyr__video-embed__container",
            poster: "plyr__poster",
            posterEnabled: "plyr__poster-enabled",
            ads: "plyr__ads",
            control: "plyr__control",
            controlPressed: "plyr__control--pressed",
            playing: "plyr--playing",
            paused: "plyr--paused",
            stopped: "plyr--stopped",
            loading: "plyr--loading",
            hover: "plyr--hover",
            tooltip: "plyr__tooltip",
            cues: "plyr__cues",
            marker: "plyr__progress__marker",
            hidden: "plyr__sr-only",
            hideControls: "plyr--hide-controls",
            isTouch: "plyr--is-touch",
            uiSupported: "plyr--full-ui",
            noTransition: "plyr--no-transition",
            display: {
                time: "plyr__time"
            },
            menu: {
                value: "plyr__menu__value",
                badge: "plyr__badge",
                open: "plyr--menu-open"
            },
            captions: {
                enabled: "plyr--captions-enabled",
                active: "plyr--captions-active"
            },
            fullscreen: {
                enabled: "plyr--fullscreen-enabled",
                fallback: "plyr--fullscreen-fallback"
            },
            pip: {
                supported: "plyr--pip-supported",
                active: "plyr--pip-active"
            },
            airplay: {
                supported: "plyr--airplay-supported",
                active: "plyr--airplay-active"
            },
            previewThumbnails: {
                thumbContainer: "plyr__preview-thumb",
                thumbContainerShown: "plyr__preview-thumb--is-shown",
                imageContainer: "plyr__preview-thumb__image-container",
                timeContainer: "plyr__preview-thumb__time-container",
                scrubbingContainer: "plyr__preview-scrubbing",
                scrubbingContainerShown: "plyr__preview-scrubbing--is-shown"
            }
        },
        attributes: {
            embed: {
                provider: "data-plyr-provider",
                id: "data-plyr-embed-id",
                hash: "data-plyr-embed-hash"
            }
        },
        ads: {
            enabled: !1,
            publisherId: "",
            tagUrl: ""
        },
        previewThumbnails: {
            enabled: !1,
            src: ""
        },
        vimeo: {
            byline: !1,
            portrait: !1,
            title: !1,
            speed: !0,
            transparent: !1,
            customControls: !0,
            referrerPolicy: null,
            premium: !1
        },
        youtube: {
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            customControls: !0,
            noCookie: !1
        },
        mediaMetadata: {
            title: "",
            artist: "",
            album: "",
            artwork: []
        },
        markers: {
            enabled: !1,
            points: []
        }
    }, Ie = "picture-in-picture", $e = "inline", _e = {
        html5: "html5",
        youtube: "youtube",
        vimeo: "vimeo"
    }, Oe = "audio", je = "video";
    const qe = ()=>{};
    class De {
        constructor(e = !1){
            this.enabled = window.console && e, this.enabled && this.log("Debugging enabled");
        }
        get log() {
            return this.enabled ? Function.prototype.bind.call(console.log, console) : qe;
        }
        get warn() {
            return this.enabled ? Function.prototype.bind.call(console.warn, console) : qe;
        }
        get error() {
            return this.enabled ? Function.prototype.bind.call(console.error, console) : qe;
        }
    }
    class He {
        constructor(t){
            e(this, "onChange", ()=>{
                if (!this.supported) return;
                const e = this.player.elements.buttons.fullscreen;
                S.element(e) && (e.pressed = this.active);
                const t = this.target === this.player.media ? this.target : this.player.elements.container;
                Z.call(this.player, t, this.active ? "enterfullscreen" : "exitfullscreen", !0);
            }), e(this, "toggleFallback", (e = !1)=>{
                if (e ? this.scrollPosition = {
                    x: window.scrollX ?? 0,
                    y: window.scrollY ?? 0
                } : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y), document.body.style.overflow = e ? "hidden" : "", R(this.target, this.player.config.classNames.fullscreen.fallback, e), M.isIos) {
                    let t = document.head.querySelector('meta[name="viewport"]');
                    const i = "viewport-fit=cover";
                    t || (t = document.createElement("meta"), t.setAttribute("name", "viewport"));
                    const s = S.string(t.content) && t.content.includes(i);
                    e ? (this.cleanupViewport = !s, s || (t.content += `,${i}`)) : this.cleanupViewport && (t.content = t.content.split(",").filter((e)=>e.trim() !== i).join(","));
                }
                this.onChange();
            }), e(this, "trapFocus", (e)=>{
                if (M.isIos || M.isIPadOS || !this.active || "Tab" !== e.key) return;
                const t = document.activeElement, i = U.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"), [s] = i, n = i[i.length - 1];
                t !== n || e.shiftKey ? t === s && e.shiftKey && (n.focus(), e.preventDefault()) : (s.focus(), e.preventDefault());
            }), e(this, "update", ()=>{
                if (this.supported) {
                    let e;
                    e = this.forceFallback ? "Fallback (forced)" : He.nativeSupported ? "Native" : "Fallback", this.player.debug.log(`${e} fullscreen enabled`);
                } else this.player.debug.log("Fullscreen not supported and fallback disabled");
                R(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.supported);
            }), e(this, "enter", ()=>{
                this.supported && (M.isIos && this.player.config.fullscreen.iosNative ? this.player.isVimeo ? this.player.embed.requestFullscreen() : this.target.webkitEnterFullscreen() : !He.nativeSupported || this.forceFallback ? this.toggleFallback(!0) : this.prefix ? S.empty(this.prefix) || this.target[`${this.prefix}Request${this.property}`]() : this.target.requestFullscreen({
                    navigationUI: "hide"
                }));
            }), e(this, "exit", ()=>{
                if (this.supported) {
                    if (M.isIos && this.player.config.fullscreen.iosNative) this.player.isVimeo ? this.player.embed.exitFullscreen() : this.target.webkitEnterFullscreen(), ie(this.player.play());
                    else if (!He.nativeSupported || this.forceFallback) this.toggleFallback(!1);
                    else if (this.prefix) {
                        if (!S.empty(this.prefix)) {
                            const e = "moz" === this.prefix ? "Cancel" : "Exit";
                            document[`${this.prefix}${e}${this.property}`]();
                        }
                    } else (document.cancelFullScreen || document.exitFullscreen).call(document);
                }
            }), e(this, "toggle", ()=>{
                this.active ? this.exit() : this.enter();
            }), this.player = t, this.prefix = He.prefix, this.property = He.property, this.scrollPosition = {
                x: 0,
                y: 0
            }, this.forceFallback = "force" === t.config.fullscreen.fallback, this.player.elements.fullscreen = t.config.fullscreen.container && function(e, t) {
                const { prototype: i } = Element;
                return (i.closest || function() {
                    let e = this;
                    do {
                        if (V.matches(e, t)) return e;
                        e = e.parentElement || e.parentNode;
                    }while (null !== e && 1 === e.nodeType);
                    return null;
                }).call(e, t);
            }(this.player.elements.container, t.config.fullscreen.container), X.call(this.player, document, "ms" === this.prefix ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, ()=>{
                this.onChange();
            }), X.call(this.player, this.player.elements.container, "dblclick", (e)=>{
                S.element(this.player.elements.controls) && this.player.elements.controls.contains(e.target) || this.player.listeners.proxy(e, this.toggle, "fullscreen");
            }), X.call(this, this.player.elements.container, "keydown", (e)=>this.trapFocus(e)), this.update();
        }
        static get nativeSupported() {
            return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
        }
        get useNative() {
            return He.nativeSupported && !this.forceFallback;
        }
        static get prefix() {
            if (S.function(document.exitFullscreen)) return "";
            let e = "";
            return [
                "webkit",
                "moz",
                "ms"
            ].some((t)=>!(!S.function(document[`${t}ExitFullscreen`]) && !S.function(document[`${t}CancelFullScreen`])) && (e = t, !0)), e;
        }
        static get property() {
            return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
        }
        get supported() {
            return [
                this.player.config.fullscreen.enabled,
                this.player.isVideo,
                He.nativeSupported || this.player.config.fullscreen.fallback,
                !this.player.isYouTube || He.nativeSupported || !M.isIos || this.player.config.playsinline && !this.player.config.fullscreen.iosNative
            ].every(Boolean);
        }
        get active() {
            if (!this.supported) return !1;
            if (!He.nativeSupported || this.forceFallback) return F(this.target, this.player.config.classNames.fullscreen.fallback);
            const e = this.prefix ? this.target.getRootNode()[`${this.prefix}${this.property}Element`] : this.target.getRootNode().fullscreenElement;
            return e && e.shadowRoot ? e === this.target.getRootNode().host : e === this.target;
        }
        get target() {
            return M.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen ?? this.player.elements.container;
        }
    }
    function Re(e, t = 1) {
        return new Promise((i, s)=>{
            const n = new Image, a = ()=>{
                delete n.onload, delete n.onerror, (n.naturalWidth >= t ? i : s)(n);
            };
            Object.assign(n, {
                onload: a,
                onerror: a,
                src: e
            });
        });
    }
    const Fe = {
        addStyleHook () {
            R(this.elements.container, this.config.selectors.container.replace(".", ""), !0), R(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
        },
        toggleNativeControls (e = !1) {
            e && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
        },
        build () {
            if (this.listeners.media(), !this.supported.ui) return this.debug.warn(`Basic support only for ${this.provider} ${this.type}`), void Fe.toggleNativeControls.call(this, !0);
            S.element(this.elements.controls) || (Pe.inject.call(this), this.listeners.controls()), Fe.toggleNativeControls.call(this), this.isHTML5 && xe.setup.call(this), this.volume = null, this.muted = null, this.loop = null, this.quality = null, this.speed = null, Pe.updateVolume.call(this), Pe.timeUpdate.call(this), Pe.durationUpdate.call(this), Fe.checkPlaying.call(this), R(this.elements.container, this.config.classNames.pip.supported, K.pip && this.isHTML5 && this.isVideo), R(this.elements.container, this.config.classNames.airplay.supported, K.airplay && this.isHTML5), R(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = !0, setTimeout(()=>{
                Z.call(this, this.media, "ready");
            }, 0), Fe.setTitle.call(this), this.poster && Fe.setPoster.call(this, this.poster, !1).catch(()=>{}), this.config.duration && Pe.durationUpdate.call(this), this.config.mediaMetadata && Pe.setMediaMetadata.call(this);
        },
        setTitle () {
            let e = ve.get("play", this.config);
            if (S.string(this.config.title) && !S.empty(this.config.title) && (e += `, ${this.config.title}`), Array.from(this.elements.buttons.play || []).forEach((t)=>{
                t.setAttribute("aria-label", e);
            }), this.isEmbed) {
                const e = B.call(this, "iframe");
                if (!S.element(e)) return;
                const t = S.empty(this.config.title) ? "video" : this.config.title, i = ve.get("frameTitle", this.config);
                e.setAttribute("title", i.replace("{title}", t));
            }
        },
        togglePoster (e) {
            R(this.elements.container, this.config.classNames.posterEnabled, e);
        },
        setPoster (e, t = !0) {
            return t && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", e), this.elements.poster.removeAttribute("hidden"), te.call(this).then(()=>Re(e)).catch((t)=>{
                throw e === this.poster && Fe.togglePoster.call(this, !1), t;
            }).then(()=>{
                if (e !== this.poster) throw new Error("setPoster cancelled by later call to setPoster");
            }).then(()=>(Object.assign(this.elements.poster.style, {
                    backgroundImage: `url('${e}')`,
                    backgroundSize: ""
                }), Fe.togglePoster.call(this, !0), e)));
        },
        checkPlaying (e) {
            R(this.elements.container, this.config.classNames.playing, this.playing), R(this.elements.container, this.config.classNames.paused, this.paused), R(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach((e)=>{
                Object.assign(e, {
                    pressed: this.playing
                }), e.setAttribute("aria-label", ve.get(this.playing ? "pause" : "play", this.config));
            }), S.event(e) && "timeupdate" === e.type || Fe.toggleControls.call(this);
        },
        checkLoading (e) {
            this.loading = [
                "stalled",
                "waiting"
            ].includes(e.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout(()=>{
                R(this.elements.container, this.config.classNames.loading, this.loading), Fe.toggleControls.call(this);
            }, this.loading ? 250 : 0);
        },
        toggleControls (e) {
            const { controls: t } = this.elements;
            if (t && this.config.hideControls) {
                const i = this.touch && this.lastSeekTime + 2e3 > Date.now();
                this.toggleControls(Boolean(e || this.loading || this.paused || t.pressed || t.hover || i));
            }
        },
        migrateStyles () {
            Object.values({
                ...this.media.style
            }).filter((e)=>!S.empty(e) && S.string(e) && e.startsWith("--plyr")).forEach((e)=>{
                this.elements.container.style.setProperty(e, this.media.style.getPropertyValue(e)), this.media.style.removeProperty(e);
            }), S.empty(this.media.style) && this.media.removeAttribute("style");
        }
    };
    class Ve {
        constructor(t){
            e(this, "firstTouch", ()=>{
                const { player: e } = this, { elements: t } = e;
                e.touch = !0, R(t.container, e.config.classNames.isTouch, !0);
            }), e(this, "global", (e = !0)=>{
                const { player: t } = this;
                t.config.keyboard.global && Q.call(t, window, "keydown keyup", this.handleKey, e, !1), Q.call(t, document.body, "click", this.toggleMenu, e), G.call(t, document.body, "touchstart", this.firstTouch);
            }), e(this, "container", ()=>{
                const { player: e } = this, { config: t, elements: i, timers: s } = e;
                !t.keyboard.global && t.keyboard.focused && X.call(e, i.container, "keydown keyup", this.handleKey, !1), X.call(e, i.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", (t)=>{
                    const { controls: n } = i;
                    n && "enterfullscreen" === t.type && (n.pressed = !1, n.hover = !1);
                    let a = 0;
                    [
                        "touchstart",
                        "touchmove",
                        "mousemove"
                    ].includes(t.type) && (Fe.toggleControls.call(e, !0), a = e.touch ? 3e3 : 2e3), clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), a);
                });
                const n = ()=>{
                    if (!e.isVimeo || e.config.vimeo.premium) return;
                    const t = i.wrapper, { active: s } = e.fullscreen, [n, a] = ce.call(e), l = ae(`aspect-ratio: ${n} / ${a}`);
                    if (!s) return void (l ? (t.style.width = null, t.style.height = null) : (t.style.maxWidth = null, t.style.margin = null));
                    const [r, o] = [
                        Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
                        Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
                    ], c = r / o > n / a;
                    l ? (t.style.width = c ? "auto" : "100%", t.style.height = c ? "100%" : "auto") : (t.style.maxWidth = c ? o / a * n + "px" : null, t.style.margin = c ? "0 auto" : null);
                }, a = ()=>{
                    clearTimeout(s.resized), s.resized = setTimeout(n, 50);
                };
                X.call(e, i.container, "enterfullscreen exitfullscreen", (t)=>{
                    const { target: s } = e.fullscreen;
                    if (s !== i.container) return;
                    if (!e.isEmbed && S.empty(e.config.ratio)) return;
                    n();
                    ("enterfullscreen" === t.type ? X : J).call(e, window, "resize", a);
                });
            }), e(this, "media", ()=>{
                const { player: e } = this, { elements: t } = e;
                if (X.call(e, e.media, "timeupdate seeking seeked", (t)=>Pe.timeUpdate.call(e, t)), X.call(e, e.media, "durationchange loadeddata loadedmetadata", (t)=>Pe.durationUpdate.call(e, t)), X.call(e, e.media, "ended", ()=>{
                    e.isHTML5 && e.isVideo && e.config.resetOnEnd && (e.restart(), e.pause());
                }), X.call(e, e.media, "progress playing seeking seeked", (t)=>Pe.updateProgress.call(e, t)), X.call(e, e.media, "volumechange", (t)=>Pe.updateVolume.call(e, t)), X.call(e, e.media, "playing play pause ended emptied timeupdate", (t)=>Fe.checkPlaying.call(e, t)), X.call(e, e.media, "waiting canplay seeked playing", (t)=>Fe.checkLoading.call(e, t)), e.supported.ui && e.config.clickToPlay && !e.isAudio) {
                    const i = B.call(e, `.${e.config.classNames.video}`);
                    if (!S.element(i)) return;
                    X.call(e, t.container, "click", (s)=>{
                        ([
                            t.container,
                            i
                        ].includes(s.target) || i.contains(s.target)) && (e.touch && e.config.hideControls || (e.ended ? (this.proxy(s, e.restart, "restart"), this.proxy(s, ()=>{
                            ie(e.play());
                        }, "play")) : this.proxy(s, ()=>{
                            ie(e.togglePlay());
                        }, "play")));
                    });
                }
                e.supported.ui && e.config.disableContextMenu && X.call(e, t.wrapper, "contextmenu", (e)=>{
                    e.preventDefault();
                }, !1), X.call(e, e.media, "volumechange", ()=>{
                    e.storage.set({
                        volume: e.volume,
                        muted: e.muted
                    });
                }), X.call(e, e.media, "ratechange", ()=>{
                    Pe.updateSetting.call(e, "speed"), e.storage.set({
                        speed: e.speed
                    });
                }), X.call(e, e.media, "qualitychange", (t)=>{
                    Pe.updateSetting.call(e, "quality", null, t.detail.quality);
                }), X.call(e, e.media, "ready qualitychange", ()=>{
                    Pe.setDownloadUrl.call(e);
                });
                const i = e.config.events.concat([
                    "keyup",
                    "keydown"
                ]).join(" ");
                X.call(e, e.media, i, (i)=>{
                    let { detail: s = {} } = i;
                    "error" === i.type && (s = e.media.error), Z.call(e, t.container, i.type, !0, s);
                });
            }), e(this, "proxy", (e, t, i)=>{
                const { player: s } = this, n = s.config.listeners[i];
                let a = !0;
                S.function(n) && (a = n.call(s, e)), !1 !== a && S.function(t) && t.call(s, e);
            }), e(this, "bind", (e, t, i, s, n = !0)=>{
                const { player: a } = this, l = a.config.listeners[s], r = S.function(l);
                X.call(a, e, t, (e)=>this.proxy(e, i, s), n && !r);
            }), e(this, "controls", ()=>{
                const { player: e } = this, { elements: t } = e, i = M.isIE ? "change" : "input";
                if (t.buttons.play && Array.from(t.buttons.play).forEach((t)=>{
                    this.bind(t, "click", ()=>{
                        ie(e.togglePlay());
                    }, "play");
                }), this.bind(t.buttons.restart, "click", e.restart, "restart"), this.bind(t.buttons.rewind, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.rewind();
                }, "rewind"), this.bind(t.buttons.fastForward, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.forward();
                }, "fastForward"), this.bind(t.buttons.mute, "click", ()=>{
                    e.muted = !e.muted;
                }, "mute"), this.bind(t.buttons.captions, "click", ()=>e.toggleCaptions()), this.bind(t.buttons.download, "click", ()=>{
                    Z.call(e, e.media, "download");
                }, "download"), this.bind(t.buttons.fullscreen, "click", ()=>{
                    e.fullscreen.toggle();
                }, "fullscreen"), this.bind(t.buttons.pip, "click", ()=>{
                    e.pip = "toggle";
                }, "pip"), this.bind(t.buttons.airplay, "click", e.airplay, "airplay"), this.bind(t.buttons.settings, "click", (t)=>{
                    t.stopPropagation(), t.preventDefault(), Pe.toggleMenu.call(e, t);
                }, null, !1), this.bind(t.buttons.settings, "keyup", (t)=>{
                    [
                        " ",
                        "Enter"
                    ].includes(t.key) && ("Enter" !== t.key ? (t.preventDefault(), t.stopPropagation(), Pe.toggleMenu.call(e, t)) : Pe.focusFirstMenuItem.call(e, null, !0));
                }, null, !1), this.bind(t.settings.menu, "keydown", (t)=>{
                    "Escape" === t.key && Pe.toggleMenu.call(e, t);
                }), this.bind(t.inputs.seek, "mousedown mousemove", (e)=>{
                    const i = t.progress.getBoundingClientRect(), s = 100 / i.width * (e.pageX - i.left);
                    e.currentTarget.setAttribute("seek-value", s);
                }), this.bind(t.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", (t)=>{
                    const i = t.currentTarget, s = "play-on-seeked";
                    if (S.keyboardEvent(t) && ![
                        "ArrowLeft",
                        "ArrowRight"
                    ].includes(t.key)) return;
                    e.lastSeekTime = Date.now();
                    const n = i.hasAttribute(s), a = [
                        "mouseup",
                        "touchend",
                        "keyup"
                    ].includes(t.type);
                    n && a ? (i.removeAttribute(s), ie(e.play())) : !a && e.playing && (i.setAttribute(s, ""), e.pause());
                }), M.isIos) {
                    const t = U.call(e, 'input[type="range"]');
                    Array.from(t).forEach((e)=>this.bind(e, i, (e)=>P(e.target)));
                }
                this.bind(t.inputs.seek, i, (t)=>{
                    const i = t.currentTarget;
                    let s = i.getAttribute("seek-value");
                    S.empty(s) && (s = i.value), i.removeAttribute("seek-value"), e.currentTime = s / i.max * e.duration;
                }, "seek"), this.bind(t.progress, "mouseenter mouseleave mousemove", (t)=>Pe.updateSeekTooltip.call(e, t)), this.bind(t.progress, "mousemove touchmove", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.startMove(t);
                }), this.bind(t.progress, "mouseleave touchend click", ()=>{
                    const { previewThumbnails: t } = e;
                    t && t.loaded && t.endMove(!1, !0);
                }), this.bind(t.progress, "mousedown touchstart", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.startScrubbing(t);
                }), this.bind(t.progress, "mouseup touchend", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.endScrubbing(t);
                }), M.isWebKit && Array.from(U.call(e, 'input[type="range"]')).forEach((t)=>{
                    this.bind(t, "input", (t)=>Pe.updateRangeFill.call(e, t.target));
                }), e.config.toggleInvert && !S.element(t.display.duration) && this.bind(t.display.currentTime, "click", ()=>{
                    0 !== e.currentTime && (e.config.invertTime = !e.config.invertTime, Pe.timeUpdate.call(e));
                }), this.bind(t.inputs.volume, i, (t)=>{
                    e.volume = t.target.value;
                }, "volume"), this.bind(t.controls, "mouseenter mouseleave", (i)=>{
                    t.controls.hover = !e.touch && "mouseenter" === i.type;
                }), t.fullscreen && Array.from(t.fullscreen.children).filter((e)=>!e.contains(t.container)).forEach((i)=>{
                    this.bind(i, "mouseenter mouseleave", (i)=>{
                        t.controls && (t.controls.hover = !e.touch && "mouseenter" === i.type);
                    });
                }), this.bind(t.controls, "mousedown mouseup touchstart touchend touchcancel", (e)=>{
                    t.controls.pressed = [
                        "mousedown",
                        "touchstart"
                    ].includes(e.type);
                }), this.bind(t.controls, "focusin", ()=>{
                    const { config: i, timers: s } = e;
                    R(t.controls, i.classNames.noTransition, !0), Fe.toggleControls.call(e, !0), setTimeout(()=>{
                        R(t.controls, i.classNames.noTransition, !1);
                    }, 0);
                    const n = this.touch ? 3e3 : 4e3;
                    clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), n);
                }), this.bind(t.inputs.volume, "wheel", (t)=>{
                    const i = t.webkitDirectionInvertedFromDevice, [s, n] = [
                        t.deltaX,
                        -t.deltaY
                    ].map((e)=>i ? -e : e), a = Math.sign(Math.abs(s) > Math.abs(n) ? s : n);
                    e.increaseVolume(a / 50);
                    const { volume: l } = e.media;
                    (1 === a && l < 1 || -1 === a && l > 0) && t.preventDefault();
                }, "volume", !1);
            }), this.player = t, this.lastKey = null, this.focusTimer = null, this.lastKeyDown = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.firstTouch = this.firstTouch.bind(this);
        }
        handleKey(e) {
            const { player: t } = this, { elements: i } = t, { key: s, type: n, altKey: a, ctrlKey: l, metaKey: r, shiftKey: o } = e, c = "keydown" === n, u = c && s === this.lastKey;
            if (a || l || r || o) return;
            if (!s) return;
            if (c) {
                const n = document.activeElement;
                if (S.element(n)) {
                    const { editable: s } = t.config.selectors, { seek: a } = i.inputs;
                    if (n !== a && V(n, s)) return;
                    if (" " === e.key && V(n, 'button, [role^="menuitem"]')) return;
                }
                switch([
                    " ",
                    "ArrowLeft",
                    "ArrowUp",
                    "ArrowRight",
                    "ArrowDown",
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "c",
                    "f",
                    "k",
                    "l",
                    "m"
                ].includes(s) && (e.preventDefault(), e.stopPropagation()), s){
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        u || (h = parseInt(s, 10), t.currentTime = t.duration / 10 * h);
                        break;
                    case " ":
                    case "k":
                        u || ie(t.togglePlay());
                        break;
                    case "ArrowUp":
                        t.increaseVolume(.1);
                        break;
                    case "ArrowDown":
                        t.decreaseVolume(.1);
                        break;
                    case "m":
                        u || (t.muted = !t.muted);
                        break;
                    case "ArrowRight":
                        t.forward();
                        break;
                    case "ArrowLeft":
                        t.rewind();
                        break;
                    case "f":
                        t.fullscreen.toggle();
                        break;
                    case "c":
                        u || t.toggleCaptions();
                        break;
                    case "l":
                        t.loop = !t.loop;
                }
                "Escape" === s && !t.fullscreen.usingNative && t.fullscreen.active && t.fullscreen.toggle(), this.lastKey = s;
            } else this.lastKey = null;
            var h;
        }
        toggleMenu(e) {
            Pe.toggleMenu.call(this.player, e);
        }
    }
    "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self && self;
    var Ue = function(e, t) {
        return e(t = {
            exports: {}
        }, t.exports), t.exports;
    }(function(e, t) {
        e.exports = function() {
            var e = function() {}, t = {}, i = {}, s = {};
            function n(e, t) {
                e = e.push ? e : [
                    e
                ];
                var n, a, l, r = [], o = e.length, c = o;
                for(n = function(e, i) {
                    i.length && r.push(e), --c || t(r);
                }; o--;)a = e[o], (l = i[a]) ? n(a, l) : (s[a] = s[a] || []).push(n);
            }
            function a(e, t) {
                if (e) {
                    var n = s[e];
                    if (i[e] = t, n) for(; n.length;)n[0](e, t), n.splice(0, 1);
                }
            }
            function l(t, i) {
                t.call && (t = {
                    success: t
                }), i.length ? (t.error || e)(i) : (t.success || e)(t);
            }
            function r(t, i, s, n) {
                var a, l, o = document, c = s.async, u = (s.numRetries || 0) + 1, h = s.before || e, d = t.replace(/[\?|#].*$/, ""), m = t.replace(/^(css|img)!/, "");
                n = n || 0, /(^css!|\.css$)/.test(d) ? ((l = o.createElement("link")).rel = "stylesheet", l.href = m, (a = "hideFocus" in l) && l.relList && (a = 0, l.rel = "preload", l.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d) ? (l = o.createElement("img")).src = m : ((l = o.createElement("script")).src = t, l.async = void 0 === c || c), l.onload = l.onerror = l.onbeforeload = function(e) {
                    var o = e.type[0];
                    if (a) try {
                        l.sheet.cssText.length || (o = "e");
                    } catch (e) {
                        18 != e.code && (o = "e");
                    }
                    if ("e" == o) {
                        if ((n += 1) < u) return r(t, i, s, n);
                    } else if ("preload" == l.rel && "style" == l.as) return l.rel = "stylesheet";
                    i(t, o, e.defaultPrevented);
                }, !1 !== h(t, l) && o.head.appendChild(l);
            }
            function o(e, t, i) {
                var s, n, a = (e = e.push ? e : [
                    e
                ]).length, l = a, o = [];
                for(s = function(e, i, s) {
                    if ("e" == i && o.push(e), "b" == i) {
                        if (!s) return;
                        o.push(e);
                    }
                    --a || t(o);
                }, n = 0; n < l; n++)r(e[n], s, i);
            }
            function c(e, i, s) {
                var n, r;
                if (i && i.trim && (n = i), r = (n ? s : i) || {}, n) {
                    if (n in t) throw "LoadJS";
                    t[n] = !0;
                }
                function c(t, i) {
                    o(e, function(e) {
                        l(r, e), t && l({
                            success: t,
                            error: i
                        }, e), a(n, e);
                    }, r);
                }
                if (r.returnPromise) return new Promise(c);
                c();
            }
            return c.ready = function(e, t) {
                return n(e, function(e) {
                    l(t, e);
                }), c;
            }, c.done = function(e) {
                a(e, []);
            }, c.reset = function() {
                t = {}, i = {}, s = {};
            }, c.isDefined = function(e) {
                return e in t;
            }, c;
        }();
    });
    function Be(e) {
        return new Promise((t, i)=>{
            Ue(e, {
                success: t,
                error: i
            });
        });
    }
    function We(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    const ze = {
        setup () {
            const e = this;
            R(e.elements.wrapper, e.config.classNames.embed, !0), e.options.speed = e.config.speed.options, ue.call(e), S.object(window.Vimeo) ? ze.ready.call(e) : Be(e.config.urls.vimeo.sdk).then(()=>{
                ze.ready.call(e);
            }).catch((t)=>{
                e.debug.warn("Vimeo SDK (player.js) failed to load", t);
            });
        },
        ready () {
            const e = this, t = e.config.vimeo, { premium: i, referrerPolicy: s, ...n } = t;
            let a = e.media.getAttribute("src"), l = "";
            S.empty(a) ? (a = e.media.getAttribute(e.config.attributes.embed.id), l = e.media.getAttribute(e.config.attributes.embed.hash)) : l = function(e) {
                const t = e.match(/^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/);
                return t && 5 === t.length ? t[4] : null;
            }(a);
            const r = l ? {
                h: l
            } : {};
            i && Object.assign(n, {
                controls: !1,
                sidedock: !1
            });
            const o = Ne({
                loop: e.config.loop.active,
                autoplay: e.autoplay,
                muted: e.muted,
                gesture: "media",
                playsinline: e.config.playsinline,
                ...r,
                ...n
            }), c = (u = a, S.empty(u) ? null : S.number(Number(u)) ? u : u.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : u);
            var u;
            const h = $("iframe"), d = me(e.config.urls.vimeo.iframe, c, o);
            if (h.setAttribute("src", d), h.setAttribute("allowfullscreen", ""), h.setAttribute("allow", [
                "autoplay",
                "fullscreen",
                "picture-in-picture",
                "encrypted-media",
                "accelerometer",
                "gyroscope"
            ].join("; ")), S.empty(s) || h.setAttribute("referrerPolicy", s), i || !t.customControls) h.setAttribute("data-poster", e.poster), e.media = q(h, e.media);
            else {
                const t = $("div", {
                    class: e.config.classNames.embedContainer,
                    "data-poster": e.poster
                });
                t.appendChild(h), e.media = q(t, e.media);
            }
            t.customControls || Te(me(e.config.urls.vimeo.api, d)).then((t)=>{
                !S.empty(t) && t.thumbnail_url && Fe.setPoster.call(e, t.thumbnail_url).catch(()=>{});
            }), e.embed = new window.Vimeo.Player(h, {
                autopause: e.config.autopause,
                muted: e.muted
            }), e.media.paused = !0, e.media.currentTime = 0, e.supported.ui && e.embed.disableTextTrack(), e.media.play = ()=>(We.call(e, !0), e.embed.play()), e.media.pause = ()=>(We.call(e, !1), e.embed.pause()), e.media.stop = ()=>{
                e.pause(), e.currentTime = 0;
            };
            let { currentTime: m } = e.media;
            Object.defineProperty(e.media, "currentTime", {
                get: ()=>m,
                set (t) {
                    const { embed: i, media: s, paused: n, volume: a } = e, l = n && !i.hasPlayed;
                    s.seeking = !0, Z.call(e, s, "seeking"), Promise.resolve(l && i.setVolume(0)).then(()=>i.setCurrentTime(t)).then(()=>l && i.pause()).then(()=>l && i.setVolume(a)).catch(()=>{});
                }
            });
            let p = e.config.speed.selected;
            Object.defineProperty(e.media, "playbackRate", {
                get: ()=>p,
                set (t) {
                    e.embed.setPlaybackRate(t).then(()=>{
                        p = t, Z.call(e, e.media, "ratechange");
                    }).catch(()=>{
                        e.options.speed = [
                            1
                        ];
                    });
                }
            });
            let { volume: g } = e.config;
            Object.defineProperty(e.media, "volume", {
                get: ()=>g,
                set (t) {
                    e.embed.setVolume(t).then(()=>{
                        g = t, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let { muted: f } = e.config;
            Object.defineProperty(e.media, "muted", {
                get: ()=>f,
                set (t) {
                    const i = !!S.boolean(t) && t;
                    e.embed.setMuted(!!i || e.config.muted).then(()=>{
                        f = i, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let y, { loop: b } = e.config;
            Object.defineProperty(e.media, "loop", {
                get: ()=>b,
                set (t) {
                    const i = S.boolean(t) ? t : e.config.loop.active;
                    e.embed.setLoop(i).then(()=>{
                        b = i;
                    });
                }
            }), e.embed.getVideoUrl().then((t)=>{
                y = t, Pe.setDownloadUrl.call(e);
            }).catch((e)=>{
                this.debug.warn(e);
            }), Object.defineProperty(e.media, "currentSrc", {
                get: ()=>y
            }), Object.defineProperty(e.media, "ended", {
                get: ()=>e.currentTime === e.duration
            }), Promise.all([
                e.embed.getVideoWidth(),
                e.embed.getVideoHeight()
            ]).then((t)=>{
                const [i, s] = t;
                e.embed.ratio = he(i, s), ue.call(this);
            }), e.embed.setAutopause(e.config.autopause).then((t)=>{
                e.config.autopause = t;
            }), e.embed.getVideoTitle().then((t)=>{
                e.config.title = t, Fe.setTitle.call(this);
            }), e.embed.getCurrentTime().then((t)=>{
                m = t, Z.call(e, e.media, "timeupdate");
            }), e.embed.getDuration().then((t)=>{
                e.media.duration = t, Z.call(e, e.media, "durationchange");
            }), e.embed.getTextTracks().then((t)=>{
                e.media.textTracks = t, xe.setup.call(e);
            }), e.embed.on("cuechange", ({ cues: t = [] })=>{
                const i = t.map((e)=>(function(e) {
                        const t = document.createDocumentFragment(), i = document.createElement("div");
                        return t.appendChild(i), i.innerHTML = e, t.firstChild.innerText;
                    })(e.text));
                xe.updateCues.call(e, i);
            }), e.embed.on("loaded", ()=>{
                if (e.embed.getPaused().then((t)=>{
                    We.call(e, !t), t || Z.call(e, e.media, "playing");
                }), S.element(e.embed.element) && e.supported.ui) e.embed.element.setAttribute("tabindex", -1);
            }), e.embed.on("bufferstart", ()=>{
                Z.call(e, e.media, "waiting");
            }), e.embed.on("bufferend", ()=>{
                Z.call(e, e.media, "playing");
            }), e.embed.on("play", ()=>{
                We.call(e, !0), Z.call(e, e.media, "playing");
            }), e.embed.on("pause", ()=>{
                We.call(e, !1);
            }), e.embed.on("timeupdate", (t)=>{
                e.media.seeking = !1, m = t.seconds, Z.call(e, e.media, "timeupdate");
            }), e.embed.on("progress", (t)=>{
                e.media.buffered = t.percent, Z.call(e, e.media, "progress"), 1 === parseInt(t.percent, 10) && Z.call(e, e.media, "canplaythrough"), e.embed.getDuration().then((t)=>{
                    t !== e.media.duration && (e.media.duration = t, Z.call(e, e.media, "durationchange"));
                });
            }), e.embed.on("seeked", ()=>{
                e.media.seeking = !1, Z.call(e, e.media, "seeked");
            }), e.embed.on("ended", ()=>{
                e.media.paused = !0, Z.call(e, e.media, "ended");
            }), e.embed.on("error", (t)=>{
                e.media.error = t, Z.call(e, e.media, "error");
            }), t.customControls && setTimeout(()=>Fe.build.call(e), 0);
        }
    };
    function Ke(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    function Ye(e) {
        return e.noCookie ? "https://www.youtube-nocookie.com" : "http:" === window.location.protocol ? "http://www.youtube.com" : void 0;
    }
    const Qe = {
        setup () {
            if (R(this.elements.wrapper, this.config.classNames.embed, !0), S.object(window.YT) && S.function(window.YT.Player)) Qe.ready.call(this);
            else {
                const e = window.onYouTubeIframeAPIReady;
                window.onYouTubeIframeAPIReady = ()=>{
                    S.function(e) && e(), Qe.ready.call(this);
                }, Be(this.config.urls.youtube.sdk).catch((e)=>{
                    this.debug.warn("YouTube API failed to load", e);
                });
            }
        },
        getTitle (e) {
            Te(me(this.config.urls.youtube.api, e)).then((e)=>{
                if (S.object(e)) {
                    const { title: t, height: i, width: s } = e;
                    this.config.title = t, Fe.setTitle.call(this), this.embed.ratio = he(s, i);
                }
                ue.call(this);
            }).catch(()=>{
                ue.call(this);
            });
        },
        ready () {
            const e = this, t = e.config.youtube, i = e.media && e.media.getAttribute("id");
            if (!S.empty(i) && i.startsWith("youtube-")) return;
            let s = e.media.getAttribute("src");
            S.empty(s) && (s = e.media.getAttribute(this.config.attributes.embed.id));
            const n = (a = s, S.empty(a) ? null : a.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : a);
            var a;
            const l = $("div", {
                id: `${e.provider}-${Math.floor(1e4 * Math.random())}`,
                "data-poster": t.customControls ? e.poster : void 0
            });
            if (e.media = q(l, e.media), t.customControls) {
                const t = (e)=>`https://i.ytimg.com/vi/${n}/${e}default.jpg`;
                Re(t("maxres"), 121).catch(()=>Re(t("sd"), 121)).catch(()=>Re(t("hq"))).then((t)=>Fe.setPoster.call(e, t.src)).then((t)=>{
                    t.includes("maxres") || (e.elements.poster.style.backgroundSize = "cover");
                }).catch(()=>{});
            }
            e.embed = new window.YT.Player(e.media, {
                videoId: n,
                host: Ye(t),
                playerVars: x({}, {
                    autoplay: e.config.autoplay ? 1 : 0,
                    hl: e.config.hl,
                    controls: e.supported.ui && t.customControls ? 0 : 1,
                    disablekb: 1,
                    playsinline: e.config.playsinline && !e.config.fullscreen.iosNative ? 1 : 0,
                    cc_load_policy: e.captions.active ? 1 : 0,
                    cc_lang_pref: e.config.captions.language,
                    widget_referrer: window ? window.location.href : null
                }, t),
                events: {
                    onError (t) {
                        if (!e.media.error) {
                            const i = t.data, s = {
                                2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                                5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                                100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                                101: "The owner of the requested video does not allow it to be played in embedded players.",
                                150: "The owner of the requested video does not allow it to be played in embedded players."
                            }[i] || "An unknown error occurred";
                            e.media.error = {
                                code: i,
                                message: s
                            }, Z.call(e, e.media, "error");
                        }
                    },
                    onPlaybackRateChange (t) {
                        const i = t.target;
                        e.media.playbackRate = i.getPlaybackRate(), Z.call(e, e.media, "ratechange");
                    },
                    onReady (i) {
                        if (S.function(e.media.play)) return;
                        const s = i.target;
                        Qe.getTitle.call(e, n), e.media.play = ()=>{
                            Ke.call(e, !0), s.playVideo();
                        }, e.media.pause = ()=>{
                            Ke.call(e, !1), s.pauseVideo();
                        }, e.media.stop = ()=>{
                            s.stopVideo();
                        }, e.media.duration = s.getDuration(), e.media.paused = !0, e.media.currentTime = 0, Object.defineProperty(e.media, "currentTime", {
                            get: ()=>Number(s.getCurrentTime()),
                            set (t) {
                                e.paused && !e.embed.hasPlayed && e.embed.mute(), e.media.seeking = !0, Z.call(e, e.media, "seeking"), s.seekTo(t);
                            }
                        }), Object.defineProperty(e.media, "playbackRate", {
                            get: ()=>s.getPlaybackRate(),
                            set (e) {
                                s.setPlaybackRate(e);
                            }
                        });
                        let { volume: a } = e.config;
                        Object.defineProperty(e.media, "volume", {
                            get: ()=>a,
                            set (t) {
                                a = t, s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        });
                        let { muted: l } = e.config;
                        Object.defineProperty(e.media, "muted", {
                            get: ()=>l,
                            set (t) {
                                const i = S.boolean(t) ? t : l;
                                l = i, s[i ? "mute" : "unMute"](), s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        }), Object.defineProperty(e.media, "currentSrc", {
                            get: ()=>s.getVideoUrl()
                        }), Object.defineProperty(e.media, "ended", {
                            get: ()=>e.currentTime === e.duration
                        });
                        const r = s.getAvailablePlaybackRates();
                        e.options.speed = r.filter((t)=>e.config.speed.options.includes(t)), e.supported.ui && t.customControls && e.media.setAttribute("tabindex", -1), Z.call(e, e.media, "timeupdate"), Z.call(e, e.media, "durationchange"), clearInterval(e.timers.buffering), e.timers.buffering = setInterval(()=>{
                            e.media.buffered = s.getVideoLoadedFraction(), (null === e.media.lastBuffered || e.media.lastBuffered < e.media.buffered) && Z.call(e, e.media, "progress"), e.media.lastBuffered = e.media.buffered, 1 === e.media.buffered && (clearInterval(e.timers.buffering), Z.call(e, e.media, "canplaythrough"));
                        }, 200), t.customControls && setTimeout(()=>Fe.build.call(e), 50);
                    },
                    onStateChange (i) {
                        const s = i.target;
                        clearInterval(e.timers.playing);
                        switch(e.media.seeking && [
                            1,
                            2
                        ].includes(i.data) && (e.media.seeking = !1, Z.call(e, e.media, "seeked")), i.data){
                            case -1:
                                Z.call(e, e.media, "timeupdate"), e.media.buffered = s.getVideoLoadedFraction(), Z.call(e, e.media, "progress");
                                break;
                            case 0:
                                Ke.call(e, !1), e.media.loop ? (s.stopVideo(), s.playVideo()) : Z.call(e, e.media, "ended");
                                break;
                            case 1:
                                t.customControls && !e.config.autoplay && e.media.paused && !e.embed.hasPlayed ? e.media.pause() : (Ke.call(e, !0), Z.call(e, e.media, "playing"), e.timers.playing = setInterval(()=>{
                                    Z.call(e, e.media, "timeupdate");
                                }, 50), e.media.duration !== s.getDuration() && (e.media.duration = s.getDuration(), Z.call(e, e.media, "durationchange")));
                                break;
                            case 2:
                                e.muted || e.embed.unMute(), Ke.call(e, !1);
                                break;
                            case 3:
                                Z.call(e, e.media, "waiting");
                        }
                        Z.call(e, e.elements.container, "statechange", !1, {
                            code: i.data
                        });
                    }
                }
            });
        }
    }, Xe = {
        setup () {
            this.media ? (R(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0), R(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0), this.isEmbed && R(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0), this.isVideo && (this.elements.wrapper = $("div", {
                class: this.config.classNames.video
            }), L(this.media, this.elements.wrapper), this.elements.poster = $("div", {
                class: this.config.classNames.poster
            }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? de.setup.call(this) : this.isYouTube ? Qe.setup.call(this) : this.isVimeo && ze.setup.call(this)) : this.debug.warn("No media element found!");
        }
    };
    class Je {
        constructor(t){
            e(this, "load", ()=>{
                this.enabled && (S.object(window.google) && S.object(window.google.ima) ? this.ready() : Be(this.player.config.urls.googleIMA.sdk).then(()=>{
                    this.ready();
                }).catch(()=>{
                    this.trigger("error", new Error("Google IMA SDK failed to load"));
                }));
            }), e(this, "ready", ()=>{
                var e;
                this.enabled || ((e = this).manager && e.manager.destroy(), e.elements.displayContainer && e.elements.displayContainer.destroy(), e.elements.container.remove()), this.startSafetyTimer(12e3, "ready()"), this.managerPromise.then(()=>{
                    this.clearSafetyTimer("onAdsManagerLoaded()");
                }), this.listeners(), this.setupIMA();
            }), e(this, "setupIMA", ()=>{
                this.elements.container = $("div", {
                    class: this.player.config.classNames.ads
                }), this.player.elements.container.appendChild(this.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(this.player.config.ads.language), google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline), this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media), this.loader = new google.ima.AdsLoader(this.elements.displayContainer), this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (e)=>this.onAdsManagerLoaded(e), !1), this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e), !1), this.requestAds();
            }), e(this, "requestAds", ()=>{
                const { container: e } = this.player.elements;
                try {
                    const t = new google.ima.AdsRequest;
                    t.adTagUrl = this.tagUrl, t.linearAdSlotWidth = e.offsetWidth, t.linearAdSlotHeight = e.offsetHeight, t.nonLinearAdSlotWidth = e.offsetWidth, t.nonLinearAdSlotHeight = e.offsetHeight, t.forceNonLinearFullSlot = !1, t.setAdWillPlayMuted(!this.player.muted), this.loader.requestAds(t);
                } catch (e) {
                    this.onAdError(e);
                }
            }), e(this, "pollCountdown", (e = !1)=>{
                if (!e) return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
                this.countdownTimer = setInterval(()=>{
                    const e = Ee(Math.max(this.manager.getRemainingTime(), 0)), t = `${ve.get("advertisement", this.player.config)} - ${e}`;
                    this.elements.container.setAttribute("data-badge-text", t);
                }, 100);
            }), e(this, "onAdsManagerLoaded", (e)=>{
                if (!this.enabled) return;
                const t = new google.ima.AdsRenderingSettings;
                t.restoreCustomPlaybackStateOnAdBreakComplete = !0, t.enablePreloading = !0, this.manager = e.getAdsManager(this.player, t), this.cuePoints = this.manager.getCuePoints(), this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e)), Object.keys(google.ima.AdEvent.Type).forEach((e)=>{
                    this.manager.addEventListener(google.ima.AdEvent.Type[e], (e)=>this.onAdEvent(e));
                }), this.trigger("loaded");
            }), e(this, "addCuePoints", ()=>{
                S.empty(this.cuePoints) || this.cuePoints.forEach((e)=>{
                    if (0 !== e && -1 !== e && e < this.player.duration) {
                        const t = this.player.elements.progress;
                        if (S.element(t)) {
                            const i = 100 / this.player.duration * e, s = $("span", {
                                class: this.player.config.classNames.cues
                            });
                            s.style.left = `${i.toString()}%`, t.appendChild(s);
                        }
                    }
                });
            }), e(this, "onAdEvent", (e)=>{
                const { container: t } = this.player.elements, i = e.getAd(), s = e.getAdData();
                switch(((e)=>{
                    Z.call(this.player, this.player.media, `ads${e.replace(/_/g, "").toLowerCase()}`);
                })(e.type), e.type){
                    case google.ima.AdEvent.Type.LOADED:
                        this.trigger("loaded"), this.pollCountdown(!0), i.isLinear() || (i.width = t.offsetWidth, i.height = t.offsetHeight);
                        break;
                    case google.ima.AdEvent.Type.STARTED:
                        this.manager.setVolume(this.player.volume);
                        break;
                    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                        this.player.ended ? this.loadAds() : this.loader.contentComplete();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                        this.pauseContent();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                        this.pollCountdown(), this.resumeContent();
                        break;
                    case google.ima.AdEvent.Type.LOG:
                        s.adError && this.player.debug.warn(`Non-fatal ad error: ${s.adError.getMessage()}`);
                }
            }), e(this, "onAdError", (e)=>{
                this.cancel(), this.player.debug.warn("Ads error", e);
            }), e(this, "listeners", ()=>{
                const { container: e } = this.player.elements;
                let t;
                this.player.on("canplay", ()=>{
                    this.addCuePoints();
                }), this.player.on("ended", ()=>{
                    this.loader.contentComplete();
                }), this.player.on("timeupdate", ()=>{
                    t = this.player.currentTime;
                }), this.player.on("seeked", ()=>{
                    const e = this.player.currentTime;
                    S.empty(this.cuePoints) || this.cuePoints.forEach((i, s)=>{
                        t < i && i < e && (this.manager.discardAdBreak(), this.cuePoints.splice(s, 1));
                    });
                }), window.addEventListener("resize", ()=>{
                    this.manager && this.manager.resize(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL);
                });
            }), e(this, "play", ()=>{
                const { container: e } = this.player.elements;
                this.managerPromise || this.resumeContent(), this.managerPromise.then(()=>{
                    this.manager.setVolume(this.player.volume), this.elements.displayContainer.initialize();
                    try {
                        this.initialized || (this.manager.init(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL), this.manager.start()), this.initialized = !0;
                    } catch (e) {
                        this.onAdError(e);
                    }
                }).catch(()=>{});
            }), e(this, "resumeContent", ()=>{
                this.elements.container.style.zIndex = "", this.playing = !1, ie(this.player.media.play());
            }), e(this, "pauseContent", ()=>{
                this.elements.container.style.zIndex = 3, this.playing = !0, this.player.media.pause();
            }), e(this, "cancel", ()=>{
                this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds();
            }), e(this, "loadAds", ()=>{
                this.managerPromise.then(()=>{
                    this.manager && this.manager.destroy(), this.managerPromise = new Promise((e)=>{
                        this.on("loaded", e), this.player.debug.log(this.manager);
                    }), this.initialized = !1, this.requestAds();
                }).catch(()=>{});
            }), e(this, "trigger", (e, ...t)=>{
                const i = this.events[e];
                S.array(i) && i.forEach((e)=>{
                    S.function(e) && e.apply(this, t);
                });
            }), e(this, "on", (e, t)=>(S.array(this.events[e]) || (this.events[e] = []), this.events[e].push(t), this)), e(this, "startSafetyTimer", (e, t)=>{
                this.player.debug.log(`Safety timer invoked from: ${t}`), this.safetyTimer = setTimeout(()=>{
                    this.cancel(), this.clearSafetyTimer("startSafetyTimer()");
                }, e);
            }), e(this, "clearSafetyTimer", (e)=>{
                S.nullOrUndefined(this.safetyTimer) || (this.player.debug.log(`Safety timer cleared from: ${e}`), clearTimeout(this.safetyTimer), this.safetyTimer = null);
            }), this.player = t, this.config = t.config.ads, this.playing = !1, this.initialized = !1, this.elements = {
                container: null,
                displayContainer: null
            }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise((e, t)=>{
                this.on("loaded", e), this.on("error", t);
            }), this.load();
        }
        get enabled() {
            const { config: e } = this;
            return this.player.isHTML5 && this.player.isVideo && e.enabled && (!S.empty(e.publisherId) || S.url(e.tagUrl));
        }
        get tagUrl() {
            const { config: e } = this;
            if (S.url(e.tagUrl)) return e.tagUrl;
            return `https://go.aniview.com/api/adserver6/vast/?${Ne({
                AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                AV_CHANNELID: "5a0458dc28a06145e4519d21",
                AV_URL: window.location.hostname,
                cb: Date.now(),
                AV_WIDTH: 640,
                AV_HEIGHT: 480,
                AV_CDIM2: e.publisherId
            })}`;
        }
    }
    function Ge(e = 0, t = 0, i = 255) {
        return Math.min(Math.max(e, t), i);
    }
    const Ze = (e)=>{
        const t = [];
        return e.split(/\r\n\r\n|\n\n|\r\r/).forEach((e)=>{
            const i = {};
            e.split(/\r\n|\n|\r/).forEach((e)=>{
                if (S.number(i.startTime)) {
                    if (!S.empty(e.trim()) && S.empty(i.text)) {
                        const t = e.trim().split("#xywh=");
                        [i.text] = t, t[1] && ([i.x, i.y, i.w, i.h] = t[1].split(","));
                    }
                } else {
                    const t = e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
                    t && (i.startTime = 60 * Number(t[1] || 0) * 60 + 60 * Number(t[2]) + Number(t[3]) + Number(`0.${t[4]}`), i.endTime = 60 * Number(t[6] || 0) * 60 + 60 * Number(t[7]) + Number(t[8]) + Number(`0.${t[9]}`));
                }
            }), i.text && t.push(i);
        }), t;
    }, et = (e, t)=>{
        const i = {};
        return e > t.width / t.height ? (i.width = t.width, i.height = 1 / e * t.width) : (i.height = t.height, i.width = e * t.height), i;
    };
    class tt {
        constructor(t){
            e(this, "load", ()=>{
                this.player.elements.display.seekTooltip && (this.player.elements.display.seekTooltip.hidden = this.enabled), this.enabled && this.getThumbnails().then(()=>{
                    this.enabled && (this.render(), this.determineContainerAutoSizing(), this.listeners(), this.loaded = !0);
                });
            }), e(this, "getThumbnails", ()=>new Promise((e)=>{
                    const { src: t } = this.player.config.previewThumbnails;
                    if (S.empty(t)) throw new Error("Missing previewThumbnails.src config attribute");
                    const i = ()=>{
                        this.thumbnails.sort((e, t)=>e.height - t.height), this.player.debug.log("Preview thumbnails", this.thumbnails), e();
                    };
                    if (S.function(t)) t((e)=>{
                        this.thumbnails = e, i();
                    });
                    else {
                        const e = (S.string(t) ? [
                            t
                        ] : t).map((e)=>this.getThumbnail(e));
                        Promise.all(e).then(i);
                    }
                })), e(this, "getThumbnail", (e)=>new Promise((t)=>{
                    Te(e).then((i)=>{
                        const s = {
                            frames: Ze(i),
                            height: null,
                            urlPrefix: ""
                        };
                        s.frames[0].text.startsWith("/") || s.frames[0].text.startsWith("http://") || s.frames[0].text.startsWith("https://") || (s.urlPrefix = e.substring(0, e.lastIndexOf("/") + 1));
                        const n = new Image;
                        n.onload = ()=>{
                            s.height = n.naturalHeight, s.width = n.naturalWidth, this.thumbnails.push(s), t();
                        }, n.src = s.urlPrefix + s.frames[0].text;
                    });
                })), e(this, "startMove", (e)=>{
                if (this.loaded && S.event(e) && [
                    "touchmove",
                    "mousemove"
                ].includes(e.type) && this.player.media.duration) {
                    if ("touchmove" === e.type) this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                    else {
                        var t, i;
                        const s = this.player.elements.progress.getBoundingClientRect(), n = 100 / s.width * (e.pageX - s.left);
                        this.seekTime = this.player.media.duration * (n / 100), this.seekTime < 0 && (this.seekTime = 0), this.seekTime > this.player.media.duration - 1 && (this.seekTime = this.player.media.duration - 1), this.mousePosX = e.pageX, this.elements.thumb.time.innerText = Ee(this.seekTime);
                        const a = null === (t = this.player.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e })=>e === Math.round(this.seekTime));
                        a && this.elements.thumb.time.insertAdjacentHTML("afterbegin", `${a.label}<br>`);
                    }
                    this.showImageAtCurrentTime();
                }
            }), e(this, "endMove", ()=>{
                this.toggleThumbContainer(!1, !0);
            }), e(this, "startScrubbing", (e)=>{
                (S.nullOrUndefined(e.button) || !1 === e.button || 0 === e.button) && (this.mouseDown = !0, this.player.media.duration && (this.toggleScrubbingContainer(!0), this.toggleThumbContainer(!1, !0), this.showImageAtCurrentTime()));
            }), e(this, "endScrubbing", ()=>{
                this.mouseDown = !1, Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime) ? this.toggleScrubbingContainer(!1) : G.call(this.player, this.player.media, "timeupdate", ()=>{
                    this.mouseDown || this.toggleScrubbingContainer(!1);
                });
            }), e(this, "listeners", ()=>{
                this.player.on("play", ()=>{
                    this.toggleThumbContainer(!1, !0);
                }), this.player.on("seeked", ()=>{
                    this.toggleThumbContainer(!1);
                }), this.player.on("timeupdate", ()=>{
                    this.lastTime = this.player.media.currentTime;
                });
            }), e(this, "render", ()=>{
                this.elements.thumb.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.thumbContainer
                }), this.elements.thumb.imageContainer = $("div", {
                    class: this.player.config.classNames.previewThumbnails.imageContainer
                }), this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
                const e = $("div", {
                    class: this.player.config.classNames.previewThumbnails.timeContainer
                });
                this.elements.thumb.time = $("span", {}, "00:00"), e.appendChild(this.elements.thumb.time), this.elements.thumb.imageContainer.appendChild(e), S.element(this.player.elements.progress) && this.player.elements.progress.appendChild(this.elements.thumb.container), this.elements.scrubbing.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.scrubbingContainer
                }), this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
            }), e(this, "destroy", ()=>{
                this.elements.thumb.container && this.elements.thumb.container.remove(), this.elements.scrubbing.container && this.elements.scrubbing.container.remove();
            }), e(this, "showImageAtCurrentTime", ()=>{
                this.mouseDown ? this.setScrubbingContainerSize() : this.setThumbContainerSizeAndPos();
                const e = this.thumbnails[0].frames.findIndex((e)=>this.seekTime >= e.startTime && this.seekTime <= e.endTime), t = e >= 0;
                let i = 0;
                this.mouseDown || this.toggleThumbContainer(t), t && (this.thumbnails.forEach((t, s)=>{
                    this.loadedImages.includes(t.frames[e].text) && (i = s);
                }), e !== this.showingThumb && (this.showingThumb = e, this.loadImage(i)));
            }), e(this, "loadImage", (e = 0)=>{
                const t = this.showingThumb, i = this.thumbnails[e], { urlPrefix: s } = i, n = i.frames[t], a = i.frames[t].text, l = s + a;
                if (this.currentImageElement && this.currentImageElement.dataset.filename === a) this.showImage(this.currentImageElement, n, e, t, a, !1), this.currentImageElement.dataset.index = t, this.removeOldImages(this.currentImageElement);
                else {
                    this.loadingImage && this.usingSprites && (this.loadingImage.onload = null);
                    const i = new Image;
                    i.src = l, i.dataset.index = t, i.dataset.filename = a, this.showingThumbFilename = a, this.player.debug.log(`Loading image: ${l}`), i.onload = ()=>this.showImage(i, n, e, t, a, !0), this.loadingImage = i, this.removeOldImages(i);
                }
            }), e(this, "showImage", (e, t, i, s, n, a = !0)=>{
                this.player.debug.log(`Showing thumb: ${n}. num: ${s}. qual: ${i}. newimg: ${a}`), this.setImageSizeAndOffset(e, t), a && (this.currentImageContainer.appendChild(e), this.currentImageElement = e, this.loadedImages.includes(n) || this.loadedImages.push(n)), this.preloadNearby(s, !0).then(this.preloadNearby(s, !1)).then(this.getHigherQuality(i, e, t, n));
            }), e(this, "removeOldImages", (e)=>{
                Array.from(this.currentImageContainer.children).forEach((t)=>{
                    if ("img" !== t.tagName.toLowerCase()) return;
                    const i = this.usingSprites ? 500 : 1e3;
                    if (t.dataset.index !== e.dataset.index && !t.dataset.deleting) {
                        t.dataset.deleting = !0;
                        const { currentImageContainer: e } = this;
                        setTimeout(()=>{
                            e.removeChild(t), this.player.debug.log(`Removing thumb: ${t.dataset.filename}`);
                        }, i);
                    }
                });
            }), e(this, "preloadNearby", (e, t = !0)=>new Promise((i)=>{
                    setTimeout(()=>{
                        const s = this.thumbnails[0].frames[e].text;
                        if (this.showingThumbFilename === s) {
                            let n;
                            n = t ? this.thumbnails[0].frames.slice(e) : this.thumbnails[0].frames.slice(0, e).reverse();
                            let a = !1;
                            n.forEach((e)=>{
                                const t = e.text;
                                if (t !== s && !this.loadedImages.includes(t)) {
                                    a = !0, this.player.debug.log(`Preloading thumb filename: ${t}`);
                                    const { urlPrefix: e } = this.thumbnails[0], s = e + t, n = new Image;
                                    n.src = s, n.onload = ()=>{
                                        this.player.debug.log(`Preloaded thumb filename: ${t}`), this.loadedImages.includes(t) || this.loadedImages.push(t), i();
                                    };
                                }
                            }), a || i();
                        }
                    }, 300);
                })), e(this, "getHigherQuality", (e, t, i, s)=>{
                if (e < this.thumbnails.length - 1) {
                    let n = t.naturalHeight;
                    this.usingSprites && (n = i.h), n < this.thumbContainerHeight && setTimeout(()=>{
                        this.showingThumbFilename === s && (this.player.debug.log(`Showing higher quality thumb for: ${s}`), this.loadImage(e + 1));
                    }, 300);
                }
            }), e(this, "toggleThumbContainer", (e = !1, t = !1)=>{
                const i = this.player.config.classNames.previewThumbnails.thumbContainerShown;
                this.elements.thumb.container.classList.toggle(i, e), !e && t && (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "toggleScrubbingContainer", (e = !1)=>{
                const t = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                this.elements.scrubbing.container.classList.toggle(t, e), e || (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "determineContainerAutoSizing", ()=>{
                (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) && (this.sizeSpecifiedInCSS = !0);
            }), e(this, "setThumbContainerSizeAndPos", ()=>{
                const { imageContainer: e } = this.elements.thumb;
                if (this.sizeSpecifiedInCSS) {
                    if (e.clientHeight > 20 && e.clientWidth < 20) {
                        const t = Math.floor(e.clientHeight * this.thumbAspectRatio);
                        e.style.width = `${t}px`;
                    } else if (e.clientHeight < 20 && e.clientWidth > 20) {
                        const t = Math.floor(e.clientWidth / this.thumbAspectRatio);
                        e.style.height = `${t}px`;
                    }
                } else {
                    const t = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                    e.style.height = `${this.thumbContainerHeight}px`, e.style.width = `${t}px`;
                }
                this.setThumbContainerPos();
            }), e(this, "setThumbContainerPos", ()=>{
                const e = this.player.elements.progress.getBoundingClientRect(), t = this.player.elements.container.getBoundingClientRect(), { container: i } = this.elements.thumb, s = t.left - e.left + 10, n = t.right - e.left - i.clientWidth - 10, a = this.mousePosX - e.left - i.clientWidth / 2, l = Ge(a, s, n);
                i.style.left = `${l}px`, i.style.setProperty("--preview-arrow-offset", a - l + "px");
            }), e(this, "setScrubbingContainerSize", ()=>{
                const { width: e, height: t } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                this.elements.scrubbing.container.style.width = `${e}px`, this.elements.scrubbing.container.style.height = `${t}px`;
            }), e(this, "setImageSizeAndOffset", (e, t)=>{
                if (!this.usingSprites) return;
                const i = this.thumbContainerHeight / t.h;
                e.style.height = e.naturalHeight * i + "px", e.style.width = e.naturalWidth * i + "px", e.style.left = `-${t.x * i}px`, e.style.top = `-${t.y * i}px`;
            }), this.player = t, this.thumbnails = [], this.loaded = !1, this.lastMouseMoveTime = Date.now(), this.mouseDown = !1, this.loadedImages = [], this.elements = {
                thumb: {},
                scrubbing: {}
            }, this.load();
        }
        get enabled() {
            return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
        }
        get currentImageContainer() {
            return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
        }
        get usingSprites() {
            return Object.keys(this.thumbnails[0].frames[0]).includes("w");
        }
        get thumbAspectRatio() {
            return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
        }
        get thumbContainerHeight() {
            if (this.mouseDown) {
                const { height: e } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                return e;
            }
            return this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
        }
        get currentImageElement() {
            return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
        }
        set currentImageElement(e) {
            this.mouseDown ? this.currentScrubbingImageElement = e : this.currentThumbnailImageElement = e;
        }
    }
    const it = {
        insertElements (e, t) {
            S.string(t) ? _(e, this.media, {
                src: t
            }) : S.array(t) && t.forEach((t)=>{
                _(e, this.media, t);
            });
        },
        change (e) {
            N(e, "sources.length") ? (de.cancelRequests.call(this), this.destroy.call(this, ()=>{
                this.options.quality = [], O(this.media), this.media = null, S.element(this.elements.container) && this.elements.container.removeAttribute("class");
                const { sources: t, type: i } = e, [{ provider: s = _e.html5, src: n }] = t, a = "html5" === s ? i : "div", l = "html5" === s ? {} : {
                    src: n
                };
                Object.assign(this, {
                    provider: s,
                    type: i,
                    supported: K.check(i, s, this.config.playsinline),
                    media: $(a, l)
                }), this.elements.container.appendChild(this.media), S.boolean(e.autoplay) && (this.config.autoplay = e.autoplay), this.isHTML5 && (this.config.crossorigin && this.media.setAttribute("crossorigin", ""), this.config.autoplay && this.media.setAttribute("autoplay", ""), S.empty(e.poster) || (this.poster = e.poster), this.config.loop.active && this.media.setAttribute("loop", ""), this.config.muted && this.media.setAttribute("muted", ""), this.config.playsinline && this.media.setAttribute("playsinline", "")), Fe.addStyleHook.call(this), this.isHTML5 && it.insertElements.call(this, "source", t), this.config.title = e.title, Xe.setup.call(this), this.isHTML5 && Object.keys(e).includes("tracks") && it.insertElements.call(this, "track", e.tracks), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.isHTML5 && this.media.load(), S.empty(e.previewThumbnails) || (Object.assign(this.config.previewThumbnails, e.previewThumbnails), this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))), this.fullscreen.update();
            }, !0)) : this.debug.warn("Invalid source format");
        }
    };
    class st {
        constructor(t, i){
            if (e(this, "play", ()=>S.function(this.media.play) ? (this.ads && this.ads.enabled && this.ads.managerPromise.then(()=>this.ads.play()).catch(()=>ie(this.media.play())), this.media.play()) : null), e(this, "pause", ()=>this.playing && S.function(this.media.pause) ? this.media.pause() : null), e(this, "togglePlay", (e)=>(S.boolean(e) ? e : !this.playing) ? this.play() : this.pause()), e(this, "stop", ()=>{
                this.isHTML5 ? (this.pause(), this.restart()) : S.function(this.media.stop) && this.media.stop();
            }), e(this, "restart", ()=>{
                this.currentTime = 0;
            }), e(this, "rewind", (e)=>{
                this.currentTime -= S.number(e) ? e : this.config.seekTime;
            }), e(this, "forward", (e)=>{
                this.currentTime += S.number(e) ? e : this.config.seekTime;
            }), e(this, "increaseVolume", (e)=>{
                const t = this.media.muted ? 0 : this.volume;
                this.volume = t + (S.number(e) ? e : 0);
            }), e(this, "decreaseVolume", (e)=>{
                this.increaseVolume(-e);
            }), e(this, "airplay", ()=>{
                K.airplay && this.media.webkitShowPlaybackTargetPicker();
            }), e(this, "toggleControls", (e)=>{
                if (this.supported.ui && !this.isAudio) {
                    const t = F(this.elements.container, this.config.classNames.hideControls), i = void 0 === e ? void 0 : !e, s = R(this.elements.container, this.config.classNames.hideControls, i);
                    if (s && S.array(this.config.controls) && this.config.controls.includes("settings") && !S.empty(this.config.settings) && Pe.toggleMenu.call(this, !1), s !== t) {
                        const e = s ? "controlshidden" : "controlsshown";
                        Z.call(this, this.media, e);
                    }
                    return !s;
                }
                return !1;
            }), e(this, "on", (e, t)=>{
                X.call(this, this.elements.container, e, t);
            }), e(this, "once", (e, t)=>{
                G.call(this, this.elements.container, e, t);
            }), e(this, "off", (e, t)=>{
                J(this.elements.container, e, t);
            }), e(this, "destroy", (e, t = !1)=>{
                if (!this.ready) return;
                const i = ()=>{
                    document.body.style.overflow = "", this.embed = null, t ? (Object.keys(this.elements).length && (O(this.elements.buttons.play), O(this.elements.captions), O(this.elements.controls), O(this.elements.wrapper), this.elements.buttons.play = null, this.elements.captions = null, this.elements.controls = null, this.elements.wrapper = null), S.function(e) && e()) : (ee.call(this), de.cancelRequests.call(this), q(this.elements.original, this.elements.container), Z.call(this, this.elements.original, "destroyed", !0), S.function(e) && e.call(this.elements.original), this.ready = !1, setTimeout(()=>{
                        this.elements = null, this.media = null;
                    }, 200));
                };
                this.stop(), clearTimeout(this.timers.loading), clearTimeout(this.timers.controls), clearTimeout(this.timers.resized), this.isHTML5 ? (Fe.toggleNativeControls.call(this, !0), i()) : this.isYouTube ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), null !== this.embed && S.function(this.embed.destroy) && this.embed.destroy(), i()) : this.isVimeo && (null !== this.embed && this.embed.unload().then(i), setTimeout(i, 200));
            }), e(this, "supports", (e)=>K.mime.call(this, e)), this.timers = {}, this.ready = !1, this.loading = !1, this.failed = !1, this.touch = K.touch, this.media = t, S.string(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || S.nodeList(this.media) || S.array(this.media)) && (this.media = this.media[0]), this.config = x({}, Le, st.defaults, i || {}, (()=>{
                try {
                    return JSON.parse(this.media.getAttribute("data-plyr-config"));
                } catch (e) {
                    return {};
                }
            })()), this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                    popup: null,
                    menu: null,
                    panels: {},
                    buttons: {}
                }
            }, this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap
            }, this.fullscreen = {
                active: !1
            }, this.options = {
                speed: [],
                quality: []
            }, this.debug = new De(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", K), S.nullOrUndefined(this.media) || !S.element(this.media)) return void this.debug.error("Setup failed: no suitable element passed");
            if (this.media.plyr) return void this.debug.warn("Target already setup");
            if (!this.config.enabled) return void this.debug.error("Setup failed: disabled by config");
            if (!K.check().api) return void this.debug.error("Setup failed: no support");
            const s = this.media.cloneNode(!0);
            s.autoplay = !1, this.elements.original = s;
            const n = this.media.tagName.toLowerCase();
            let a = null, l = null;
            switch(n){
                case "div":
                    if (a = this.media.querySelector("iframe"), S.element(a)) {
                        if (l = Me(a.getAttribute("src")), this.provider = function(e) {
                            return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e) ? _e.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e) ? _e.vimeo : null;
                        }(l.toString()), this.elements.container = this.media, this.media = a, this.elements.container.className = "", l.search.length) {
                            const e = [
                                "1",
                                "true"
                            ];
                            e.includes(l.searchParams.get("autoplay")) && (this.config.autoplay = !0), e.includes(l.searchParams.get("loop")) && (this.config.loop.active = !0), this.isYouTube ? (this.config.playsinline = e.includes(l.searchParams.get("playsinline")), this.config.youtube.hl = l.searchParams.get("hl")) : this.config.playsinline = !0;
                        }
                    } else this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);
                    if (S.empty(this.provider) || !Object.values(_e).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
                    this.type = je;
                    break;
                case "video":
                case "audio":
                    this.type = n, this.provider = _e.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0), this.media.hasAttribute("autoplay") && (this.config.autoplay = !0), (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = !0), this.media.hasAttribute("muted") && (this.config.muted = !0), this.media.hasAttribute("loop") && (this.config.loop.active = !0);
                    break;
                default:
                    return void this.debug.error("Setup failed: unsupported type");
            }
            this.supported = K.check(this.type, this.provider), this.supported.api ? (this.eventListeners = [], this.listeners = new Ve(this), this.storage = new we(this), this.media.plyr = this, S.element(this.elements.container) || (this.elements.container = $("div"), L(this.media, this.elements.container)), Fe.migrateStyles.call(this), Fe.addStyleHook.call(this), Xe.setup.call(this), this.config.debug && X.call(this, this.elements.container, this.config.events.join(" "), (e)=>{
                this.debug.log(`event: ${e.type}`);
            }), this.fullscreen = new He(this), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.listeners.container(), this.listeners.global(), this.config.ads.enabled && (this.ads = new Je(this)), this.isHTML5 && this.config.autoplay && this.once("canplay", ()=>ie(this.play())), this.lastSeekTime = 0, this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))) : this.debug.error("Setup failed: no support");
        }
        get isHTML5() {
            return this.provider === _e.html5;
        }
        get isEmbed() {
            return this.isYouTube || this.isVimeo;
        }
        get isYouTube() {
            return this.provider === _e.youtube;
        }
        get isVimeo() {
            return this.provider === _e.vimeo;
        }
        get isVideo() {
            return this.type === je;
        }
        get isAudio() {
            return this.type === Oe;
        }
        get playing() {
            return Boolean(this.ready && !this.paused && !this.ended);
        }
        get paused() {
            return Boolean(this.media.paused);
        }
        get stopped() {
            return Boolean(this.paused && 0 === this.currentTime);
        }
        get ended() {
            return Boolean(this.media.ended);
        }
        set currentTime(e) {
            if (!this.duration) return;
            const t = S.number(e) && e > 0;
            this.media.currentTime = t ? Math.min(e, this.duration) : 0, this.debug.log(`Seeking to ${this.currentTime} seconds`);
        }
        get currentTime() {
            return Number(this.media.currentTime);
        }
        get buffered() {
            const { buffered: e } = this.media;
            return S.number(e) ? e : e && e.length && this.duration > 0 ? e.end(0) / this.duration : 0;
        }
        get seeking() {
            return Boolean(this.media.seeking);
        }
        get duration() {
            const e = parseFloat(this.config.duration), t = (this.media || {}).duration, i = S.number(t) && t !== 1 / 0 ? t : 0;
            return e || i;
        }
        set volume(e) {
            let t = e;
            S.string(t) && (t = Number(t)), S.number(t) || (t = this.storage.get("volume")), S.number(t) || ({ volume: t } = this.config), t > 1 && (t = 1), t < 0 && (t = 0), this.config.volume = t, this.media.volume = t, !S.empty(e) && this.muted && t > 0 && (this.muted = !1);
        }
        get volume() {
            return Number(this.media.volume);
        }
        set muted(e) {
            let t = e;
            S.boolean(t) || (t = this.storage.get("muted")), S.boolean(t) || (t = this.config.muted), this.config.muted = t, this.media.muted = t;
        }
        get muted() {
            return Boolean(this.media.muted);
        }
        get hasAudio() {
            return !this.isHTML5 || !!this.isAudio || Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
        }
        set speed(e) {
            let t = null;
            S.number(e) && (t = e), S.number(t) || (t = this.storage.get("speed")), S.number(t) || (t = this.config.speed.selected);
            const { minimumSpeed: i, maximumSpeed: s } = this;
            t = Ge(t, i, s), this.config.speed.selected = t, setTimeout(()=>{
                this.media && (this.media.playbackRate = t);
            }, 0);
        }
        get speed() {
            return Number(this.media.playbackRate);
        }
        get minimumSpeed() {
            return this.isYouTube ? Math.min(...this.options.speed) : this.isVimeo ? .5 : .0625;
        }
        get maximumSpeed() {
            return this.isYouTube ? Math.max(...this.options.speed) : this.isVimeo ? 2 : 16;
        }
        set quality(e) {
            const t = this.config.quality, i = this.options.quality;
            if (!i.length) return;
            let s = [
                !S.empty(e) && Number(e),
                this.storage.get("quality"),
                t.selected,
                t.default
            ].find(S.number), n = !0;
            if (!i.includes(s)) {
                const e = ne(i, s);
                this.debug.warn(`Unsupported quality option: ${s}, using ${e} instead`), s = e, n = !1;
            }
            t.selected = s, this.media.quality = s, n && this.storage.set({
                quality: s
            });
        }
        get quality() {
            return this.media.quality;
        }
        set loop(e) {
            const t = S.boolean(e) ? e : this.config.loop.active;
            this.config.loop.active = t, this.media.loop = t;
        }
        get loop() {
            return Boolean(this.media.loop);
        }
        set source(e) {
            it.change.call(this, e);
        }
        get source() {
            return this.media.currentSrc;
        }
        get download() {
            const { download: e } = this.config.urls;
            return S.url(e) ? e : this.source;
        }
        set download(e) {
            S.url(e) && (this.config.urls.download = e, Pe.setDownloadUrl.call(this));
        }
        set poster(e) {
            this.isVideo ? Fe.setPoster.call(this, e, !1).catch(()=>{}) : this.debug.warn("Poster can only be set for video");
        }
        get poster() {
            return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
        }
        get ratio() {
            if (!this.isVideo) return null;
            const e = oe(ce.call(this));
            return S.array(e) ? e.join(":") : e;
        }
        set ratio(e) {
            this.isVideo ? S.string(e) && re(e) ? (this.config.ratio = oe(e), ue.call(this)) : this.debug.error(`Invalid aspect ratio specified (${e})`) : this.debug.warn("Aspect ratio can only be set for video");
        }
        set autoplay(e) {
            this.config.autoplay = S.boolean(e) ? e : this.config.autoplay;
        }
        get autoplay() {
            return Boolean(this.config.autoplay);
        }
        toggleCaptions(e) {
            xe.toggle.call(this, e, !1);
        }
        set currentTrack(e) {
            xe.set.call(this, e, !1), xe.setup.call(this);
        }
        get currentTrack() {
            const { toggled: e, currentTrack: t } = this.captions;
            return e ? t : -1;
        }
        set language(e) {
            xe.setLanguage.call(this, e, !1);
        }
        get language() {
            return (xe.getCurrentTrack.call(this) || {}).language;
        }
        set pip(e) {
            if (!K.pip) return;
            const t = S.boolean(e) ? e : !this.pip;
            S.function(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t ? Ie : $e), S.function(this.media.requestPictureInPicture) && (!this.pip && t ? this.media.requestPictureInPicture() : this.pip && !t && document.exitPictureInPicture());
        }
        get pip() {
            return K.pip ? S.empty(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === Ie : null;
        }
        setPreviewThumbnails(e) {
            this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), Object.assign(this.config.previewThumbnails, e), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this));
        }
        static supported(e, t) {
            return K.check(e, t);
        }
        static loadSprite(e, t) {
            return ke(e, t);
        }
        static setup(e, t = {}) {
            let i = null;
            return S.string(e) ? i = Array.from(document.querySelectorAll(e)) : S.nodeList(e) ? i = Array.from(e) : S.array(e) && (i = e.filter(S.element)), S.empty(i) ? null : i.map((e)=>new st(e, t));
        }
    }
    var nt;
    return st.defaults = (nt = Le, JSON.parse(JSON.stringify(nt))), st;
});


class $1fd1f89bcda06d5b$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root;
        const player = new (0, (/*@__PURE__*/$parcel$interopDefault($77e0898a05762ba3$exports)))(this.root, {
            controls: [
                'play-large',
                'play',
                'progress',
                'current-time',
                'mute',
                'volume',
                'captions',
                'fullscreen'
            ]
        });
        // console.log(player)
        player.on('enterfullscreen', (event)=>{
            // console.log('Entered fullscreen mode');
            const header = document.querySelector('.header');
            header.style.opacity = "0";
            header.style.pointerEvents = "none";
        });
        player.on('exitfullscreen', ()=>{
            // console.log('Exited fullscreen mode');
            const header = document.querySelector('.header');
            header.style.opacity = "1";
            header.style.pointerEvents = "auto";
        });
    }
}


class $c7f806b99a3824e3$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root;
        this.items = root.querySelectorAll('.people-item.has-back');
        this.addEvents();
        this.updateOffset();
        window.addEventListener('resize', ()=>this.updateOffset());
    }
    updateOffset() {
        if (this.root.classList.contains('people-twocolumnoffset') && this.items.length > 0) this.root.style.setProperty('--offset', this.items[0].offsetWidth / 4 + 'px');
    }
    addEvents() {
        this.items.forEach((item)=>{
            const panelId = item.getAttribute('aria-controls');
            const panel = panelId ? document.getElementById(panelId) : null;
            item.addEventListener('click', ()=>{
                const isActive = item.classList.contains('active');
                // Close all items first
                this.items.forEach((i)=>{
                    i.classList.remove('active');
                    i.setAttribute('aria-expanded', 'false');
                    const iPanelId = i.getAttribute('aria-controls');
                    const iPanel = iPanelId ? document.getElementById(iPanelId) : null;
                    if (iPanel) iPanel.hidden = true;
                    // Make all links unfocusable inside closed panels
                    const links = i.querySelectorAll('.people-item-mail');
                    links.forEach((link)=>{
                        link.setAttribute('tabindex', '-1');
                    });
                });
                if (!isActive) {
                    item.classList.add('active');
                    item.setAttribute('aria-expanded', 'true');
                    if (panel) panel.hidden = false;
                    // Make links inside opened panel focusable again
                    const links = item.querySelectorAll('.people-item-mail');
                    links.forEach((link)=>{
                        link.removeAttribute('tabindex');
                    });
                }
            });
            // Also support Enter and Space keys
            item.addEventListener('keydown', (event)=>{
                if (event.key === ' ' || event.key === 'Enter') {
                    event.preventDefault();
                    item.click();
                }
            });
        });
    }
}


class $4a365ef086d0c37b$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root;
        this.items = root.querySelectorAll('.logocard-item.has-back');
        this.addEvents();
    }
    addEvents() {
        this.items.forEach((item)=>{
            const backPanel = item.querySelector('.logocard-item-back');
            const isBackVisible = item.classList.contains('active');
            // Set aria-expanded based on whether the back of the card is visible
            item.setAttribute('aria-expanded', isBackVisible ? 'true' : 'false');
            // Optional: Use aria-controls to associate the card with the back panel
            item.setAttribute('aria-controls', backPanel ? backPanel.id : '');
            item.addEventListener('click', ()=>{
                const isExpanded = item.classList.contains('active');
                // Toggle card active state and aria-expanded
                if (isExpanded) {
                    item.classList.remove('active');
                    item.setAttribute('aria-expanded', 'false');
                    if (backPanel) backPanel.hidden = true;
                } else {
                    this.items.forEach((i)=>{
                        i.classList.remove('active');
                        i.setAttribute('aria-expanded', 'false');
                        const iBackPanel = i.querySelector('.logocard-item-back');
                        if (iBackPanel) iBackPanel.hidden = true;
                    });
                    item.classList.add('active');
                    item.setAttribute('aria-expanded', 'true');
                    if (backPanel) backPanel.hidden = false;
                }
            });
            // Support Enter and Space keys for toggling
            item.addEventListener('keydown', (event)=>{
                if (event.key === ' ' || event.key === 'Enter') {
                    event.preventDefault();
                    item.click();
                }
            });
        });
    }
}


const $76149f9d24a90a9e$export$871de8747c9eaa88 = (n, start1, stop1, start2 = 0, stop2 = 1)=>{
    return (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
};
const $76149f9d24a90a9e$export$7d15b64cf5a3a4c4 = (number, min = 0, max = 1)=>{
    return Math.max(min, Math.min(number, max));
};
const $76149f9d24a90a9e$export$3a89f8d6f6bf6c9f = (value1, value2, amount)=>{
    amount = amount < 0 ? 0 : amount;
    amount = amount > 1 ? 1 : amount;
    return value1 + (value2 - value1) * amount;
};
const $76149f9d24a90a9e$export$750987c389eca1ca = (i, m = 100)=>{
    //returns 1 while value is progressing, returns 0 if value is 0 or 1
    //based on triangle wave function
    i = $76149f9d24a90a9e$export$7d15b64cf5a3a4c4(i) //normalize value to 0-1
    ;
    return Math.ceil(Math.abs(i * m % m) / m);
};
const $76149f9d24a90a9e$export$233b8f01b7f8637c = (min, max)=>{
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
const $76149f9d24a90a9e$export$cdcb2233916b77da = (s)=>{
    if (s) return `<mark>${s.split('').map((c)=>c.toLowerCase() !== c ? `<span>${c}</span>` : `<span>${c}</span>`).join('').split(' ').join('</mark> <mark>')}</span>`;
    return '';
};
const $76149f9d24a90a9e$export$1d83bcb8568cb53c = (time, duration, valueStart, valueChange)=>{
    var s = 1.70158;
    var p = 0;
    var a = valueChange;
    if (time == 0) return valueStart;
    if ((time /= duration) == 1) return valueStart + valueChange;
    if (!p) p = duration * .3;
    if (a < Math.abs(valueChange)) {
        a = valueChange;
        var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(valueChange / a);
    return a * Math.pow(2, -10 * time) * Math.sin((time * duration - s) * (2 * Math.PI) / p) + valueChange + valueStart;
};


// import Lenis from '@studio-freight/lenis'


let $ac6e65077e03f9d6$export$2a111da947c407d2 = {
    // w: window.innerWidth,
    // h: window.innerHeight
    w: document.querySelector('.resize-helper').offsetWidth,
    h: document.querySelector('.resize-helper').offsetHeight
};
const $ac6e65077e03f9d6$var$getWindowSize = ()=>{
    $ac6e65077e03f9d6$export$2a111da947c407d2 = {
        // w: window.innerWidth,
        // h: window.innerHeight
        w: document.querySelector('.resize-helper').offsetWidth,
        h: document.querySelector('.resize-helper').offsetHeight
    };
// r.style.setProperty('--100vh', `${doc.h}px`);
};
const $ac6e65077e03f9d6$export$1f241d5ed8444754 = document.body.dataset.siteurl;
console.log($ac6e65077e03f9d6$export$1f241d5ed8444754);
let $ac6e65077e03f9d6$var$r = document.querySelector(':root');
$ac6e65077e03f9d6$var$r.style.setProperty('--100vh', `${$ac6e65077e03f9d6$export$2a111da947c407d2.h}px`);
let $ac6e65077e03f9d6$export$58734539bbfa41a2 = {
    x: 0.5,
    y: 0.5
};
let $ac6e65077e03f9d6$export$a089f110d3132747 = {
    scroll: 0
};
/* Listen for Scroll Event */ $ac6e65077e03f9d6$export$a089f110d3132747.scroll = window.scrollY || (document.documentElement || document.body.parentNode || document.body).scrollTop;
window.addEventListener('scroll', ()=>{
    $ac6e65077e03f9d6$export$a089f110d3132747.scroll = window.scrollY || (document.documentElement || document.body.parentNode || document.body).scrollTop;
});
let $ac6e65077e03f9d6$export$3acebae7264add46 = $ac6e65077e03f9d6$var$isTouchDevice();
function $ac6e65077e03f9d6$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
let $ac6e65077e03f9d6$export$dc13cae83df62ba6 = []; //this is set to be empty on page
const $ac6e65077e03f9d6$export$6e196edbcc00e5bc = (elPos)=>{
    const progress = (0, $76149f9d24a90a9e$export$871de8747c9eaa88)($ac6e65077e03f9d6$export$a089f110d3132747.scroll + $ac6e65077e03f9d6$export$2a111da947c407d2.h, elPos.y, elPos.y + elPos.h + $ac6e65077e03f9d6$export$2a111da947c407d2.h);
    return {
        progress: progress,
        loopback: (0, $76149f9d24a90a9e$export$750987c389eca1ca)(progress)
    };
};
const $ac6e65077e03f9d6$export$1690e12b840569b9 = (element)=>{
    return {
        x: element.getBoundingClientRect().left,
        y: element.getBoundingClientRect().top + document.documentElement.scrollTop,
        w: element.offsetWidth,
        h: element.offsetHeight
    };
};
const $ac6e65077e03f9d6$export$68cdf4e2cb6fc30e = ()=>{
    // console.log(registeredLoops)
    $ac6e65077e03f9d6$export$dc13cae83df62ba6.forEach((el)=>{
        el.position = $ac6e65077e03f9d6$export$1690e12b840569b9(el.root);
    });
};
$ac6e65077e03f9d6$export$68cdf4e2cb6fc30e();
let $ac6e65077e03f9d6$var$smoothScroll = true;
if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    if ($ac6e65077e03f9d6$export$2a111da947c407d2.w > 960) $ac6e65077e03f9d6$var$smoothScroll = false;
}
//init Lenis scroll
const $ac6e65077e03f9d6$var$lenisOptions = {
    duration: 1.2,
    easing: (t)=>Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: 'vertical',
    gestureDirection: 'vertical',
    smooth: $ac6e65077e03f9d6$var$smoothScroll,
    smoothTouch: false,
    touchMultiplier: 2,
    infinite: false
};
/*export let lenis;

const addLenis = () => {
  document.querySelector('.container').classList.remove('onload')
  lenis = new Lenis(lenisOptions)

  //save scroll value
  lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
    //console.log({ scroll, limit, velocity, direction, progress })
    scrl = {
      scroll: scroll,
      velocity: velocity,
      direction: direction,
      progress: progress
    }
  })
  lenis.start()
}

addLenis()*/ // global requestAnimationFrame, orginally for Lenis Scroll
function $ac6e65077e03f9d6$var$raf(time) {
    // lenis.raf(time)
    $ac6e65077e03f9d6$export$dc13cae83df62ba6.forEach((el)=>{
        el.loop(time);
    });
    requestAnimationFrame($ac6e65077e03f9d6$var$raf);
}
requestAnimationFrame($ac6e65077e03f9d6$var$raf);
/*
export const stopLenis = () => {
  lenis.stop()
}
export const startLenis = () => {
  lenis.start()
}
export const lenisScrollTo = (el, duration, offset = 0) => {
  // console.log(el)
  lenis.scrollTo(el, {duration: duration, offset: offset, easing: (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2})  //https://easings.net/en#easeInOutCubic
}
*/ //let gyroscopeActive = false;
document.addEventListener('mousemove', (event)=>{
    //if(gyroscopeActive == false) {
    $ac6e65077e03f9d6$export$58734539bbfa41a2 = {
        x: (0, $76149f9d24a90a9e$export$871de8747c9eaa88)(event.clientX, 0, $ac6e65077e03f9d6$export$2a111da947c407d2.w),
        y: (0, $76149f9d24a90a9e$export$871de8747c9eaa88)(event.clientY, 0, $ac6e65077e03f9d6$export$2a111da947c407d2.h)
    };
//console.log(cursor)
//}
});
const $ac6e65077e03f9d6$export$d70cf44bc3ae170 = (type, selector, callback)=>{
    document.addEventListener(type, (e)=>{
        if (e.target.matches(selector)) callback(e);
    });
};
let $ac6e65077e03f9d6$var$lastTouchX = 0.5;
let $ac6e65077e03f9d6$export$4f480c76b12f4253 = 0.5;
if ($ac6e65077e03f9d6$export$3acebae7264add46 == true) {
    document.addEventListener('touchstart', (e)=>{
        $ac6e65077e03f9d6$var$lastTouchX = (0, $76149f9d24a90a9e$export$871de8747c9eaa88)(e.changedTouches[0].clientX, 0, $ac6e65077e03f9d6$export$2a111da947c407d2.w);
    });
    document.addEventListener('touchmove', (e)=>{
        $ac6e65077e03f9d6$export$4f480c76b12f4253 = (0, $76149f9d24a90a9e$export$7d15b64cf5a3a4c4)($ac6e65077e03f9d6$export$4f480c76b12f4253 + ($ac6e65077e03f9d6$var$lastTouchX - (0, $76149f9d24a90a9e$export$871de8747c9eaa88)(e.changedTouches[0].clientX, 0, $ac6e65077e03f9d6$export$2a111da947c407d2.w)));
        $ac6e65077e03f9d6$var$lastTouchX = (0, $76149f9d24a90a9e$export$871de8747c9eaa88)(e.changedTouches[0].clientX, 0, $ac6e65077e03f9d6$export$2a111da947c407d2.w);
    });
}
let $ac6e65077e03f9d6$export$4608d636ee9f5261 = []; //can be pushed to in individual component
let $ac6e65077e03f9d6$var$resizeCount = 0;
let $ac6e65077e03f9d6$var$doit;
const $ac6e65077e03f9d6$var$resizeObserver = new ResizeObserver((entries)=>{
    // for (const entry of entries) {}
    if ($ac6e65077e03f9d6$var$resizeCount > 0) {
        $ac6e65077e03f9d6$var$getWindowSize();
        clearTimeout($ac6e65077e03f9d6$var$doit); //cancle the timeout if new resize happend in the meantime
        $ac6e65077e03f9d6$var$doit = setTimeout($ac6e65077e03f9d6$var$resizeUpdated, 500);
    }
    $ac6e65077e03f9d6$var$resizeCount++;
});
const $ac6e65077e03f9d6$var$resizeUpdated = ()=>{
    // console.log('resize')
    $ac6e65077e03f9d6$export$68cdf4e2cb6fc30e();
    // console.log(registeredResizeFunctions)
    $ac6e65077e03f9d6$export$4608d636ee9f5261.forEach((el)=>{
        el.resize();
    });
};
$ac6e65077e03f9d6$var$resizeObserver.observe(document.querySelector(".resize-helper"));
function $ac6e65077e03f9d6$export$1f1e0729723effb2(el, offset = 0, behavior = 'auto') {
    if (el) {
        const elementPosition = el.getBoundingClientRect().top;
        const scrollToPosition = elementPosition + offset;
        window.scrollTo({
            top: scrollToPosition,
            behavior: behavior
        });
    }
}



class $68f1e2c9bce2a35c$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root;
        this.workGridEl = this.root.querySelector('.work-grid');
        this.filterButtons = this.root.querySelectorAll('.work-filter button');
        this.workItems = this.root.querySelectorAll('.work-grid-item');
        this.activeFilter = null;
        this.setupFilterButtons();
    }
    setupFilterButtons() {
        this.filterButtons.forEach((button)=>{
            button.addEventListener('click', ()=>{
                const filter = button.getAttribute('data-filter');
                // Toggle filter
                if (this.activeFilter === filter) this.activeFilter = null;
                else this.activeFilter = filter;
                this.updateUI();
            });
        });
    }
    updateUI() {
        // Toggle active button
        this.filterButtons.forEach((button)=>{
            const isActive = button.getAttribute('data-filter') === this.activeFilter;
            button.classList.toggle('active', isActive);
        });
        // Filter grid items
        this.workItems.forEach((item)=>{
            const tags = item.getAttribute('data-tags')?.split(',').map((tag)=>tag.trim()) || [];
            const show = !this.activeFilter || tags.includes(this.activeFilter);
            item.style.display = show ? '' : 'none';
        });
    }
}


class $b2d227a9647fbef0$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root; // .accordion element
        this.items = root.querySelectorAll('.accordion-item');
        this.addEvents();
    }
    addEvents() {
        this.items.forEach((item, index)=>{
            const header = item.querySelector('.accordion-header');
            const icon = item.querySelector('.accordion-icon');
            const content = item.querySelector('.accordion-content');
            console.log('Accordion item:', item);
            // Toggle accordion content visibility
            const toggleAccordion = ()=>{
                const isOpen = item.classList.contains('open');
                // Update the classes for open/closed states
                if (isOpen) {
                    item.classList.remove('open');
                    item.classList.add('closed');
                } else {
                    item.classList.remove('closed');
                    item.classList.add('open');
                }
                // Update ARIA attributes for accessibility
                const expanded = !isOpen;
                header.setAttribute('aria-expanded', expanded);
                content.setAttribute('aria-hidden', !expanded);
            };
            // Open/close on clicking header or icon
            header.addEventListener('click', toggleAccordion);
            icon.addEventListener('click', toggleAccordion);
            // Optionally, handle keyboard interactions for better accessibility
            header.addEventListener('keydown', (e)=>{
                // Allow toggling with Enter or Space
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleAccordion();
                }
            });
            // Optionally, focus on the header when toggled
            header.addEventListener('click', ()=>{
                header.focus();
            });
        });
    }
}



var $bvJM2 = parcelRequire("bvJM2");
/*!
 * CSSPlugin 3.12.7
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $bvJM2 = parcelRequire("bvJM2");
var $7d9b5a7dd4dbaff5$var$_win, $7d9b5a7dd4dbaff5$var$_doc, $7d9b5a7dd4dbaff5$var$_docElement, $7d9b5a7dd4dbaff5$var$_pluginInitted, $7d9b5a7dd4dbaff5$var$_tempDiv, $7d9b5a7dd4dbaff5$var$_tempDivStyler, $7d9b5a7dd4dbaff5$var$_recentSetterPlugin, $7d9b5a7dd4dbaff5$var$_reverting, $7d9b5a7dd4dbaff5$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $7d9b5a7dd4dbaff5$var$_transformProps = {}, $7d9b5a7dd4dbaff5$var$_RAD2DEG = 180 / Math.PI, $7d9b5a7dd4dbaff5$var$_DEG2RAD = Math.PI / 180, $7d9b5a7dd4dbaff5$var$_atan2 = Math.atan2, $7d9b5a7dd4dbaff5$var$_bigNum = 1e8, $7d9b5a7dd4dbaff5$var$_capsExp = /([A-Z])/g, $7d9b5a7dd4dbaff5$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $7d9b5a7dd4dbaff5$var$_complexExp = /[\s,\(]\S/, $7d9b5a7dd4dbaff5$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $7d9b5a7dd4dbaff5$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $7d9b5a7dd4dbaff5$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $7d9b5a7dd4dbaff5$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $7d9b5a7dd4dbaff5$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_transformProp = "transform", $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin", $7d9b5a7dd4dbaff5$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $7d9b5a7dd4dbaff5$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $7d9b5a7dd4dbaff5$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $7d9b5a7dd4dbaff5$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $7d9b5a7dd4dbaff5$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $7d9b5a7dd4dbaff5$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($7d9b5a7dd4dbaff5$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, isNotCSS, "");
        }
        property = $7d9b5a7dd4dbaff5$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $7d9b5a7dd4dbaff5$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $7d9b5a7dd4dbaff5$var$_reverting();
        if ((!i || !i.isStart) && !style[$7d9b5a7dd4dbaff5$var$_transformProp]) {
            $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]) {
                style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $7d9b5a7dd4dbaff5$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $7d9b5a7dd4dbaff5$var$_revertStyle,
        save: $7d9b5a7dd4dbaff5$var$_saveStyle
    };
    target._gsap || (0, $bvJM2.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $7d9b5a7dd4dbaff5$var$_supports3D, $7d9b5a7dd4dbaff5$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $7d9b5a7dd4dbaff5$var$_doc.createElementNS ? $7d9b5a7dd4dbaff5$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $7d9b5a7dd4dbaff5$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $7d9b5a7dd4dbaff5$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $7d9b5a7dd4dbaff5$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($7d9b5a7dd4dbaff5$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $7d9b5a7dd4dbaff5$var$_prefixes[i] : "") + property;
}, $7d9b5a7dd4dbaff5$var$_initCore = function _initCore() {
    if ($7d9b5a7dd4dbaff5$var$_windowExists() && window.document) {
        $7d9b5a7dd4dbaff5$var$_win = window;
        $7d9b5a7dd4dbaff5$var$_doc = $7d9b5a7dd4dbaff5$var$_win.document;
        $7d9b5a7dd4dbaff5$var$_docElement = $7d9b5a7dd4dbaff5$var$_doc.documentElement;
        $7d9b5a7dd4dbaff5$var$_tempDiv = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $7d9b5a7dd4dbaff5$var$_tempDivStyler = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div");
        $7d9b5a7dd4dbaff5$var$_transformProp = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b($7d9b5a7dd4dbaff5$var$_transformProp);
        $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin";
        $7d9b5a7dd4dbaff5$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $7d9b5a7dd4dbaff5$var$_supports3D = !!$7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b("perspective");
        $7d9b5a7dd4dbaff5$var$_reverting = (0, $bvJM2.gsap).core.reverting;
        $7d9b5a7dd4dbaff5$var$_pluginInitted = 1;
    }
}, $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $7d9b5a7dd4dbaff5$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $7d9b5a7dd4dbaff5$var$_docElement.removeChild(svg);
    return bbox;
}, $7d9b5a7dd4dbaff5$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $7d9b5a7dd4dbaff5$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$7d9b5a7dd4dbaff5$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp) property = $7d9b5a7dd4dbaff5$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $7d9b5a7dd4dbaff5$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $7d9b5a7dd4dbaff5$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$7d9b5a7dd4dbaff5$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $7d9b5a7dd4dbaff5$var$_tempDiv.style, horizontal = $7d9b5a7dd4dbaff5$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[unit] || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($7d9b5a7dd4dbaff5$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $bvJM2._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $7d9b5a7dd4dbaff5$var$_doc || !parent.appendChild) parent = $7d9b5a7dd4dbaff5$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $bvJM2._ticker).time && !cache.uncache) return (0, $bvJM2._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $7d9b5a7dd4dbaff5$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$7d9b5a7dd4dbaff5$var$_nonStandardLayouts[$7d9b5a7dd4dbaff5$var$_getComputedProperty(parent, "display")] && (style.position = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            px = $7d9b5a7dd4dbaff5$var$_tempDiv[measureProperty];
            parent.removeChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $bvJM2._getCache)(parent);
            cache.time = (0, $bvJM2._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $bvJM2._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $7d9b5a7dd4dbaff5$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore();
    if (property in $7d9b5a7dd4dbaff5$var$_propertyAliases && property !== "transform") {
        property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($7d9b5a7dd4dbaff5$var$_transformProps[property] && property !== "transform") {
        value = $7d9b5a7dd4dbaff5$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $7d9b5a7dd4dbaff5$var$_firstTwoOnly($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $7d9b5a7dd4dbaff5$var$_specialProps[property] && $7d9b5a7dd4dbaff5$var$_specialProps[property](target, property, unit) || $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, property) || (0, $bvJM2._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $bvJM2.PropTween)(this._pt, target.style, prop, 0, 1, (0, $bvJM2._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $bvJM2._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $bvJM2._numWithUnitExp)) || [];
    endValues = end.match((0, $bvJM2._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $bvJM2._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $bvJM2._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $bvJM2._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $bvJM2._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue;
    (0, $bvJM2._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $7d9b5a7dd4dbaff5$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[x] || x;
    split[1] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $7d9b5a7dd4dbaff5$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($7d9b5a7dd4dbaff5$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $7d9b5a7dd4dbaff5$var$_transformOriginProp : $7d9b5a7dd4dbaff5$var$_transformProp;
                }
                $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$7d9b5a7dd4dbaff5$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 0, $7d9b5a7dd4dbaff5$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $7d9b5a7dd4dbaff5$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $7d9b5a7dd4dbaff5$var$_rotationalProperties = {}, $7d9b5a7dd4dbaff5$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
    return $7d9b5a7dd4dbaff5$var$_isNullTransform(matrixString) ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrixString.substr(7).match((0, $bvJM2._numExp)).map((0, $bvJM2._round));
}, $7d9b5a7dd4dbaff5$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $bvJM2._getCache)(target), style = target.style, matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrix;
    } else if (matrix === $7d9b5a7dd4dbaff5$var$_identity2DMatrix && !target.offsetParent && target !== $7d9b5a7dd4dbaff5$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $7d9b5a7dd4dbaff5$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $7d9b5a7dd4dbaff5$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $7d9b5a7dd4dbaff5$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $7d9b5a7dd4dbaff5$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $7d9b5a7dd4dbaff5$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $7d9b5a7dd4dbaff5$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $bvJM2.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$7d9b5a7dd4dbaff5$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$7d9b5a7dd4dbaff5$var$_transformProp] !== "none" ? cs[$7d9b5a7dd4dbaff5$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $7d9b5a7dd4dbaff5$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $7d9b5a7dd4dbaff5$var$_atan2(b, a) * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $7d9b5a7dd4dbaff5$var$_atan2(c, d) * $7d9b5a7dd4dbaff5$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $7d9b5a7dd4dbaff5$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a32, a33);
            rotationX = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $7d9b5a7dd4dbaff5$var$_atan2(-c, a33);
            rotationY = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $7d9b5a7dd4dbaff5$var$_atan2(b, a);
            rotation = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $bvJM2._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $bvJM2._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$7d9b5a7dd4dbaff5$var$_isNullTransform($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $bvJM2._round)(scaleX);
    cache.scaleY = (0, $bvJM2._round)(scaleY);
    cache.rotation = (0, $bvJM2._round)(rotation) + deg;
    cache.rotationX = (0, $bvJM2._round)(rotationX) + deg;
    cache.rotationY = (0, $bvJM2._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = $7d9b5a7dd4dbaff5$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $bvJM2._config).force3D;
    cache.renderTransform = cache.svg ? $7d9b5a7dd4dbaff5$var$_renderSVGTransforms : $7d9b5a7dd4dbaff5$var$_supports3D ? $7d9b5a7dd4dbaff5$var$_renderCSSTransforms : $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $7d9b5a7dd4dbaff5$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$7d9b5a7dd4dbaff5$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $bvJM2.getUnit)(start);
    return (0, $bvJM2._round)(parseFloat(start) + parseFloat($7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $7d9b5a7dd4dbaff5$var$_renderCSSTransforms(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_zeroDeg = "0deg", $7d9b5a7dd4dbaff5$var$_zeroPx = "0px", $7d9b5a7dd4dbaff5$var$_endParenthesis = ") ", $7d9b5a7dd4dbaff5$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $7d9b5a7dd4dbaff5$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += "perspective(" + transformPerspective + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $7d9b5a7dd4dbaff5$var$_zeroPx || y !== $7d9b5a7dd4dbaff5$var$_zeroPx || z !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += z !== $7d9b5a7dd4dbaff5$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotation !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotate(" + rotation + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateY(" + rotationY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateX(" + rotationX + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (skewX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || skewY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms || "translate(0, 0)";
}, $7d9b5a7dd4dbaff5$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        skewX *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $bvJM2._round)(a11);
        a21 = (0, $bvJM2._round)(a21);
        a12 = (0, $bvJM2._round)(a12);
        a22 = (0, $bvJM2._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", x, "px");
        ty = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $bvJM2._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $bvJM2._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $bvJM2._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $bvJM2._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $7d9b5a7dd4dbaff5$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $bvJM2._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $7d9b5a7dd4dbaff5$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, startNum, change, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $7d9b5a7dd4dbaff5$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $7d9b5a7dd4dbaff5$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$7d9b5a7dd4dbaff5$var$_transformProp];
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = startValue;
    }
    for(p in $7d9b5a7dd4dbaff5$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $bvJM2.getUnit)(startValue);
            endUnit = (0, $bvJM2.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $7d9b5a7dd4dbaff5$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $bvJM2._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $7d9b5a7dd4dbaff5$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $7d9b5a7dd4dbaff5$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $7d9b5a7dd4dbaff5$export$855822f522f18eef = {
    name: "css",
    register: $7d9b5a7dd4dbaff5$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $7d9b5a7dd4dbaff5$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $bvJM2._plugins)[p] && (0, $bvJM2._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $7d9b5a7dd4dbaff5$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $bvJM2._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $bvJM2._colorExp).lastIndex = 0;
                if (!(0, $bvJM2._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $bvJM2.getUnit)(startValue);
                    endUnit = (0, $bvJM2.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $bvJM2._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $bvJM2._replaceRandom)(startValue));
                    (0, $bvJM2.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $bvJM2._config).units[p] || (0, $bvJM2.getUnit)($7d9b5a7dd4dbaff5$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $7d9b5a7dd4dbaff5$var$_get(target, p)); // can't work with relative values
                } else startValue = $7d9b5a7dd4dbaff5$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $7d9b5a7dd4dbaff5$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $7d9b5a7dd4dbaff5$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $7d9b5a7dd4dbaff5$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $7d9b5a7dd4dbaff5$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $7d9b5a7dd4dbaff5$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $bvJM2.PropTween)(this._pt, style, $7d9b5a7dd4dbaff5$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $bvJM2.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $bvJM2._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, 0, style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]);
                        endValue = $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, p, $7d9b5a7dd4dbaff5$var$_firstTwoOnly(startValue), $7d9b5a7dd4dbaff5$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $7d9b5a7dd4dbaff5$var$_rotationalProperties) {
                        $7d9b5a7dd4dbaff5$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $bvJM2._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $7d9b5a7dd4dbaff5$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$7d9b5a7dd4dbaff5$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $bvJM2.getUnit)(endValue) || (p in (0, $bvJM2._config).units ? (0, $bvJM2._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $bvJM2.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $bvJM2._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp : $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $bvJM2._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $bvJM2._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$7d9b5a7dd4dbaff5$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $7d9b5a7dd4dbaff5$var$_get,
    aliases: $7d9b5a7dd4dbaff5$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp && (target._gsap.x || $7d9b5a7dd4dbaff5$var$_get(target, "x")) ? plugin && $7d9b5a7dd4dbaff5$var$_recentSetterPlugin === plugin ? property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScale : $7d9b5a7dd4dbaff5$var$_setterTransform : ($7d9b5a7dd4dbaff5$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScaleWithRender : $7d9b5a7dd4dbaff5$var$_setterTransformWithRender) : target.style && !(0, $bvJM2._isUndefined)(target.style[property]) ? $7d9b5a7dd4dbaff5$var$_setterCSSStyle : ~property.indexOf("-") ? $7d9b5a7dd4dbaff5$var$_setterCSSProp : (0, $bvJM2._getSetter)(target, property);
    },
    core: {
        _removeProperty: $7d9b5a7dd4dbaff5$var$_removeProperty,
        _getMatrix: $7d9b5a7dd4dbaff5$var$_getMatrix
    }
};
(0, $bvJM2.gsap).utils.checkPrefix = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b;
(0, $bvJM2.gsap).core.getStyleSaver = $7d9b5a7dd4dbaff5$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $bvJM2._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $7d9b5a7dd4dbaff5$var$_transformProps[name] = 1;
    });
    (0, $bvJM2._forEachName)(rotation, function(name) {
        (0, $bvJM2._config).units[name] = "deg";
        $7d9b5a7dd4dbaff5$var$_rotationalProperties[name] = 1;
    });
    $7d9b5a7dd4dbaff5$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $bvJM2._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $7d9b5a7dd4dbaff5$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $bvJM2._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $bvJM2._config).units[name] = "px";
});
(0, $bvJM2.gsap).registerPlugin($7d9b5a7dd4dbaff5$export$855822f522f18eef);


var $1974f63041948ee8$export$99ee26438460406a = (0, $bvJM2.gsap).registerPlugin((0, $7d9b5a7dd4dbaff5$export$855822f522f18eef)) || (0, $bvJM2.gsap), // to protect from tree shaking
$1974f63041948ee8$export$7b23975ad686bf91 = $1974f63041948ee8$export$99ee26438460406a.core.Tween;


/*!
 * ScrollTrigger 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $7e9d8e753943228a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7e9d8e753943228a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7e9d8e753943228a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7e9d8e753943228a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $7e9d8e753943228a$var$gsap, $7e9d8e753943228a$var$_coreInitted, $7e9d8e753943228a$var$_clamp, $7e9d8e753943228a$var$_win, $7e9d8e753943228a$var$_doc, $7e9d8e753943228a$var$_docEl, $7e9d8e753943228a$var$_body, $7e9d8e753943228a$var$_isTouch, $7e9d8e753943228a$var$_pointerType, $7e9d8e753943228a$var$ScrollTrigger, $7e9d8e753943228a$var$_root, $7e9d8e753943228a$var$_normalizer, $7e9d8e753943228a$var$_eventTypes, $7e9d8e753943228a$var$_context, $7e9d8e753943228a$var$_getGSAP = function _getGSAP() {
    return $7e9d8e753943228a$var$gsap || typeof window !== "undefined" && ($7e9d8e753943228a$var$gsap = window.gsap) && $7e9d8e753943228a$var$gsap.registerPlugin && $7e9d8e753943228a$var$gsap;
}, $7e9d8e753943228a$var$_startup = 1, $7e9d8e753943228a$var$_observers = [], $7e9d8e753943228a$export$3cd1cee43d19b683 = [], $7e9d8e753943228a$export$d8e56d510a804d0a = [], $7e9d8e753943228a$var$_getTime = Date.now, $7e9d8e753943228a$var$_bridge = function _bridge(name, value) {
    return value;
}, $7e9d8e753943228a$var$_integrate = function _integrate() {
    var core = $7e9d8e753943228a$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $7e9d8e753943228a$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $7e9d8e753943228a$export$d8e56d510a804d0a);
    $7e9d8e753943228a$export$3cd1cee43d19b683 = scrollers;
    $7e9d8e753943228a$export$d8e56d510a804d0a = proxies;
    $7e9d8e753943228a$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $7e9d8e753943228a$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$7e9d8e753943228a$export$d8e56d510a804d0a.indexOf(element) && $7e9d8e753943228a$export$d8e56d510a804d0a[$7e9d8e753943228a$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $7e9d8e753943228a$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$7e9d8e753943228a$var$_root.indexOf(el);
}, $7e9d8e753943228a$var$_addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
    });
}, $7e9d8e753943228a$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $7e9d8e753943228a$var$_scrollLeft = "scrollLeft", $7e9d8e753943228a$var$_scrollTop = "scrollTop", $7e9d8e753943228a$var$_onScroll = function _onScroll() {
    return $7e9d8e753943228a$var$_normalizer && $7e9d8e753943228a$var$_normalizer.isPressed || $7e9d8e753943228a$export$3cd1cee43d19b683.cache++;
}, $7e9d8e753943228a$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $7e9d8e753943228a$var$_startup && ($7e9d8e753943228a$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $7e9d8e753943228a$var$_normalizer && $7e9d8e753943228a$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($7e9d8e753943228a$var$_normalizer && $7e9d8e753943228a$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $7e9d8e753943228a$export$3cd1cee43d19b683.cache;
            isNormalizing && $7e9d8e753943228a$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $7e9d8e753943228a$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $7e9d8e753943228a$var$_bridge("ref")) {
            cachingFunc.cacheID = $7e9d8e753943228a$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $7e9d8e753943228a$export$b2cabb342cb0ebe1 = {
    s: $7e9d8e753943228a$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $7e9d8e753943228a$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $7e9d8e753943228a$var$_win.scrollTo(value, $7e9d8e753943228a$export$8e40fc98ff518e9d.sc()) : $7e9d8e753943228a$var$_win.pageXOffset || $7e9d8e753943228a$var$_doc[$7e9d8e753943228a$var$_scrollLeft] || $7e9d8e753943228a$var$_docEl[$7e9d8e753943228a$var$_scrollLeft] || $7e9d8e753943228a$var$_body[$7e9d8e753943228a$var$_scrollLeft] || 0;
    })
}, $7e9d8e753943228a$export$8e40fc98ff518e9d = {
    s: $7e9d8e753943228a$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $7e9d8e753943228a$export$b2cabb342cb0ebe1,
    sc: $7e9d8e753943228a$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $7e9d8e753943228a$var$_win.scrollTo($7e9d8e753943228a$export$b2cabb342cb0ebe1.sc(), value) : $7e9d8e753943228a$var$_win.pageYOffset || $7e9d8e753943228a$var$_doc[$7e9d8e753943228a$var$_scrollTop] || $7e9d8e753943228a$var$_docEl[$7e9d8e753943228a$var$_scrollTop] || $7e9d8e753943228a$var$_body[$7e9d8e753943228a$var$_scrollTop] || 0;
    })
}, $7e9d8e753943228a$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $7e9d8e753943228a$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $7e9d8e753943228a$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $7e9d8e753943228a$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $7e9d8e753943228a$export$4330f3a92e5d2e94(element) && (element = $7e9d8e753943228a$var$_doc.scrollingElement || $7e9d8e753943228a$var$_docEl);
    var i = $7e9d8e753943228a$export$3cd1cee43d19b683.indexOf(element), offset = sc === $7e9d8e753943228a$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $7e9d8e753943228a$export$3cd1cee43d19b683.push(element) - 1);
    $7e9d8e753943228a$export$3cd1cee43d19b683[i + offset] || $7e9d8e753943228a$var$_addListener(element, "scroll", $7e9d8e753943228a$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $7e9d8e753943228a$export$3cd1cee43d19b683[i + offset], func = prev || ($7e9d8e753943228a$export$3cd1cee43d19b683[i + offset] = $7e9d8e753943228a$var$_scrollCacheFunc($7e9d8e753943228a$export$6078f1ef08b38af9(element, s), true) || ($7e9d8e753943228a$export$4330f3a92e5d2e94(element) ? sc : $7e9d8e753943228a$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $7e9d8e753943228a$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $7e9d8e753943228a$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $7e9d8e753943228a$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $7e9d8e753943228a$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $7e9d8e753943228a$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $7e9d8e753943228a$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $7e9d8e753943228a$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $7e9d8e753943228a$var$_setScrollTrigger = function _setScrollTrigger() {
    $7e9d8e753943228a$var$ScrollTrigger = $7e9d8e753943228a$var$gsap.core.globals().ScrollTrigger;
    $7e9d8e753943228a$var$ScrollTrigger && $7e9d8e753943228a$var$ScrollTrigger.core && $7e9d8e753943228a$var$_integrate();
}, $7e9d8e753943228a$var$_initCore = function _initCore(core) {
    $7e9d8e753943228a$var$gsap = core || $7e9d8e753943228a$var$_getGSAP();
    if (!$7e9d8e753943228a$var$_coreInitted && $7e9d8e753943228a$var$gsap && typeof document !== "undefined" && document.body) {
        $7e9d8e753943228a$var$_win = window;
        $7e9d8e753943228a$var$_doc = document;
        $7e9d8e753943228a$var$_docEl = $7e9d8e753943228a$var$_doc.documentElement;
        $7e9d8e753943228a$var$_body = $7e9d8e753943228a$var$_doc.body;
        $7e9d8e753943228a$var$_root = [
            $7e9d8e753943228a$var$_win,
            $7e9d8e753943228a$var$_doc,
            $7e9d8e753943228a$var$_docEl,
            $7e9d8e753943228a$var$_body
        ];
        $7e9d8e753943228a$var$_clamp = $7e9d8e753943228a$var$gsap.utils.clamp;
        $7e9d8e753943228a$var$_context = $7e9d8e753943228a$var$gsap.core.context || function() {};
        $7e9d8e753943228a$var$_pointerType = "onpointerenter" in $7e9d8e753943228a$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $7e9d8e753943228a$var$_isTouch = $7e9d8e753943228a$export$c1cbdee04e18ea8b.isTouch = $7e9d8e753943228a$var$_win.matchMedia && $7e9d8e753943228a$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $7e9d8e753943228a$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $7e9d8e753943228a$var$_eventTypes = $7e9d8e753943228a$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $7e9d8e753943228a$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $7e9d8e753943228a$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $7e9d8e753943228a$var$_startup = 0;
        }, 500);
        $7e9d8e753943228a$var$_setScrollTrigger();
        $7e9d8e753943228a$var$_coreInitted = 1;
    }
    return $7e9d8e753943228a$var$_coreInitted;
};
$7e9d8e753943228a$export$b2cabb342cb0ebe1.op = $7e9d8e753943228a$export$8e40fc98ff518e9d;
$7e9d8e753943228a$export$3cd1cee43d19b683.cache = 0;
var $7e9d8e753943228a$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $7e9d8e753943228a$var$_coreInitted || $7e9d8e753943228a$var$_initCore($7e9d8e753943228a$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $7e9d8e753943228a$var$ScrollTrigger || $7e9d8e753943228a$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $7e9d8e753943228a$export$937374fea3f88711(target) || $7e9d8e753943228a$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $7e9d8e753943228a$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($7e9d8e753943228a$var$_win.getComputedStyle($7e9d8e753943228a$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault && vars.passive !== false, scrollFuncX = $7e9d8e753943228a$export$8665aac53dad5647(target, $7e9d8e753943228a$export$b2cabb342cb0ebe1), scrollFuncY = $7e9d8e753943228a$export$8665aac53dad5647(target, $7e9d8e753943228a$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $7e9d8e753943228a$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $7e9d8e753943228a$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $7e9d8e753943228a$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $7e9d8e753943228a$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $7e9d8e753943228a$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $7e9d8e753943228a$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDragStart && dragged === 1 && onDragStart(self);
                    onDrag && onDrag(self);
                    dragged = 0;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $7e9d8e753943228a$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || (dx || dy) && (Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum)) {
                dragged = isDragging ? 2 : 1; // dragged: 0 = not dragging, 1 = first drag, 2 = normal drag
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $7e9d8e753943228a$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $7e9d8e753943228a$var$_addListener(isNormalizer ? target : ownerDoc, $7e9d8e753943228a$var$_eventTypes[1], _onDrag, passive, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $7e9d8e753943228a$var$_removeListener(isNormalizer ? target : ownerDoc, $7e9d8e753943228a$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $7e9d8e753943228a$var$_getEvent(e);
            if (!isDragNotClick && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
                if (preventDefault && allowClicks) $7e9d8e753943228a$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($7e9d8e753943228a$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $7e9d8e753943228a$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
            dragged && update(); // in case debouncing, we don't want onDrag to fire AFTER onDragEnd().
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $7e9d8e753943228a$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $7e9d8e753943228a$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            onStop && onStopDelayedCall.restart(true);
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $7e9d8e753943228a$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $7e9d8e753943228a$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $7e9d8e753943228a$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $7e9d8e753943228a$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $7e9d8e753943228a$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $7e9d8e753943228a$var$_addListener(isViewport ? ownerDoc : target, "scroll", $7e9d8e753943228a$var$_onScroll);
                type.indexOf("scroll") >= 0 && $7e9d8e753943228a$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
                type.indexOf("wheel") >= 0 && $7e9d8e753943228a$var$_addListener(target, "wheel", _onWheel, passive, capture);
                if (type.indexOf("touch") >= 0 && $7e9d8e753943228a$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $7e9d8e753943228a$var$_addListener(target, $7e9d8e753943228a$var$_eventTypes[0], _onPress, passive, capture);
                    $7e9d8e753943228a$var$_addListener(ownerDoc, $7e9d8e753943228a$var$_eventTypes[2], _onRelease);
                    $7e9d8e753943228a$var$_addListener(ownerDoc, $7e9d8e753943228a$var$_eventTypes[3], _onRelease);
                    allowClicks && $7e9d8e753943228a$var$_addListener(target, "click", clickCapture, true, true);
                    onClick && $7e9d8e753943228a$var$_addListener(target, "click", _onClick);
                    onGestureStart && $7e9d8e753943228a$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $7e9d8e753943228a$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $7e9d8e753943228a$var$_addListener(target, $7e9d8e753943228a$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $7e9d8e753943228a$var$_addListener(target, $7e9d8e753943228a$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $7e9d8e753943228a$var$_addListener(target, $7e9d8e753943228a$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                self.isDragging = self.isGesturing = self.isPressed = moved = dragged = false;
                self._vx.reset();
                self._vy.reset();
                scrollX = scrollFuncX();
                scrollY = scrollFuncY();
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $7e9d8e753943228a$var$_observers.filter(function(o) {
                    return o !== self && $7e9d8e753943228a$export$4330f3a92e5d2e94(o.target);
                }).length || $7e9d8e753943228a$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $7e9d8e753943228a$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $7e9d8e753943228a$var$_removeListener(isNormalizer ? target : ownerDoc, $7e9d8e753943228a$var$_eventTypes[1], _onDrag, true);
                }
                $7e9d8e753943228a$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $7e9d8e753943228a$var$_removeListener(target, "wheel", _onWheel, capture);
                $7e9d8e753943228a$var$_removeListener(target, $7e9d8e753943228a$var$_eventTypes[0], _onPress, capture);
                $7e9d8e753943228a$var$_removeListener(ownerDoc, $7e9d8e753943228a$var$_eventTypes[2], _onRelease);
                $7e9d8e753943228a$var$_removeListener(ownerDoc, $7e9d8e753943228a$var$_eventTypes[3], _onRelease);
                $7e9d8e753943228a$var$_removeListener(target, "click", clickCapture, true);
                $7e9d8e753943228a$var$_removeListener(target, "click", _onClick);
                $7e9d8e753943228a$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $7e9d8e753943228a$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $7e9d8e753943228a$var$_removeListener(target, $7e9d8e753943228a$var$_pointerType + "enter", _onHover);
                $7e9d8e753943228a$var$_removeListener(target, $7e9d8e753943228a$var$_pointerType + "leave", _onHoverEnd);
                $7e9d8e753943228a$var$_removeListener(target, $7e9d8e753943228a$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $7e9d8e753943228a$var$_observers.indexOf(self);
            i >= 0 && $7e9d8e753943228a$var$_observers.splice(i, 1);
            $7e9d8e753943228a$var$_normalizer === self && ($7e9d8e753943228a$var$_normalizer = 0);
        };
        $7e9d8e753943228a$var$_observers.push(self);
        isNormalizer && $7e9d8e753943228a$export$4330f3a92e5d2e94(target) && ($7e9d8e753943228a$var$_normalizer = self);
        self.enable(event);
    };
    $7e9d8e753943228a$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$7e9d8e753943228a$export$c1cbdee04e18ea8b.version = "3.12.7";
$7e9d8e753943228a$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $7e9d8e753943228a$export$c1cbdee04e18ea8b(vars);
};
$7e9d8e753943228a$export$c1cbdee04e18ea8b.register = $7e9d8e753943228a$var$_initCore;
$7e9d8e753943228a$export$c1cbdee04e18ea8b.getAll = function() {
    return $7e9d8e753943228a$var$_observers.slice();
};
$7e9d8e753943228a$export$c1cbdee04e18ea8b.getById = function(id) {
    return $7e9d8e753943228a$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$7e9d8e753943228a$var$_getGSAP() && $7e9d8e753943228a$var$gsap.registerPlugin($7e9d8e753943228a$export$c1cbdee04e18ea8b);


var $cff96cc64f639998$var$gsap, $cff96cc64f639998$var$_coreInitted, $cff96cc64f639998$var$_win, $cff96cc64f639998$var$_doc, $cff96cc64f639998$var$_docEl, $cff96cc64f639998$var$_body, $cff96cc64f639998$var$_root, $cff96cc64f639998$var$_resizeDelay, $cff96cc64f639998$var$_toArray, $cff96cc64f639998$var$_clamp, $cff96cc64f639998$var$_time2, $cff96cc64f639998$var$_syncInterval, $cff96cc64f639998$var$_refreshing, $cff96cc64f639998$var$_pointerIsDown, $cff96cc64f639998$var$_transformProp, $cff96cc64f639998$var$_i, $cff96cc64f639998$var$_prevWidth, $cff96cc64f639998$var$_prevHeight, $cff96cc64f639998$var$_autoRefresh, $cff96cc64f639998$var$_sort, $cff96cc64f639998$var$_suppressOverwrites, $cff96cc64f639998$var$_ignoreResize, $cff96cc64f639998$var$_normalizer, $cff96cc64f639998$var$_ignoreMobileResize, $cff96cc64f639998$var$_baseScreenHeight, $cff96cc64f639998$var$_baseScreenWidth, $cff96cc64f639998$var$_fixIOSBug, $cff96cc64f639998$var$_context, $cff96cc64f639998$var$_scrollRestoration, $cff96cc64f639998$var$_div100vh, $cff96cc64f639998$var$_100vh, $cff96cc64f639998$var$_isReverted, $cff96cc64f639998$var$_clampingMax, $cff96cc64f639998$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$cff96cc64f639998$var$_startup = 1, $cff96cc64f639998$var$_getTime = Date.now, $cff96cc64f639998$var$_time1 = $cff96cc64f639998$var$_getTime(), $cff96cc64f639998$var$_lastScrollTime = 0, $cff96cc64f639998$var$_enabled = 0, $cff96cc64f639998$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $cff96cc64f639998$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $cff96cc64f639998$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$cff96cc64f639998$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $cff96cc64f639998$var$_rafBugFix = function _rafBugFix() {
    return $cff96cc64f639998$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$cff96cc64f639998$var$_pointerDownHandler = function _pointerDownHandler() {
    return $cff96cc64f639998$var$_pointerIsDown = 1;
}, $cff96cc64f639998$var$_pointerUpHandler = function _pointerUpHandler() {
    return $cff96cc64f639998$var$_pointerIsDown = 0;
}, $cff96cc64f639998$var$_passThrough = function _passThrough(v) {
    return v;
}, $cff96cc64f639998$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $cff96cc64f639998$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $cff96cc64f639998$var$_getGSAP = function _getGSAP() {
    return $cff96cc64f639998$var$gsap || $cff96cc64f639998$var$_windowExists() && ($cff96cc64f639998$var$gsap = window.gsap) && $cff96cc64f639998$var$gsap.registerPlugin && $cff96cc64f639998$var$gsap;
}, $cff96cc64f639998$var$_isViewport = function _isViewport(e) {
    return !!~$cff96cc64f639998$var$_root.indexOf(e);
}, $cff96cc64f639998$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $cff96cc64f639998$var$_100vh : $cff96cc64f639998$var$_win["inner" + dimensionProperty]) || $cff96cc64f639998$var$_docEl["client" + dimensionProperty] || $cff96cc64f639998$var$_body["client" + dimensionProperty];
}, $cff96cc64f639998$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($cff96cc64f639998$var$_isViewport(element) ? function() {
        $cff96cc64f639998$var$_winOffsets.width = $cff96cc64f639998$var$_win.innerWidth;
        $cff96cc64f639998$var$_winOffsets.height = $cff96cc64f639998$var$_100vh;
        return $cff96cc64f639998$var$_winOffsets;
    } : function() {
        return $cff96cc64f639998$var$_getBounds(element);
    });
}, $cff96cc64f639998$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $cff96cc64f639998$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $cff96cc64f639998$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $7e9d8e753943228a$export$d8e56d510a804d0a).indexOf(element) ? $cff96cc64f639998$var$_getBoundsFunc(element) : function() {
        return $cff96cc64f639998$var$_winOffsets;
    };
}, $cff96cc64f639998$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(element, s)) ? a() - $cff96cc64f639998$var$_getBoundsFunc(element)()[d] : $cff96cc64f639998$var$_isViewport(element) ? ($cff96cc64f639998$var$_docEl[s] || $cff96cc64f639998$var$_body[s]) - $cff96cc64f639998$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $cff96cc64f639998$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $cff96cc64f639998$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($cff96cc64f639998$var$_autoRefresh[i + 1])) && func($cff96cc64f639998$var$_autoRefresh[i], $cff96cc64f639998$var$_autoRefresh[i + 1], $cff96cc64f639998$var$_autoRefresh[i + 2]);
}, $cff96cc64f639998$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $cff96cc64f639998$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $cff96cc64f639998$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $cff96cc64f639998$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $cff96cc64f639998$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $cff96cc64f639998$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
            return func(self);
        }) : func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $cff96cc64f639998$var$_abs = Math.abs, $cff96cc64f639998$var$_left = "left", $cff96cc64f639998$var$_top = "top", $cff96cc64f639998$var$_right = "right", $cff96cc64f639998$var$_bottom = "bottom", $cff96cc64f639998$var$_width = "width", $cff96cc64f639998$var$_height = "height", $cff96cc64f639998$var$_Right = "Right", $cff96cc64f639998$var$_Left = "Left", $cff96cc64f639998$var$_Top = "Top", $cff96cc64f639998$var$_Bottom = "Bottom", $cff96cc64f639998$var$_padding = "padding", $cff96cc64f639998$var$_margin = "margin", $cff96cc64f639998$var$_Width = "Width", $cff96cc64f639998$var$_Height = "Height", $cff96cc64f639998$var$_px = "px", $cff96cc64f639998$var$_getComputedStyle = function _getComputedStyle(element) {
    return $cff96cc64f639998$var$_win.getComputedStyle(element);
}, $cff96cc64f639998$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $cff96cc64f639998$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $cff96cc64f639998$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $cff96cc64f639998$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $cff96cc64f639998$var$_getComputedStyle(element)[$cff96cc64f639998$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $cff96cc64f639998$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $cff96cc64f639998$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $cff96cc64f639998$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $cff96cc64f639998$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $cff96cc64f639998$var$gsap.utils.snap($cff96cc64f639998$var$_getLabelRatioArray(animation), value);
    };
}, $cff96cc64f639998$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $cff96cc64f639998$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $cff96cc64f639998$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $cff96cc64f639998$var$_snapDirectional($cff96cc64f639998$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $cff96cc64f639998$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $cff96cc64f639998$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $cff96cc64f639998$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $cff96cc64f639998$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $cff96cc64f639998$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $cff96cc64f639998$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $cff96cc64f639998$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $cff96cc64f639998$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($cff96cc64f639998$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $cff96cc64f639998$var$_keywords ? $cff96cc64f639998$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $cff96cc64f639998$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $cff96cc64f639998$var$_doc.createElement("div"), useFixedPosition = $cff96cc64f639998$var$_isViewport(container) || (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $cff96cc64f639998$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $7e9d8e753943228a$export$8e40fc98ff518e9d) ? $cff96cc64f639998$var$_right : $cff96cc64f639998$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $cff96cc64f639998$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $cff96cc64f639998$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $cff96cc64f639998$var$_Width] = 1;
    vars["border" + oppositeSide + $cff96cc64f639998$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $cff96cc64f639998$var$gsap.set(marker, vars);
}, $cff96cc64f639998$var$_triggers = [], $cff96cc64f639998$var$_ids = {}, $cff96cc64f639998$var$_rafID, $cff96cc64f639998$var$_sync = function _sync() {
    return $cff96cc64f639998$var$_getTime() - $cff96cc64f639998$var$_lastScrollTime > 34 && ($cff96cc64f639998$var$_rafID || ($cff96cc64f639998$var$_rafID = requestAnimationFrame($cff96cc64f639998$var$_updateAll)));
}, $cff96cc64f639998$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$cff96cc64f639998$var$_normalizer || !$cff96cc64f639998$var$_normalizer.isPressed || $cff96cc64f639998$var$_normalizer.startX > $cff96cc64f639998$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache++;
        if ($cff96cc64f639998$var$_normalizer) $cff96cc64f639998$var$_rafID || ($cff96cc64f639998$var$_rafID = requestAnimationFrame($cff96cc64f639998$var$_updateAll));
        else $cff96cc64f639998$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $cff96cc64f639998$var$_lastScrollTime || $cff96cc64f639998$var$_dispatch("scrollStart");
        $cff96cc64f639998$var$_lastScrollTime = $cff96cc64f639998$var$_getTime();
    }
}, $cff96cc64f639998$var$_setBaseDimensions = function _setBaseDimensions() {
    $cff96cc64f639998$var$_baseScreenWidth = $cff96cc64f639998$var$_win.innerWidth;
    $cff96cc64f639998$var$_baseScreenHeight = $cff96cc64f639998$var$_win.innerHeight;
}, $cff96cc64f639998$var$_onResize = function _onResize(force) {
    (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache++;
    (force === true || !$cff96cc64f639998$var$_refreshing && !$cff96cc64f639998$var$_ignoreResize && !$cff96cc64f639998$var$_doc.fullscreenElement && !$cff96cc64f639998$var$_doc.webkitFullscreenElement && (!$cff96cc64f639998$var$_ignoreMobileResize || $cff96cc64f639998$var$_baseScreenWidth !== $cff96cc64f639998$var$_win.innerWidth || Math.abs($cff96cc64f639998$var$_win.innerHeight - $cff96cc64f639998$var$_baseScreenHeight) > $cff96cc64f639998$var$_win.innerHeight * 0.25)) && $cff96cc64f639998$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$cff96cc64f639998$var$_listeners = {}, $cff96cc64f639998$var$_emptyArray = [], $cff96cc64f639998$var$_softRefresh = function _softRefresh() {
    return $cff96cc64f639998$var$_removeListener($cff96cc64f639998$export$875bcbe48555930, "scrollEnd", _softRefresh) || $cff96cc64f639998$var$_refreshAll(true);
}, $cff96cc64f639998$var$_dispatch = function _dispatch(type) {
    return $cff96cc64f639998$var$_listeners[type] && $cff96cc64f639998$var$_listeners[type].map(function(f) {
        return f();
    }) || $cff96cc64f639998$var$_emptyArray;
}, $cff96cc64f639998$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$cff96cc64f639998$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $cff96cc64f639998$var$_savedStyles.length; i += 5)if (!media || $cff96cc64f639998$var$_savedStyles[i + 4] && $cff96cc64f639998$var$_savedStyles[i + 4].query === media) {
        $cff96cc64f639998$var$_savedStyles[i].style.cssText = $cff96cc64f639998$var$_savedStyles[i + 1];
        $cff96cc64f639998$var$_savedStyles[i].getBBox && $cff96cc64f639998$var$_savedStyles[i].setAttribute("transform", $cff96cc64f639998$var$_savedStyles[i + 2] || "");
        $cff96cc64f639998$var$_savedStyles[i + 3].uncache = 1;
    }
}, $cff96cc64f639998$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($cff96cc64f639998$var$_i = 0; $cff96cc64f639998$var$_i < $cff96cc64f639998$var$_triggers.length; $cff96cc64f639998$var$_i++){
        trigger = $cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    $cff96cc64f639998$var$_isReverted = true;
    media && $cff96cc64f639998$var$_revertRecorded(media);
    media || $cff96cc64f639998$var$_dispatch("revert");
}, $cff96cc64f639998$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache++;
    (force || !$cff96cc64f639998$var$_refreshingAll) && (0, $7e9d8e753943228a$export$3cd1cee43d19b683).forEach(function(obj) {
        return $cff96cc64f639998$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $cff96cc64f639998$var$_isString(scrollRestoration) && ($cff96cc64f639998$var$_win.history.scrollRestoration = $cff96cc64f639998$var$_scrollRestoration = scrollRestoration);
}, $cff96cc64f639998$var$_refreshingAll, $cff96cc64f639998$var$_refreshID = 0, $cff96cc64f639998$var$_queueRefreshID, $cff96cc64f639998$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($cff96cc64f639998$var$_queueRefreshID !== $cff96cc64f639998$var$_refreshID) {
        var id = $cff96cc64f639998$var$_queueRefreshID = $cff96cc64f639998$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $cff96cc64f639998$var$_refreshID && $cff96cc64f639998$var$_refreshAll(true);
        });
    }
}, $cff96cc64f639998$var$_refresh100vh = function _refresh100vh() {
    $cff96cc64f639998$var$_body.appendChild($cff96cc64f639998$var$_div100vh);
    $cff96cc64f639998$var$_100vh = !$cff96cc64f639998$var$_normalizer && $cff96cc64f639998$var$_div100vh.offsetHeight || $cff96cc64f639998$var$_win.innerHeight;
    $cff96cc64f639998$var$_body.removeChild($cff96cc64f639998$var$_div100vh);
}, $cff96cc64f639998$var$_hideAllMarkers = function _hideAllMarkers(hide) {
    return $cff96cc64f639998$var$_toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
    });
}, $cff96cc64f639998$var$_refreshAll = function _refreshAll(force, skipRevert) {
    $cff96cc64f639998$var$_docEl = $cff96cc64f639998$var$_doc.documentElement; // some frameworks like Astro may cache the <body> and replace it during routing, so we'll just re-record the _docEl and _body for safety (otherwise, the markers may not get added properly).
    $cff96cc64f639998$var$_body = $cff96cc64f639998$var$_doc.body;
    $cff96cc64f639998$var$_root = [
        $cff96cc64f639998$var$_win,
        $cff96cc64f639998$var$_doc,
        $cff96cc64f639998$var$_docEl,
        $cff96cc64f639998$var$_body
    ];
    if ($cff96cc64f639998$var$_lastScrollTime && !force && !$cff96cc64f639998$var$_isReverted) {
        $cff96cc64f639998$var$_addListener($cff96cc64f639998$export$875bcbe48555930, "scrollEnd", $cff96cc64f639998$var$_softRefresh);
        return;
    }
    $cff96cc64f639998$var$_refresh100vh();
    $cff96cc64f639998$var$_refreshingAll = $cff96cc64f639998$export$875bcbe48555930.isRefreshing = true;
    (0, $7e9d8e753943228a$export$3cd1cee43d19b683).forEach(function(obj) {
        return $cff96cc64f639998$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    }); // force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
    var refreshInits = $cff96cc64f639998$var$_dispatch("refreshInit");
    $cff96cc64f639998$var$_sort && $cff96cc64f639998$export$875bcbe48555930.sort();
    skipRevert || $cff96cc64f639998$var$_revertAll();
    (0, $7e9d8e753943228a$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($cff96cc64f639998$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $cff96cc64f639998$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $cff96cc64f639998$var$_isReverted = false;
    $cff96cc64f639998$var$_triggers.forEach(function(t) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $cff96cc64f639998$var$_clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
    $cff96cc64f639998$var$_hideAllMarkers(true);
    $cff96cc64f639998$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $cff96cc64f639998$var$_maxScroll(t.scroller, t._dir), endClamp = t.vars.end === "max" || t._endClamp && t.end > max, startClamp = t._startClamp && t.start >= max;
        (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });
    $cff96cc64f639998$var$_hideAllMarkers(false);
    $cff96cc64f639998$var$_clampingMax = 0;
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $7e9d8e753943228a$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($cff96cc64f639998$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $cff96cc64f639998$var$_clearScrollMemory($cff96cc64f639998$var$_scrollRestoration, 1);
    $cff96cc64f639998$var$_resizeDelay.pause();
    $cff96cc64f639998$var$_refreshID++;
    $cff96cc64f639998$var$_refreshingAll = 2;
    $cff96cc64f639998$var$_updateAll(2);
    $cff96cc64f639998$var$_triggers.forEach(function(t) {
        return $cff96cc64f639998$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $cff96cc64f639998$var$_refreshingAll = $cff96cc64f639998$export$875bcbe48555930.isRefreshing = false;
    $cff96cc64f639998$var$_dispatch("refresh");
}, $cff96cc64f639998$var$_lastScroll = 0, $cff96cc64f639998$var$_direction = 1, $cff96cc64f639998$var$_primary, $cff96cc64f639998$var$_updateAll = function _updateAll(force) {
    if (force === 2 || !$cff96cc64f639998$var$_refreshingAll && !$cff96cc64f639998$var$_isReverted) {
        // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
        $cff96cc64f639998$export$875bcbe48555930.isUpdating = true;
        $cff96cc64f639998$var$_primary && $cff96cc64f639998$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $cff96cc64f639998$var$_triggers.length, time = $cff96cc64f639998$var$_getTime(), recordVelocity = time - $cff96cc64f639998$var$_time1 >= 50, scroll = l && $cff96cc64f639998$var$_triggers[0].scroll();
        $cff96cc64f639998$var$_direction = $cff96cc64f639998$var$_lastScroll > scroll ? -1 : 1;
        $cff96cc64f639998$var$_refreshingAll || ($cff96cc64f639998$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($cff96cc64f639998$var$_lastScrollTime && !$cff96cc64f639998$var$_pointerIsDown && time - $cff96cc64f639998$var$_lastScrollTime > 200) {
                $cff96cc64f639998$var$_lastScrollTime = 0;
                $cff96cc64f639998$var$_dispatch("scrollEnd");
            }
            $cff96cc64f639998$var$_time2 = $cff96cc64f639998$var$_time1;
            $cff96cc64f639998$var$_time1 = time;
        }
        if ($cff96cc64f639998$var$_direction < 0) {
            $cff96cc64f639998$var$_i = l;
            while($cff96cc64f639998$var$_i-- > 0)$cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_i] && $cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_i].update(0, recordVelocity);
            $cff96cc64f639998$var$_direction = 1;
        } else for($cff96cc64f639998$var$_i = 0; $cff96cc64f639998$var$_i < l; $cff96cc64f639998$var$_i++)$cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_i] && $cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_i].update(0, recordVelocity);
        $cff96cc64f639998$export$875bcbe48555930.isUpdating = false;
    }
    $cff96cc64f639998$var$_rafID = 0;
}, $cff96cc64f639998$var$_propNamesToCopy = [
    $cff96cc64f639998$var$_left,
    $cff96cc64f639998$var$_top,
    $cff96cc64f639998$var$_bottom,
    $cff96cc64f639998$var$_right,
    $cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Bottom,
    $cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Right,
    $cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Top,
    $cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $cff96cc64f639998$var$_stateProps = $cff96cc64f639998$var$_propNamesToCopy.concat([
    $cff96cc64f639998$var$_width,
    $cff96cc64f639998$var$_height,
    "boxSizing",
    "max" + $cff96cc64f639998$var$_Width,
    "max" + $cff96cc64f639998$var$_Height,
    "position",
    $cff96cc64f639998$var$_margin,
    $cff96cc64f639998$var$_padding,
    $cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Top,
    $cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Right,
    $cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Bottom,
    $cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Left
]), $cff96cc64f639998$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $cff96cc64f639998$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $cff96cc64f639998$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $cff96cc64f639998$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $cff96cc64f639998$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $cff96cc64f639998$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$cff96cc64f639998$var$_bottom] = pinStyle[$cff96cc64f639998$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$cff96cc64f639998$var$_width] = $cff96cc64f639998$var$_getSize(pin, (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1)) + $cff96cc64f639998$var$_px;
        spacerStyle[$cff96cc64f639998$var$_height] = $cff96cc64f639998$var$_getSize(pin, (0, $7e9d8e753943228a$export$8e40fc98ff518e9d)) + $cff96cc64f639998$var$_px;
        spacerStyle[$cff96cc64f639998$var$_padding] = pinStyle[$cff96cc64f639998$var$_margin] = pinStyle[$cff96cc64f639998$var$_top] = pinStyle[$cff96cc64f639998$var$_left] = "0";
        $cff96cc64f639998$var$_setState(spacerState);
        pinStyle[$cff96cc64f639998$var$_width] = pinStyle["max" + $cff96cc64f639998$var$_Width] = cs[$cff96cc64f639998$var$_width];
        pinStyle[$cff96cc64f639998$var$_height] = pinStyle["max" + $cff96cc64f639998$var$_Height] = cs[$cff96cc64f639998$var$_height];
        pinStyle[$cff96cc64f639998$var$_padding] = cs[$cff96cc64f639998$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $cff96cc64f639998$var$_capsExp = /([A-Z])/g, $cff96cc64f639998$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $cff96cc64f639998$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($cff96cc64f639998$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $cff96cc64f639998$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $cff96cc64f639998$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($cff96cc64f639998$var$_stateProps[i], style[$cff96cc64f639998$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $cff96cc64f639998$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $cff96cc64f639998$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$cff96cc64f639998$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $cff96cc64f639998$var$_isFunction(value) && (value = value(self));
    if ($cff96cc64f639998$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $cff96cc64f639998$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$cff96cc64f639998$var$_isNumber(value)) {
        $cff96cc64f639998$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $7e9d8e753943228a$export$937374fea3f88711)(trigger, self) || $cff96cc64f639998$var$_body;
        bounds = $cff96cc64f639998$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $cff96cc64f639998$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $cff96cc64f639998$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $cff96cc64f639998$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $cff96cc64f639998$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $cff96cc64f639998$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $cff96cc64f639998$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $cff96cc64f639998$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $cff96cc64f639998$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($cff96cc64f639998$var$_body[p1], $cff96cc64f639998$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $cff96cc64f639998$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $cff96cc64f639998$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $cff96cc64f639998$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $cff96cc64f639998$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $cff96cc64f639998$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $cff96cc64f639998$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $cff96cc64f639998$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $cff96cc64f639998$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$cff96cc64f639998$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $cff96cc64f639998$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $cff96cc64f639998$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = Math.round(value);
        return last1;
    };
}, $cff96cc64f639998$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $cff96cc64f639998$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$cff96cc64f639998$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $7e9d8e753943228a$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $cff96cc64f639998$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache++;
            getTween.tween && $cff96cc64f639998$var$_updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $cff96cc64f639998$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $cff96cc64f639998$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $cff96cc64f639998$export$875bcbe48555930.isTouch && $cff96cc64f639998$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $cff96cc64f639998$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $cff96cc64f639998$var$_coreInitted || ScrollTrigger.register($cff96cc64f639998$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $cff96cc64f639998$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$cff96cc64f639998$var$_enabled) {
            this.update = this.refresh = this.kill = $cff96cc64f639998$var$_passThrough;
            return;
        }
        vars = $cff96cc64f639998$var$_setDefaults($cff96cc64f639998$var$_isString(vars) || $cff96cc64f639998$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $cff96cc64f639998$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1) : (0, $7e9d8e753943228a$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $7e9d8e753943228a$export$937374fea3f88711)(vars.scroller || $cff96cc64f639998$var$_win), scrollerCache = $cff96cc64f639998$var$gsap.core.getCache(scroller), isViewport = $cff96cc64f639998$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $cff96cc64f639998$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($cff96cc64f639998$var$_getComputedStyle(scroller)["border" + direction.p2 + $cff96cc64f639998$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $cff96cc64f639998$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $cff96cc64f639998$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $7e9d8e753943228a$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $cff96cc64f639998$var$_sort = 1;
            vars.refreshPriority === -9999 && ($cff96cc64f639998$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $cff96cc64f639998$var$_getTweenCreator(scroller, (0, $7e9d8e753943228a$export$8e40fc98ff518e9d)),
            left: $cff96cc64f639998$var$_getTweenCreator(scroller, (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $cff96cc64f639998$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $cff96cc64f639998$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$cff96cc64f639998$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $cff96cc64f639998$var$_body.style && $cff96cc64f639998$var$gsap.set(isViewport ? [
                $cff96cc64f639998$var$_body,
                $cff96cc64f639998$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $7e9d8e753943228a$export$3cd1cee43d19b683).forEach(function(o) {
                return $cff96cc64f639998$var$_isFunction(o) && o.target === (isViewport ? $cff96cc64f639998$var$_doc.scrollingElement || $cff96cc64f639998$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $cff96cc64f639998$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $cff96cc64f639998$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $cff96cc64f639998$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $cff96cc64f639998$var$_snapDirectional(snap.snapTo)(value, $cff96cc64f639998$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $cff96cc64f639998$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $cff96cc64f639998$var$_isObject(snapDurClamp) ? $cff96cc64f639998$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $cff96cc64f639998$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $cff96cc64f639998$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $cff96cc64f639998$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$cff96cc64f639998$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($cff96cc64f639998$var$_getTime() - $cff96cc64f639998$var$_time2) * 1000 || 0, change1 = $cff96cc64f639998$var$gsap.utils.clamp(-progress, 1 - progress, $cff96cc64f639998$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    endValue = snapFunc(naturalEnd, self);
                    $cff96cc64f639998$var$_isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
                    endScroll = Math.max(0, Math.round(start + endValue * change));
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $cff96cc64f639998$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($cff96cc64f639998$var$_abs(Math.max($cff96cc64f639998$var$_abs(naturalEnd - totalProgress), $cff96cc64f639998$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $cff96cc64f639998$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                if (animation && !isToggle) // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                                scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($cff96cc64f639998$var$_ids[id] = self);
        trigger = self.trigger = (0, $7e9d8e753943228a$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $7e9d8e753943228a$export$937374fea3f88711)(pin);
        $cff96cc64f639998$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $cff96cc64f639998$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $cff96cc64f639998$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $cff96cc64f639998$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $cff96cc64f639998$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $7e9d8e753943228a$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $cff96cc64f639998$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $cff96cc64f639998$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $cff96cc64f639998$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $cff96cc64f639998$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $cff96cc64f639998$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $cff96cc64f639998$var$gsap.getProperty(pin);
            pinSetter = $cff96cc64f639998$var$gsap.quickSetter(pin, direction.a, $cff96cc64f639998$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $cff96cc64f639998$var$_swapPinIn(pin, spacer, cs);
            pinState = $cff96cc64f639998$var$_getState(pin);
        }
        if (markers) {
            markerVars = $cff96cc64f639998$var$_isObject(markers) ? $cff96cc64f639998$var$_setDefaults(markers, $cff96cc64f639998$var$_markerDefaults) : $cff96cc64f639998$var$_markerDefaults;
            markerStartTrigger = $cff96cc64f639998$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $cff96cc64f639998$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $7e9d8e753943228a$export$937374fea3f88711)((0, $7e9d8e753943228a$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $cff96cc64f639998$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $cff96cc64f639998$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $cff96cc64f639998$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $cff96cc64f639998$var$_px));
            if (!useFixedPosition && !((0, $7e9d8e753943228a$export$d8e56d510a804d0a).length && (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $cff96cc64f639998$var$_makePositionable(isViewport ? $cff96cc64f639998$var$_body : scroller);
                $cff96cc64f639998$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $cff96cc64f639998$var$gsap.quickSetter(markerStartTrigger, direction.a, $cff96cc64f639998$var$_px);
                markerEndSetter = $cff96cc64f639998$var$gsap.quickSetter(markerEndTrigger, direction.a, $cff96cc64f639998$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $cff96cc64f639998$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $cff96cc64f639998$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $cff96cc64f639998$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $cff96cc64f639998$var$_swapPinIn(pin, spacer, $cff96cc64f639998$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $cff96cc64f639998$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($cff96cc64f639998$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $cff96cc64f639998$var$_lastScrollTime) {
                $cff96cc64f639998$var$_addListener(ScrollTrigger, "scrollEnd", $cff96cc64f639998$var$_softRefresh);
                return;
            }
            !$cff96cc64f639998$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $cff96cc64f639998$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.revert({
                kill: false
            }).invalidate();
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $cff96cc64f639998$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $cff96cc64f639998$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $cff96cc64f639998$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $7e9d8e753943228a$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $cff96cc64f639998$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $cff96cc64f639998$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $cff96cc64f639998$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $cff96cc64f639998$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i-- > 0){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $cff96cc64f639998$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($cff96cc64f639998$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $cff96cc64f639998$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $cff96cc64f639998$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $cff96cc64f639998$var$_parseClamp(parsedStart, "start", self);
            start = $cff96cc64f639998$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $cff96cc64f639998$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($cff96cc64f639998$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($cff96cc64f639998$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $cff96cc64f639998$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $cff96cc64f639998$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $cff96cc64f639998$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $cff96cc64f639998$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $cff96cc64f639998$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $cff96cc64f639998$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$cff96cc64f639998$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $cff96cc64f639998$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $cff96cc64f639998$var$gsap.utils.clamp(0, 1, $cff96cc64f639998$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $cff96cc64f639998$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin && !($cff96cc64f639998$var$_clampingMax && self.end >= $cff96cc64f639998$var$_maxScroll(scroller, direction))) {
                cs = $cff96cc64f639998$var$_getComputedStyle(pin);
                isVertical = direction === (0, $7e9d8e753943228a$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $cff96cc64f639998$var$_doc.scrollingElement || $cff96cc64f639998$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $cff96cc64f639998$var$_getComputedStyle($cff96cc64f639998$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $cff96cc64f639998$var$_swapPinIn(pin, spacer, cs);
                pinState = $cff96cc64f639998$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $cff96cc64f639998$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $7e9d8e753943228a$export$8665aac53dad5647)(scroller, isVertical ? (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1) : (0, $7e9d8e753943228a$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $cff96cc64f639998$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $cff96cc64f639998$var$_padding ? $cff96cc64f639998$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    if (i) {
                        spacerState.push(direction.d, i + $cff96cc64f639998$var$_px); // for box-sizing: border-box (must include padding).
                        spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $cff96cc64f639998$var$_px);
                    }
                    $cff96cc64f639998$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $cff96cc64f639998$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                } else {
                    i = $cff96cc64f639998$var$_getSize(pin, direction);
                    i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $cff96cc64f639998$var$_px);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $cff96cc64f639998$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $cff96cc64f639998$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$cff96cc64f639998$var$_width] = override["max" + $cff96cc64f639998$var$_Width] = Math.ceil(bounds.width) + $cff96cc64f639998$var$_px;
                    override[$cff96cc64f639998$var$_height] = override["max" + $cff96cc64f639998$var$_Height] = Math.ceil(bounds.height) + $cff96cc64f639998$var$_px;
                    override[$cff96cc64f639998$var$_margin] = override[$cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Top] = override[$cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Right] = override[$cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Bottom] = override[$cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Left] = "0";
                    override[$cff96cc64f639998$var$_padding] = cs[$cff96cc64f639998$var$_padding];
                    override[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Top] = cs[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Top];
                    override[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Right] = cs[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Right];
                    override[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Bottom] = cs[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Bottom];
                    override[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Left] = cs[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Left];
                    pinActiveState = $cff96cc64f639998$var$_copyState(pinOriginalState, override, pinReparent);
                    $cff96cc64f639998$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $cff96cc64f639998$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $cff96cc64f639998$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $cff96cc64f639998$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $cff96cc64f639998$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$cff96cc64f639998$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $cff96cc64f639998$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $cff96cc64f639998$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh || animation && !animation._initted) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $cff96cc64f639998$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $cff96cc64f639998$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $cff96cc64f639998$var$gsap.getProperty(markerEndTrigger, direction.p);
                $cff96cc64f639998$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $cff96cc64f639998$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $cff96cc64f639998$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $cff96cc64f639998$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$cff96cc64f639998$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$cff96cc64f639998$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($cff96cc64f639998$var$_getTime() - $cff96cc64f639998$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $cff96cc64f639998$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $cff96cc64f639998$var$_endAnimation(animation, animation.reversed()) : isToggle || $cff96cc64f639998$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $cff96cc64f639998$var$_triggers.indexOf(self), a = self.direction > 0 ? $cff96cc64f639998$var$_triggers.slice(0, i).reverse() : $cff96cc64f639998$var$_triggers.slice(i + 1);
            return ($cff96cc64f639998$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $cff96cc64f639998$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            if (anticipatePin && pin && !$cff96cc64f639998$var$_refreshing && !$cff96cc64f639998$var$_startup && $cff96cc64f639998$var$_lastScrollTime) {
                if (!clipped && start < scroll + (scroll - scroll2) / ($cff96cc64f639998$var$_getTime() - $cff96cc64f639998$var$_time2) * anticipatePin) clipped = 0.0001;
                else if (clipped === 1 && end > scroll + (scroll - scroll2) / ($cff96cc64f639998$var$_getTime() - $cff96cc64f639998$var$_time2) * anticipatePin) clipped = 0.9999;
            }
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$cff96cc64f639998$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($cff96cc64f639998$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$cff96cc64f639998$var$_refreshing && !$cff96cc64f639998$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($cff96cc64f639998$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($cff96cc64f639998$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $cff96cc64f639998$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $cff96cc64f639998$var$_getBounds(pin, true), _offset = scroll - start;
                                $cff96cc64f639998$var$_reparent(pin, $cff96cc64f639998$var$_body, bounds.top + (direction === (0, $7e9d8e753943228a$export$8e40fc98ff518e9d) ? _offset : 0) + $cff96cc64f639998$var$_px, bounds.left + (direction === (0, $7e9d8e753943228a$export$8e40fc98ff518e9d) ? 0 : _offset) + $cff96cc64f639998$var$_px);
                            } else $cff96cc64f639998$var$_reparent(pin, spacer);
                        }
                        $cff96cc64f639998$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$cff96cc64f639998$var$_refreshing && !$cff96cc64f639998$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$cff96cc64f639998$var$_limitCallbacks)) && $cff96cc64f639998$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$cff96cc64f639998$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$cff96cc64f639998$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $cff96cc64f639998$var$_callback(self, onToggle);
                        callbacks[toggleState] && $cff96cc64f639998$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $cff96cc64f639998$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($cff96cc64f639998$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $cff96cc64f639998$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $cff96cc64f639998$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$cff96cc64f639998$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $cff96cc64f639998$var$_addListener(scroller, "resize", $cff96cc64f639998$var$_onResize);
                isViewport || $cff96cc64f639998$var$_addListener(scroller, "scroll", $cff96cc64f639998$var$_onScroll);
                onRefreshInit && $cff96cc64f639998$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $cff96cc64f639998$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $cff96cc64f639998$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $cff96cc64f639998$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $cff96cc64f639998$var$_px;
                $cff96cc64f639998$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert(true, true);
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $cff96cc64f639998$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $cff96cc64f639998$var$_triggers.length;
                    while(i--){
                        if ($cff96cc64f639998$var$_triggers[i].scroller === scroller && $cff96cc64f639998$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $cff96cc64f639998$var$_removeListener(scroller, "resize", $cff96cc64f639998$var$_onResize);
                    isViewport || $cff96cc64f639998$var$_removeListener(scroller, "scroll", $cff96cc64f639998$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $cff96cc64f639998$var$_ids[id];
            var i = $cff96cc64f639998$var$_triggers.indexOf(self);
            i >= 0 && $cff96cc64f639998$var$_triggers.splice(i, 1);
            i === $cff96cc64f639998$var$_i && $cff96cc64f639998$var$_direction > 0 && $cff96cc64f639998$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $cff96cc64f639998$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $cff96cc64f639998$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $cff96cc64f639998$var$_primary === self && ($cff96cc64f639998$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $cff96cc64f639998$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $cff96cc64f639998$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache++; // otherwise a cached scroll position may get used in the refresh() in a very rare scenario, like if ScrollTriggers are created inside a DOMContentLoaded event and the queued requestAnimationFrame() fires beforehand. See https://gsap.com/community/forums/topic/41267-scrolltrigger-breaks-on-refresh-when-using-domcontentloaded/
                start || end || self.refresh();
            };
            $cff96cc64f639998$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $cff96cc64f639998$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$cff96cc64f639998$var$_coreInitted) {
            $cff96cc64f639998$var$gsap = core || $cff96cc64f639998$var$_getGSAP();
            $cff96cc64f639998$var$_windowExists() && window.document && ScrollTrigger.enable();
            $cff96cc64f639998$var$_coreInitted = $cff96cc64f639998$var$_enabled;
        }
        return $cff96cc64f639998$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$cff96cc64f639998$var$_defaults[p] = config[p];
        return $cff96cc64f639998$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $cff96cc64f639998$var$_enabled = 0;
        $cff96cc64f639998$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_win, "wheel", $cff96cc64f639998$var$_onScroll);
        $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_doc, "scroll", $cff96cc64f639998$var$_onScroll);
        clearInterval($cff96cc64f639998$var$_syncInterval);
        $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_doc, "touchcancel", $cff96cc64f639998$var$_passThrough);
        $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_body, "touchstart", $cff96cc64f639998$var$_passThrough);
        $cff96cc64f639998$var$_multiListener($cff96cc64f639998$var$_removeListener, $cff96cc64f639998$var$_doc, "pointerdown,touchstart,mousedown", $cff96cc64f639998$var$_pointerDownHandler);
        $cff96cc64f639998$var$_multiListener($cff96cc64f639998$var$_removeListener, $cff96cc64f639998$var$_doc, "pointerup,touchend,mouseup", $cff96cc64f639998$var$_pointerUpHandler);
        $cff96cc64f639998$var$_resizeDelay.kill();
        $cff96cc64f639998$var$_iterateAutoRefresh($cff96cc64f639998$var$_removeListener);
        for(var i = 0; i < (0, $7e9d8e753943228a$export$3cd1cee43d19b683).length; i += 3){
            $cff96cc64f639998$var$_wheelListener($cff96cc64f639998$var$_removeListener, (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i], (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i + 1]);
            $cff96cc64f639998$var$_wheelListener($cff96cc64f639998$var$_removeListener, (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i], (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $cff96cc64f639998$var$_win = window;
        $cff96cc64f639998$var$_doc = document;
        $cff96cc64f639998$var$_docEl = $cff96cc64f639998$var$_doc.documentElement;
        $cff96cc64f639998$var$_body = $cff96cc64f639998$var$_doc.body;
        if ($cff96cc64f639998$var$gsap) {
            $cff96cc64f639998$var$_toArray = $cff96cc64f639998$var$gsap.utils.toArray;
            $cff96cc64f639998$var$_clamp = $cff96cc64f639998$var$gsap.utils.clamp;
            $cff96cc64f639998$var$_context = $cff96cc64f639998$var$gsap.core.context || $cff96cc64f639998$var$_passThrough;
            $cff96cc64f639998$var$_suppressOverwrites = $cff96cc64f639998$var$gsap.core.suppressOverwrites || $cff96cc64f639998$var$_passThrough;
            $cff96cc64f639998$var$_scrollRestoration = $cff96cc64f639998$var$_win.history.scrollRestoration || "auto";
            $cff96cc64f639998$var$_lastScroll = $cff96cc64f639998$var$_win.pageYOffset || 0;
            $cff96cc64f639998$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($cff96cc64f639998$var$_body) {
                $cff96cc64f639998$var$_enabled = 1;
                $cff96cc64f639998$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $cff96cc64f639998$var$_div100vh.style.height = "100vh";
                $cff96cc64f639998$var$_div100vh.style.position = "absolute";
                $cff96cc64f639998$var$_refresh100vh();
                $cff96cc64f639998$var$_rafBugFix();
                (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).register($cff96cc64f639998$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).isTouch;
                $cff96cc64f639998$var$_fixIOSBug = (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $cff96cc64f639998$var$_ignoreMobileResize = (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).isTouch === 1;
                $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_win, "wheel", $cff96cc64f639998$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $cff96cc64f639998$var$_root = [
                    $cff96cc64f639998$var$_win,
                    $cff96cc64f639998$var$_doc,
                    $cff96cc64f639998$var$_docEl,
                    $cff96cc64f639998$var$_body
                ];
                if ($cff96cc64f639998$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $cff96cc64f639998$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $cff96cc64f639998$var$gsap.addEventListener("matchMediaInit", function() {
                        return $cff96cc64f639998$var$_revertAll();
                    });
                    $cff96cc64f639998$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $cff96cc64f639998$var$_revertRecorded();
                    });
                    $cff96cc64f639998$var$gsap.addEventListener("matchMedia", function() {
                        $cff96cc64f639998$var$_refreshAll(0, 1);
                        $cff96cc64f639998$var$_dispatch("matchMedia");
                    });
                    $cff96cc64f639998$var$gsap.matchMedia().add("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $cff96cc64f639998$var$_setBaseDimensions();
                        return $cff96cc64f639998$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $cff96cc64f639998$var$_setBaseDimensions();
                $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_doc, "scroll", $cff96cc64f639998$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyHasStyle = $cff96cc64f639998$var$_body.hasAttribute("style"), bodyStyle = $cff96cc64f639998$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $cff96cc64f639998$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $cff96cc64f639998$var$_getBounds($cff96cc64f639998$var$_body);
                (0, $7e9d8e753943228a$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $7e9d8e753943228a$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style");
                if (!bodyHasStyle) {
                    // SSR frameworks like Next.js complain if this attribute gets added.
                    $cff96cc64f639998$var$_body.setAttribute("style", ""); // it's not enough to just removeAttribute() - we must first set it to empty, otherwise Next.js complains.
                    $cff96cc64f639998$var$_body.removeAttribute("style");
                } // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $cff96cc64f639998$var$_syncInterval = setInterval($cff96cc64f639998$var$_sync, 250);
                $cff96cc64f639998$var$gsap.delayedCall(0.5, function() {
                    return $cff96cc64f639998$var$_startup = 0;
                });
                $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_doc, "touchcancel", $cff96cc64f639998$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_body, "touchstart", $cff96cc64f639998$var$_passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $cff96cc64f639998$var$_multiListener($cff96cc64f639998$var$_addListener, $cff96cc64f639998$var$_doc, "pointerdown,touchstart,mousedown", $cff96cc64f639998$var$_pointerDownHandler);
                $cff96cc64f639998$var$_multiListener($cff96cc64f639998$var$_addListener, $cff96cc64f639998$var$_doc, "pointerup,touchend,mouseup", $cff96cc64f639998$var$_pointerUpHandler);
                $cff96cc64f639998$var$_transformProp = $cff96cc64f639998$var$gsap.utils.checkPrefix("transform");
                $cff96cc64f639998$var$_stateProps.push($cff96cc64f639998$var$_transformProp);
                $cff96cc64f639998$var$_coreInitted = $cff96cc64f639998$var$_getTime();
                $cff96cc64f639998$var$_resizeDelay = $cff96cc64f639998$var$gsap.delayedCall(0.2, $cff96cc64f639998$var$_refreshAll).pause();
                $cff96cc64f639998$var$_autoRefresh = [
                    $cff96cc64f639998$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $cff96cc64f639998$var$_win.innerWidth, h = $cff96cc64f639998$var$_win.innerHeight;
                        if ($cff96cc64f639998$var$_doc.hidden) {
                            $cff96cc64f639998$var$_prevWidth = w;
                            $cff96cc64f639998$var$_prevHeight = h;
                        } else if ($cff96cc64f639998$var$_prevWidth !== w || $cff96cc64f639998$var$_prevHeight !== h) $cff96cc64f639998$var$_onResize();
                    },
                    $cff96cc64f639998$var$_doc,
                    "DOMContentLoaded",
                    $cff96cc64f639998$var$_refreshAll,
                    $cff96cc64f639998$var$_win,
                    "load",
                    $cff96cc64f639998$var$_refreshAll,
                    $cff96cc64f639998$var$_win,
                    "resize",
                    $cff96cc64f639998$var$_onResize
                ];
                $cff96cc64f639998$var$_iterateAutoRefresh($cff96cc64f639998$var$_addListener);
                $cff96cc64f639998$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $7e9d8e753943228a$export$3cd1cee43d19b683).length; i += 3){
                    $cff96cc64f639998$var$_wheelListener($cff96cc64f639998$var$_removeListener, (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i], (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i + 1]);
                    $cff96cc64f639998$var$_wheelListener($cff96cc64f639998$var$_removeListener, (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i], (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($cff96cc64f639998$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($cff96cc64f639998$var$_syncInterval) || ($cff96cc64f639998$var$_syncInterval = ms) && setInterval($cff96cc64f639998$var$_sync, ms);
        "ignoreMobileResize" in vars && ($cff96cc64f639998$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $cff96cc64f639998$var$_iterateAutoRefresh($cff96cc64f639998$var$_removeListener) || $cff96cc64f639998$var$_iterateAutoRefresh($cff96cc64f639998$var$_addListener, vars.autoRefreshEvents || "none");
            $cff96cc64f639998$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $7e9d8e753943228a$export$937374fea3f88711)(target), i = (0, $7e9d8e753943228a$export$3cd1cee43d19b683).indexOf(t), isViewport = $cff96cc64f639998$var$_isViewport(t);
        if (~i) (0, $7e9d8e753943228a$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $7e9d8e753943228a$export$d8e56d510a804d0a).unshift($cff96cc64f639998$var$_win, vars, $cff96cc64f639998$var$_body, vars, $cff96cc64f639998$var$_docEl, vars) : (0, $7e9d8e753943228a$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $cff96cc64f639998$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($cff96cc64f639998$var$_isString(element) ? (0, $7e9d8e753943228a$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $cff96cc64f639998$var$_width : $cff96cc64f639998$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $cff96cc64f639998$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $cff96cc64f639998$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $cff96cc64f639998$var$_isString(element) && (element = (0, $7e9d8e753943228a$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $cff96cc64f639998$var$_width : $cff96cc64f639998$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $cff96cc64f639998$var$_keywords ? $cff96cc64f639998$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $cff96cc64f639998$var$_win.innerWidth : (bounds.top + offset) / $cff96cc64f639998$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $cff96cc64f639998$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $cff96cc64f639998$var$_listeners.killAll || [];
            $cff96cc64f639998$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$cff96cc64f639998$export$875bcbe48555930.version = "3.12.7";
$cff96cc64f639998$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $cff96cc64f639998$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $cff96cc64f639998$var$_savedStyles.indexOf(target);
            i >= 0 && $cff96cc64f639998$var$_savedStyles.splice(i, 5);
            $cff96cc64f639998$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $cff96cc64f639998$var$gsap.core.getCache(target), $cff96cc64f639998$var$_context());
        }
    }) : $cff96cc64f639998$var$_savedStyles;
};
$cff96cc64f639998$export$875bcbe48555930.revert = function(soft, media) {
    return $cff96cc64f639998$var$_revertAll(!soft, media);
};
$cff96cc64f639998$export$875bcbe48555930.create = function(vars, animation) {
    return new $cff96cc64f639998$export$875bcbe48555930(vars, animation);
};
$cff96cc64f639998$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $cff96cc64f639998$var$_onResize(true) : ($cff96cc64f639998$var$_coreInitted || $cff96cc64f639998$export$875bcbe48555930.register()) && $cff96cc64f639998$var$_refreshAll(true);
};
$cff96cc64f639998$export$875bcbe48555930.update = function(force) {
    return ++(0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache && $cff96cc64f639998$var$_updateAll(force === true ? 2 : 0);
};
$cff96cc64f639998$export$875bcbe48555930.clearScrollMemory = $cff96cc64f639998$var$_clearScrollMemory;
$cff96cc64f639998$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $cff96cc64f639998$var$_maxScroll(element, horizontal ? (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1) : (0, $7e9d8e753943228a$export$8e40fc98ff518e9d));
};
$cff96cc64f639998$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $7e9d8e753943228a$export$8665aac53dad5647)((0, $7e9d8e753943228a$export$937374fea3f88711)(element), horizontal ? (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1) : (0, $7e9d8e753943228a$export$8e40fc98ff518e9d));
};
$cff96cc64f639998$export$875bcbe48555930.getById = function(id) {
    return $cff96cc64f639998$var$_ids[id];
};
$cff96cc64f639998$export$875bcbe48555930.getAll = function() {
    return $cff96cc64f639998$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$cff96cc64f639998$export$875bcbe48555930.isScrolling = function() {
    return !!$cff96cc64f639998$var$_lastScrollTime;
};
$cff96cc64f639998$export$875bcbe48555930.snapDirectional = $cff96cc64f639998$var$_snapDirectional;
$cff96cc64f639998$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $cff96cc64f639998$var$_listeners[type] || ($cff96cc64f639998$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$cff96cc64f639998$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $cff96cc64f639998$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$cff96cc64f639998$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $cff96cc64f639998$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $cff96cc64f639998$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($cff96cc64f639998$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $cff96cc64f639998$var$_addListener($cff96cc64f639998$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $cff96cc64f639998$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($cff96cc64f639998$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $cff96cc64f639998$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $cff96cc64f639998$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $cff96cc64f639998$var$_docEl && _allowNativePanning($cff96cc64f639998$var$_body, direction);
}, $cff96cc64f639998$var$_overflow = {
    auto: 1,
    scroll: 1
}, $cff96cc64f639998$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $cff96cc64f639998$var$gsap.core.getCache(node), time = $cff96cc64f639998$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $cff96cc64f639998$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($cff96cc64f639998$var$_overflow[(cs = $cff96cc64f639998$var$_getComputedStyle(node)).overflowY] || $cff96cc64f639998$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$cff96cc64f639998$var$_isViewport(node) && ($cff96cc64f639998$var$_overflow[(cs = $cff96cc64f639998$var$_getComputedStyle(node)).overflowY] || $cff96cc64f639998$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$cff96cc64f639998$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $cff96cc64f639998$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_doc, (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).eventTypes[0], $cff96cc64f639998$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_doc, (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).eventTypes[0], $cff96cc64f639998$var$_captureInputs, true);
        }
    });
}, $cff96cc64f639998$var$_inputExp = /(input|label|select|textarea)/i, $cff96cc64f639998$var$_inputIsFocused, $cff96cc64f639998$var$_captureInputs = function _captureInputs(e) {
    var isInput = $cff96cc64f639998$var$_inputExp.test(e.target.tagName);
    if (isInput || $cff96cc64f639998$var$_inputIsFocused) {
        e._gsapAllow = true;
        $cff96cc64f639998$var$_inputIsFocused = isInput;
    }
}, $cff96cc64f639998$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $cff96cc64f639998$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $7e9d8e753943228a$export$937374fea3f88711)(vars.target) || $cff96cc64f639998$var$_docEl, smoother = $cff96cc64f639998$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $cff96cc64f639998$var$_fixIOSBug && (vars.content && (0, $7e9d8e753943228a$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $7e9d8e753943228a$export$8665aac53dad5647)(target, (0, $7e9d8e753943228a$export$8e40fc98ff518e9d)), scrollFuncX = (0, $7e9d8e753943228a$export$8665aac53dad5647)(target, (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).isTouch && $cff96cc64f639998$var$_win.visualViewport ? $cff96cc64f639998$var$_win.visualViewport.scale * $cff96cc64f639998$var$_win.visualViewport.width : $cff96cc64f639998$var$_win.outerWidth) / $cff96cc64f639998$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $cff96cc64f639998$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $cff96cc64f639998$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $cff96cc64f639998$var$_passThrough, scrollClampY = $cff96cc64f639998$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $cff96cc64f639998$var$_maxScroll(target, (0, $7e9d8e753943228a$export$8e40fc98ff518e9d));
        scrollClampY = $cff96cc64f639998$var$_clamp($cff96cc64f639998$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $cff96cc64f639998$var$_clamp(0, $cff96cc64f639998$var$_maxScroll(target, (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1))));
        lastRefreshID = $cff96cc64f639998$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $cff96cc64f639998$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $cff96cc64f639998$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $cff96cc64f639998$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache;
                $cff96cc64f639998$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $cff96cc64f639998$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $cff96cc64f639998$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $cff96cc64f639998$var$_round(($cff96cc64f639998$var$_win.visualViewport && $cff96cc64f639998$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $cff96cc64f639998$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $cff96cc64f639998$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $cff96cc64f639998$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $cff96cc64f639998$var$_maxScroll(target, (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $cff96cc64f639998$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $cff96cc64f639998$var$_maxScroll(target, (0, $7e9d8e753943228a$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($cff96cc64f639998$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $cff96cc64f639998$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($cff96cc64f639998$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $cff96cc64f639998$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $cff96cc64f639998$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $cff96cc64f639998$var$_updateAll();
    };
    vars.onEnable = function() {
        $cff96cc64f639998$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $cff96cc64f639998$export$875bcbe48555930.addEventListener("refresh", onResize);
        $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $cff96cc64f639998$var$_allowNativePanning(target, true);
        $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_win, "resize", onResize);
        $cff96cc64f639998$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $cff96cc64f639998$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $cff96cc64f639998$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $cff96cc64f639998$var$_fixIOSBug && $cff96cc64f639998$var$gsap.ticker.add($cff96cc64f639998$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $cff96cc64f639998$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $cff96cc64f639998$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $cff96cc64f639998$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$cff96cc64f639998$export$875bcbe48555930.sort = function(func) {
    if ($cff96cc64f639998$var$_isFunction(func)) return $cff96cc64f639998$var$_triggers.sort(func);
    var scroll = $cff96cc64f639998$var$_win.pageYOffset || 0;
    $cff96cc64f639998$export$875bcbe48555930.getAll().forEach(function(t) {
        return t._sortY = t.trigger ? scroll + t.trigger.getBoundingClientRect().top : t.start + $cff96cc64f639998$var$_win.innerHeight;
    });
    return $cff96cc64f639998$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + (a.vars.containerAnimation ? 1e6 : a._sortY) - ((b.vars.containerAnimation ? 1e6 : b._sortY) + (b.vars.refreshPriority || 0) * -1000000);
    }); // anything with a containerAnimation should refresh last.
};
$cff96cc64f639998$export$875bcbe48555930.observe = function(vars) {
    return new (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b)(vars);
};
$cff96cc64f639998$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $cff96cc64f639998$var$_normalizer;
    if (vars === true && $cff96cc64f639998$var$_normalizer) return $cff96cc64f639998$var$_normalizer.enable();
    if (vars === false) {
        $cff96cc64f639998$var$_normalizer && $cff96cc64f639998$var$_normalizer.kill();
        $cff96cc64f639998$var$_normalizer = vars;
        return;
    }
    var normalizer = vars instanceof (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b) ? vars : $cff96cc64f639998$var$_getScrollNormalizer(vars);
    $cff96cc64f639998$var$_normalizer && $cff96cc64f639998$var$_normalizer.target === normalizer.target && $cff96cc64f639998$var$_normalizer.kill();
    $cff96cc64f639998$var$_isViewport(normalizer.target) && ($cff96cc64f639998$var$_normalizer = normalizer);
    return normalizer;
};
$cff96cc64f639998$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $7e9d8e753943228a$export$5de019f4480f0f8d),
    _inputObserver: $cff96cc64f639998$var$_inputObserver,
    _scrollers: (0, $7e9d8e753943228a$export$3cd1cee43d19b683),
    _proxies: (0, $7e9d8e753943228a$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $cff96cc64f639998$var$_lastScrollTime || $cff96cc64f639998$var$_dispatch("scrollStart");
            $cff96cc64f639998$var$_lastScrollTime = $cff96cc64f639998$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $cff96cc64f639998$var$_refreshing;
        }
    }
};
$cff96cc64f639998$var$_getGSAP() && $cff96cc64f639998$var$gsap.registerPlugin($cff96cc64f639998$export$875bcbe48555930);




(0, $1974f63041948ee8$export$99ee26438460406a).registerPlugin((0, $cff96cc64f639998$export$875bcbe48555930));
class $ba8905e5c0e6f6bd$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root;
        this.video = this.root.querySelector('.flipbook-video');
        this.btnWrapper = document.querySelector('.flipbook-controls');
        this.btn = this.btnWrapper.querySelector('.toggle-animations');
        this.animationPaused = false;
        this.checkVideoTime = this.checkVideoTime.bind(this);
        this.firstFrameImg = this.root.querySelector('.flipbook-first-frame');
        this.triggers = document.querySelectorAll('.flipbooktrigger');
        let currentSize = window.innerWidth > 1200 ? 'large' : 'small';
        // Set initial video
        this.video.src = currentSize === 'large' ? './assets/videos/tinkertank-notransparency-large-opt.mp4' : './assets/videos/tinkertank-notransparency-small-opt.mp4';
        this.video.load();
        window.addEventListener('resize', ()=>{
            if ((0, $ac6e65077e03f9d6$export$2a111da947c407d2).w > 1200 && currentSize === 'small') {
                // Upgrade from small to large
                this.video.src = './assets/videos/tinkertank-notransparency-large-opt.mp4';
                this.video.load();
                currentSize = 'large';
            }
        });
        this.siblingColumns = [
            ...this.triggers,
            this.root
        ].map((trigger)=>{
            const parentColumn = trigger.closest('.column');
            return Array.from(parentColumn.parentElement.children).filter((sibling)=>sibling !== parentColumn && sibling.classList.contains('column'));
        });
        this.siblingColumns.forEach((siblingColumn, index)=>{
            siblingColumn[0].classList.add('flipbook-sibling-column');
        });
        this.videoDuration = 14.2; // Default duration, will be updated when video metadata is loaded
        this.video.addEventListener('loadedmetadata', ()=>{
            this.videoDuration = this.video.duration;
        //   console.log('video loaded', this.videoDuration);
        });
        setTimeout(()=>{
            this.setupScrollTriggers();
        }, 200);
        this.btn.addEventListener('click', ()=>{
            this.animationPaused = !this.animationPaused;
            this.btn.classList.toggle('is-paused', this.animationPaused);
            if (this.animationPaused) this.video.pause();
            else {
                this.video.play();
                requestAnimationFrame(this.checkVideoTime);
            //   console.log('play it')
            }
        });
    }
    setupScrollTriggers() {
        (0, $cff96cc64f639998$export$875bcbe48555930).getAll().forEach((trigger)=>trigger.kill());
        const container = this.root.closest('.column');
        container.classList.add('no-container');
        const startPinPos = window.innerWidth < 720 ? 'bottom bottom' : 'center center';
        // Pin the video
        (0, $cff96cc64f639998$export$875bcbe48555930).create({
            trigger: this.root,
            start: startPinPos,
            endTrigger: this.triggers[this.triggers.length - 1],
            end: 'center center',
            //   markers: true,
            pin: this.root,
            onEnter: ()=>{
                const layoutLeft = document.querySelector('.layout').getBoundingClientRect().left;
                Object.assign(this.btnWrapper.style, {
                    position: 'fixed',
                    left: `${layoutLeft}px`,
                    opacity: '1',
                    transform: 'translateY(0)'
                });
            },
            onLeave: ()=>{
                this.btnWrapper.style.opacity = '0';
            },
            onEnterBack: ()=>{
                const layoutLeft = document.querySelector('.layout').getBoundingClientRect().left;
                Object.assign(this.btnWrapper.style, {
                    position: 'fixed',
                    left: `${layoutLeft}px`,
                    opacity: '1',
                    transform: 'translateY(0)'
                });
            },
            onLeaveBack: ()=>{
                this.btnWrapper.style.opacity = '0';
            }
        });
        this.desiredTime = 0;
        // Scroll scrubbing for each trigger section
        this.triggers.forEach((trigger, index)=>{
            const startFrame = parseInt(trigger.dataset.startFrame, 10) - 1;
            const endFrame = parseInt(trigger.dataset.endFrame, 10) - 1;
            // Automatically find highest endFrame to calculate totalFrames
            const totalFrames = Math.max(...Array.from(this.triggers).map((t)=>parseInt(t.dataset.endFrame, 10)));
            let startPos = 'top bottom';
            if (index === 0 && (0, $ac6e65077e03f9d6$export$2a111da947c407d2).w > 720) startPos = 'top center';
            (0, $cff96cc64f639998$export$875bcbe48555930).create({
                trigger: trigger,
                // start: index === 0 ? 'top center' : 'top bottom',
                // start: index === 0 && doc.w < 720 ? 'top center' : 'top bottom',
                start: startPos,
                end: 'bottom bottom',
                scrub: 1,
                // markers: true,
                onToggle: (self)=>{
                    const siblingColumn = this.siblingColumns[index];
                    if (siblingColumn) siblingColumn[0].classList.toggle('is-active', self.isActive);
                },
                onUpdate: (self)=>{
                    const progressStart = startFrame / totalFrames;
                    const progressEnd = endFrame / totalFrames;
                    const videoProgress = (0, $76149f9d24a90a9e$export$871de8747c9eaa88)(self.progress, 0, 1, progressStart, progressEnd);
                    this.desiredTime = (0, $76149f9d24a90a9e$export$7d15b64cf5a3a4c4)(videoProgress * this.videoDuration, 0, this.videoDuration);
                    if (!this.animationPaused) {
                        // console.log(this.desiredTime)
                        if (this.video.currentTime < this.desiredTime && this.desiredTime - this.video.currentTime < 2.5) {
                            this.video.play();
                            requestAnimationFrame(this.checkVideoTime);
                        // console.log('play it until desired time')
                        } else {
                            this.video.pause();
                            this.video.currentTime = this.desiredTime;
                        // console.log('set time directly')
                        }
                    } else this.video.pause();
                    if (this.desiredTime === 0) {
                        this.firstFrameImg.style.display = 'block';
                        this.video.style.display = 'none';
                        this.root.style.zIndex = "0";
                        this.video.currentTime = 0;
                        this.video.pause();
                    } else {
                        this.video.style.display = 'block';
                        this.root.style.zIndex = "-1";
                        this.firstFrameImg.style.display = 'none';
                    }
                }
            });
        });
        // Start the loop
        requestAnimationFrame(this.checkVideoTime);
    }
    checkVideoTime() {
        // console.log('checkVideoTime')
        // console.log(this.video)
        if (this.video && this.video.currentTime > this.desiredTime) this.video.pause();
        else requestAnimationFrame(this.checkVideoTime);
    }
}


class $ae13e61272ec84ae$export$2e2bcd8739ae039 {
    constructor(){
        this.root = null;
        this.columns = 10;
        this.rows = 5;
        this.dots = [];
        this.audioEnabled = false;
        this.animationStep = 0; // Tracks which animation should play
    }
    init(root) {
        this.root = root;
        this.updateGrid();
        window.addEventListener("resize", ()=>this.updateGrid());
        this.button = document.querySelector(".flipdotdisplay-button");
        if (this.button) this.button.addEventListener("click", ()=>this.runAnimations());
    }
    updateGrid() {
        const containerWidth = this.root.clientWidth;
        let dotSize = Math.floor(containerWidth / this.columns);
        dotSize = Math.max(24, Math.min(50, dotSize));
        this.columns = Math.floor(containerWidth / dotSize);
        dotSize = containerWidth / this.columns;
        this.rows = Math.min(8, Math.floor(this.columns / 2));
        this.root.innerHTML = "";
        this.dots = [];
        this.root.style.gridTemplateColumns = `repeat(${this.columns}, ${dotSize}px)`;
        for(let i = 0; i < this.rows * this.columns; i++){
            const dot = document.createElement("div");
            dot.classList.add("flipdot");
            dot.dataset.active = "false";
            dot.style.width = `${dotSize}px`;
            dot.style.height = `${dotSize}px`;
            dot.addEventListener("mouseenter", ()=>this.hoverDot(dot));
            dot.addEventListener("click", ()=>this.toggleDot(dot));
            this.dots.push(dot);
            this.root.appendChild(dot);
        }
    }
    hoverDot(dot) {
        if (dot.dataset.active === "true") return;
        dot.dataset.active = "hover";
        this.playSound("./assets/audio/flip-on-2.mp3");
        setTimeout(()=>{
            if (dot.dataset.active === "hover") {
                dot.dataset.active = "false";
                this.playSound("./assets/audio/flip-off-2.mp3");
            }
        }, 800);
    }
    toggleDot(dot) {
        this.audioEnabled = true;
        if (dot.dataset.active === "true") {
            dot.dataset.active = "false";
            this.playSound("./assets/audio/flip-off-2.mp3");
        } else if (dot.dataset.active === "hover") dot.dataset.active = "true";
        else {
            dot.dataset.active = "true";
            this.playSound("./assets/audio/flip-on-2.mp3");
        }
    }
    playSound(src) {
        if (!this.audioEnabled) return;
        const audio = new Audio(src);
        audio.play();
    }
    runAnimations() {
        this.button.classList.add('pressed');
        setTimeout(()=>this.button.classList.remove('pressed'), 200);
        if (this.animationStep === 0) this.animateColumns();
        else if (this.animationStep === 1) this.animateChessboard();
        else if (this.animationStep === 2) this.animateRandom();
        this.animationStep = (this.animationStep + 1) % 3; // Cycle back to 0 after 2
    }
    animateColumns() {
        const columns = this.columns;
        const rows = this.rows;
        for(let col = 0; col < columns; col++)setTimeout(()=>{
            for(let row = 0; row < rows; row++){
                const index = row * columns + col;
                if (this.dots[index] && this.dots[index].dataset.active === "false") this.dots[index].dataset.active = "true";
            }
            this.playSound("./assets/audio/flip-on-2.mp3");
            setTimeout(()=>{
                for(let row = 0; row < rows; row++){
                    const index = row * columns + col;
                    if (this.dots[index] && this.dots[index].dataset.active === "true") this.dots[index].dataset.active = "false";
                }
                this.playSound("./assets/audio/flip-off-2.mp3");
            }, 1600);
        }, col * 75);
    }
    animateChessboard() {
        const dots = this.dots;
        const togglePattern = (pattern)=>{
            dots.forEach((dot, index)=>{
                if ((index % this.columns + Math.floor(index / this.columns)) % 2 === pattern) dot.dataset.active = "true";
                else dot.dataset.active = "false";
            });
            this.playSound("./assets/audio/flip-on-2.mp3");
        };
        togglePattern(0);
        setTimeout(()=>{
            togglePattern(1);
            setTimeout(()=>{
                dots.forEach((dot)=>dot.dataset.active = "false");
                this.playSound("./assets/audio/flip-off-2.mp3");
            }, 1000);
        }, 1000);
    }
    animateRandom() {
        const dots = this.dots;
        let iterations = 5;
        const randomToggle = ()=>{
            for(let i = 0; i < dots.length / 2; i++){
                const index = Math.floor(Math.random() * dots.length);
                dots[index].dataset.active = dots[index].dataset.active === "true" ? "false" : "true";
            }
            this.playSound("./assets/audio/flip-on-2.mp3");
        };
        const interval = setInterval(()=>{
            randomToggle();
            iterations--;
            if (iterations === 0) {
                clearInterval(interval);
                setTimeout(()=>{
                    dots.forEach((dot)=>dot.dataset.active = "false");
                    this.playSound("./assets/audio/flip-off-2.mp3");
                }, 200);
            }
        }, 200);
    }
}



/**
 * Swiper 11.2.6
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: March 19, 2025
 */ /**
 * SSR Window 5.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 12, 2025
 */ /* eslint-disable no-param-reassign */ function $768c2f4c151a0363$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $768c2f4c151a0363$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($768c2f4c151a0363$var$isObject(src[key]) && $768c2f4c151a0363$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $768c2f4c151a0363$var$extend(target[key], src[key]);
    });
}
const $768c2f4c151a0363$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $768c2f4c151a0363$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $768c2f4c151a0363$var$extend(doc, $768c2f4c151a0363$var$ssrDocument);
    return doc;
}
const $768c2f4c151a0363$var$ssrWindow = {
    document: $768c2f4c151a0363$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $768c2f4c151a0363$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $768c2f4c151a0363$var$extend(win, $768c2f4c151a0363$var$ssrWindow);
    return win;
}



function $3e0e2b092da8f124$export$23f2a1d2818174ef(classes) {
    if (classes === void 0) classes = '';
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $3e0e2b092da8f124$export$d141bba7fdc215a3(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $3e0e2b092da8f124$export$4368d992c4eafac0() {
    return Date.now();
}
function $3e0e2b092da8f124$var$getComputedStyle(el) {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $3e0e2b092da8f124$export$35e795649ee09318(el, axis) {
    if (axis === void 0) axis = 'x';
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $3e0e2b092da8f124$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $3e0e2b092da8f124$export$882b5998b3b9117c(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $3e0e2b092da8f124$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $3e0e2b092da8f124$export$efccba1c4a2ef57b() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$3e0e2b092da8f124$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($3e0e2b092da8f124$export$882b5998b3b9117c(to[nextKey]) && $3e0e2b092da8f124$export$882b5998b3b9117c(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $3e0e2b092da8f124$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else if (!$3e0e2b092da8f124$export$882b5998b3b9117c(to[nextKey]) && $3e0e2b092da8f124$export$882b5998b3b9117c(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $3e0e2b092da8f124$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $3e0e2b092da8f124$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $3e0e2b092da8f124$export$625550452a3fa3ec(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $3e0e2b092da8f124$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $3e0e2b092da8f124$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = '';
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $3e0e2b092da8f124$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $3e0e2b092da8f124$export$90a7f3efeed30595(el, parent) {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $3e0e2b092da8f124$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $3e0e2b092da8f124$export$3b14a55fb2447963(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $3e0e2b092da8f124$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $3e0e2b092da8f124$export$23f2a1d2818174ef(classes));
    return el;
}
function $3e0e2b092da8f124$export$8b22cf2602fb60ce(el) {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $3e0e2b092da8f124$export$43caf9889c228507(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $3e0e2b092da8f124$export$9e5f44173e64f162(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $3e0e2b092da8f124$export$ffb5f4729a158638(el, prop) {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $3e0e2b092da8f124$export$dda1d9f60106f0e9(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $3e0e2b092da8f124$export$407448d2b89b1813(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $3e0e2b092da8f124$export$342063e11d6c3cad(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $3e0e2b092da8f124$export$2d1720544b23b823(el, size, includeMargins) {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $3e0e2b092da8f124$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $3e0e2b092da8f124$export$ae1af26003f05816(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}


let $6946bfb4689eabba$var$support;
function $6946bfb4689eabba$var$calcSupport() {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $6946bfb4689eabba$var$getSupport() {
    if (!$6946bfb4689eabba$var$support) $6946bfb4689eabba$var$support = $6946bfb4689eabba$var$calcSupport();
    return $6946bfb4689eabba$var$support;
}
let $6946bfb4689eabba$var$deviceCached;
function $6946bfb4689eabba$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $6946bfb4689eabba$var$getSupport();
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $6946bfb4689eabba$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$6946bfb4689eabba$var$deviceCached) $6946bfb4689eabba$var$deviceCached = $6946bfb4689eabba$var$calcDevice(overrides);
    return $6946bfb4689eabba$var$deviceCached;
}
let $6946bfb4689eabba$var$browser;
function $6946bfb4689eabba$var$calcBrowser() {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const device = $6946bfb4689eabba$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $6946bfb4689eabba$var$getBrowser() {
    if (!$6946bfb4689eabba$var$browser) $6946bfb4689eabba$var$browser = $6946bfb4689eabba$var$calcBrowser();
    return $6946bfb4689eabba$var$browser;
}
function $6946bfb4689eabba$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $6946bfb4689eabba$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $3e0e2b092da8f124$export$407448d2b89b1813)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $6946bfb4689eabba$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $6946bfb4689eabba$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $3e0e2b092da8f124$export$ffb5f4729a158638)(el, 'padding-left') || 0, 10) - parseInt((0, $3e0e2b092da8f124$export$ffb5f4729a158638)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $3e0e2b092da8f124$export$ffb5f4729a158638)(el, 'padding-top') || 0, 10) - parseInt((0, $3e0e2b092da8f124$export$ffb5f4729a158638)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $6946bfb4689eabba$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $3e0e2b092da8f124$export$ffb5f4729a158638)(slide, 'display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $3e0e2b092da8f124$export$2d1720544b23b823)(slide, 'width', true) : (0, $3e0e2b092da8f124$export$2d1720544b23b823)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $6946bfb4689eabba$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $6946bfb4689eabba$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $6946bfb4689eabba$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $6946bfb4689eabba$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $6946bfb4689eabba$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $6946bfb4689eabba$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $6946bfb4689eabba$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $6946bfb4689eabba$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $6946bfb4689eabba$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $3e0e2b092da8f124$export$9e5f44173e64f162)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $3e0e2b092da8f124$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $6946bfb4689eabba$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $6946bfb4689eabba$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $6946bfb4689eabba$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $6946bfb4689eabba$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $6946bfb4689eabba$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $6946bfb4689eabba$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $6946bfb4689eabba$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $6946bfb4689eabba$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $6946bfb4689eabba$var$unlazy(swiper, i);
    }
};
function $6946bfb4689eabba$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $6946bfb4689eabba$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $6946bfb4689eabba$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $6946bfb4689eabba$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $6946bfb4689eabba$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $6946bfb4689eabba$var$update = {
    updateSize: $6946bfb4689eabba$var$updateSize,
    updateSlides: $6946bfb4689eabba$var$updateSlides,
    updateAutoHeight: $6946bfb4689eabba$var$updateAutoHeight,
    updateSlidesOffset: $6946bfb4689eabba$var$updateSlidesOffset,
    updateSlidesProgress: $6946bfb4689eabba$var$updateSlidesProgress,
    updateProgress: $6946bfb4689eabba$var$updateProgress,
    updateSlidesClasses: $6946bfb4689eabba$var$updateSlidesClasses,
    updateActiveIndex: $6946bfb4689eabba$var$updateActiveIndex,
    updateClickedSlide: $6946bfb4689eabba$var$updateClickedSlide
};
function $6946bfb4689eabba$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $3e0e2b092da8f124$export$35e795649ee09318)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $6946bfb4689eabba$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $6946bfb4689eabba$var$minTranslate() {
    return -this.snapGrid[0];
}
function $6946bfb4689eabba$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $6946bfb4689eabba$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $3e0e2b092da8f124$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $6946bfb4689eabba$var$translate = {
    getTranslate: $6946bfb4689eabba$var$getSwiperTranslate,
    setTranslate: $6946bfb4689eabba$var$setTranslate,
    minTranslate: $6946bfb4689eabba$var$minTranslate,
    maxTranslate: $6946bfb4689eabba$var$maxTranslate,
    translateTo: $6946bfb4689eabba$var$translateTo
};
function $6946bfb4689eabba$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $6946bfb4689eabba$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $6946bfb4689eabba$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $6946bfb4689eabba$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $6946bfb4689eabba$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $6946bfb4689eabba$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $6946bfb4689eabba$var$transition = {
    setTransition: $6946bfb4689eabba$var$setTransition,
    transitionStart: $6946bfb4689eabba$var$transitionStart,
    transitionEnd: $6946bfb4689eabba$var$transitionEnd
};
function $6946bfb4689eabba$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $3e0e2b092da8f124$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $6946bfb4689eabba$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $6946bfb4689eabba$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $6946bfb4689eabba$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $6946bfb4689eabba$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $6946bfb4689eabba$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $6946bfb4689eabba$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $6946bfb4689eabba$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $6946bfb4689eabba$var$slide = {
    slideTo: $6946bfb4689eabba$var$slideTo,
    slideToLoop: $6946bfb4689eabba$var$slideToLoop,
    slideNext: $6946bfb4689eabba$var$slideNext,
    slidePrev: $6946bfb4689eabba$var$slidePrev,
    slideReset: $6946bfb4689eabba$var$slideReset,
    slideToClosest: $6946bfb4689eabba$var$slideToClosest,
    slideToClickedSlide: $6946bfb4689eabba$var$slideToClickedSlide
};
function $6946bfb4689eabba$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $3e0e2b092da8f124$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $3e0e2b092da8f124$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $3e0e2b092da8f124$export$3b14a55fb2447963)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $3e0e2b092da8f124$export$3b14a55fb2447963)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : 'next',
        initial: initial
    });
}
function $6946bfb4689eabba$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, initialSlide: initialSlide } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $3e0e2b092da8f124$export$3b14a55fb2447963)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $3e0e2b092da8f124$export$3b14a55fb2447963)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
function $6946bfb4689eabba$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $6946bfb4689eabba$var$loop = {
    loopCreate: $6946bfb4689eabba$var$loopCreate,
    loopFix: $6946bfb4689eabba$var$loopFix,
    loopDestroy: $6946bfb4689eabba$var$loopDestroy
};
function $6946bfb4689eabba$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $6946bfb4689eabba$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $6946bfb4689eabba$var$grabCursor = {
    setGrabCursor: $6946bfb4689eabba$var$setGrabCursor,
    unsetGrabCursor: $6946bfb4689eabba$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $6946bfb4689eabba$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $768c2f4c151a0363$export$39b482c5e57630a8)() || el === (0, $768c2f4c151a0363$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $6946bfb4689eabba$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $6946bfb4689eabba$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $6946bfb4689eabba$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $3e0e2b092da8f124$export$90a7f3efeed30595)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $6946bfb4689eabba$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$6946bfb4689eabba$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $3e0e2b092da8f124$export$4368d992c4eafac0)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $6946bfb4689eabba$var$onTouchMove(event) {
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $3e0e2b092da8f124$export$4368d992c4eafac0)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $6946bfb4689eabba$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $3e0e2b092da8f124$export$4368d992c4eafac0)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $3e0e2b092da8f124$export$4368d992c4eafac0)();
    (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $6946bfb4689eabba$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $6946bfb4689eabba$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $6946bfb4689eabba$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $6946bfb4689eabba$var$onLoad(e) {
    const swiper = this;
    $6946bfb4689eabba$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $6946bfb4689eabba$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $6946bfb4689eabba$var$events = (swiper, method)=>{
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $6946bfb4689eabba$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $6946bfb4689eabba$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $6946bfb4689eabba$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $6946bfb4689eabba$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $6946bfb4689eabba$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $6946bfb4689eabba$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $6946bfb4689eabba$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $6946bfb4689eabba$var$onScroll.bind(swiper);
    swiper.onClick = $6946bfb4689eabba$var$onClick.bind(swiper);
    swiper.onLoad = $6946bfb4689eabba$var$onLoad.bind(swiper);
    $6946bfb4689eabba$var$events(swiper, 'on');
}
function $6946bfb4689eabba$var$detachEvents() {
    const swiper = this;
    $6946bfb4689eabba$var$events(swiper, 'off');
}
var $6946bfb4689eabba$var$events$1 = {
    attachEvents: $6946bfb4689eabba$var$attachEvents,
    detachEvents: $6946bfb4689eabba$var$detachEvents
};
const $6946bfb4689eabba$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $6946bfb4689eabba$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $6946bfb4689eabba$var$isGridEnabled(swiper, params);
    const isMultiRow = $6946bfb4689eabba$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $6946bfb4689eabba$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = 'window';
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $6946bfb4689eabba$var$breakpoints = {
    setBreakpoint: $6946bfb4689eabba$var$setBreakpoint,
    getBreakpoint: $6946bfb4689eabba$var$getBreakpoint
};
function $6946bfb4689eabba$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $6946bfb4689eabba$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $6946bfb4689eabba$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $6946bfb4689eabba$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $6946bfb4689eabba$var$classes = {
    addClasses: $6946bfb4689eabba$var$addClasses,
    removeClasses: $6946bfb4689eabba$var$removeClasses
};
function $6946bfb4689eabba$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $6946bfb4689eabba$var$checkOverflow$1 = {
    checkOverflow: $6946bfb4689eabba$var$checkOverflow
};
var $6946bfb4689eabba$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $6946bfb4689eabba$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $6946bfb4689eabba$var$prototypes = {
    eventsEmitter: $6946bfb4689eabba$var$eventsEmitter,
    update: $6946bfb4689eabba$var$update,
    translate: $6946bfb4689eabba$var$translate,
    transition: $6946bfb4689eabba$var$transition,
    slide: $6946bfb4689eabba$var$slide,
    loop: $6946bfb4689eabba$var$loop,
    grabCursor: $6946bfb4689eabba$var$grabCursor,
    events: $6946bfb4689eabba$var$events$1,
    breakpoints: $6946bfb4689eabba$var$breakpoints,
    checkOverflow: $6946bfb4689eabba$var$checkOverflow$1,
    classes: $6946bfb4689eabba$var$classes
};
const $6946bfb4689eabba$var$extendedDefaults = {};
class $6946bfb4689eabba$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)({}, params, {
                    el: containerEl
                });
                swipers.push(new $6946bfb4689eabba$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $6946bfb4689eabba$var$getSupport();
        swiper.device = $6946bfb4689eabba$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $6946bfb4689eabba$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $6946bfb4689eabba$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)({}, $6946bfb4689eabba$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)({}, swiperParams, $6946bfb4689eabba$var$extendedDefaults, params);
        swiper.originalParams = (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)({}, swiper.params);
        swiper.passedParams = (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $3e0e2b092da8f124$export$dda1d9f60106f0e9)(slides[0]);
        return (0, $3e0e2b092da8f124$export$dda1d9f60106f0e9)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = 'current';
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $6946bfb4689eabba$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $3e0e2b092da8f124$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $3e0e2b092da8f124$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $3e0e2b092da8f124$export$ffb5f4729a158638)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $3e0e2b092da8f124$export$ffb5f4729a158638)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $3e0e2b092da8f124$export$ffb5f4729a158638)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $6946bfb4689eabba$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $6946bfb4689eabba$var$processLazyPreloader(swiper, e.target);
            });
        });
        $6946bfb4689eabba$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $6946bfb4689eabba$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $3e0e2b092da8f124$export$d141bba7fdc215a3)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $3e0e2b092da8f124$export$efccba1c4a2ef57b)($6946bfb4689eabba$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $6946bfb4689eabba$var$extendedDefaults;
    }
    static get defaults() {
        return $6946bfb4689eabba$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$6946bfb4689eabba$export$25ce5a424b770e84.prototype.__modules__) $6946bfb4689eabba$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $6946bfb4689eabba$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$6946bfb4689eabba$export$25ce5a424b770e84.installModule(m));
            return $6946bfb4689eabba$export$25ce5a424b770e84;
        }
        $6946bfb4689eabba$export$25ce5a424b770e84.installModule(module);
        return $6946bfb4689eabba$export$25ce5a424b770e84;
    }
}
Object.keys($6946bfb4689eabba$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($6946bfb4689eabba$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $6946bfb4689eabba$export$25ce5a424b770e84.prototype[protoMethod] = $6946bfb4689eabba$var$prototypes[prototypeGroup][protoMethod];
    });
});
$6946bfb4689eabba$export$25ce5a424b770e84.use([
    $6946bfb4689eabba$var$Resize,
    $6946bfb4689eabba$var$Observer
]);





function $4dfb92d69cb8a433$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $3e0e2b092da8f124$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}


function $ce39167a9c5549e3$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $1edc75782959477e$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $3e0e2b092da8f124$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $3ea27eb365069d23$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $3e0e2b092da8f124$export$342063e11d6c3cad)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $ccd0a7134d1e48e4$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $1edc75782959477e$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $3e0e2b092da8f124$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3ea27eb365069d23$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}



class $1222a91a1039d3df$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root;
        this.gallery = this.root;
        this.galleryWrapper = this.root.querySelector(".gallery-wrapper");
        this.items = Array.from(this.galleryWrapper.children);
        this.totalItems = this.items.length;
        this.hoveredIndex;
        if (window.innerWidth < 820) this.mobileVersion = true;
        else this.mobileVersion = false;
        this.waitForImages().then(()=>{
            this.root.style.opacity = 1; // Show root when all images are loaded
            if (this.mobileVersion != true) this.setupGallery();
            if (this.mobileVersion === true) this.setupSwiper();
        });
        // Resize event listener to switch between swiper and gallery
        window.addEventListener("resize", this.onResize.bind(this));
    }
    onResize() {
        const isMobile = window.innerWidth < 820;
        if (isMobile && !this.mobileVersion) {
            this.mobileVersion = true;
            this.destroyGallery();
            this.setupSwiper();
        } else if (!isMobile && this.mobileVersion) {
            this.mobileVersion = false;
            this.destroySwiper();
            this.setupGallery();
        }
    }
    setupGallery() {
        // console.log("setupGallery");
        this.setItemStyles();
        this.root.style.opacity = 1;
        // Create references for the event listeners
        this.onHoverHandler = (event)=>this.onHover(event.currentTarget);
        this.onLeaveHandler = ()=>this.onLeave();
        this.items.forEach((item)=>{
            item.addEventListener("mouseenter", this.onHoverHandler);
            item.addEventListener("mouseleave", this.onLeaveHandler);
        });
        window.addEventListener("resize", this.setItemStyles.bind(this));
    }
    destroyGallery() {
        // console.log("destroyGallery");
        this.items.forEach((item)=>{
            item.removeEventListener("mouseenter", this.onHoverHandler);
            item.removeEventListener("mouseleave", this.onLeaveHandler);
        });
        window.removeEventListener("resize", this.setItemStyles.bind(this));
    }
    setupSwiper() {
        // console.log("setupSwiper");
        this.gallery.classList.add("swiper");
        this.gallery.classList.remove("gallery");
        // this.galleryWrapper.classList.remove("gallery-wrapper");
        // Ensure gallery element is valid before initializing swiper
        // console.log('EffectCards')
        // console.log(EffectCards)
        if (this.gallery && this.items.length > 0 && !this.swiperInstance) this.swiperInstance = new (0, $6946bfb4689eabba$export$25ce5a424b770e84)(this.root, {
            effect: "cards",
            modules: [
                (0, $ccd0a7134d1e48e4$export$2e2bcd8739ae039)
            ],
            grabCursor: true
        });
    }
    destroySwiper() {
        // console.log("destroySwiper");
        this.root.classList.add("gallery");
        this.root.classList.remove("swiper");
        // this.galleryWrapper.classList.add("gallery-wrapper");
        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true); // Properly destroy the swiper instance
            this.swiperInstance = null;
        }
    }
    setItemStyles() {
        // console.log("setItemStyles");
        this.galleryWidth = this.root.offsetWidth;
        let scale = (0, $76149f9d24a90a9e$export$7d15b64cf5a3a4c4)((0, $76149f9d24a90a9e$export$871de8747c9eaa88)(this.galleryWidth, 0, 1200, 2.5, 1.4), 1.4, 2.5);
        // this.galleryWrapper.style.margin = `${scale * 10 - 10}% auto`;
        this.galleryWrapper.style.setProperty("--spaceoverflow", `${scale.toFixed(3) * 10 - 10}%`);
        this.items.forEach((item, index)=>{
            const tilt = (Math.random() - 0.5) * 20;
            const arcOffset = Math.floor(Math.sin(index / (this.totalItems - 1) * Math.PI) * -20) + 10;
            item.style.setProperty("--tilt", `${tilt}deg`);
            item.style.setProperty("--scale", `${scale}`);
            item.style.setProperty("--index", index);
            item.style.setProperty("--arc-offset", `${arcOffset}%`);
            item.style.setProperty("--hoffset", `${0}%`);
        });
    }
    onHover(hoveredItem) {
        // console.log("onHover");
        const newHoveredIndex = Number(hoveredItem.style.getPropertyValue("--index"));
        if (newHoveredIndex < this.hoveredIndex) //the new element is to the left
        hoveredItem.style.zIndex = 1;
        else // the new element is to the right
        //it's likely overlapping the las hovered element. Animation is likely smoother if we delay the z-index update
        setTimeout(()=>{
            if (hoveredItem.classList.contains("active")) hoveredItem.style.zIndex = 1;
        }, 200);
        this.hoveredIndex = newHoveredIndex;
        const totalItems = this.items.length;
        hoveredItem.classList.add("active");
        const maxMovement = 50; // Max movement near hovered item
        this.items.forEach((item)=>{
            const index = Number(item.style.getPropertyValue("--index"));
            const movementLeftNeigbour = (0, $76149f9d24a90a9e$export$871de8747c9eaa88)(index, 0, this.hoveredIndex, 0, maxMovement);
            const movementRightNeigbour = (0, $76149f9d24a90a9e$export$871de8747c9eaa88)(index, this.hoveredIndex, totalItems - 1, maxMovement, 0);
            let moveDistance = 0;
            if (index < this.hoveredIndex) moveDistance = movementLeftNeigbour;
            else if (index > this.hoveredIndex) moveDistance = movementRightNeigbour;
            const moveDirection = index < this.hoveredIndex ? -1 : 1;
            item.style.setProperty("--hoffset", `${moveDirection * moveDistance}%`);
        });
        hoveredItem.style.setProperty("--hoffset", `${0}%`);
    }
    onLeave() {
        // console.log("onLeave");
        this.items.forEach((item)=>{
            item.classList.remove("active");
            item.style.setProperty("--hoffset", `${0}%`);
            item.style.zIndex = 0;
        });
    }
    waitForImages() {
        // console.log("waitForImages");
        return new Promise((resolve)=>{
            const images = Array.from(this.gallery.querySelectorAll("img"));
            let loadedCount = 0;
            if (images.length === 0) {
                resolve(); // No images, resolve immediately
                return;
            }
            images.forEach((img)=>{
                if (img.complete) loadedCount++;
                else {
                    img.addEventListener("load", ()=>{
                        loadedCount++;
                        if (loadedCount === images.length) resolve();
                    });
                    img.addEventListener("error", ()=>{
                        loadedCount++; // Even if an image fails, count it
                        if (loadedCount === images.length) resolve();
                    });
                }
            });
            // If all images were already loaded (cached), resolve immediately
            if (loadedCount === images.length) resolve();
        });
    }
}




class $d2e0903d4f69e257$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root //is an arrray
        ;
        this.parallaxSpeed = this.root.dataset.parallaxSpeed;
        if (this.parallaxSpeed != 1) (0, $ac6e65077e03f9d6$export$dc13cae83df62ba6).push({
            root: this.root,
            component: this,
            position: (0, $ac6e65077e03f9d6$export$1690e12b840569b9)(this.root),
            loop: this.loop
        });
    // console.log(registeredLoops)
    }
    loop(time) {
        // console.log(scrl)
        const inView = (0, $ac6e65077e03f9d6$export$6e196edbcc00e5bc)(this.position);
        // console.log(inView)
        // console.log(inView)
        this.maxOffset = (0, $76149f9d24a90a9e$export$871de8747c9eaa88)(this.component.parallaxSpeed, 1, 2, 0, -(0, $ac6e65077e03f9d6$export$2a111da947c407d2).h);
        if (inView.loopback === 1) this.root.style.transform = `translate3d(0, ${(0, $76149f9d24a90a9e$export$871de8747c9eaa88)(inView.progress, 0, 1, 0, this.maxOffset)}px, 0)`;
    // if(inView.loopback === 1) {
    //   this.root.classList.add('fade-in')
    // } else {
    //   this.root.classList.remove('fade-in')
    // }
    }
}


class $04e9dc7179e5294a$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root;
        this.button = this.root.querySelector('.textexpand-button');
        this.hiddenText = this.root.querySelector('.textexpand-hiddentext');
        // Initialize with hidden text initially hidden
        this.hiddenText.hidden = true;
        this.button.setAttribute('aria-expanded', 'false');
        this.button.setAttribute('aria-controls', this.hiddenText.id);
        this.addEvents();
    }
    addEvents() {
        this.button.addEventListener('click', (e)=>{
            const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
            // Toggle button state and aria-expanded
            if (isExpanded) {
                this.button.setAttribute('aria-expanded', 'false');
                this.hiddenText.hidden = true;
            } else {
                this.button.setAttribute('aria-expanded', 'true');
                this.hiddenText.hidden = false;
            }
            // Toggle the visual state (optional class for custom styles)
            this.root.classList.toggle('is-open');
        });
        // Optional: Add keyboard support (Enter or Space keys)
        this.button.addEventListener('keydown', (event)=>{
            if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault();
                this.button.click();
            }
        });
    }
}



class $7c8d4f6c2d917c0b$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root;
        this.typedTextEl = root.querySelector('.typed-text');
        this.mailBackground = root.querySelector('.contact-mail-background');
        this.phone = root.querySelector('.contact-phone-number');
        this.cursorEl = root.querySelector('.cursor');
        this.toggleButton = root.querySelector('#toggle-animations-contactdetails');
        this.fullText = this.mailBackground.textContent.trim();
        this.currentIndex = 0;
        this.typingForward = true;
        this.typingSpeed = 100;
        this.typingInterval = null;
        this.vibrateInterval = null;
        this.animationsRunning = true;
        this.startAnimations();
        this.addEvents();
    }
    addEvents() {
        this.toggleButton.addEventListener('click', ()=>{
            if (this.animationsRunning) {
                this.stopAnimations();
                this.toggleButton.classList.add('is-paused');
            // this.toggleButton.textContent = 'Start Animations';
            } else {
                this.startAnimations();
                this.toggleButton.classList.remove('is-paused');
            // this.toggleButton.textContent = 'Stop Animations';
            }
        });
    }
    startAnimations() {
        this.typingInterval = setInterval(()=>this.type(), this.typingSpeed);
        this.vibrateInterval = setInterval(()=>this.vibratePhone(), 8500);
        this.animationsRunning = true;
    }
    stopAnimations() {
        clearInterval(this.typingInterval);
        this.typedTextEl.textContent = this.fullText; // Show full text when stopping
        this.cursorEl.classList.add('typing');
        this.currentIndex = this.fullText.length;
        this.typingForward = false;
        clearInterval(this.vibrateInterval);
        this.phone.classList.remove('vibrate');
        this.animationsRunning = false;
    }
    type() {
        // Check if the typing is paused
        if (this.pauseFlag) return; // If paused, return early
        if ((0, $76149f9d24a90a9e$export$233b8f01b7f8637c)(0, 2) > 1) return; // Return early to create a pause effect
        // Add 'typing' class while typing, remove when waiting
        this.cursorEl.classList.add('typing');
        if (this.typingForward) {
            this.currentIndex++;
            if (this.currentIndex >= this.fullText.length) {
                this.typingForward = false;
                this.pauseFlag = true; // Start pause after typing forward
                this.cursorEl.classList.remove('typing'); // Blink cursor while paused
                setTimeout(()=>{
                    this.pauseFlag = false; // Allow typing to resume
                }, 5000);
            }
        } else {
            this.currentIndex--;
            if (this.currentIndex <= (0, $76149f9d24a90a9e$export$233b8f01b7f8637c)(2, 7)) {
                this.typingForward = true;
                this.pauseFlag = true; // Start pause after typing backward
                this.cursorEl.classList.remove('typing'); // Blink cursor while paused
                setTimeout(()=>{
                    this.pauseFlag = false; // Allow typing to resume
                }, 1000);
            }
        }
        this.typedTextEl.textContent = this.fullText.substring(0, this.currentIndex);
    }
    vibratePhone() {
        this.phone.classList.add('vibrate');
        setTimeout(()=>{
            this.phone.classList.remove('vibrate');
        }, 1200); // matches the vibration duration
    }
}


class $5c8b08acfd85dadb$export$2e2bcd8739ae039 {
    init(root) {
        this.root = root;
        this.buttons = root.querySelectorAll('[data-filter]');
        this.items = root.querySelectorAll('.eventlist-item');
        this.activeFilter = null;
        this.setupFilterButtons();
    }
    setupFilterButtons() {
        this.buttons.forEach((button)=>{
            button.addEventListener('click', ()=>{
                const filter = button.getAttribute('data-filter');
                // Toggle logic
                if (this.activeFilter === filter) {
                    // Deselect filter
                    this.activeFilter = null;
                    this.updateUI();
                } else {
                    // Set new filter
                    this.activeFilter = filter;
                    this.updateUI();
                }
            });
        });
    }
    updateUI() {
        // Toggle active button style
        this.buttons.forEach((button)=>{
            const isActive = button.getAttribute('data-filter') === this.activeFilter;
            button.classList.toggle('active', isActive);
        });
        // Show/hide event items
        this.items.forEach((item)=>{
            const itemFilter = item.getAttribute('data-filter');
            const show = !this.activeFilter || itemFilter === this.activeFilter;
            item.style.display = show ? '' : 'none';
        });
    }
}


var $7edcc86b8e795c8a$exports = {};
!function(e, t) {
    $7edcc86b8e795c8a$exports = t();
}(self, ()=>(()=>{
        var e = {
            2690: (e, t, r)=>{
                "use strict";
                function n() {
                    for(var e = document.cookie.split(";"), t = [], r = new RegExp("^\\s*([^=]+)\\s*=\\s*(.*?)$"), n = 0; n < e.length; n++){
                        var i = e[n], o = r.exec(i);
                        null !== o && t.push({
                            name: o[1],
                            value: o[2]
                        });
                    }
                    return t;
                }
                function i(e, t, r) {
                    var n = e + "=; Max-Age=-99999999;";
                    document.cookie = n, n += " path=" + (t || "/") + ";", document.cookie = n, void 0 !== r && (n += " domain=" + r + ";", document.cookie = n);
                }
                r.d(t, {
                    default: ()=>C
                }), r(9305), r(2733), r(4701), r(1678), r(4776), r(4382), r(9892), r(4962), r(6584), r(9336), r(4754), r(1908), r(94), r(7132), r(6457), r(8908), r(3810), r(8557), r(646), r(5021), r(3687), r(2745), r(3994), r(3062), r(4062), r(3630), r(2367);
                var o = r(5482);
                function a(e) {
                    return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, a(e);
                }
                function s(e, t, r) {
                    return t = u(t), function(e, t) {
                        if (t && ("object" === a(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(e, c() ? Reflect.construct(t, r || [], u(e).constructor) : t.apply(e, r));
                }
                function c() {
                    try {
                        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e) {}
                    return (c = function() {
                        return !!e;
                    })();
                }
                function u(e) {
                    return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, u(e);
                }
                function l(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && p(e, t);
                }
                function p(e, t) {
                    return p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, p(e, t);
                }
                function f(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function d(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, m(n.key), n);
                    }
                }
                function v(e, t, r) {
                    return t && d(e.prototype, t), r && d(e, r), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function m(e) {
                    var t = function(e, t) {
                        if ("object" != a(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, "string");
                            if ("object" != a(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" == a(t) ? t : String(t);
                }
                r(6437), r(2697), r(1359);
                var y = function() {
                    function e() {
                        f(this, e), this.value = null;
                    }
                    return v(e, [
                        {
                            key: "get",
                            value: function() {
                                return this.value;
                            }
                        },
                        {
                            key: "set",
                            value: function(e) {
                                this.value = e;
                            }
                        },
                        {
                            key: "delete",
                            value: function() {
                                this.value = null;
                            }
                        }
                    ]), e;
                }(), h = function() {
                    function e(t) {
                        f(this, e), this.cookieName = t.storageName, this.cookieDomain = t.cookieDomain, this.cookiePath = t.cookiePath, this.cookieExpiresAfterDays = t.cookieExpiresAfterDays;
                    }
                    return v(e, [
                        {
                            key: "get",
                            value: function() {
                                var e = function(e) {
                                    for(var t = n(), r = 0; r < t.length; r++)if (t[r].name === e) return t[r];
                                    return null;
                                }(this.cookieName);
                                return e ? e.value : null;
                            }
                        },
                        {
                            key: "set",
                            value: function(e) {
                                return function(e, t, r, n, i) {
                                    var o = "";
                                    if (r) {
                                        var a = new Date;
                                        a.setTime(a.getTime() + 24 * r * 3600000), o = "; expires=" + a.toUTCString();
                                    }
                                    void 0 !== n && (o += "; domain=" + n), o += void 0 !== i ? "; path=" + i : "; path=/", document.cookie = e + "=" + (t || "") + o + "; SameSite=Lax";
                                }(this.cookieName, e, this.cookieExpiresAfterDays, this.cookieDomain, this.cookiePath);
                            }
                        },
                        {
                            key: "delete",
                            value: function() {
                                return i(this.cookieName);
                            }
                        }
                    ]), e;
                }(), b = function() {
                    function e(t, r) {
                        f(this, e), this.key = t.storageName, this.handle = r;
                    }
                    return v(e, [
                        {
                            key: "get",
                            value: function() {
                                return this.handle.getItem(this.key);
                            }
                        },
                        {
                            key: "getWithKey",
                            value: function(e) {
                                return this.handle.getItem(e);
                            }
                        },
                        {
                            key: "set",
                            value: function(e) {
                                return this.handle.setItem(this.key, e);
                            }
                        },
                        {
                            key: "setWithKey",
                            value: function(e, t) {
                                return this.handle.setItem(e, t);
                            }
                        },
                        {
                            key: "delete",
                            value: function() {
                                return this.handle.removeItem(this.key);
                            }
                        },
                        {
                            key: "deleteWithKey",
                            value: function(e) {
                                return this.handle.removeItem(e);
                            }
                        }
                    ]), e;
                }(), g = function(e) {
                    function t(e) {
                        return f(this, t), s(this, t, [
                            e,
                            localStorage
                        ]);
                    }
                    return l(t, e), v(t);
                }(b), _ = function(e) {
                    function t(e) {
                        return f(this, t), s(this, t, [
                            e,
                            sessionStorage
                        ]);
                    }
                    return l(t, e), v(t);
                }(b);
                const w = {
                    cookie: h,
                    test: y,
                    localStorage: g,
                    sessionStorage: _
                };
                function k(e) {
                    return k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, k(e);
                }
                function S(e, t) {
                    var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!r) {
                        if (Array.isArray(e) || (r = x(e)) || t && e && "number" == typeof e.length) {
                            r && (e = r);
                            var n = 0, i = function() {};
                            return {
                                s: i,
                                n: function() {
                                    return n >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[n++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: i
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var o, a = !0, s = !1;
                    return {
                        s: function() {
                            r = r.call(e);
                        },
                        n: function() {
                            var e = r.next();
                            return a = e.done, e;
                        },
                        e: function(e) {
                            s = !0, o = e;
                        },
                        f: function() {
                            try {
                                a || null == r.return || r.return();
                            } finally{
                                if (s) throw o;
                            }
                        }
                    };
                }
                function j(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, s = [], c = !0, u = !1;
                            try {
                                if (o = (r = r.call(e)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    c = !1;
                                } else for(; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0);
                            } catch (e) {
                                u = !0, i = e;
                            } finally{
                                try {
                                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (u) throw i;
                                }
                            }
                            return s;
                        }
                    }(e, t) || x(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function x(e, t) {
                    if (e) {
                        if ("string" == typeof e) return O(e, t);
                        var r = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? O(e, t) : void 0;
                    }
                }
                function O(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function E(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function P(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? E(Object(r), !0).forEach(function(t) {
                            var n, i, o;
                            n = e, i = t, o = r[t], (i = z(i)) in n ? Object.defineProperty(n, i, {
                                value: o,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : n[i] = o;
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : E(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function A(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, z(n.key), n);
                    }
                }
                function z(e) {
                    var t = function(e, t) {
                        if ("object" != k(e) || !e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, "string");
                            if ("object" != k(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" == k(t) ? t : String(t);
                }
                var C = function() {
                    function e(t, r, n) {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.config = t, this.store = void 0 !== r ? r : new w[this.storageMethod](this), void 0 === this.store && (this.store = w.cookie), this.auxiliaryStore = void 0 !== n ? n : new _(this), this.consents = this.defaultConsents, this.confirmed = !1, this.changed = !1, this.states = {}, this.initialized = {}, this.executedOnce = {}, this.watchers = new Set([]), this.loadConsents(), this.applyConsents(), this.savedConsents = P({}, this.consents);
                    }
                    var t, r;
                    return t = e, r = [
                        {
                            key: "storageMethod",
                            get: function() {
                                return this.config.storageMethod || "cookie";
                            }
                        },
                        {
                            key: "storageName",
                            get: function() {
                                return this.config.storageName || this.config.cookieName || "klaro";
                            }
                        },
                        {
                            key: "cookieDomain",
                            get: function() {
                                return this.config.cookieDomain || void 0;
                            }
                        },
                        {
                            key: "cookiePath",
                            get: function() {
                                return this.config.cookiePath || void 0;
                            }
                        },
                        {
                            key: "cookieExpiresAfterDays",
                            get: function() {
                                return this.config.cookieExpiresAfterDays || 120;
                            }
                        },
                        {
                            key: "defaultConsents",
                            get: function() {
                                for(var e = {}, t = 0; t < this.config.services.length; t++){
                                    var r = this.config.services[t];
                                    e[r.name] = this.getDefaultConsent(r);
                                }
                                return e;
                            }
                        },
                        {
                            key: "watch",
                            value: function(e) {
                                this.watchers.has(e) || this.watchers.add(e);
                            }
                        },
                        {
                            key: "unwatch",
                            value: function(e) {
                                this.watchers.has(e) && this.watchers.delete(e);
                            }
                        },
                        {
                            key: "notify",
                            value: function(e, t) {
                                var r = this;
                                this.watchers.forEach(function(n) {
                                    n.update(r, e, t);
                                });
                            }
                        },
                        {
                            key: "getService",
                            value: function(e) {
                                var t = this.config.services.filter(function(t) {
                                    return t.name === e;
                                });
                                if (t.length > 0) return t[0];
                            }
                        },
                        {
                            key: "getDefaultConsent",
                            value: function(e) {
                                var t = e.default || e.required;
                                return void 0 === t && (t = this.config.default), void 0 === t && (t = !1), t;
                            }
                        },
                        {
                            key: "changeAll",
                            value: function(e) {
                                var t = this, r = 0;
                                return this.config.services.filter(function(e) {
                                    return !e.contextualConsentOnly;
                                }).map(function(n) {
                                    n.required || t.config.required || e ? t.updateConsent(n.name, !0) && r++ : t.updateConsent(n.name, !1) && r++;
                                }), r;
                            }
                        },
                        {
                            key: "updateConsent",
                            value: function(e, t) {
                                var r = (this.consents[e] || !1) !== t;
                                return this.consents[e] = t, this.notify("consents", this.consents), r;
                            }
                        },
                        {
                            key: "resetConsents",
                            value: function() {
                                this.consents = this.defaultConsents, this.states = {}, this.confirmed = !1, this.applyConsents(), this.savedConsents = P({}, this.consents), this.store.delete(), this.notify("consents", this.consents);
                            }
                        },
                        {
                            key: "getConsent",
                            value: function(e) {
                                return this.consents[e] || !1;
                            }
                        },
                        {
                            key: "loadConsents",
                            value: function() {
                                var e = this.store.get();
                                return null !== e && (this.consents = JSON.parse(decodeURIComponent(e)), this._checkConsents(), this.notify("consents", this.consents)), this.consents;
                            }
                        },
                        {
                            key: "saveAndApplyConsents",
                            value: function(e) {
                                this.saveConsents(e), this.applyConsents();
                            }
                        },
                        {
                            key: "changedConsents",
                            value: function() {
                                for(var e = {}, t = 0, r = Object.entries(this.consents); t < r.length; t++){
                                    var n = j(r[t], 2), i = n[0], o = n[1];
                                    this.savedConsents[i] !== o && (e[i] = o);
                                }
                                return e;
                            }
                        },
                        {
                            key: "saveConsents",
                            value: function(e) {
                                var t = encodeURIComponent(JSON.stringify(this.consents));
                                this.store.set(t), this.confirmed = !0, this.changed = !1;
                                var r = this.changedConsents();
                                this.savedConsents = P({}, this.consents), this.notify("saveConsents", {
                                    changes: r,
                                    consents: this.consents,
                                    type: e || "script"
                                });
                            }
                        },
                        {
                            key: "applyConsents",
                            value: function(e, t, r) {
                                function n(e, t) {
                                    if (void 0 !== e) return ("function" == typeof e ? e : new Function("opts", e))(t);
                                }
                                for(var i = 0, o = 0; o < this.config.services.length; o++){
                                    var a = this.config.services[o];
                                    if (void 0 === r || r === a.name) {
                                        var s = a.vars || {}, c = {
                                            service: a,
                                            config: this.config,
                                            vars: s
                                        };
                                        this.initialized[a.name] || (this.initialized[a.name] = !0, n(a.onInit, c));
                                    }
                                }
                                for(var u = 0; u < this.config.services.length; u++){
                                    var l = this.config.services[u];
                                    if (void 0 === r || r === l.name) {
                                        var p = this.states[l.name], f = l.vars || {}, d = void 0 !== l.optOut ? l.optOut : this.config.optOut || !1, v = void 0 !== l.required ? l.required : this.config.required || !1, m = this.confirmed || d || e || t, y = this.getConsent(l.name) && m || v, h = {
                                            service: l,
                                            config: this.config,
                                            vars: f,
                                            consents: this.consents,
                                            confirmed: this.confirmed
                                        };
                                        p !== y && i++, e || (n(y ? l.onAccept : l.onDecline, h), this.updateServiceElements(l, y), this.updateServiceStorage(l, y), void 0 !== l.callback && l.callback(y, l), void 0 !== this.config.callback && this.config.callback(y, l), this.states[l.name] = y);
                                    }
                                }
                                return this.notify("applyConsents", i, r), i;
                            }
                        },
                        {
                            key: "updateServiceElements",
                            value: function(e, t) {
                                if (t) {
                                    if (e.onlyOnce && this.executedOnce[e.name]) return;
                                    this.executedOnce[e.name] = !0;
                                }
                                for(var r = document.querySelectorAll("[data-name='" + e.name + "']"), n = 0; n < r.length; n++){
                                    var i = r[n], a = i.parentElement, s = (0, o.RT)(i), c = s.type, u = s.src, l = s.href, p = [
                                        "href",
                                        "src",
                                        "type"
                                    ];
                                    if ("placeholder" !== c) {
                                        if ("IFRAME" === i.tagName) {
                                            if (t && i.src === u) {
                                                console.debug("Skipping ".concat(i.tagName, " for service ").concat(e.name, ", as it already has the correct type..."));
                                                continue;
                                            }
                                            var f, d = document.createElement(i.tagName), v = S(i.attributes);
                                            try {
                                                for(v.s(); !(f = v.n()).done;){
                                                    var m = f.value;
                                                    d.setAttribute(m.name, m.value);
                                                }
                                            } catch (e) {
                                                v.e(e);
                                            } finally{
                                                v.f();
                                            }
                                            d.innerText = i.innerText, d.text = i.text, t ? (void 0 !== s["original-display"] && (d.style.display = s["original-display"]), void 0 !== s.src && (d.src = s.src)) : (d.src = "", void 0 !== s["modified-by-klaro"] && void 0 !== s["original-display"] ? d.setAttribute("data-original-display", s["original-display"]) : (void 0 !== i.style.display && d.setAttribute("data-original-display", i.style.display), d.setAttribute("data-modified-by-klaro", "yes")), d.style.display = "none"), a.insertBefore(d, i), a.removeChild(i);
                                        } else if ("SCRIPT" === i.tagName || "LINK" === i.tagName) {
                                            if (t && i.type === (c || "") && i.src === u) {
                                                console.debug("Skipping ".concat(i.tagName, " for service ").concat(e.name, ", as it already has the correct type or src..."));
                                                continue;
                                            }
                                            var y, h = document.createElement(i.tagName), b = S(i.attributes);
                                            try {
                                                for(b.s(); !(y = b.n()).done;){
                                                    var g = y.value;
                                                    h.setAttribute(g.name, g.value);
                                                }
                                            } catch (e) {
                                                b.e(e);
                                            } finally{
                                                b.f();
                                            }
                                            h.innerText = i.innerText, h.text = i.text, t ? (h.type = c || "", void 0 !== u && (h.src = u), void 0 !== l && (h.href = l)) : h.type = "text/plain", a.insertBefore(h, i), a.removeChild(i);
                                        } else {
                                            if (t) {
                                                var _, w = S(p);
                                                try {
                                                    for(w.s(); !(_ = w.n()).done;){
                                                        var k = _.value, j = s[k];
                                                        void 0 !== j && (void 0 === s["original-" + k] && (s["original-" + k] = i[k]), i[k] = j);
                                                    }
                                                } catch (e) {
                                                    w.e(e);
                                                } finally{
                                                    w.f();
                                                }
                                                void 0 !== s.title && (i.title = s.title), void 0 !== s["original-display"] ? i.style.display = s["original-display"] : i.style.removeProperty("display");
                                            } else {
                                                void 0 !== s.title && i.removeAttribute("title"), void 0 === s["original-display"] && void 0 !== i.style.display && (s["original-display"] = i.style.display), i.style.display = "none";
                                                var x, O = S(p);
                                                try {
                                                    for(O.s(); !(x = O.n()).done;){
                                                        var E = x.value;
                                                        void 0 !== s[E] && (void 0 !== s["original-" + E] ? i[E] = s["original-" + E] : i.removeAttribute(E));
                                                    }
                                                } catch (e) {
                                                    O.e(e);
                                                } finally{
                                                    O.f();
                                                }
                                            }
                                            (0, o.X7)(s, i);
                                        }
                                    } else t ? (i.style.display = "none", s["original-display"] = i.style.display) : i.style.display = s["original-display"] || "block";
                                }
                            }
                        },
                        {
                            key: "updateServiceStorage",
                            value: function(e, t) {
                                if (!t && void 0 !== e.cookies && e.cookies.length > 0) for(var r = n(), o = 0; o < e.cookies.length; o++){
                                    var a = e.cookies[o], s = void 0, c = void 0;
                                    if (a instanceof Array) {
                                        var u = j(a, 3);
                                        a = u[0], s = u[1], c = u[2];
                                    } else if (a instanceof Object && !(a instanceof RegExp)) {
                                        var l = a;
                                        a = l.pattern, s = l.path, c = l.domain;
                                    }
                                    if (void 0 !== a) {
                                        a instanceof RegExp || (a = a.startsWith("^") ? new RegExp(a) : new RegExp("^" + a.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&") + "$"));
                                        for(var p = 0; p < r.length; p++){
                                            var f = r[p];
                                            null !== a.exec(f.name) && (console.debug("Deleting cookie:", f.name, "Matched pattern:", a, "Path:", s, "Domain:", c), i(f.name, s, c), void 0 === c && i(f.name, s, "." + window.location.hostname));
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "_checkConsents",
                            value: function() {
                                for(var e = !0, t = new Set(this.config.services.map(function(e) {
                                    return e.name;
                                })), r = new Set(Object.keys(this.consents)), n = 0, i = Object.keys(this.consents); n < i.length; n++){
                                    var o = i[n];
                                    t.has(o) || delete this.consents[o];
                                }
                                var a, s = S(this.config.services);
                                try {
                                    for(s.s(); !(a = s.n()).done;){
                                        var c = a.value;
                                        r.has(c.name) || (this.consents[c.name] = this.getDefaultConsent(c), e = !1);
                                    }
                                } catch (e) {
                                    s.e(e);
                                } finally{
                                    s.f();
                                }
                                this.confirmed = e, e || (this.changed = !0);
                            }
                        }
                    ], A(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            5482: (e, t, r)=>{
                "use strict";
                function n(e, t) {
                    if (e) {
                        if ("string" == typeof e) return i(e, t);
                        var r = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? i(e, t) : void 0;
                    }
                }
                function i(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function o(e) {
                    if (null !== document.currentScript && void 0 !== document.currentScript) return document.currentScript;
                    for(var t = document.getElementsByTagName("script"), r = 0; r < t.length; r++){
                        var n = t[r];
                        if (n.src.includes(e)) return n;
                    }
                    return null;
                }
                function a(e) {
                    for(var t = {}, r = 0; r < e.attributes.length; r++){
                        var n = e.attributes[r];
                        n.name.startsWith("data-") && (t[n.name.slice(5)] = n.value);
                    }
                    return t;
                }
                function s(e, t) {
                    for(var r = Object.keys(e), n = 0; n < r.length; n++){
                        var i = r[n], o = e[i];
                        t[i] !== o && t.setAttribute("data-" + i, o);
                    }
                }
                function c(e) {
                    var t, r = function(e, t) {
                        var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (!r) {
                            if (Array.isArray(e) || (r = n(e))) {
                                r && (e = r);
                                var i = 0, o = function() {};
                                return {
                                    s: o,
                                    n: function() {
                                        return i >= e.length ? {
                                            done: !0
                                        } : {
                                            done: !1,
                                            value: e[i++]
                                        };
                                    },
                                    e: function(e) {
                                        throw e;
                                    },
                                    f: o
                                };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var a, s = !0, c = !1;
                        return {
                            s: function() {
                                r = r.call(e);
                            },
                            n: function() {
                                var e = r.next();
                                return s = e.done, e;
                            },
                            e: function(e) {
                                c = !0, a = e;
                            },
                            f: function() {
                                try {
                                    s || null == r.return || r.return();
                                } finally{
                                    if (c) throw a;
                                }
                            }
                        };
                    }(document.querySelectorAll("style[data-context=klaro-styles]"));
                    try {
                        for(r.s(); !(t = r.n()).done;){
                            var i = t.value, o = i.innerText;
                            void 0 !== i.styleSheet && (o = i.styleSheet.cssText);
                            for(var a = function() {
                                var e, t, r = (e = c[s], t = 2, function(e) {
                                    if (Array.isArray(e)) return e;
                                }(e) || function(e, t) {
                                    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                    if (null != r) {
                                        var n, i, o, a, s = [], c = !0, u = !1;
                                        try {
                                            if (o = (r = r.call(e)).next, 0 === t) {
                                                if (Object(r) !== r) return;
                                                c = !1;
                                            } else for(; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0);
                                        } catch (e) {
                                            u = !0, i = e;
                                        } finally{
                                            try {
                                                if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                        return s;
                                    }
                                }(e, t) || n(e, t) || function() {
                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }()), i = r[0], a = r[1], u = new RegExp("([a-z0-9-]+):[^;]+;[\\s\\n]*\\1:\\s*var\\(--" + i + ",\\s*[^\\)]+\\)", "g");
                                o = o.replace(u, function(e, t) {
                                    return "".concat(t, ": ").concat(a, "; ").concat(t, ": var(--").concat(i, ", ").concat(a, ")");
                                });
                            }, s = 0, c = Object.entries(e); s < c.length; s++)a();
                            var u = document.createElement("style");
                            u.setAttribute("type", "text/css"), u.setAttribute("data-context", "klaro-styles"), void 0 !== u.styleSheet ? u.styleSheet.cssText = o : u.innerText = o, i.parentElement.appendChild(u), i.parentElement.removeChild(i);
                        }
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                }
                r.d(t, {
                    N3: ()=>c,
                    RT: ()=>a,
                    X7: ()=>s,
                    XZ: ()=>o
                }), r(9305), r(2733), r(4701), r(4776), r(9892), r(6281), r(4962), r(9336), r(1908), r(7132), r(3810), r(8557), r(646), r(5021), r(3687), r(9425), r(3994), r(3062), r(4062), r(2367);
            },
            362: (e, t, r)=>{
                "use strict";
                var n = r(6441);
                function i() {}
                function o() {}
                o.resetWarningCache = i, e.exports = function() {
                    function e(e, t, r, i, o, a) {
                        if (a !== n) {
                            var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                            throw s.name = "Invariant Violation", s;
                        }
                    }
                    function t() {
                        return e;
                    }
                    e.isRequired = e;
                    var r = {
                        array: e,
                        bigint: e,
                        bool: e,
                        func: e,
                        number: e,
                        object: e,
                        string: e,
                        symbol: e,
                        any: e,
                        arrayOf: t,
                        element: e,
                        elementType: e,
                        instanceOf: t,
                        node: e,
                        objectOf: t,
                        oneOf: t,
                        oneOfType: t,
                        shape: t,
                        exact: t,
                        checkPropTypes: o,
                        resetWarningCache: i
                    };
                    return r.PropTypes = r, r;
                };
            },
            2688: (e, t, r)=>{
                e.exports = r(362)();
            },
            6441: (e)=>{
                "use strict";
                e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            },
            8120: (e, t, r)=>{
                "use strict";
                var n = r(1483), i = r(8761), o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not a function");
                };
            },
            2374: (e, t, r)=>{
                "use strict";
                var n = r(943), i = r(8761), o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not a constructor");
                };
            },
            3852: (e, t, r)=>{
                "use strict";
                var n = r(735), i = String, o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o("Can't set " + i(e) + " as a prototype");
                };
            },
            7095: (e, t, r)=>{
                "use strict";
                var n = r(1), i = r(5290), o = r(5835).f, a = n("unscopables"), s = Array.prototype;
                void 0 === s[a] && o(s, a, {
                    configurable: !0,
                    value: i(null)
                }), e.exports = function(e) {
                    s[a][e] = !0;
                };
            },
            4419: (e, t, r)=>{
                "use strict";
                var n = r(9105).charAt;
                e.exports = function(e, t, r) {
                    return t + (r ? n(e, t).length : 1);
                };
            },
            6021: (e, t, r)=>{
                "use strict";
                var n = r(4815), i = TypeError;
                e.exports = function(e, t) {
                    if (n(t, e)) return e;
                    throw new i("Incorrect invocation");
                };
            },
            2293: (e, t, r)=>{
                "use strict";
                var n = r(1704), i = String, o = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw new o(i(e) + " is not an object");
                };
            },
            9214: (e, t, r)=>{
                "use strict";
                var n = r(8473);
                e.exports = n(function() {
                    if ("function" == typeof ArrayBuffer) {
                        var e = new ArrayBuffer(8);
                        Object.isExtensible(e) && Object.defineProperty(e, "a", {
                            value: 8
                        });
                    }
                });
            },
            4793: (e, t, r)=>{
                "use strict";
                var n = r(2867).forEach, i = r(3152)("forEach");
                e.exports = i ? [].forEach : function(e) {
                    return n(this, e, arguments.length > 1 ? arguments[1] : void 0);
                };
            },
            6142: (e, t, r)=>{
                "use strict";
                var n = r(2914), i = r(1807), o = r(2347), a = r(8901), s = r(5299), c = r(943), u = r(6960), l = r(670), p = r(4887), f = r(6665), d = Array;
                e.exports = function(e) {
                    var t = o(e), r = c(this), v = arguments.length, m = v > 1 ? arguments[1] : void 0, y = void 0 !== m;
                    y && (m = n(m, v > 2 ? arguments[2] : void 0));
                    var h, b, g, _, w, k, S = f(t), j = 0;
                    if (!S || this === d && s(S)) for(h = u(t), b = r ? new this(h) : d(h); h > j; j++)k = y ? m(t[j], j) : t[j], l(b, j, k);
                    else for(w = (_ = p(t, S)).next, b = r ? new this : []; !(g = i(w, _)).done; j++)k = y ? a(_, m, [
                        g.value,
                        j
                    ], !0) : g.value, l(b, j, k);
                    return b.length = j, b;
                };
            },
            6651: (e, t, r)=>{
                "use strict";
                var n = r(5599), i = r(3392), o = r(6960), a = function(e) {
                    return function(t, r, a) {
                        var s = n(t), c = o(s);
                        if (0 === c) return !e && -1;
                        var u, l = i(a, c);
                        if (e && r != r) {
                            for(; c > l;)if ((u = s[l++]) != u) return !0;
                        } else for(; c > l; l++)if ((e || l in s) && s[l] === r) return e || l || 0;
                        return !e && -1;
                    };
                };
                e.exports = {
                    includes: a(!0),
                    indexOf: a(!1)
                };
            },
            2867: (e, t, r)=>{
                "use strict";
                var n = r(2914), i = r(4762), o = r(2121), a = r(2347), s = r(6960), c = r(4551), u = i([].push), l = function(e) {
                    var t = 1 === e, r = 2 === e, i = 3 === e, l = 4 === e, p = 6 === e, f = 7 === e, d = 5 === e || p;
                    return function(v, m, y, h) {
                        for(var b, g, _ = a(v), w = o(_), k = s(w), S = n(m, y), j = 0, x = h || c, O = t ? x(v, k) : r || f ? x(v, 0) : void 0; k > j; j++)if ((d || j in w) && (g = S(b = w[j], j, _), e)) {
                            if (t) O[j] = g;
                            else if (g) switch(e){
                                case 3:
                                    return !0;
                                case 5:
                                    return b;
                                case 6:
                                    return j;
                                case 2:
                                    u(O, b);
                            }
                            else switch(e){
                                case 4:
                                    return !1;
                                case 7:
                                    u(O, b);
                            }
                        }
                        return p ? -1 : i || l ? l : O;
                    };
                };
                e.exports = {
                    forEach: l(0),
                    map: l(1),
                    filter: l(2),
                    some: l(3),
                    every: l(4),
                    find: l(5),
                    findIndex: l(6),
                    filterReject: l(7)
                };
            },
            4595: (e, t, r)=>{
                "use strict";
                var n = r(8473), i = r(1), o = r(6170), a = i("species");
                e.exports = function(e) {
                    return o >= 51 || !n(function() {
                        var t = [];
                        return (t.constructor = {})[a] = function() {
                            return {
                                foo: 1
                            };
                        }, 1 !== t[e](Boolean).foo;
                    });
                };
            },
            3152: (e, t, r)=>{
                "use strict";
                var n = r(8473);
                e.exports = function(e, t) {
                    var r = [][e];
                    return !!r && n(function() {
                        r.call(null, t || function() {
                            return 1;
                        }, 1);
                    });
                };
            },
            1698: (e, t, r)=>{
                "use strict";
                var n = r(4762);
                e.exports = n([].slice);
            },
            7354: (e, t, r)=>{
                "use strict";
                var n = r(1698), i = Math.floor, o = function(e, t) {
                    var r = e.length;
                    if (r < 8) for(var a, s, c = 1; c < r;){
                        for(s = c, a = e[c]; s && t(e[s - 1], a) > 0;)e[s] = e[--s];
                        s !== c++ && (e[s] = a);
                    }
                    else for(var u = i(r / 2), l = o(n(e, 0, u), t), p = o(n(e, u), t), f = l.length, d = p.length, v = 0, m = 0; v < f || m < d;)e[v + m] = v < f && m < d ? t(l[v], p[m]) <= 0 ? l[v++] : p[m++] : v < f ? l[v++] : p[m++];
                    return e;
                };
                e.exports = o;
            },
            9703: (e, t, r)=>{
                "use strict";
                var n = r(4914), i = r(943), o = r(1704), a = r(1)("species"), s = Array;
                e.exports = function(e) {
                    var t;
                    return n(e) && (t = e.constructor, (i(t) && (t === s || n(t.prototype)) || o(t) && null === (t = t[a])) && (t = void 0)), void 0 === t ? s : t;
                };
            },
            4551: (e, t, r)=>{
                "use strict";
                var n = r(9703);
                e.exports = function(e, t) {
                    return new (n(e))(0 === t ? 0 : t);
                };
            },
            8901: (e, t, r)=>{
                "use strict";
                var n = r(2293), i = r(6721);
                e.exports = function(e, t, r, o) {
                    try {
                        return o ? t(n(r)[0], r[1]) : t(r);
                    } catch (t) {
                        i(e, "throw", t);
                    }
                };
            },
            1554: (e, t, r)=>{
                "use strict";
                var n = r(1)("iterator"), i = !1;
                try {
                    var o = 0, a = {
                        next: function() {
                            return {
                                done: !!o++
                            };
                        },
                        return: function() {
                            i = !0;
                        }
                    };
                    a[n] = function() {
                        return this;
                    }, Array.from(a, function() {
                        throw 2;
                    });
                } catch (e) {}
                e.exports = function(e, t) {
                    try {
                        if (!t && !i) return !1;
                    } catch (e) {
                        return !1;
                    }
                    var r = !1;
                    try {
                        var o = {};
                        o[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e(o);
                    } catch (e) {}
                    return r;
                };
            },
            1278: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = n({}.toString), o = n("".slice);
                e.exports = function(e) {
                    return o(i(e), 8, -1);
                };
            },
            6145: (e, t, r)=>{
                "use strict";
                var n = r(4338), i = r(1483), o = r(1278), a = r(1)("toStringTag"), s = Object, c = "Arguments" === o(function() {
                    return arguments;
                }());
                e.exports = n ? o : function(e) {
                    var t, r, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = s(e), a)) ? r : c ? o(t) : "Object" === (n = o(t)) && i(t.callee) ? "Arguments" : n;
                };
            },
            4092: (e, t, r)=>{
                "use strict";
                var n = r(5290), i = r(3864), o = r(2313), a = r(2914), s = r(6021), c = r(5983), u = r(1506), l = r(5662), p = r(5247), f = r(240), d = r(382), v = r(8041).fastKey, m = r(4483), y = m.set, h = m.getterFor;
                e.exports = {
                    getConstructor: function(e, t, r, l) {
                        var p = e(function(e, i) {
                            s(e, f), y(e, {
                                type: t,
                                index: n(null),
                                first: void 0,
                                last: void 0,
                                size: 0
                            }), d || (e.size = 0), c(i) || u(i, e[l], {
                                that: e,
                                AS_ENTRIES: r
                            });
                        }), f = p.prototype, m = h(t), b = function(e, t, r) {
                            var n, i, o = m(e), a = g(e, t);
                            return a ? a.value = r : (o.last = a = {
                                index: i = v(t, !0),
                                key: t,
                                value: r,
                                previous: n = o.last,
                                next: void 0,
                                removed: !1
                            }, o.first || (o.first = a), n && (n.next = a), d ? o.size++ : e.size++, "F" !== i && (o.index[i] = a)), e;
                        }, g = function(e, t) {
                            var r, n = m(e), i = v(t);
                            if ("F" !== i) return n.index[i];
                            for(r = n.first; r; r = r.next)if (r.key === t) return r;
                        };
                        return o(f, {
                            clear: function() {
                                for(var e = m(this), t = e.first; t;)t.removed = !0, t.previous && (t.previous = t.previous.next = void 0), t = t.next;
                                e.first = e.last = void 0, e.index = n(null), d ? e.size = 0 : this.size = 0;
                            },
                            delete: function(e) {
                                var t = this, r = m(t), n = g(t, e);
                                if (n) {
                                    var i = n.next, o = n.previous;
                                    delete r.index[n.index], n.removed = !0, o && (o.next = i), i && (i.previous = o), r.first === n && (r.first = i), r.last === n && (r.last = o), d ? r.size-- : t.size--;
                                }
                                return !!n;
                            },
                            forEach: function(e) {
                                for(var t, r = m(this), n = a(e, arguments.length > 1 ? arguments[1] : void 0); t = t ? t.next : r.first;)for(n(t.value, t.key, this); t && t.removed;)t = t.previous;
                            },
                            has: function(e) {
                                return !!g(this, e);
                            }
                        }), o(f, r ? {
                            get: function(e) {
                                var t = g(this, e);
                                return t && t.value;
                            },
                            set: function(e, t) {
                                return b(this, 0 === e ? 0 : e, t);
                            }
                        } : {
                            add: function(e) {
                                return b(this, e = 0 === e ? 0 : e, e);
                            }
                        }), d && i(f, "size", {
                            configurable: !0,
                            get: function() {
                                return m(this).size;
                            }
                        }), p;
                    },
                    setStrong: function(e, t, r) {
                        var n = t + " Iterator", i = h(t), o = h(n);
                        l(e, t, function(e, t) {
                            y(this, {
                                type: n,
                                target: e,
                                state: i(e),
                                kind: t,
                                last: void 0
                            });
                        }, function() {
                            for(var e = o(this), t = e.kind, r = e.last; r && r.removed;)r = r.previous;
                            return e.target && (e.last = r = r ? r.next : e.state.first) ? p("keys" === t ? r.key : "values" === t ? r.value : [
                                r.key,
                                r.value
                            ], !1) : (e.target = void 0, p(void 0, !0));
                        }, r ? "entries" : "values", !r, !0), f(t);
                    }
                };
            },
            7446: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(8389), o = r(4762), a = r(8730), s = r(7914), c = r(8041), u = r(1506), l = r(6021), p = r(1483), f = r(5983), d = r(1704), v = r(8473), m = r(1554), y = r(2277), h = r(2429);
                e.exports = function(e, t, r) {
                    var b = -1 !== e.indexOf("Map"), g = -1 !== e.indexOf("Weak"), _ = b ? "set" : "add", w = i[e], k = w && w.prototype, S = w, j = {}, x = function(e) {
                        var t = o(k[e]);
                        s(k, e, "add" === e ? function(e) {
                            return t(this, 0 === e ? 0 : e), this;
                        } : "delete" === e ? function(e) {
                            return !(g && !d(e)) && t(this, 0 === e ? 0 : e);
                        } : "get" === e ? function(e) {
                            return g && !d(e) ? void 0 : t(this, 0 === e ? 0 : e);
                        } : "has" === e ? function(e) {
                            return !(g && !d(e)) && t(this, 0 === e ? 0 : e);
                        } : function(e, r) {
                            return t(this, 0 === e ? 0 : e, r), this;
                        });
                    };
                    if (a(e, !p(w) || !(g || k.forEach && !v(function() {
                        (new w).entries().next();
                    })))) S = r.getConstructor(t, e, b, _), c.enable();
                    else if (a(e, !0)) {
                        var O = new S, E = O[_](g ? {} : -0, 1) !== O, P = v(function() {
                            O.has(1);
                        }), A = m(function(e) {
                            new w(e);
                        }), z = !g && v(function() {
                            for(var e = new w, t = 5; t--;)e[_](t, t);
                            return !e.has(-0);
                        });
                        A || ((S = t(function(e, t) {
                            l(e, k);
                            var r = h(new w, e, S);
                            return f(t) || u(t, r[_], {
                                that: r,
                                AS_ENTRIES: b
                            }), r;
                        })).prototype = k, k.constructor = S), (P || z) && (x("delete"), x("has"), b && x("get")), (z || E) && x(_), g && k.clear && delete k.clear;
                    }
                    return j[e] = S, n({
                        global: !0,
                        constructor: !0,
                        forced: S !== w
                    }, j), y(S, e), g || r.setStrong(S, e, b), S;
                };
            },
            6726: (e, t, r)=>{
                "use strict";
                var n = r(5755), i = r(9497), o = r(4961), a = r(5835);
                e.exports = function(e, t, r) {
                    for(var s = i(t), c = a.f, u = o.f, l = 0; l < s.length; l++){
                        var p = s[l];
                        n(e, p) || r && n(r, p) || c(e, p, u(t, p));
                    }
                };
            },
            4522: (e, t, r)=>{
                "use strict";
                var n = r(1)("match");
                e.exports = function(e) {
                    var t = /./;
                    try {
                        "/./"[e](t);
                    } catch (r) {
                        try {
                            return t[n] = !1, "/./"[e](t);
                        } catch (e) {}
                    }
                    return !1;
                };
            },
            9441: (e, t, r)=>{
                "use strict";
                var n = r(8473);
                e.exports = !n(function() {
                    function e() {}
                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
                });
            },
            5247: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                };
            },
            9037: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(5835), o = r(7738);
                e.exports = n ? function(e, t, r) {
                    return i.f(e, t, o(1, r));
                } : function(e, t, r) {
                    return e[t] = r, e;
                };
            },
            7738: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            670: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(5835), o = r(7738);
                e.exports = function(e, t, r) {
                    n ? i.f(e, t, o(0, r)) : e[t] = r;
                };
            },
            6446: (e, t, r)=>{
                "use strict";
                var n = r(2293), i = r(348), o = TypeError;
                e.exports = function(e) {
                    if (n(this), "string" === e || "default" === e) e = "string";
                    else if ("number" !== e) throw new o("Incorrect hint");
                    return i(this, e);
                };
            },
            3864: (e, t, r)=>{
                "use strict";
                var n = r(169), i = r(5835);
                e.exports = function(e, t, r) {
                    return r.get && n(r.get, t, {
                        getter: !0
                    }), r.set && n(r.set, t, {
                        setter: !0
                    }), i.f(e, t, r);
                };
            },
            7914: (e, t, r)=>{
                "use strict";
                var n = r(1483), i = r(5835), o = r(169), a = r(2095);
                e.exports = function(e, t, r, s) {
                    s || (s = {});
                    var c = s.enumerable, u = void 0 !== s.name ? s.name : t;
                    if (n(r) && o(r, u, s), s.global) c ? e[t] = r : a(t, r);
                    else {
                        try {
                            s.unsafe ? e[t] && (c = !0) : delete e[t];
                        } catch (e) {}
                        c ? e[t] = r : i.f(e, t, {
                            value: r,
                            enumerable: !1,
                            configurable: !s.nonConfigurable,
                            writable: !s.nonWritable
                        });
                    }
                    return e;
                };
            },
            2313: (e, t, r)=>{
                "use strict";
                var n = r(7914);
                e.exports = function(e, t, r) {
                    for(var i in t)n(e, i, t[i], r);
                    return e;
                };
            },
            2095: (e, t, r)=>{
                "use strict";
                var n = r(8389), i = Object.defineProperty;
                e.exports = function(e, t) {
                    try {
                        i(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (r) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            6060: (e, t, r)=>{
                "use strict";
                var n = r(8761), i = TypeError;
                e.exports = function(e, t) {
                    if (!delete e[t]) throw new i("Cannot delete property " + n(t) + " of " + n(e));
                };
            },
            382: (e, t, r)=>{
                "use strict";
                var n = r(8473);
                e.exports = !n(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            3145: (e, t, r)=>{
                "use strict";
                var n = r(8389), i = r(1704), o = n.document, a = i(o) && i(o.createElement);
                e.exports = function(e) {
                    return a ? o.createElement(e) : {};
                };
            },
            1091: (e)=>{
                "use strict";
                var t = TypeError;
                e.exports = function(e) {
                    if (e > 9007199254740991) throw t("Maximum allowed index exceeded");
                    return e;
                };
            },
            4842: (e)=>{
                "use strict";
                e.exports = {
                    CSSRuleList: 0,
                    CSSStyleDeclaration: 0,
                    CSSValueList: 0,
                    ClientRectList: 0,
                    DOMRectList: 0,
                    DOMStringList: 0,
                    DOMTokenList: 1,
                    DataTransferItemList: 0,
                    FileList: 0,
                    HTMLAllCollection: 0,
                    HTMLCollection: 0,
                    HTMLFormElement: 0,
                    HTMLSelectElement: 0,
                    MediaList: 0,
                    MimeTypeArray: 0,
                    NamedNodeMap: 0,
                    NodeList: 1,
                    PaintRequestList: 0,
                    Plugin: 0,
                    PluginArray: 0,
                    SVGLengthList: 0,
                    SVGNumberList: 0,
                    SVGPathSegList: 0,
                    SVGPointList: 0,
                    SVGStringList: 0,
                    SVGTransformList: 0,
                    SourceBufferList: 0,
                    StyleSheetList: 0,
                    TextTrackCueList: 0,
                    TextTrackList: 0,
                    TouchList: 0
                };
            },
            1902: (e, t, r)=>{
                "use strict";
                var n = r(3145)("span").classList, i = n && n.constructor && n.constructor.prototype;
                e.exports = i === Object.prototype ? void 0 : i;
            },
            7332: (e, t, r)=>{
                "use strict";
                var n = r(9966).match(/firefox\/(\d+)/i);
                e.exports = !!n && +n[1];
            },
            6956: (e, t, r)=>{
                "use strict";
                var n = r(938), i = r(4334);
                e.exports = !n && !i && "object" == typeof window && "object" == typeof document;
            },
            5413: (e)=>{
                "use strict";
                e.exports = "function" == typeof Bun && Bun && "string" == typeof Bun.version;
            },
            938: (e)=>{
                "use strict";
                e.exports = "object" == typeof Deno && Deno && "object" == typeof Deno.version;
            },
            8996: (e, t, r)=>{
                "use strict";
                var n = r(9966);
                e.exports = /MSIE|Trident/.test(n);
            },
            4466: (e, t, r)=>{
                "use strict";
                var n = r(9966);
                e.exports = /ipad|iphone|ipod/i.test(n) && "undefined" != typeof Pebble;
            },
            8417: (e, t, r)=>{
                "use strict";
                var n = r(9966);
                e.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
            },
            4334: (e, t, r)=>{
                "use strict";
                var n = r(8389), i = r(1278);
                e.exports = "process" === i(n.process);
            },
            6639: (e, t, r)=>{
                "use strict";
                var n = r(9966);
                e.exports = /web0s(?!.*chrome)/i.test(n);
            },
            9966: (e)=>{
                "use strict";
                e.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            6170: (e, t, r)=>{
                "use strict";
                var n, i, o = r(8389), a = r(9966), s = o.process, c = o.Deno, u = s && s.versions || c && c.version, l = u && u.v8;
                l && (i = (n = l.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !i && a && (!(n = a.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = a.match(/Chrome\/(\d+)/)) && (i = +n[1]), e.exports = i;
            },
            5158: (e, t, r)=>{
                "use strict";
                var n = r(9966).match(/AppleWebKit\/(\d+)\./);
                e.exports = !!n && +n[1];
            },
            4741: (e)=>{
                "use strict";
                e.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            8612: (e, t, r)=>{
                "use strict";
                var n = r(8389), i = r(4961).f, o = r(9037), a = r(7914), s = r(2095), c = r(6726), u = r(8730);
                e.exports = function(e, t) {
                    var r, l, p, f, d, v = e.target, m = e.global, y = e.stat;
                    if (r = m ? n : y ? n[v] || s(v, {}) : n[v] && n[v].prototype) for(l in t){
                        if (f = t[l], p = e.dontCallGetSet ? (d = i(r, l)) && d.value : r[l], !u(m ? l : v + (y ? "." : "#") + l, e.forced) && void 0 !== p) {
                            if (typeof f == typeof p) continue;
                            c(f, p);
                        }
                        (e.sham || p && p.sham) && o(f, "sham", !0), a(r, l, f, e);
                    }
                };
            },
            8473: (e)=>{
                "use strict";
                e.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            3358: (e, t, r)=>{
                "use strict";
                r(5021);
                var n = r(1807), i = r(7914), o = r(8865), a = r(8473), s = r(1), c = r(9037), u = s("species"), l = RegExp.prototype;
                e.exports = function(e, t, r, p) {
                    var f = s(e), d = !a(function() {
                        var t = {};
                        return t[f] = function() {
                            return 7;
                        }, 7 !== ""[e](t);
                    }), v = d && !a(function() {
                        var t = !1, r = /a/;
                        return "split" === e && ((r = {}).constructor = {}, r.constructor[u] = function() {
                            return r;
                        }, r.flags = "", r[f] = /./[f]), r.exec = function() {
                            return t = !0, null;
                        }, r[f](""), !t;
                    });
                    if (!d || !v || r) {
                        var m = /./[f], y = t(f, ""[e], function(e, t, r, i, a) {
                            var s = t.exec;
                            return s === o || s === l.exec ? d && !a ? {
                                done: !0,
                                value: n(m, t, r, i)
                            } : {
                                done: !0,
                                value: n(e, r, t, i)
                            } : {
                                done: !1
                            };
                        });
                        i(String.prototype, e, y[0]), i(l, f, y[1]);
                    }
                    p && c(l[f], "sham", !0);
                };
            },
            6530: (e, t, r)=>{
                "use strict";
                var n = r(8473);
                e.exports = !n(function() {
                    return Object.isExtensible(Object.preventExtensions({}));
                });
            },
            3067: (e, t, r)=>{
                "use strict";
                var n = r(274), i = Function.prototype, o = i.apply, a = i.call;
                e.exports = "object" == typeof Reflect && Reflect.apply || (n ? a.bind(o) : function() {
                    return a.apply(o, arguments);
                });
            },
            2914: (e, t, r)=>{
                "use strict";
                var n = r(3786), i = r(8120), o = r(274), a = n(n.bind);
                e.exports = function(e, t) {
                    return i(e), void 0 === t ? e : o ? a(e, t) : function() {
                        return e.apply(t, arguments);
                    };
                };
            },
            274: (e, t, r)=>{
                "use strict";
                var n = r(8473);
                e.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            2164: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(8120), o = r(1704), a = r(5755), s = r(1698), c = r(274), u = Function, l = n([].concat), p = n([].join), f = {};
                e.exports = c ? u.bind : function(e) {
                    var t = i(this), r = t.prototype, n = s(arguments, 1), c = function() {
                        var r = l(n, s(arguments));
                        return this instanceof c ? function(e, t, r) {
                            if (!a(f, t)) {
                                for(var n = [], i = 0; i < t; i++)n[i] = "a[" + i + "]";
                                f[t] = u("C,a", "return new C(" + p(n, ",") + ")");
                            }
                            return f[t](e, r);
                        }(t, r.length, r) : t.apply(e, r);
                    };
                    return o(r) && (c.prototype = r), c;
                };
            },
            1807: (e, t, r)=>{
                "use strict";
                var n = r(274), i = Function.prototype.call;
                e.exports = n ? i.bind(i) : function() {
                    return i.apply(i, arguments);
                };
            },
            2048: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(5755), o = Function.prototype, a = n && Object.getOwnPropertyDescriptor, s = i(o, "name"), c = s && "something" === (function() {}).name, u = s && (!n || n && a(o, "name").configurable);
                e.exports = {
                    EXISTS: s,
                    PROPER: c,
                    CONFIGURABLE: u
                };
            },
            680: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(8120);
                e.exports = function(e, t, r) {
                    try {
                        return n(i(Object.getOwnPropertyDescriptor(e, t)[r]));
                    } catch (e) {}
                };
            },
            3786: (e, t, r)=>{
                "use strict";
                var n = r(1278), i = r(4762);
                e.exports = function(e) {
                    if ("Function" === n(e)) return i(e);
                };
            },
            4762: (e, t, r)=>{
                "use strict";
                var n = r(274), i = Function.prototype, o = i.call, a = n && i.bind.bind(o, o);
                e.exports = n ? a : function(e) {
                    return function() {
                        return o.apply(e, arguments);
                    };
                };
            },
            1409: (e, t, r)=>{
                "use strict";
                var n = r(8389), i = r(1483);
                e.exports = function(e, t) {
                    var r;
                    return arguments.length < 2 ? (r = n[e], i(r) ? r : void 0) : n[e] && n[e][t];
                };
            },
            6665: (e, t, r)=>{
                "use strict";
                var n = r(6145), i = r(2564), o = r(5983), a = r(6775), s = r(1)("iterator");
                e.exports = function(e) {
                    if (!o(e)) return i(e, s) || i(e, "@@iterator") || a[n(e)];
                };
            },
            4887: (e, t, r)=>{
                "use strict";
                var n = r(1807), i = r(8120), o = r(2293), a = r(8761), s = r(6665), c = TypeError;
                e.exports = function(e, t) {
                    var r = arguments.length < 2 ? s(e) : t;
                    if (i(r)) return o(n(r, e));
                    throw new c(a(e) + " is not iterable");
                };
            },
            5215: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(4914), o = r(1483), a = r(1278), s = r(6261), c = n([].push);
                e.exports = function(e) {
                    if (o(e)) return e;
                    if (i(e)) {
                        for(var t = e.length, r = [], n = 0; n < t; n++){
                            var u = e[n];
                            "string" == typeof u ? c(r, u) : "number" != typeof u && "Number" !== a(u) && "String" !== a(u) || c(r, s(u));
                        }
                        var l = r.length, p = !0;
                        return function(e, t) {
                            if (p) return p = !1, t;
                            if (i(this)) return t;
                            for(var n = 0; n < l; n++)if (r[n] === e) return t;
                        };
                    }
                };
            },
            2564: (e, t, r)=>{
                "use strict";
                var n = r(8120), i = r(5983);
                e.exports = function(e, t) {
                    var r = e[t];
                    return i(r) ? void 0 : n(r);
                };
            },
            708: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(2347), o = Math.floor, a = n("".charAt), s = n("".replace), c = n("".slice), u = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, l = /\$([$&'`]|\d{1,2})/g;
                e.exports = function(e, t, r, n, p, f) {
                    var d = r + e.length, v = n.length, m = l;
                    return void 0 !== p && (p = i(p), m = u), s(f, m, function(i, s) {
                        var u;
                        switch(a(s, 0)){
                            case "$":
                                return "$";
                            case "&":
                                return e;
                            case "`":
                                return c(t, 0, r);
                            case "'":
                                return c(t, d);
                            case "<":
                                u = p[c(s, 1, -1)];
                                break;
                            default:
                                var l = +s;
                                if (0 === l) return i;
                                if (l > v) {
                                    var f = o(l / 10);
                                    return 0 === f ? i : f <= v ? void 0 === n[f - 1] ? a(s, 1) : n[f - 1] + a(s, 1) : i;
                                }
                                u = n[l - 1];
                        }
                        return void 0 === u ? "" : u;
                    });
                };
            },
            8389: function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.Math === Math && e;
                };
                e.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof r.g && r.g) || n("object" == typeof this && this) || function() {
                    return this;
                }() || Function("return this")();
            },
            5755: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(2347), o = n({}.hasOwnProperty);
                e.exports = Object.hasOwn || function(e, t) {
                    return o(i(e), t);
                };
            },
            1507: (e)=>{
                "use strict";
                e.exports = {};
            },
            1339: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    try {
                        1 === arguments.length ? console.error(e) : console.error(e, t);
                    } catch (e) {}
                };
            },
            2811: (e, t, r)=>{
                "use strict";
                var n = r(1409);
                e.exports = n("document", "documentElement");
            },
            1799: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(8473), o = r(3145);
                e.exports = !n && !i(function() {
                    return 7 !== Object.defineProperty(o("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            2121: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(8473), o = r(1278), a = Object, s = n("".split);
                e.exports = i(function() {
                    return !a("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" === o(e) ? s(e, "") : a(e);
                } : a;
            },
            2429: (e, t, r)=>{
                "use strict";
                var n = r(1483), i = r(1704), o = r(1953);
                e.exports = function(e, t, r) {
                    var a, s;
                    return o && n(a = t.constructor) && a !== r && i(s = a.prototype) && s !== r.prototype && o(e, s), e;
                };
            },
            7268: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(1483), o = r(1831), a = n(Function.toString);
                i(o.inspectSource) || (o.inspectSource = function(e) {
                    return a(e);
                }), e.exports = o.inspectSource;
            },
            8041: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(4762), o = r(1507), a = r(1704), s = r(5755), c = r(5835).f, u = r(2278), l = r(2020), p = r(706), f = r(1866), d = r(6530), v = !1, m = f("meta"), y = 0, h = function(e) {
                    c(e, m, {
                        value: {
                            objectID: "O" + y++,
                            weakData: {}
                        }
                    });
                }, b = e.exports = {
                    enable: function() {
                        b.enable = function() {}, v = !0;
                        var e = u.f, t = i([].splice), r = {};
                        r[m] = 1, e(r).length && (u.f = function(r) {
                            for(var n = e(r), i = 0, o = n.length; i < o; i++)if (n[i] === m) {
                                t(n, i, 1);
                                break;
                            }
                            return n;
                        }, n({
                            target: "Object",
                            stat: !0,
                            forced: !0
                        }, {
                            getOwnPropertyNames: l.f
                        }));
                    },
                    fastKey: function(e, t) {
                        if (!a(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
                        if (!s(e, m)) {
                            if (!p(e)) return "F";
                            if (!t) return "E";
                            h(e);
                        }
                        return e[m].objectID;
                    },
                    getWeakData: function(e, t) {
                        if (!s(e, m)) {
                            if (!p(e)) return !0;
                            if (!t) return !1;
                            h(e);
                        }
                        return e[m].weakData;
                    },
                    onFreeze: function(e) {
                        return d && v && p(e) && !s(e, m) && h(e), e;
                    }
                };
                o[m] = !0;
            },
            4483: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(4644), s = r(8389), c = r(1704), u = r(9037), l = r(5755), p = r(1831), f = r(5409), d = r(1507), v = "Object already initialized", m = s.TypeError, y = s.WeakMap;
                if (a || p.state) {
                    var h = p.state || (p.state = new y);
                    h.get = h.get, h.has = h.has, h.set = h.set, n = function(e, t) {
                        if (h.has(e)) throw new m(v);
                        return t.facade = e, h.set(e, t), t;
                    }, i = function(e) {
                        return h.get(e) || {};
                    }, o = function(e) {
                        return h.has(e);
                    };
                } else {
                    var b = f("state");
                    d[b] = !0, n = function(e, t) {
                        if (l(e, b)) throw new m(v);
                        return t.facade = e, u(e, b, t), t;
                    }, i = function(e) {
                        return l(e, b) ? e[b] : {};
                    }, o = function(e) {
                        return l(e, b);
                    };
                }
                e.exports = {
                    set: n,
                    get: i,
                    has: o,
                    enforce: function(e) {
                        return o(e) ? i(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var r;
                            if (!c(t) || (r = i(t)).type !== e) throw new m("Incompatible receiver, " + e + " required");
                            return r;
                        };
                    }
                };
            },
            5299: (e, t, r)=>{
                "use strict";
                var n = r(1), i = r(6775), o = n("iterator"), a = Array.prototype;
                e.exports = function(e) {
                    return void 0 !== e && (i.Array === e || a[o] === e);
                };
            },
            4914: (e, t, r)=>{
                "use strict";
                var n = r(1278);
                e.exports = Array.isArray || function(e) {
                    return "Array" === n(e);
                };
            },
            1483: (e)=>{
                "use strict";
                var t = "object" == typeof document && document.all;
                e.exports = void 0 === t && void 0 !== t ? function(e) {
                    return "function" == typeof e || e === t;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            943: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(8473), o = r(1483), a = r(6145), s = r(1409), c = r(7268), u = function() {}, l = s("Reflect", "construct"), p = /^\s*(?:class|function)\b/, f = n(p.exec), d = !p.test(u), v = function(e) {
                    if (!o(e)) return !1;
                    try {
                        return l(u, [], e), !0;
                    } catch (e) {
                        return !1;
                    }
                }, m = function(e) {
                    if (!o(e)) return !1;
                    switch(a(e)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return !1;
                    }
                    try {
                        return d || !!f(p, c(e));
                    } catch (e) {
                        return !0;
                    }
                };
                m.sham = !0, e.exports = !l || i(function() {
                    var e;
                    return v(v.call) || !v(Object) || !v(function() {
                        e = !0;
                    }) || e;
                }) ? m : v;
            },
            8730: (e, t, r)=>{
                "use strict";
                var n = r(8473), i = r(1483), o = /#|\.prototype\./, a = function(e, t) {
                    var r = c[s(e)];
                    return r === l || r !== u && (i(t) ? n(t) : !!t);
                }, s = a.normalize = function(e) {
                    return String(e).replace(o, ".").toLowerCase();
                }, c = a.data = {}, u = a.NATIVE = "N", l = a.POLYFILL = "P";
                e.exports = a;
            },
            5983: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return null == e;
                };
            },
            1704: (e, t, r)=>{
                "use strict";
                var n = r(1483);
                e.exports = function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            735: (e, t, r)=>{
                "use strict";
                var n = r(1704);
                e.exports = function(e) {
                    return n(e) || null === e;
                };
            },
            9557: (e)=>{
                "use strict";
                e.exports = !1;
            },
            4786: (e, t, r)=>{
                "use strict";
                var n = r(1704), i = r(1278), o = r(1)("match");
                e.exports = function(e) {
                    var t;
                    return n(e) && (void 0 !== (t = e[o]) ? !!t : "RegExp" === i(e));
                };
            },
            1423: (e, t, r)=>{
                "use strict";
                var n = r(1409), i = r(1483), o = r(4815), a = r(5022), s = Object;
                e.exports = a ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return i(t) && o(t.prototype, s(e));
                };
            },
            1506: (e, t, r)=>{
                "use strict";
                var n = r(2914), i = r(1807), o = r(2293), a = r(8761), s = r(5299), c = r(6960), u = r(4815), l = r(4887), p = r(6665), f = r(6721), d = TypeError, v = function(e, t) {
                    this.stopped = e, this.result = t;
                }, m = v.prototype;
                e.exports = function(e, t, r) {
                    var y, h, b, g, _, w, k, S = r && r.that, j = !(!r || !r.AS_ENTRIES), x = !(!r || !r.IS_RECORD), O = !(!r || !r.IS_ITERATOR), E = !(!r || !r.INTERRUPTED), P = n(t, S), A = function(e) {
                        return y && f(y, "normal", e), new v(!0, e);
                    }, z = function(e) {
                        return j ? (o(e), E ? P(e[0], e[1], A) : P(e[0], e[1])) : E ? P(e, A) : P(e);
                    };
                    if (x) y = e.iterator;
                    else if (O) y = e;
                    else {
                        if (!(h = p(e))) throw new d(a(e) + " is not iterable");
                        if (s(h)) {
                            for(b = 0, g = c(e); g > b; b++)if ((_ = z(e[b])) && u(m, _)) return _;
                            return new v(!1);
                        }
                        y = l(e, h);
                    }
                    for(w = x ? e.next : y.next; !(k = i(w, y)).done;){
                        try {
                            _ = z(k.value);
                        } catch (e) {
                            f(y, "throw", e);
                        }
                        if ("object" == typeof _ && _ && u(m, _)) return _;
                    }
                    return new v(!1);
                };
            },
            6721: (e, t, r)=>{
                "use strict";
                var n = r(1807), i = r(2293), o = r(2564);
                e.exports = function(e, t, r) {
                    var a, s;
                    i(e);
                    try {
                        if (!(a = o(e, "return"))) {
                            if ("throw" === t) throw r;
                            return r;
                        }
                        a = n(a, e);
                    } catch (e) {
                        s = !0, a = e;
                    }
                    if ("throw" === t) throw r;
                    if (s) throw a;
                    return i(a), r;
                };
            },
            1040: (e, t, r)=>{
                "use strict";
                var n = r(1851).IteratorPrototype, i = r(5290), o = r(7738), a = r(2277), s = r(6775), c = function() {
                    return this;
                };
                e.exports = function(e, t, r, u) {
                    var l = t + " Iterator";
                    return e.prototype = i(n, {
                        next: o(+!u, r)
                    }), a(e, l, !1, !0), s[l] = c, e;
                };
            },
            5662: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(1807), o = r(9557), a = r(2048), s = r(1483), c = r(1040), u = r(3181), l = r(1953), p = r(2277), f = r(9037), d = r(7914), v = r(1), m = r(6775), y = r(1851), h = a.PROPER, b = a.CONFIGURABLE, g = y.IteratorPrototype, _ = y.BUGGY_SAFARI_ITERATORS, w = v("iterator"), k = "keys", S = "values", j = "entries", x = function() {
                    return this;
                };
                e.exports = function(e, t, r, a, v, y, O) {
                    c(r, t, a);
                    var E, P, A, z = function(e) {
                        if (e === v && D) return D;
                        if (!_ && e && e in N) return N[e];
                        switch(e){
                            case k:
                            case S:
                            case j:
                                return function() {
                                    return new r(this, e);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }, C = t + " Iterator", T = !1, N = e.prototype, I = N[w] || N["@@iterator"] || v && N[v], D = !_ && I || z(v), R = "Array" === t && N.entries || I;
                    if (R && (E = u(R.call(new e))) !== Object.prototype && E.next && (o || u(E) === g || (l ? l(E, g) : s(E[w]) || d(E, w, x)), p(E, C, !0, !0), o && (m[C] = x)), h && v === S && I && I.name !== S && (!o && b ? f(N, "name", S) : (T = !0, D = function() {
                        return i(I, this);
                    })), v) {
                        if (P = {
                            values: z(S),
                            keys: y ? D : z(k),
                            entries: z(j)
                        }, O) for(A in P)(_ || T || !(A in N)) && d(N, A, P[A]);
                        else n({
                            target: t,
                            proto: !0,
                            forced: _ || T
                        }, P);
                    }
                    return o && !O || N[w] === D || d(N, w, D, {
                        name: v
                    }), m[t] = D, P;
                };
            },
            1851: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(8473), s = r(1483), c = r(1704), u = r(5290), l = r(3181), p = r(7914), f = r(1), d = r(9557), v = f("iterator"), m = !1;
                [].keys && ("next" in (o = [].keys()) ? (i = l(l(o))) !== Object.prototype && (n = i) : m = !0), !c(n) || a(function() {
                    var e = {};
                    return n[v].call(e) !== e;
                }) ? n = {} : d && (n = u(n)), s(n[v]) || p(n, v, function() {
                    return this;
                }), e.exports = {
                    IteratorPrototype: n,
                    BUGGY_SAFARI_ITERATORS: m
                };
            },
            6775: (e)=>{
                "use strict";
                e.exports = {};
            },
            6960: (e, t, r)=>{
                "use strict";
                var n = r(8324);
                e.exports = function(e) {
                    return n(e.length);
                };
            },
            169: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(8473), o = r(1483), a = r(5755), s = r(382), c = r(2048).CONFIGURABLE, u = r(7268), l = r(4483), p = l.enforce, f = l.get, d = String, v = Object.defineProperty, m = n("".slice), y = n("".replace), h = n([].join), b = s && !i(function() {
                    return 8 !== v(function() {}, "length", {
                        value: 8
                    }).length;
                }), g = String(String).split("String"), _ = e.exports = function(e, t, r) {
                    "Symbol(" === m(d(t), 0, 7) && (t = "[" + y(d(t), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!a(e, "name") || c && e.name !== t) && (s ? v(e, "name", {
                        value: t,
                        configurable: !0
                    }) : e.name = t), b && r && a(r, "arity") && e.length !== r.arity && v(e, "length", {
                        value: r.arity
                    });
                    try {
                        r && a(r, "constructor") && r.constructor ? s && v(e, "prototype", {
                            writable: !1
                        }) : e.prototype && (e.prototype = void 0);
                    } catch (e) {}
                    var n = p(e);
                    return a(n, "source") || (n.source = h(g, "string" == typeof t ? t : "")), e;
                };
                Function.prototype.toString = _(function() {
                    return o(this) && f(this).source || u(this);
                }, "toString");
            },
            1703: (e)=>{
                "use strict";
                var t = Math.ceil, r = Math.floor;
                e.exports = Math.trunc || function(e) {
                    var n = +e;
                    return (n > 0 ? r : t)(n);
                };
            },
            553: (e, t, r)=>{
                "use strict";
                var n, i, o, a, s, c = r(8389), u = r(8123), l = r(2914), p = r(7007).set, f = r(5459), d = r(8417), v = r(4466), m = r(6639), y = r(4334), h = c.MutationObserver || c.WebKitMutationObserver, b = c.document, g = c.process, _ = c.Promise, w = u("queueMicrotask");
                if (!w) {
                    var k = new f, S = function() {
                        var e, t;
                        for(y && (e = g.domain) && e.exit(); t = k.get();)try {
                            t();
                        } catch (e) {
                            throw k.head && n(), e;
                        }
                        e && e.enter();
                    };
                    d || y || m || !h || !b ? !v && _ && _.resolve ? ((a = _.resolve(void 0)).constructor = _, s = l(a.then, a), n = function() {
                        s(S);
                    }) : y ? n = function() {
                        g.nextTick(S);
                    } : (p = l(p, c), n = function() {
                        p(S);
                    }) : (i = !0, o = b.createTextNode(""), new h(S).observe(o, {
                        characterData: !0
                    }), n = function() {
                        o.data = i = !i;
                    }), w = function(e) {
                        k.head || n(), k.add(e);
                    };
                }
                e.exports = w;
            },
            1173: (e, t, r)=>{
                "use strict";
                var n = r(8120), i = TypeError, o = function(e) {
                    var t, r;
                    this.promise = new e(function(e, n) {
                        if (void 0 !== t || void 0 !== r) throw new i("Bad Promise constructor");
                        t = e, r = n;
                    }), this.resolve = n(t), this.reject = n(r);
                };
                e.exports.f = function(e) {
                    return new o(e);
                };
            },
            4989: (e, t, r)=>{
                "use strict";
                var n = r(4786), i = TypeError;
                e.exports = function(e) {
                    if (n(e)) throw new i("The method doesn't accept regular expressions");
                    return e;
                };
            },
            1439: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(4762), o = r(1807), a = r(8473), s = r(3658), c = r(4347), u = r(7611), l = r(2347), p = r(2121), f = Object.assign, d = Object.defineProperty, v = i([].concat);
                e.exports = !f || a(function() {
                    if (n && 1 !== f({
                        b: 1
                    }, f(d({}, "a", {
                        enumerable: !0,
                        get: function() {
                            d(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) return !0;
                    var e = {}, t = {}, r = Symbol("assign detection"), i = "abcdefghijklmnopqrst";
                    return e[r] = 7, i.split("").forEach(function(e) {
                        t[e] = e;
                    }), 7 !== f({}, e)[r] || s(f({}, t)).join("") !== i;
                }) ? function(e, t) {
                    for(var r = l(e), i = arguments.length, a = 1, f = c.f, d = u.f; i > a;)for(var m, y = p(arguments[a++]), h = f ? v(s(y), f(y)) : s(y), b = h.length, g = 0; b > g;)m = h[g++], n && !o(d, y, m) || (r[m] = y[m]);
                    return r;
                } : f;
            },
            5290: (e, t, r)=>{
                "use strict";
                var n, i = r(2293), o = r(5799), a = r(4741), s = r(1507), c = r(2811), u = r(3145), l = r(5409), p = "prototype", f = "script", d = l("IE_PROTO"), v = function() {}, m = function(e) {
                    return "<" + f + ">" + e + "</" + f + ">";
                }, y = function(e) {
                    e.write(m("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, h = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t, r;
                    h = "undefined" != typeof document ? document.domain && n ? y(n) : (t = u("iframe"), r = "java" + f + ":", t.style.display = "none", c.appendChild(t), t.src = String(r), (e = t.contentWindow.document).open(), e.write(m("document.F=Object")), e.close(), e.F) : y(n);
                    for(var i = a.length; i--;)delete h[p][a[i]];
                    return h();
                };
                s[d] = !0, e.exports = Object.create || function(e, t) {
                    var r;
                    return null !== e ? (v[p] = i(e), r = new v, v[p] = null, r[d] = e) : r = h(), void 0 === t ? r : o.f(r, t);
                };
            },
            5799: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(3896), o = r(5835), a = r(2293), s = r(5599), c = r(3658);
                t.f = n && !i ? Object.defineProperties : function(e, t) {
                    a(e);
                    for(var r, n = s(t), i = c(t), u = i.length, l = 0; u > l;)o.f(e, r = i[l++], n[r]);
                    return e;
                };
            },
            5835: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(1799), o = r(3896), a = r(2293), s = r(3815), c = TypeError, u = Object.defineProperty, l = Object.getOwnPropertyDescriptor, p = "enumerable", f = "configurable", d = "writable";
                t.f = n ? o ? function(e, t, r) {
                    if (a(e), t = s(t), a(r), "function" == typeof e && "prototype" === t && "value" in r && d in r && !r[d]) {
                        var n = l(e, t);
                        n && n[d] && (e[t] = r.value, r = {
                            configurable: f in r ? r[f] : n[f],
                            enumerable: p in r ? r[p] : n[p],
                            writable: !1
                        });
                    }
                    return u(e, t, r);
                } : u : function(e, t, r) {
                    if (a(e), t = s(t), a(r), i) try {
                        return u(e, t, r);
                    } catch (e) {}
                    if ("get" in r || "set" in r) throw new c("Accessors not supported");
                    return "value" in r && (e[t] = r.value), e;
                };
            },
            4961: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(1807), o = r(7611), a = r(7738), s = r(5599), c = r(3815), u = r(5755), l = r(1799), p = Object.getOwnPropertyDescriptor;
                t.f = n ? p : function(e, t) {
                    if (e = s(e), t = c(t), l) try {
                        return p(e, t);
                    } catch (e) {}
                    if (u(e, t)) return a(!i(o.f, e, t), e[t]);
                };
            },
            2020: (e, t, r)=>{
                "use strict";
                var n = r(1278), i = r(5599), o = r(2278).f, a = r(1698), s = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                e.exports.f = function(e) {
                    return s && "Window" === n(e) ? function(e) {
                        try {
                            return o(e);
                        } catch (e) {
                            return a(s);
                        }
                    }(e) : o(i(e));
                };
            },
            2278: (e, t, r)=>{
                "use strict";
                var n = r(6742), i = r(4741).concat("length", "prototype");
                t.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, i);
                };
            },
            4347: (e, t)=>{
                "use strict";
                t.f = Object.getOwnPropertySymbols;
            },
            3181: (e, t, r)=>{
                "use strict";
                var n = r(5755), i = r(1483), o = r(2347), a = r(5409), s = r(9441), c = a("IE_PROTO"), u = Object, l = u.prototype;
                e.exports = s ? u.getPrototypeOf : function(e) {
                    var t = o(e);
                    if (n(t, c)) return t[c];
                    var r = t.constructor;
                    return i(r) && t instanceof r ? r.prototype : t instanceof u ? l : null;
                };
            },
            706: (e, t, r)=>{
                "use strict";
                var n = r(8473), i = r(1704), o = r(1278), a = r(9214), s = Object.isExtensible, c = n(function() {
                    s(1);
                });
                e.exports = c || a ? function(e) {
                    return !!i(e) && (!a || "ArrayBuffer" !== o(e)) && (!s || s(e));
                } : s;
            },
            4815: (e, t, r)=>{
                "use strict";
                var n = r(4762);
                e.exports = n({}.isPrototypeOf);
            },
            6742: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(5755), o = r(5599), a = r(6651).indexOf, s = r(1507), c = n([].push);
                e.exports = function(e, t) {
                    var r, n = o(e), u = 0, l = [];
                    for(r in n)!i(s, r) && i(n, r) && c(l, r);
                    for(; t.length > u;)i(n, r = t[u++]) && (~a(l, r) || c(l, r));
                    return l;
                };
            },
            3658: (e, t, r)=>{
                "use strict";
                var n = r(6742), i = r(4741);
                e.exports = Object.keys || function(e) {
                    return n(e, i);
                };
            },
            7611: (e, t)=>{
                "use strict";
                var r = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor, i = n && !r.call({
                    1: 2
                }, 1);
                t.f = i ? function(e) {
                    var t = n(this, e);
                    return !!t && t.enumerable;
                } : r;
            },
            1953: (e, t, r)=>{
                "use strict";
                var n = r(680), i = r(2293), o = r(3852);
                e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var e, t = !1, r = {};
                    try {
                        (e = n(Object.prototype, "__proto__", "set"))(r, []), t = r instanceof Array;
                    } catch (e) {}
                    return function(r, n) {
                        return i(r), o(n), t ? e(r, n) : r.__proto__ = n, r;
                    };
                }() : void 0);
            },
            5627: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(8473), o = r(4762), a = r(3181), s = r(3658), c = r(5599), u = o(r(7611).f), l = o([].push), p = n && i(function() {
                    var e = Object.create(null);
                    return e[2] = 2, !u(e, 2);
                }), f = function(e) {
                    return function(t) {
                        for(var r, i = c(t), o = s(i), f = p && null === a(i), d = o.length, v = 0, m = []; d > v;)r = o[v++], n && !(f ? r in i : u(i, r)) || l(m, e ? [
                            r,
                            i[r]
                        ] : i[r]);
                        return m;
                    };
                };
                e.exports = {
                    entries: f(!0),
                    values: f(!1)
                };
            },
            5685: (e, t, r)=>{
                "use strict";
                var n = r(4338), i = r(6145);
                e.exports = n ? ({}).toString : function() {
                    return "[object " + i(this) + "]";
                };
            },
            348: (e, t, r)=>{
                "use strict";
                var n = r(1807), i = r(1483), o = r(1704), a = TypeError;
                e.exports = function(e, t) {
                    var r, s;
                    if ("string" === t && i(r = e.toString) && !o(s = n(r, e))) return s;
                    if (i(r = e.valueOf) && !o(s = n(r, e))) return s;
                    if ("string" !== t && i(r = e.toString) && !o(s = n(r, e))) return s;
                    throw new a("Can't convert object to primitive value");
                };
            },
            9497: (e, t, r)=>{
                "use strict";
                var n = r(1409), i = r(4762), o = r(2278), a = r(4347), s = r(2293), c = i([].concat);
                e.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = o.f(s(e)), r = a.f;
                    return r ? c(t, r(e)) : t;
                };
            },
            6589: (e, t, r)=>{
                "use strict";
                var n = r(8389);
                e.exports = n;
            },
            4193: (e)=>{
                "use strict";
                e.exports = function(e) {
                    try {
                        return {
                            error: !1,
                            value: e()
                        };
                    } catch (e) {
                        return {
                            error: !0,
                            value: e
                        };
                    }
                };
            },
            5502: (e, t, r)=>{
                "use strict";
                var n = r(8389), i = r(2832), o = r(1483), a = r(8730), s = r(7268), c = r(1), u = r(6956), l = r(938), p = r(9557), f = r(6170), d = i && i.prototype, v = c("species"), m = !1, y = o(n.PromiseRejectionEvent), h = a("Promise", function() {
                    var e = s(i), t = e !== String(i);
                    if (!t && 66 === f) return !0;
                    if (p && (!d.catch || !d.finally)) return !0;
                    if (!f || f < 51 || !/native code/.test(e)) {
                        var r = new i(function(e) {
                            e(1);
                        }), n = function(e) {
                            e(function() {}, function() {});
                        };
                        if ((r.constructor = {})[v] = n, !(m = r.then(function() {}) instanceof n)) return !0;
                    }
                    return !t && (u || l) && !y;
                });
                e.exports = {
                    CONSTRUCTOR: h,
                    REJECTION_EVENT: y,
                    SUBCLASSING: m
                };
            },
            2832: (e, t, r)=>{
                "use strict";
                var n = r(8389);
                e.exports = n.Promise;
            },
            2172: (e, t, r)=>{
                "use strict";
                var n = r(2293), i = r(1704), o = r(1173);
                e.exports = function(e, t) {
                    if (n(e), i(t) && t.constructor === e) return t;
                    var r = o.f(e);
                    return (0, r.resolve)(t), r.promise;
                };
            },
            1407: (e, t, r)=>{
                "use strict";
                var n = r(2832), i = r(1554), o = r(5502).CONSTRUCTOR;
                e.exports = o || !i(function(e) {
                    n.all(e).then(void 0, function() {});
                });
            },
            7150: (e, t, r)=>{
                "use strict";
                var n = r(5835).f;
                e.exports = function(e, t, r) {
                    r in e || n(e, r, {
                        configurable: !0,
                        get: function() {
                            return t[r];
                        },
                        set: function(e) {
                            t[r] = e;
                        }
                    });
                };
            },
            5459: (e)=>{
                "use strict";
                var t = function() {
                    this.head = null, this.tail = null;
                };
                t.prototype = {
                    add: function(e) {
                        var t = {
                            item: e,
                            next: null
                        }, r = this.tail;
                        r ? r.next = t : this.head = t, this.tail = t;
                    },
                    get: function() {
                        var e = this.head;
                        if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
                    }
                }, e.exports = t;
            },
            2428: (e, t, r)=>{
                "use strict";
                var n = r(1807), i = r(2293), o = r(1483), a = r(1278), s = r(8865), c = TypeError;
                e.exports = function(e, t) {
                    var r = e.exec;
                    if (o(r)) {
                        var u = n(r, e, t);
                        return null !== u && i(u), u;
                    }
                    if ("RegExp" === a(e)) return n(s, e, t);
                    throw new c("RegExp#exec called on incompatible receiver");
                };
            },
            8865: (e, t, r)=>{
                "use strict";
                var n, i, o = r(1807), a = r(4762), s = r(6261), c = r(6653), u = r(7435), l = r(7255), p = r(5290), f = r(4483).get, d = r(3933), v = r(4528), m = l("native-string-replace", String.prototype.replace), y = RegExp.prototype.exec, h = y, b = a("".charAt), g = a("".indexOf), _ = a("".replace), w = a("".slice), k = (i = /b*/g, o(y, n = /a/, "a"), o(y, i, "a"), 0 !== n.lastIndex || 0 !== i.lastIndex), S = u.BROKEN_CARET, j = void 0 !== /()??/.exec("")[1];
                (k || j || S || d || v) && (h = function(e) {
                    var t, r, n, i, a, u, l, d = this, v = f(d), x = s(e), O = v.raw;
                    if (O) return O.lastIndex = d.lastIndex, t = o(h, O, x), d.lastIndex = O.lastIndex, t;
                    var E = v.groups, P = S && d.sticky, A = o(c, d), z = d.source, C = 0, T = x;
                    if (P && (A = _(A, "y", ""), -1 === g(A, "g") && (A += "g"), T = w(x, d.lastIndex), d.lastIndex > 0 && (!d.multiline || d.multiline && "\n" !== b(x, d.lastIndex - 1)) && (z = "(?: " + z + ")", T = " " + T, C++), r = new RegExp("^(?:" + z + ")", A)), j && (r = new RegExp("^" + z + "$(?!\\s)", A)), k && (n = d.lastIndex), i = o(y, P ? r : d, T), P ? i ? (i.input = w(i.input, C), i[0] = w(i[0], C), i.index = d.lastIndex, d.lastIndex += i[0].length) : d.lastIndex = 0 : k && i && (d.lastIndex = d.global ? i.index + i[0].length : n), j && i && i.length > 1 && o(m, i[0], r, function() {
                        for(a = 1; a < arguments.length - 2; a++)void 0 === arguments[a] && (i[a] = void 0);
                    }), i && E) for(i.groups = u = p(null), a = 0; a < E.length; a++)u[(l = E[a])[0]] = i[l[1]];
                    return i;
                }), e.exports = h;
            },
            6653: (e, t, r)=>{
                "use strict";
                var n = r(2293);
                e.exports = function() {
                    var e = n(this), t = "";
                    return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
                };
            },
            9736: (e, t, r)=>{
                "use strict";
                var n = r(1807), i = r(5755), o = r(4815), a = r(6653), s = RegExp.prototype;
                e.exports = function(e) {
                    var t = e.flags;
                    return void 0 !== t || "flags" in s || i(e, "flags") || !o(s, e) ? t : n(a, e);
                };
            },
            7435: (e, t, r)=>{
                "use strict";
                var n = r(8473), i = r(8389).RegExp, o = n(function() {
                    var e = i("a", "y");
                    return e.lastIndex = 2, null !== e.exec("abcd");
                }), a = o || n(function() {
                    return !i("a", "y").sticky;
                }), s = o || n(function() {
                    var e = i("^r", "gy");
                    return e.lastIndex = 2, null !== e.exec("str");
                });
                e.exports = {
                    BROKEN_CARET: s,
                    MISSED_STICKY: a,
                    UNSUPPORTED_Y: o
                };
            },
            3933: (e, t, r)=>{
                "use strict";
                var n = r(8473), i = r(8389).RegExp;
                e.exports = n(function() {
                    var e = i(".", "s");
                    return !(e.dotAll && e.test("\n") && "s" === e.flags);
                });
            },
            4528: (e, t, r)=>{
                "use strict";
                var n = r(8473), i = r(8389).RegExp;
                e.exports = n(function() {
                    var e = i("(?<a>b)", "g");
                    return "b" !== e.exec("b").groups.a || "bc" !== "b".replace(e, "$<a>c");
                });
            },
            3312: (e, t, r)=>{
                "use strict";
                var n = r(5983), i = TypeError;
                e.exports = function(e) {
                    if (n(e)) throw new i("Can't call method on " + e);
                    return e;
                };
            },
            8123: (e, t, r)=>{
                "use strict";
                var n = r(8389), i = r(382), o = Object.getOwnPropertyDescriptor;
                e.exports = function(e) {
                    if (!i) return n[e];
                    var t = o(n, e);
                    return t && t.value;
                };
            },
            9570: (e, t, r)=>{
                "use strict";
                var n, i = r(8389), o = r(3067), a = r(1483), s = r(5413), c = r(9966), u = r(1698), l = r(4066), p = i.Function, f = /MSIE .\./.test(c) || s && ((n = i.Bun.version.split(".")).length < 3 || "0" === n[0] && (n[1] < 3 || "3" === n[1] && "0" === n[2]));
                e.exports = function(e, t) {
                    var r = t ? 2 : 1;
                    return f ? function(n, i) {
                        var s = l(arguments.length, 1) > r, c = a(n) ? n : p(n), f = s ? u(arguments, r) : [], d = s ? function() {
                            o(c, this, f);
                        } : c;
                        return t ? e(d, i) : e(d);
                    } : e;
                };
            },
            240: (e, t, r)=>{
                "use strict";
                var n = r(1409), i = r(3864), o = r(1), a = r(382), s = o("species");
                e.exports = function(e) {
                    var t = n(e);
                    a && t && !t[s] && i(t, s, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            2277: (e, t, r)=>{
                "use strict";
                var n = r(5835).f, i = r(5755), o = r(1)("toStringTag");
                e.exports = function(e, t, r) {
                    e && !r && (e = e.prototype), e && !i(e, o) && n(e, o, {
                        configurable: !0,
                        value: t
                    });
                };
            },
            5409: (e, t, r)=>{
                "use strict";
                var n = r(7255), i = r(1866), o = n("keys");
                e.exports = function(e) {
                    return o[e] || (o[e] = i(e));
                };
            },
            1831: (e, t, r)=>{
                "use strict";
                var n = r(9557), i = r(8389), o = r(2095), a = "__core-js_shared__", s = e.exports = i[a] || o(a, {});
                (s.versions || (s.versions = [])).push({
                    version: "3.36.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.36.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            7255: (e, t, r)=>{
                "use strict";
                var n = r(1831);
                e.exports = function(e, t) {
                    return n[e] || (n[e] = t || {});
                };
            },
            483: (e, t, r)=>{
                "use strict";
                var n = r(2293), i = r(2374), o = r(5983), a = r(1)("species");
                e.exports = function(e, t) {
                    var r, s = n(e).constructor;
                    return void 0 === s || o(r = n(s)[a]) ? t : i(r);
                };
            },
            9105: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(3005), o = r(6261), a = r(3312), s = n("".charAt), c = n("".charCodeAt), u = n("".slice), l = function(e) {
                    return function(t, r) {
                        var n, l, p = o(a(t)), f = i(r), d = p.length;
                        return f < 0 || f >= d ? e ? "" : void 0 : (n = c(p, f)) < 55296 || n > 56319 || f + 1 === d || (l = c(p, f + 1)) < 56320 || l > 57343 ? e ? s(p, f) : n : e ? u(p, f, f + 2) : l - 56320 + (n - 55296 << 10) + 65536;
                    };
                };
                e.exports = {
                    codeAt: l(!1),
                    charAt: l(!0)
                };
            },
            4544: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = r(3312), o = r(6261), a = r(5870), s = n("".replace), c = RegExp("^[" + a + "]+"), u = RegExp("(^|[^" + a + "])[" + a + "]+$"), l = function(e) {
                    return function(t) {
                        var r = o(i(t));
                        return 1 & e && (r = s(r, c, "")), 2 & e && (r = s(r, u, "$1")), r;
                    };
                };
                e.exports = {
                    start: l(1),
                    end: l(2),
                    trim: l(3)
                };
            },
            6029: (e, t, r)=>{
                "use strict";
                var n = r(6170), i = r(8473), o = r(8389).String;
                e.exports = !!Object.getOwnPropertySymbols && !i(function() {
                    var e = Symbol("symbol detection");
                    return !o(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
                });
            },
            8192: (e, t, r)=>{
                "use strict";
                var n = r(1807), i = r(1409), o = r(1), a = r(7914);
                e.exports = function() {
                    var e = i("Symbol"), t = e && e.prototype, r = t && t.valueOf, s = o("toPrimitive");
                    t && !t[s] && a(t, s, function(e) {
                        return n(r, this);
                    }, {
                        arity: 1
                    });
                };
            },
            3218: (e, t, r)=>{
                "use strict";
                var n = r(6029);
                e.exports = n && !!Symbol.for && !!Symbol.keyFor;
            },
            7007: (e, t, r)=>{
                "use strict";
                var n, i, o, a, s = r(8389), c = r(3067), u = r(2914), l = r(1483), p = r(5755), f = r(8473), d = r(2811), v = r(1698), m = r(3145), y = r(4066), h = r(8417), b = r(4334), g = s.setImmediate, _ = s.clearImmediate, w = s.process, k = s.Dispatch, S = s.Function, j = s.MessageChannel, x = s.String, O = 0, E = {}, P = "onreadystatechange";
                f(function() {
                    n = s.location;
                });
                var A = function(e) {
                    if (p(E, e)) {
                        var t = E[e];
                        delete E[e], t();
                    }
                }, z = function(e) {
                    return function() {
                        A(e);
                    };
                }, C = function(e) {
                    A(e.data);
                }, T = function(e) {
                    s.postMessage(x(e), n.protocol + "//" + n.host);
                };
                g && _ || (g = function(e) {
                    y(arguments.length, 1);
                    var t = l(e) ? e : S(e), r = v(arguments, 1);
                    return E[++O] = function() {
                        c(t, void 0, r);
                    }, i(O), O;
                }, _ = function(e) {
                    delete E[e];
                }, b ? i = function(e) {
                    w.nextTick(z(e));
                } : k && k.now ? i = function(e) {
                    k.now(z(e));
                } : j && !h ? (a = (o = new j).port2, o.port1.onmessage = C, i = u(a.postMessage, a)) : s.addEventListener && l(s.postMessage) && !s.importScripts && n && "file:" !== n.protocol && !f(T) ? (i = T, s.addEventListener("message", C, !1)) : i = P in m("script") ? function(e) {
                    d.appendChild(m("script"))[P] = function() {
                        d.removeChild(this), A(e);
                    };
                } : function(e) {
                    setTimeout(z(e), 0);
                }), e.exports = {
                    set: g,
                    clear: _
                };
            },
            2430: (e, t, r)=>{
                "use strict";
                var n = r(4762);
                e.exports = n(1..valueOf);
            },
            3392: (e, t, r)=>{
                "use strict";
                var n = r(3005), i = Math.max, o = Math.min;
                e.exports = function(e, t) {
                    var r = n(e);
                    return r < 0 ? i(r + t, 0) : o(r, t);
                };
            },
            5599: (e, t, r)=>{
                "use strict";
                var n = r(2121), i = r(3312);
                e.exports = function(e) {
                    return n(i(e));
                };
            },
            3005: (e, t, r)=>{
                "use strict";
                var n = r(1703);
                e.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            8324: (e, t, r)=>{
                "use strict";
                var n = r(3005), i = Math.min;
                e.exports = function(e) {
                    var t = n(e);
                    return t > 0 ? i(t, 9007199254740991) : 0;
                };
            },
            2347: (e, t, r)=>{
                "use strict";
                var n = r(3312), i = Object;
                e.exports = function(e) {
                    return i(n(e));
                };
            },
            2355: (e, t, r)=>{
                "use strict";
                var n = r(1807), i = r(1704), o = r(1423), a = r(2564), s = r(348), c = r(1), u = TypeError, l = c("toPrimitive");
                e.exports = function(e, t) {
                    if (!i(e) || o(e)) return e;
                    var r, c = a(e, l);
                    if (c) {
                        if (void 0 === t && (t = "default"), r = n(c, e, t), !i(r) || o(r)) return r;
                        throw new u("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), s(e, t);
                };
            },
            3815: (e, t, r)=>{
                "use strict";
                var n = r(2355), i = r(1423);
                e.exports = function(e) {
                    var t = n(e, "string");
                    return i(t) ? t : t + "";
                };
            },
            4338: (e, t, r)=>{
                "use strict";
                var n = {};
                n[r(1)("toStringTag")] = "z", e.exports = "[object z]" === String(n);
            },
            6261: (e, t, r)=>{
                "use strict";
                var n = r(6145), i = String;
                e.exports = function(e) {
                    if ("Symbol" === n(e)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return i(e);
                };
            },
            8761: (e)=>{
                "use strict";
                var t = String;
                e.exports = function(e) {
                    try {
                        return t(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            1866: (e, t, r)=>{
                "use strict";
                var n = r(4762), i = 0, o = Math.random(), a = n(1..toString);
                e.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + a(++i + o, 36);
                };
            },
            5022: (e, t, r)=>{
                "use strict";
                var n = r(6029);
                e.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            3896: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(8473);
                e.exports = n && i(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            4066: (e)=>{
                "use strict";
                var t = TypeError;
                e.exports = function(e, r) {
                    if (e < r) throw new t("Not enough arguments");
                    return e;
                };
            },
            4644: (e, t, r)=>{
                "use strict";
                var n = r(8389), i = r(1483), o = n.WeakMap;
                e.exports = i(o) && /native code/.test(String(o));
            },
            7849: (e, t, r)=>{
                "use strict";
                var n = r(6589), i = r(5755), o = r(5373), a = r(5835).f;
                e.exports = function(e) {
                    var t = n.Symbol || (n.Symbol = {});
                    i(t, e) || a(t, e, {
                        value: o.f(e)
                    });
                };
            },
            5373: (e, t, r)=>{
                "use strict";
                var n = r(1);
                t.f = n;
            },
            1: (e, t, r)=>{
                "use strict";
                var n = r(8389), i = r(7255), o = r(5755), a = r(1866), s = r(6029), c = r(5022), u = n.Symbol, l = i("wks"), p = c ? u.for || u : u && u.withoutSetter || a;
                e.exports = function(e) {
                    return o(l, e) || (l[e] = s && o(u, e) ? u[e] : p("Symbol." + e)), l[e];
                };
            },
            5870: (e)=>{
                "use strict";
                e.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
            },
            4776: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(8473), o = r(4914), a = r(1704), s = r(2347), c = r(6960), u = r(1091), l = r(670), p = r(4551), f = r(4595), d = r(1), v = r(6170), m = d("isConcatSpreadable"), y = v >= 51 || !i(function() {
                    var e = [];
                    return e[m] = !1, e.concat()[0] !== e;
                }), h = function(e) {
                    if (!a(e)) return !1;
                    var t = e[m];
                    return void 0 !== t ? !!t : o(e);
                };
                n({
                    target: "Array",
                    proto: !0,
                    arity: 1,
                    forced: !y || !f("concat")
                }, {
                    concat: function(e) {
                        var t, r, n, i, o, a = s(this), f = p(a, 0), d = 0;
                        for(t = -1, n = arguments.length; t < n; t++)if (h(o = -1 === t ? a : arguments[t])) for(i = c(o), u(d + i), r = 0; r < i; r++, d++)r in o && l(f, d, o[r]);
                        else u(d + 1), l(f, d++, o);
                        return f.length = d, f;
                    }
                });
            },
            4382: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(2867).filter;
                n({
                    target: "Array",
                    proto: !0,
                    forced: !r(4595)("filter")
                }, {
                    filter: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            2084: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(2867).find, o = r(7095), a = "find", s = !0;
                a in [] && Array(1)[a](function() {
                    s = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: s
                }, {
                    find: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), o(a);
            },
            9892: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(6142);
                n({
                    target: "Array",
                    stat: !0,
                    forced: !r(1554)(function(e) {
                        Array.from(e);
                    })
                }, {
                    from: i
                });
            },
            6281: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(6651).includes, o = r(8473), a = r(7095);
                n({
                    target: "Array",
                    proto: !0,
                    forced: o(function() {
                        return !Array(1).includes();
                    })
                }, {
                    includes: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), a("includes");
            },
            4962: (e, t, r)=>{
                "use strict";
                var n = r(5599), i = r(7095), o = r(6775), a = r(4483), s = r(5835).f, c = r(5662), u = r(5247), l = r(9557), p = r(382), f = "Array Iterator", d = a.set, v = a.getterFor(f);
                e.exports = c(Array, "Array", function(e, t) {
                    d(this, {
                        type: f,
                        target: n(e),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e = v(this), t = e.target, r = e.index++;
                    if (!t || r >= t.length) return e.target = void 0, u(void 0, !0);
                    switch(e.kind){
                        case "keys":
                            return u(r, !1);
                        case "values":
                            return u(t[r], !1);
                    }
                    return u([
                        r,
                        t[r]
                    ], !1);
                }, "values");
                var m = o.Arguments = o.Array;
                if (i("keys"), i("values"), i("entries"), !l && p && "values" !== m.name) try {
                    s(m, "name", {
                        value: "values"
                    });
                } catch (e) {}
            },
            6216: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(4762), o = r(2121), a = r(5599), s = r(3152), c = i([].join);
                n({
                    target: "Array",
                    proto: !0,
                    forced: o !== Object || !s("join", ",")
                }, {
                    join: function(e) {
                        return c(a(this), void 0 === e ? "," : e);
                    }
                });
            },
            6584: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(2867).map;
                n({
                    target: "Array",
                    proto: !0,
                    forced: !r(4595)("map")
                }, {
                    map: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            9336: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(4914), o = r(943), a = r(1704), s = r(3392), c = r(6960), u = r(5599), l = r(670), p = r(1), f = r(4595), d = r(1698), v = f("slice"), m = p("species"), y = Array, h = Math.max;
                n({
                    target: "Array",
                    proto: !0,
                    forced: !v
                }, {
                    slice: function(e, t) {
                        var r, n, p, f = u(this), v = c(f), b = s(e, v), g = s(void 0 === t ? v : t, v);
                        if (i(f) && (r = f.constructor, (o(r) && (r === y || i(r.prototype)) || a(r) && null === (r = r[m])) && (r = void 0), r === y || void 0 === r)) return d(f, b, g);
                        for(n = new (void 0 === r ? y : r)(h(g - b, 0)), p = 0; b < g; b++, p++)b in f && l(n, p, f[b]);
                        return n.length = p, n;
                    }
                });
            },
            6448: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(4762), o = r(8120), a = r(2347), s = r(6960), c = r(6060), u = r(6261), l = r(8473), p = r(7354), f = r(3152), d = r(7332), v = r(8996), m = r(6170), y = r(5158), h = [], b = i(h.sort), g = i(h.push), _ = l(function() {
                    h.sort(void 0);
                }), w = l(function() {
                    h.sort(null);
                }), k = f("sort"), S = !l(function() {
                    if (m) return m < 70;
                    if (!(d && d > 3)) {
                        if (v) return !0;
                        if (y) return y < 603;
                        var e, t, r, n, i = "";
                        for(e = 65; e < 76; e++){
                            switch(t = String.fromCharCode(e), e){
                                case 66:
                                case 69:
                                case 70:
                                case 72:
                                    r = 3;
                                    break;
                                case 68:
                                case 71:
                                    r = 4;
                                    break;
                                default:
                                    r = 2;
                            }
                            for(n = 0; n < 47; n++)h.push({
                                k: t + n,
                                v: r
                            });
                        }
                        for(h.sort(function(e, t) {
                            return t.v - e.v;
                        }), n = 0; n < h.length; n++)t = h[n].k.charAt(0), i.charAt(i.length - 1) !== t && (i += t);
                        return "DGBEFHACIJK" !== i;
                    }
                });
                n({
                    target: "Array",
                    proto: !0,
                    forced: _ || !w || !k || !S
                }, {
                    sort: function(e) {
                        void 0 !== e && o(e);
                        var t = a(this);
                        if (S) return void 0 === e ? b(t) : b(t, e);
                        var r, n, i = [], l = s(t);
                        for(n = 0; n < l; n++)n in t && g(i, t[n]);
                        for(p(i, function(e) {
                            return function(t, r) {
                                return void 0 === r ? -1 : void 0 === t ? 1 : void 0 !== e ? +e(t, r) || 0 : u(t) > u(r) ? 1 : -1;
                            };
                        }(e)), r = s(i), n = 0; n < r;)t[n] = i[n++];
                        for(; n < l;)c(t, n++);
                        return t;
                    }
                });
            },
            4754: (e, t, r)=>{
                "use strict";
                var n = r(5755), i = r(7914), o = r(6446), a = r(1)("toPrimitive"), s = Date.prototype;
                n(s, a) || i(s, a, o);
            },
            1908: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(2048).EXISTS, o = r(4762), a = r(3864), s = Function.prototype, c = o(s.toString), u = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/, l = o(u.exec);
                n && !i && a(s, "name", {
                    configurable: !0,
                    get: function() {
                        try {
                            return l(u, c(this))[1];
                        } catch (e) {
                            return "";
                        }
                    }
                });
            },
            6184: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(1409), o = r(3067), a = r(1807), s = r(4762), c = r(8473), u = r(1483), l = r(1423), p = r(1698), f = r(5215), d = r(6029), v = String, m = i("JSON", "stringify"), y = s(/./.exec), h = s("".charAt), b = s("".charCodeAt), g = s("".replace), _ = s(1..toString), w = /[\uD800-\uDFFF]/g, k = /^[\uD800-\uDBFF]$/, S = /^[\uDC00-\uDFFF]$/, j = !d || c(function() {
                    var e = i("Symbol")("stringify detection");
                    return "[null]" !== m([
                        e
                    ]) || "{}" !== m({
                        a: e
                    }) || "{}" !== m(Object(e));
                }), x = c(function() {
                    return '"\\udf06\\ud834"' !== m("\udf06\ud834") || '"\\udead"' !== m("\udead");
                }), O = function(e, t) {
                    var r = p(arguments), n = f(t);
                    if (u(n) || void 0 !== e && !l(e)) return r[1] = function(e, t) {
                        if (u(n) && (t = a(n, this, v(e), t)), !l(t)) return t;
                    }, o(m, null, r);
                }, E = function(e, t, r) {
                    var n = h(r, t - 1), i = h(r, t + 1);
                    return y(k, e) && !y(S, i) || y(S, e) && !y(k, n) ? "\\u" + _(b(e, 0), 16) : e;
                };
                m && n({
                    target: "JSON",
                    stat: !0,
                    arity: 3,
                    forced: j || x
                }, {
                    stringify: function(e, t, r) {
                        var n = p(arguments), i = o(j ? O : m, null, n);
                        return x && "string" == typeof i ? g(i, w, E) : i;
                    }
                });
            },
            2725: (e, t, r)=>{
                "use strict";
                r(7446)("Map", function(e) {
                    return function() {
                        return e(this, arguments.length ? arguments[0] : void 0);
                    };
                }, r(4092));
            },
            8551: (e, t, r)=>{
                "use strict";
                r(2725);
            },
            94: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(9557), o = r(382), a = r(8389), s = r(6589), c = r(4762), u = r(8730), l = r(5755), p = r(2429), f = r(4815), d = r(1423), v = r(2355), m = r(8473), y = r(2278).f, h = r(4961).f, b = r(5835).f, g = r(2430), _ = r(4544).trim, w = "Number", k = a[w], S = s[w], j = k.prototype, x = a.TypeError, O = c("".slice), E = c("".charCodeAt), P = u(w, !k(" 0o1") || !k("0b1") || k("+0x1")), A = function(e) {
                    var t, r = arguments.length < 1 ? 0 : k(function(e) {
                        var t = v(e, "number");
                        return "bigint" == typeof t ? t : function(e) {
                            var t, r, n, i, o, a, s, c, u = v(e, "number");
                            if (d(u)) throw new x("Cannot convert a Symbol value to a number");
                            if ("string" == typeof u && u.length > 2) {
                                if (u = _(u), 43 === (t = E(u, 0)) || 45 === t) {
                                    if (88 === (r = E(u, 2)) || 120 === r) return NaN;
                                } else if (48 === t) {
                                    switch(E(u, 1)){
                                        case 66:
                                        case 98:
                                            n = 2, i = 49;
                                            break;
                                        case 79:
                                        case 111:
                                            n = 8, i = 55;
                                            break;
                                        default:
                                            return +u;
                                    }
                                    for(a = (o = O(u, 2)).length, s = 0; s < a; s++)if ((c = E(o, s)) < 48 || c > i) return NaN;
                                    return parseInt(o, n);
                                }
                            }
                            return +u;
                        }(t);
                    }(e));
                    return f(j, t = this) && m(function() {
                        g(t);
                    }) ? p(Object(r), this, A) : r;
                };
                A.prototype = j, P && !i && (j.constructor = A), n({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: P
                }, {
                    Number: A
                });
                var z = function(e, t) {
                    for(var r, n = o ? y(t) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), i = 0; n.length > i; i++)l(t, r = n[i]) && !l(e, r) && b(e, r, h(t, r));
                };
                i && S && z(s[w], S), (P || i) && z(s[w], k);
            },
            7575: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(1439);
                n({
                    target: "Object",
                    stat: !0,
                    arity: 2,
                    forced: Object.assign !== i
                }, {
                    assign: i
                });
            },
            7132: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(5627).entries;
                n({
                    target: "Object",
                    stat: !0
                }, {
                    entries: function(e) {
                        return i(e);
                    }
                });
            },
            6457: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(8473), o = r(5599), a = r(4961).f, s = r(382);
                n({
                    target: "Object",
                    stat: !0,
                    forced: !s || i(function() {
                        a(1);
                    }),
                    sham: !s
                }, {
                    getOwnPropertyDescriptor: function(e, t) {
                        return a(o(e), t);
                    }
                });
            },
            8908: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(382), o = r(9497), a = r(5599), s = r(4961), c = r(670);
                n({
                    target: "Object",
                    stat: !0,
                    sham: !i
                }, {
                    getOwnPropertyDescriptors: function(e) {
                        for(var t, r, n = a(e), i = s.f, u = o(n), l = {}, p = 0; u.length > p;)void 0 !== (r = i(n, t = u[p++])) && c(l, t, r);
                        return l;
                    }
                });
            },
            7859: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(6029), o = r(8473), a = r(4347), s = r(2347);
                n({
                    target: "Object",
                    stat: !0,
                    forced: !i || o(function() {
                        a.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e) {
                        var t = a.f;
                        return t ? t(s(e)) : [];
                    }
                });
            },
            6437: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(8473), o = r(2347), a = r(3181), s = r(9441);
                n({
                    target: "Object",
                    stat: !0,
                    forced: i(function() {
                        a(1);
                    }),
                    sham: !s
                }, {
                    getPrototypeOf: function(e) {
                        return a(o(e));
                    }
                });
            },
            3810: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(2347), o = r(3658);
                n({
                    target: "Object",
                    stat: !0,
                    forced: r(8473)(function() {
                        o(1);
                    })
                }, {
                    keys: function(e) {
                        return o(i(e));
                    }
                });
            },
            2697: (e, t, r)=>{
                "use strict";
                r(8612)({
                    target: "Object",
                    stat: !0
                }, {
                    setPrototypeOf: r(1953)
                });
            },
            8557: (e, t, r)=>{
                "use strict";
                var n = r(4338), i = r(7914), o = r(5685);
                n || i(Object.prototype, "toString", o, {
                    unsafe: !0
                });
            },
            6249: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(1807), o = r(8120), a = r(1173), s = r(4193), c = r(1506);
                n({
                    target: "Promise",
                    stat: !0,
                    forced: r(1407)
                }, {
                    all: function(e) {
                        var t = this, r = a.f(t), n = r.resolve, u = r.reject, l = s(function() {
                            var r = o(t.resolve), a = [], s = 0, l = 1;
                            c(e, function(e) {
                                var o = s++, c = !1;
                                l++, i(r, t, e).then(function(e) {
                                    c || (c = !0, a[o] = e, --l || n(a));
                                }, u);
                            }), --l || n(a);
                        });
                        return l.error && u(l.value), r.promise;
                    }
                });
            },
            6681: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(9557), o = r(5502).CONSTRUCTOR, a = r(2832), s = r(1409), c = r(1483), u = r(7914), l = a && a.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    forced: o,
                    real: !0
                }, {
                    catch: function(e) {
                        return this.then(void 0, e);
                    }
                }), !i && c(a)) {
                    var p = s("Promise").prototype.catch;
                    l.catch !== p && u(l, "catch", p, {
                        unsafe: !0
                    });
                }
            },
            8786: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(8612), s = r(9557), c = r(4334), u = r(8389), l = r(1807), p = r(7914), f = r(1953), d = r(2277), v = r(240), m = r(8120), y = r(1483), h = r(1704), b = r(6021), g = r(483), _ = r(7007).set, w = r(553), k = r(1339), S = r(4193), j = r(5459), x = r(4483), O = r(2832), E = r(5502), P = r(1173), A = "Promise", z = E.CONSTRUCTOR, C = E.REJECTION_EVENT, T = E.SUBCLASSING, N = x.getterFor(A), I = x.set, D = O && O.prototype, R = O, M = D, q = u.TypeError, U = u.document, L = u.process, F = P.f, B = F, H = !!(U && U.createEvent && u.dispatchEvent), V = "unhandledrejection", W = function(e) {
                    var t;
                    return !(!h(e) || !y(t = e.then)) && t;
                }, K = function(e, t) {
                    var r, n, i, o = t.value, a = 1 === t.state, s = a ? e.ok : e.fail, c = e.resolve, u = e.reject, p = e.domain;
                    try {
                        s ? (a || (2 === t.rejection && J(t), t.rejection = 1), !0 === s ? r = o : (p && p.enter(), r = s(o), p && (p.exit(), i = !0)), r === e.promise ? u(new q("Promise-chain cycle")) : (n = W(r)) ? l(n, r, c, u) : c(r)) : u(o);
                    } catch (e) {
                        p && !i && p.exit(), u(e);
                    }
                }, $ = function(e, t) {
                    e.notified || (e.notified = !0, w(function() {
                        for(var r, n = e.reactions; r = n.get();)K(r, e);
                        e.notified = !1, t && !e.rejection && Z(e);
                    }));
                }, G = function(e, t, r) {
                    var n, i;
                    H ? ((n = U.createEvent("Event")).promise = t, n.reason = r, n.initEvent(e, !1, !0), u.dispatchEvent(n)) : n = {
                        promise: t,
                        reason: r
                    }, !C && (i = u["on" + e]) ? i(n) : e === V && k("Unhandled promise rejection", r);
                }, Z = function(e) {
                    l(_, u, function() {
                        var t, r = e.facade, n = e.value;
                        if (Y(e) && (t = S(function() {
                            c ? L.emit("unhandledRejection", n, r) : G(V, r, n);
                        }), e.rejection = c || Y(e) ? 2 : 1, t.error)) throw t.value;
                    });
                }, Y = function(e) {
                    return 1 !== e.rejection && !e.parent;
                }, J = function(e) {
                    l(_, u, function() {
                        var t = e.facade;
                        c ? L.emit("rejectionHandled", t) : G("rejectionhandled", t, e.value);
                    });
                }, X = function(e, t, r) {
                    return function(n) {
                        e(t, n, r);
                    };
                }, Q = function(e, t, r) {
                    e.done || (e.done = !0, r && (e = r), e.value = t, e.state = 2, $(e, !0));
                }, ee = function(e, t, r) {
                    if (!e.done) {
                        e.done = !0, r && (e = r);
                        try {
                            if (e.facade === t) throw new q("Promise can't be resolved itself");
                            var n = W(t);
                            n ? w(function() {
                                var r = {
                                    done: !1
                                };
                                try {
                                    l(n, t, X(ee, r, e), X(Q, r, e));
                                } catch (t) {
                                    Q(r, t, e);
                                }
                            }) : (e.value = t, e.state = 1, $(e, !1));
                        } catch (t) {
                            Q({
                                done: !1
                            }, t, e);
                        }
                    }
                };
                if (z && (M = (R = function(e) {
                    b(this, M), m(e), l(n, this);
                    var t = N(this);
                    try {
                        e(X(ee, t), X(Q, t));
                    } catch (e) {
                        Q(t, e);
                    }
                }).prototype, (n = function(e) {
                    I(this, {
                        type: A,
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: new j,
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = p(M, "then", function(e, t) {
                    var r = N(this), n = F(g(this, R));
                    return r.parent = !0, n.ok = !y(e) || e, n.fail = y(t) && t, n.domain = c ? L.domain : void 0, 0 === r.state ? r.reactions.add(n) : w(function() {
                        K(n, r);
                    }), n.promise;
                }), i = function() {
                    var e = new n, t = N(e);
                    this.promise = e, this.resolve = X(ee, t), this.reject = X(Q, t);
                }, P.f = F = function(e) {
                    return e === R || void 0 === e ? new i(e) : B(e);
                }, !s && y(O) && D !== Object.prototype)) {
                    o = D.then, T || p(D, "then", function(e, t) {
                        var r = this;
                        return new R(function(e, t) {
                            l(o, r, e, t);
                        }).then(e, t);
                    }, {
                        unsafe: !0
                    });
                    try {
                        delete D.constructor;
                    } catch (e) {}
                    f && f(D, M);
                }
                a({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: z
                }, {
                    Promise: R
                }), d(R, A, !1, !0), v(A);
            },
            76: (e, t, r)=>{
                "use strict";
                r(8786), r(6249), r(6681), r(1681), r(9231), r(5774);
            },
            1681: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(1807), o = r(8120), a = r(1173), s = r(4193), c = r(1506);
                n({
                    target: "Promise",
                    stat: !0,
                    forced: r(1407)
                }, {
                    race: function(e) {
                        var t = this, r = a.f(t), n = r.reject, u = s(function() {
                            var a = o(t.resolve);
                            c(e, function(e) {
                                i(a, t, e).then(r.resolve, n);
                            });
                        });
                        return u.error && n(u.value), r.promise;
                    }
                });
            },
            9231: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(1173);
                n({
                    target: "Promise",
                    stat: !0,
                    forced: r(5502).CONSTRUCTOR
                }, {
                    reject: function(e) {
                        var t = i.f(this);
                        return (0, t.reject)(e), t.promise;
                    }
                });
            },
            5774: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(1409), o = r(9557), a = r(2832), s = r(5502).CONSTRUCTOR, c = r(2172), u = i("Promise"), l = o && !s;
                n({
                    target: "Promise",
                    stat: !0,
                    forced: o || s
                }, {
                    resolve: function(e) {
                        return c(l && this === u ? a : this, e);
                    }
                });
            },
            1359: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(1409), o = r(3067), a = r(2164), s = r(2374), c = r(2293), u = r(1704), l = r(5290), p = r(8473), f = i("Reflect", "construct"), d = Object.prototype, v = [].push, m = p(function() {
                    function e() {}
                    return !(f(function() {}, [], e) instanceof e);
                }), y = !p(function() {
                    f(function() {});
                }), h = m || y;
                n({
                    target: "Reflect",
                    stat: !0,
                    forced: h,
                    sham: h
                }, {
                    construct: function(e, t) {
                        s(e), c(t);
                        var r = arguments.length < 3 ? e : s(arguments[2]);
                        if (y && !m) return f(e, t, r);
                        if (e === r) {
                            switch(t.length){
                                case 0:
                                    return new e;
                                case 1:
                                    return new e(t[0]);
                                case 2:
                                    return new e(t[0], t[1]);
                                case 3:
                                    return new e(t[0], t[1], t[2]);
                                case 4:
                                    return new e(t[0], t[1], t[2], t[3]);
                            }
                            var n = [
                                null
                            ];
                            return o(v, n, t), new (o(a, e, n));
                        }
                        var i = r.prototype, p = l(u(i) ? i : d), h = o(e, p, t);
                        return u(h) ? h : p;
                    }
                });
            },
            646: (e, t, r)=>{
                "use strict";
                var n = r(382), i = r(8389), o = r(4762), a = r(8730), s = r(2429), c = r(9037), u = r(5290), l = r(2278).f, p = r(4815), f = r(4786), d = r(6261), v = r(9736), m = r(7435), y = r(7150), h = r(7914), b = r(8473), g = r(5755), _ = r(4483).enforce, w = r(240), k = r(1), S = r(3933), j = r(4528), x = k("match"), O = i.RegExp, E = O.prototype, P = i.SyntaxError, A = o(E.exec), z = o("".charAt), C = o("".replace), T = o("".indexOf), N = o("".slice), I = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/, D = /a/g, R = /a/g, M = new O(D) !== D, q = m.MISSED_STICKY, U = m.UNSUPPORTED_Y;
                if (a("RegExp", n && (!M || q || S || j || b(function() {
                    return R[x] = !1, O(D) !== D || O(R) === R || "/a/i" !== String(O(D, "i"));
                })))) {
                    for(var L = function(e, t) {
                        var r, n, i, o, a, l, m = p(E, this), y = f(e), h = void 0 === t, b = [], w = e;
                        if (!m && y && h && e.constructor === L) return e;
                        if ((y || p(E, e)) && (e = e.source, h && (t = v(w))), e = void 0 === e ? "" : d(e), t = void 0 === t ? "" : d(t), w = e, S && "dotAll" in D && (n = !!t && T(t, "s") > -1) && (t = C(t, /s/g, "")), r = t, q && "sticky" in D && (i = !!t && T(t, "y") > -1) && U && (t = C(t, /y/g, "")), j && (o = function(e) {
                            for(var t, r = e.length, n = 0, i = "", o = [], a = u(null), s = !1, c = !1, l = 0, p = ""; n <= r; n++){
                                if ("\\" === (t = z(e, n))) t += z(e, ++n);
                                else if ("]" === t) s = !1;
                                else if (!s) switch(!0){
                                    case "[" === t:
                                        s = !0;
                                        break;
                                    case "(" === t:
                                        A(I, N(e, n + 1)) && (n += 2, c = !0), i += t, l++;
                                        continue;
                                    case ">" === t && c:
                                        if ("" === p || g(a, p)) throw new P("Invalid capture group name");
                                        a[p] = !0, o[o.length] = [
                                            p,
                                            l
                                        ], c = !1, p = "";
                                        continue;
                                }
                                c ? p += t : i += t;
                            }
                            return [
                                i,
                                o
                            ];
                        }(e), e = o[0], b = o[1]), a = s(O(e, t), m ? this : E, L), (n || i || b.length) && (l = _(a), n && (l.dotAll = !0, l.raw = L(function(e) {
                            for(var t, r = e.length, n = 0, i = "", o = !1; n <= r; n++)"\\" !== (t = z(e, n)) ? o || "." !== t ? ("[" === t ? o = !0 : "]" === t && (o = !1), i += t) : i += "[\\s\\S]" : i += t + z(e, ++n);
                            return i;
                        }(e), r)), i && (l.sticky = !0), b.length && (l.groups = b)), e !== w) try {
                            c(a, "source", "" === w ? "(?:)" : w);
                        } catch (e) {}
                        return a;
                    }, F = l(O), B = 0; F.length > B;)y(L, O, F[B++]);
                    E.constructor = L, L.prototype = E, h(i, "RegExp", L, {
                        constructor: !0
                    });
                }
                w("RegExp");
            },
            5021: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(8865);
                n({
                    target: "RegExp",
                    proto: !0,
                    forced: /./.exec !== i
                }, {
                    exec: i
                });
            },
            3687: (e, t, r)=>{
                "use strict";
                var n = r(2048).PROPER, i = r(7914), o = r(2293), a = r(6261), s = r(8473), c = r(9736), u = "toString", l = RegExp.prototype, p = l[u], f = s(function() {
                    return "/a/b" !== p.call({
                        source: "a",
                        flags: "b"
                    });
                }), d = n && p.name !== u;
                (f || d) && i(l, u, function() {
                    var e = o(this);
                    return "/" + a(e.source) + "/" + a(c(e));
                }, {
                    unsafe: !0
                });
            },
            9203: (e, t, r)=>{
                "use strict";
                r(7446)("Set", function(e) {
                    return function() {
                        return e(this, arguments.length ? arguments[0] : void 0);
                    };
                }, r(4092));
            },
            2745: (e, t, r)=>{
                "use strict";
                r(9203);
            },
            987: (e, t, r)=>{
                "use strict";
                var n, i = r(8612), o = r(3786), a = r(4961).f, s = r(8324), c = r(6261), u = r(4989), l = r(3312), p = r(4522), f = r(9557), d = o("".slice), v = Math.min, m = p("endsWith");
                i({
                    target: "String",
                    proto: !0,
                    forced: !(!f && !m && (n = a(String.prototype, "endsWith"), n && !n.writable) || m)
                }, {
                    endsWith: function(e) {
                        var t = c(l(this));
                        u(e);
                        var r = arguments.length > 1 ? arguments[1] : void 0, n = t.length, i = void 0 === r ? n : v(s(r), n), o = c(e);
                        return d(t, i - o.length, i) === o;
                    }
                });
            },
            9425: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(4762), o = r(4989), a = r(3312), s = r(6261), c = r(4522), u = i("".indexOf);
                n({
                    target: "String",
                    proto: !0,
                    forced: !c("includes")
                }, {
                    includes: function(e) {
                        return !!~u(s(a(this)), s(o(e)), arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            3994: (e, t, r)=>{
                "use strict";
                var n = r(9105).charAt, i = r(6261), o = r(4483), a = r(5662), s = r(5247), c = "String Iterator", u = o.set, l = o.getterFor(c);
                a(String, "String", function(e) {
                    u(this, {
                        type: c,
                        string: i(e),
                        index: 0
                    });
                }, function() {
                    var e, t = l(this), r = t.string, i = t.index;
                    return i >= r.length ? s(void 0, !0) : (e = n(r, i), t.index += e.length, s(e, !1));
                });
            },
            3819: (e, t, r)=>{
                "use strict";
                var n = r(1807), i = r(3358), o = r(2293), a = r(5983), s = r(8324), c = r(6261), u = r(3312), l = r(2564), p = r(4419), f = r(2428);
                i("match", function(e, t, r) {
                    return [
                        function(t) {
                            var r = u(this), i = a(t) ? void 0 : l(t, e);
                            return i ? n(i, t, r) : new RegExp(t)[e](c(r));
                        },
                        function(e) {
                            var n = o(this), i = c(e), a = r(t, n, i);
                            if (a.done) return a.value;
                            if (!n.global) return f(n, i);
                            var u = n.unicode;
                            n.lastIndex = 0;
                            for(var l, d = [], v = 0; null !== (l = f(n, i));){
                                var m = c(l[0]);
                                d[v] = m, "" === m && (n.lastIndex = p(i, s(n.lastIndex), u)), v++;
                            }
                            return 0 === v ? null : d;
                        }
                    ];
                });
            },
            3062: (e, t, r)=>{
                "use strict";
                var n = r(3067), i = r(1807), o = r(4762), a = r(3358), s = r(8473), c = r(2293), u = r(1483), l = r(5983), p = r(3005), f = r(8324), d = r(6261), v = r(3312), m = r(4419), y = r(2564), h = r(708), b = r(2428), g = r(1)("replace"), _ = Math.max, w = Math.min, k = o([].concat), S = o([].push), j = o("".indexOf), x = o("".slice), O = "$0" === "a".replace(/./, "$0"), E = !!/./[g] && "" === /./[g]("a", "$0");
                a("replace", function(e, t, r) {
                    var o = E ? "$" : "$0";
                    return [
                        function(e, r) {
                            var n = v(this), o = l(e) ? void 0 : y(e, g);
                            return o ? i(o, e, n, r) : i(t, d(n), e, r);
                        },
                        function(e, i) {
                            var a = c(this), s = d(e);
                            if ("string" == typeof i && -1 === j(i, o) && -1 === j(i, "$<")) {
                                var l = r(t, a, s, i);
                                if (l.done) return l.value;
                            }
                            var v = u(i);
                            v || (i = d(i));
                            var y, g = a.global;
                            g && (y = a.unicode, a.lastIndex = 0);
                            for(var O, E = []; null !== (O = b(a, s)) && (S(E, O), g);)"" === d(O[0]) && (a.lastIndex = m(s, f(a.lastIndex), y));
                            for(var P, A = "", z = 0, C = 0; C < E.length; C++){
                                for(var T, N = d((O = E[C])[0]), I = _(w(p(O.index), s.length), 0), D = [], R = 1; R < O.length; R++)S(D, void 0 === (P = O[R]) ? P : String(P));
                                var M = O.groups;
                                if (v) {
                                    var q = k([
                                        N
                                    ], D, I, s);
                                    void 0 !== M && S(q, M), T = d(n(i, void 0, q));
                                } else T = h(N, s, I, D, M, i);
                                I >= z && (A += x(s, z, I) + T, z = I + N.length);
                            }
                            return A + x(s, z);
                        }
                    ];
                }, !!s(function() {
                    var e = /./;
                    return e.exec = function() {
                        var e = [];
                        return e.groups = {
                            a: "7"
                        }, e;
                    }, "7" !== "".replace(e, "$<a>");
                }) || !O || E);
            },
            4062: (e, t, r)=>{
                "use strict";
                var n, i = r(8612), o = r(3786), a = r(4961).f, s = r(8324), c = r(6261), u = r(4989), l = r(3312), p = r(4522), f = r(9557), d = o("".slice), v = Math.min, m = p("startsWith");
                i({
                    target: "String",
                    proto: !0,
                    forced: !(!f && !m && (n = a(String.prototype, "startsWith"), n && !n.writable) || m)
                }, {
                    startsWith: function(e) {
                        var t = c(l(this));
                        u(e);
                        var r = s(v(arguments.length > 1 ? arguments[1] : void 0, t.length)), n = c(e);
                        return d(t, r, r + n.length) === n;
                    }
                });
            },
            5443: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(8389), o = r(1807), a = r(4762), s = r(9557), c = r(382), u = r(6029), l = r(8473), p = r(5755), f = r(4815), d = r(2293), v = r(5599), m = r(3815), y = r(6261), h = r(7738), b = r(5290), g = r(3658), _ = r(2278), w = r(2020), k = r(4347), S = r(4961), j = r(5835), x = r(5799), O = r(7611), E = r(7914), P = r(3864), A = r(7255), z = r(5409), C = r(1507), T = r(1866), N = r(1), I = r(5373), D = r(7849), R = r(8192), M = r(2277), q = r(4483), U = r(2867).forEach, L = z("hidden"), F = "Symbol", B = "prototype", H = q.set, V = q.getterFor(F), W = Object[B], K = i.Symbol, $ = K && K[B], G = i.RangeError, Z = i.TypeError, Y = i.QObject, J = S.f, X = j.f, Q = w.f, ee = O.f, te = a([].push), re = A("symbols"), ne = A("op-symbols"), ie = A("wks"), oe = !Y || !Y[B] || !Y[B].findChild, ae = function(e, t, r) {
                    var n = J(W, t);
                    n && delete W[t], X(e, t, r), n && e !== W && X(W, t, n);
                }, se = c && l(function() {
                    return 7 !== b(X({}, "a", {
                        get: function() {
                            return X(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? ae : X, ce = function(e, t) {
                    var r = re[e] = b($);
                    return H(r, {
                        type: F,
                        tag: e,
                        description: t
                    }), c || (r.description = t), r;
                }, ue = function(e, t, r) {
                    e === W && ue(ne, t, r), d(e);
                    var n = m(t);
                    return d(r), p(re, n) ? (r.enumerable ? (p(e, L) && e[L][n] && (e[L][n] = !1), r = b(r, {
                        enumerable: h(0, !1)
                    })) : (p(e, L) || X(e, L, h(1, b(null))), e[L][n] = !0), se(e, n, r)) : X(e, n, r);
                }, le = function(e, t) {
                    d(e);
                    var r = v(t), n = g(r).concat(ve(r));
                    return U(n, function(t) {
                        c && !o(pe, r, t) || ue(e, t, r[t]);
                    }), e;
                }, pe = function(e) {
                    var t = m(e), r = o(ee, this, t);
                    return !(this === W && p(re, t) && !p(ne, t)) && (!(r || !p(this, t) || !p(re, t) || p(this, L) && this[L][t]) || r);
                }, fe = function(e, t) {
                    var r = v(e), n = m(t);
                    if (r !== W || !p(re, n) || p(ne, n)) {
                        var i = J(r, n);
                        return !i || !p(re, n) || p(r, L) && r[L][n] || (i.enumerable = !0), i;
                    }
                }, de = function(e) {
                    var t = Q(v(e)), r = [];
                    return U(t, function(e) {
                        p(re, e) || p(C, e) || te(r, e);
                    }), r;
                }, ve = function(e) {
                    var t = e === W, r = Q(t ? ne : v(e)), n = [];
                    return U(r, function(e) {
                        !p(re, e) || t && !p(W, e) || te(n, re[e]);
                    }), n;
                };
                u || (E($ = (K = function() {
                    if (f($, this)) throw new Z("Symbol is not a constructor");
                    var e = arguments.length && void 0 !== arguments[0] ? y(arguments[0]) : void 0, t = T(e), r = function(e) {
                        var n = void 0 === this ? i : this;
                        n === W && o(r, ne, e), p(n, L) && p(n[L], t) && (n[L][t] = !1);
                        var a = h(1, e);
                        try {
                            se(n, t, a);
                        } catch (e) {
                            if (!(e instanceof G)) throw e;
                            ae(n, t, a);
                        }
                    };
                    return c && oe && se(W, t, {
                        configurable: !0,
                        set: r
                    }), ce(t, e);
                })[B], "toString", function() {
                    return V(this).tag;
                }), E(K, "withoutSetter", function(e) {
                    return ce(T(e), e);
                }), O.f = pe, j.f = ue, x.f = le, S.f = fe, _.f = w.f = de, k.f = ve, I.f = function(e) {
                    return ce(N(e), e);
                }, c && (P($, "description", {
                    configurable: !0,
                    get: function() {
                        return V(this).description;
                    }
                }), s || E(W, "propertyIsEnumerable", pe, {
                    unsafe: !0
                }))), n({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: !u,
                    sham: !u
                }, {
                    Symbol: K
                }), U(g(ie), function(e) {
                    D(e);
                }), n({
                    target: F,
                    stat: !0,
                    forced: !u
                }, {
                    useSetter: function() {
                        oe = !0;
                    },
                    useSimple: function() {
                        oe = !1;
                    }
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !u,
                    sham: !c
                }, {
                    create: function(e, t) {
                        return void 0 === t ? b(e) : le(b(e), t);
                    },
                    defineProperty: ue,
                    defineProperties: le,
                    getOwnPropertyDescriptor: fe
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !u
                }, {
                    getOwnPropertyNames: de
                }), R(), M(K, F), C[L] = !0;
            },
            2733: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(382), o = r(8389), a = r(4762), s = r(5755), c = r(1483), u = r(4815), l = r(6261), p = r(3864), f = r(6726), d = o.Symbol, v = d && d.prototype;
                if (i && c(d) && (!("description" in v) || void 0 !== d().description)) {
                    var m = {}, y = function() {
                        var e = arguments.length < 1 || void 0 === arguments[0] ? void 0 : l(arguments[0]), t = u(v, this) ? new d(e) : void 0 === e ? d() : d(e);
                        return "" === e && (m[t] = !0), t;
                    };
                    f(y, d), y.prototype = v, v.constructor = y;
                    var h = "Symbol(description detection)" === String(d("description detection")), b = a(v.valueOf), g = a(v.toString), _ = /^Symbol\((.*)\)[^)]+$/, w = a("".replace), k = a("".slice);
                    p(v, "description", {
                        configurable: !0,
                        get: function() {
                            var e = b(this);
                            if (s(m, e)) return "";
                            var t = g(e), r = h ? k(t, 7, -1) : w(t, _, "$1");
                            return "" === r ? void 0 : r;
                        }
                    }), n({
                        global: !0,
                        constructor: !0,
                        forced: !0
                    }, {
                        Symbol: y
                    });
                }
            },
            2484: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(1409), o = r(5755), a = r(6261), s = r(7255), c = r(3218), u = s("string-to-symbol-registry"), l = s("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !c
                }, {
                    for: function(e) {
                        var t = a(e);
                        if (o(u, t)) return u[t];
                        var r = i("Symbol")(t);
                        return u[t] = r, l[r] = t, r;
                    }
                });
            },
            4701: (e, t, r)=>{
                "use strict";
                r(7849)("iterator");
            },
            9305: (e, t, r)=>{
                "use strict";
                r(5443), r(2484), r(1894), r(6184), r(7859);
            },
            1894: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(5755), o = r(1423), a = r(8761), s = r(7255), c = r(3218), u = s("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !c
                }, {
                    keyFor: function(e) {
                        if (!o(e)) throw new TypeError(a(e) + " is not a symbol");
                        if (i(u, e)) return u[e];
                    }
                });
            },
            1678: (e, t, r)=>{
                "use strict";
                var n = r(7849), i = r(8192);
                n("toPrimitive"), i();
            },
            3630: (e, t, r)=>{
                "use strict";
                var n = r(8389), i = r(4842), o = r(1902), a = r(4793), s = r(9037), c = function(e) {
                    if (e && e.forEach !== a) try {
                        s(e, "forEach", a);
                    } catch (t) {
                        e.forEach = a;
                    }
                };
                for(var u in i)i[u] && c(n[u] && n[u].prototype);
                c(o);
            },
            2367: (e, t, r)=>{
                "use strict";
                var n = r(8389), i = r(4842), o = r(1902), a = r(4962), s = r(9037), c = r(2277), u = r(1)("iterator"), l = a.values, p = function(e, t) {
                    if (e) {
                        if (e[u] !== l) try {
                            s(e, u, l);
                        } catch (t) {
                            e[u] = l;
                        }
                        if (c(e, t, !0), i[t]) {
                            for(var r in a)if (e[r] !== a[r]) try {
                                s(e, r, a[r]);
                            } catch (t) {
                                e[r] = a[r];
                            }
                        }
                    }
                };
                for(var f in i)p(n[f] && n[f].prototype, f);
                p(o, "DOMTokenList");
            },
            9833: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(8389), o = r(9570)(i.setInterval, !0);
                n({
                    global: !0,
                    bind: !0,
                    forced: i.setInterval !== o
                }, {
                    setInterval: o
                });
            },
            3989: (e, t, r)=>{
                "use strict";
                var n = r(8612), i = r(8389), o = r(9570)(i.setTimeout, !0);
                n({
                    global: !0,
                    bind: !0,
                    forced: i.setTimeout !== o
                }, {
                    setTimeout: o
                });
            },
            7089: (e, t, r)=>{
                "use strict";
                r(9833), r(3989);
            }
        }, t = {};
        function r(n) {
            var i = t[n];
            if (void 0 !== i) return i.exports;
            var o = t[n] = {
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.exports;
        }
        r.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return r.d(t, {
                a: t
            }), t;
        }, r.d = (e, t)=>{
            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return (()=>{
            "use strict";
            r.r(n), r.d(n, {
                addEventListener: ()=>rn,
                defaultConfig: ()=>Hr,
                defaultTranslations: ()=>Jr,
                getConfigTranslations: ()=>on,
                getElement: ()=>tn,
                getElementID: ()=>en,
                getManager: ()=>mn,
                language: ()=>st,
                render: ()=>sn,
                renderContextualConsentNotices: ()=>cn,
                resetManagers: ()=>vn,
                setup: ()=>pn,
                show: ()=>fn,
                updateConfig: ()=>ar,
                validateConfig: ()=>ln,
                version: ()=>yn
            }), r(9305), r(2733), r(4701), r(1678), r(4776), r(4382), r(2084), r(9892), r(4962), r(6584), r(9336), r(4754), r(1908), r(8551), r(94), r(6457), r(8908), r(3810), r(8557), r(5021), r(3687), r(3994), r(3630), r(2367);
            var e, t, i, o, a, s, c, u, l = {}, p = [], f = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, d = Array.isArray;
            function v(e, t) {
                for(var r in t)e[r] = t[r];
                return e;
            }
            function m(e) {
                var t = e.parentNode;
                t && t.removeChild(e);
            }
            function y(t, r, n) {
                var i, o, a, s = {};
                for(a in r)"key" == a ? i = r[a] : "ref" == a ? o = r[a] : s[a] = r[a];
                if (arguments.length > 2 && (s.children = arguments.length > 3 ? e.call(arguments, 2) : n), "function" == typeof t && null != t.defaultProps) for(a in t.defaultProps)void 0 === s[a] && (s[a] = t.defaultProps[a]);
                return h(t, s, i, o, null);
            }
            function h(e, r, n, o, a) {
                var s = {
                    type: e,
                    props: r,
                    key: n,
                    ref: o,
                    __k: null,
                    __: null,
                    __b: 0,
                    __e: null,
                    __d: void 0,
                    __c: null,
                    constructor: void 0,
                    __v: null == a ? ++i : a,
                    __i: -1,
                    __u: 0
                };
                return null == a && null != t.vnode && t.vnode(s), s;
            }
            function b(e) {
                return e.children;
            }
            function g(e, t) {
                this.props = e, this.context = t;
            }
            function _(e, t) {
                if (null == t) return e.__ ? _(e.__, e.__i + 1) : null;
                for(var r; t < e.__k.length; t++)if (null != (r = e.__k[t]) && null != r.__e) return r.__e;
                return "function" == typeof e.type ? _(e) : null;
            }
            function w(e, r, n) {
                var i, o = e.__v, a = o.__e, s = e.__P;
                if (s) return (i = v({}, o)).__v = o.__v + 1, t.vnode && t.vnode(i), I(s, i, o, e.__n, void 0 !== s.ownerSVGElement, 32 & o.__u ? [
                    a
                ] : null, r, null == a ? _(o) : a, !!(32 & o.__u), n), i.__v = o.__v, i.__.__k[i.__i] = i, i.__d = void 0, i.__e != a && k(i), i;
            }
            function k(e) {
                var t, r;
                if (null != (e = e.__) && null != e.__c) {
                    for(e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)if (null != (r = e.__k[t]) && null != r.__e) {
                        e.__e = e.__c.base = r.__e;
                        break;
                    }
                    return k(e);
                }
            }
            function S(e) {
                (!e.__d && (e.__d = !0) && o.push(e) && !j.__r++ || a !== t.debounceRendering) && ((a = t.debounceRendering) || s)(j);
            }
            function j() {
                var e, r, n, i = [], a = [];
                for(o.sort(c); e = o.shift();)e.__d && (n = o.length, r = w(e, i, a) || r, 0 === n || o.length > n ? (D(i, r, a), a.length = i.length = 0, r = void 0, o.sort(c)) : r && t.__c && t.__c(r, p));
                r && D(i, r, a), j.__r = 0;
            }
            function x(e, t, r, n, i, o, a, s, c, u, f) {
                var d, v, m, y, h, b = n && n.__k || p, g = t.length;
                for(r.__d = c, O(r, t, b), c = r.__d, d = 0; d < g; d++)null != (m = r.__k[d]) && "boolean" != typeof m && "function" != typeof m && (v = -1 === m.__i ? l : b[m.__i] || l, m.__i = d, I(e, m, v, i, o, a, s, c, u, f), y = m.__e, m.ref && v.ref != m.ref && (v.ref && M(v.ref, null, m), f.push(m.ref, m.__c || y, m)), null == h && null != y && (h = y), 65536 & m.__u || v.__k === m.__k ? c = E(m, c, e) : "function" == typeof m.type && void 0 !== m.__d ? c = m.__d : y && (c = y.nextSibling), m.__d = void 0, m.__u &= -196609);
                r.__d = c, r.__e = h;
            }
            function O(e, t, r) {
                var n, i, o, a, s, c = t.length, u = r.length, l = u, p = 0;
                for(e.__k = [], n = 0; n < c; n++)a = n + p, null != (i = e.__k[n] = null == (i = t[n]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? h(null, i, null, null, null) : d(i) ? h(b, {
                    children: i
                }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? h(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = e, i.__b = e.__b + 1, s = A(i, r, a, l), i.__i = s, o = null, -1 !== s && (l--, (o = r[s]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == s && p--, "function" != typeof i.type && (i.__u |= 65536)) : s !== a && (s === a + 1 ? p++ : s > a ? l > c - a ? p += s - a : p-- : s < a ? s == a - 1 && (p = s - a) : p = 0, s !== n + p && (i.__u |= 65536))) : (o = r[a]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == e.__d && (e.__d = _(o)), q(o, o, !1), r[a] = null, l--);
                if (l) for(n = 0; n < u; n++)null != (o = r[n]) && 0 == (131072 & o.__u) && (o.__e == e.__d && (e.__d = _(o)), q(o, o));
            }
            function E(e, t, r) {
                var n, i;
                if ("function" == typeof e.type) {
                    for(n = e.__k, i = 0; n && i < n.length; i++)n[i] && (n[i].__ = e, t = E(n[i], t, r));
                    return t;
                }
                e.__e != t && (r.insertBefore(e.__e, t || null), t = e.__e);
                do t = t && t.nextSibling;
                while (null != t && 8 === t.nodeType);
                return t;
            }
            function P(e, t) {
                return t = t || [], null == e || "boolean" == typeof e || (d(e) ? e.some(function(e) {
                    P(e, t);
                }) : t.push(e)), t;
            }
            function A(e, t, r, n) {
                var i = e.key, o = e.type, a = r - 1, s = r + 1, c = t[r];
                if (null === c || c && i == c.key && o === c.type && 0 == (131072 & c.__u)) return r;
                if (n > (null != c && 0 == (131072 & c.__u) ? 1 : 0)) for(; a >= 0 || s < t.length;){
                    if (a >= 0) {
                        if ((c = t[a]) && 0 == (131072 & c.__u) && i == c.key && o === c.type) return a;
                        a--;
                    }
                    if (s < t.length) {
                        if ((c = t[s]) && 0 == (131072 & c.__u) && i == c.key && o === c.type) return s;
                        s++;
                    }
                }
                return -1;
            }
            function z(e, t, r) {
                "-" === t[0] ? e.setProperty(t, null == r ? "" : r) : e[t] = null == r ? "" : "number" != typeof r || f.test(t) ? r : r + "px";
            }
            function C(e, t, r, n, i) {
                var o;
                e: if ("style" === t) {
                    if ("string" == typeof r) e.style.cssText = r;
                    else {
                        if ("string" == typeof n && (e.style.cssText = n = ""), n) for(t in n)r && t in r || z(e.style, t, "");
                        if (r) for(t in r)n && r[t] === n[t] || z(e.style, t, r[t]);
                    }
                } else if ("o" === t[0] && "n" === t[1]) o = t !== (t = t.replace(/(PointerCapture)$|Capture$/i, "$1")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = r, r ? n ? r.u = n.u : (r.u = Date.now(), e.addEventListener(t, o ? N : T, o)) : e.removeEventListener(t, o ? N : T, o);
                else {
                    if (i) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
                    else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && "rowSpan" !== t && "colSpan" !== t && "role" !== t && t in e) try {
                        e[t] = null == r ? "" : r;
                        break e;
                    } catch (e) {}
                    "function" == typeof r || (null == r || !1 === r && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, r));
                }
            }
            function T(e) {
                if (this.l) {
                    var r = this.l[e.type + !1];
                    if (e.t) {
                        if (e.t <= r.u) return;
                    } else e.t = Date.now();
                    return r(t.event ? t.event(e) : e);
                }
            }
            function N(e) {
                if (this.l) return this.l[e.type + !0](t.event ? t.event(e) : e);
            }
            function I(e, r, n, i, o, a, s, c, u, l) {
                var p, f, m, y, h, _, w, k, S, j, O, E, P, A, z, C = r.type;
                if (void 0 !== r.constructor) return null;
                128 & n.__u && (u = !!(32 & n.__u), a = [
                    c = r.__e = n.__e
                ]), (p = t.__b) && p(r);
                e: if ("function" == typeof C) try {
                    if (k = r.props, S = (p = C.contextType) && i[p.__c], j = p ? S ? S.props.value : p.__ : i, n.__c ? w = (f = r.__c = n.__c).__ = f.__E : ("prototype" in C && C.prototype.render ? r.__c = f = new C(k, j) : (r.__c = f = new g(k, j), f.constructor = C, f.render = U), S && S.sub(f), f.props = k, f.state || (f.state = {}), f.context = j, f.__n = i, m = f.__d = !0, f.__h = [], f._sb = []), null == f.__s && (f.__s = f.state), null != C.getDerivedStateFromProps && (f.__s == f.state && (f.__s = v({}, f.__s)), v(f.__s, C.getDerivedStateFromProps(k, f.__s))), y = f.props, h = f.state, f.__v = r, m) null == C.getDerivedStateFromProps && null != f.componentWillMount && f.componentWillMount(), null != f.componentDidMount && f.__h.push(f.componentDidMount);
                    else {
                        if (null == C.getDerivedStateFromProps && k !== y && null != f.componentWillReceiveProps && f.componentWillReceiveProps(k, j), !f.__e && (null != f.shouldComponentUpdate && !1 === f.shouldComponentUpdate(k, f.__s, j) || r.__v === n.__v)) {
                            for(r.__v !== n.__v && (f.props = k, f.state = f.__s, f.__d = !1), r.__e = n.__e, r.__k = n.__k, r.__k.forEach(function(e) {
                                e && (e.__ = r);
                            }), O = 0; O < f._sb.length; O++)f.__h.push(f._sb[O]);
                            f._sb = [], f.__h.length && s.push(f);
                            break e;
                        }
                        null != f.componentWillUpdate && f.componentWillUpdate(k, f.__s, j), null != f.componentDidUpdate && f.__h.push(function() {
                            f.componentDidUpdate(y, h, _);
                        });
                    }
                    if (f.context = j, f.props = k, f.__P = e, f.__e = !1, E = t.__r, P = 0, "prototype" in C && C.prototype.render) {
                        for(f.state = f.__s, f.__d = !1, E && E(r), p = f.render(f.props, f.state, f.context), A = 0; A < f._sb.length; A++)f.__h.push(f._sb[A]);
                        f._sb = [];
                    } else do f.__d = !1, E && E(r), p = f.render(f.props, f.state, f.context), f.state = f.__s;
                    while (f.__d && ++P < 25);
                    f.state = f.__s, null != f.getChildContext && (i = v(v({}, i), f.getChildContext())), m || null == f.getSnapshotBeforeUpdate || (_ = f.getSnapshotBeforeUpdate(y, h)), x(e, d(z = null != p && p.type === b && null == p.key ? p.props.children : p) ? z : [
                        z
                    ], r, n, i, o, a, s, c, u, l), f.base = r.__e, r.__u &= -161, f.__h.length && s.push(f), w && (f.__E = f.__ = null);
                } catch (e) {
                    r.__v = null, u || null != a ? (r.__e = c, r.__u |= u ? 160 : 32, a[a.indexOf(c)] = null) : (r.__e = n.__e, r.__k = n.__k), t.__e(e, r, n);
                }
                else null == a && r.__v === n.__v ? (r.__k = n.__k, r.__e = n.__e) : r.__e = R(n.__e, r, n, i, o, a, s, u, l);
                (p = t.diffed) && p(r);
            }
            function D(e, r, n) {
                for(var i = 0; i < n.length; i++)M(n[i], n[++i], n[++i]);
                t.__c && t.__c(r, e), e.some(function(r) {
                    try {
                        e = r.__h, r.__h = [], e.some(function(e) {
                            e.call(r);
                        });
                    } catch (e) {
                        t.__e(e, r.__v);
                    }
                });
            }
            function R(t, r, n, i, o, a, s, c, u) {
                var p, f, v, y, h, b, g, w = n.props, k = r.props, S = r.type;
                if ("svg" === S && (o = !0), null != a) {
                    for(p = 0; p < a.length; p++)if ((h = a[p]) && "setAttribute" in h == !!S && (S ? h.localName === S : 3 === h.nodeType)) {
                        t = h, a[p] = null;
                        break;
                    }
                }
                if (null == t) {
                    if (null === S) return document.createTextNode(k);
                    t = o ? document.createElementNS("http://www.w3.org/2000/svg", S) : document.createElement(S, k.is && k), a = null, c = !1;
                }
                if (null === S) w === k || c && t.data === k || (t.data = k);
                else {
                    if (a = a && e.call(t.childNodes), w = n.props || l, !c && null != a) for(w = {}, p = 0; p < t.attributes.length; p++)w[(h = t.attributes[p]).name] = h.value;
                    for(p in w)h = w[p], "children" == p || ("dangerouslySetInnerHTML" == p ? v = h : "key" === p || p in k || C(t, p, null, h, o));
                    for(p in k)h = k[p], "children" == p ? y = h : "dangerouslySetInnerHTML" == p ? f = h : "value" == p ? b = h : "checked" == p ? g = h : "key" === p || c && "function" != typeof h || w[p] === h || C(t, p, h, w[p], o);
                    if (f) c || v && (f.__html === v.__html || f.__html === t.innerHTML) || (t.innerHTML = f.__html), r.__k = [];
                    else if (v && (t.innerHTML = ""), x(t, d(y) ? y : [
                        y
                    ], r, n, i, o && "foreignObject" !== S, a, s, a ? a[0] : n.__k && _(n, 0), c, u), null != a) for(p = a.length; p--;)null != a[p] && m(a[p]);
                    c || (p = "value", void 0 !== b && (b !== t[p] || "progress" === S && !b || "option" === S && b !== w[p]) && C(t, p, b, w[p], !1), p = "checked", void 0 !== g && g !== t[p] && C(t, p, g, w[p], !1));
                }
                return t;
            }
            function M(e, r, n) {
                try {
                    "function" == typeof e ? e(r) : e.current = r;
                } catch (e) {
                    t.__e(e, n);
                }
            }
            function q(e, r, n) {
                var i, o;
                if (t.unmount && t.unmount(e), (i = e.ref) && (i.current && i.current !== e.__e || M(i, null, r)), null != (i = e.__c)) {
                    if (i.componentWillUnmount) try {
                        i.componentWillUnmount();
                    } catch (e) {
                        t.__e(e, r);
                    }
                    i.base = i.__P = null, e.__c = void 0;
                }
                if (i = e.__k) for(o = 0; o < i.length; o++)i[o] && q(i[o], r, n || "function" != typeof e.type);
                n || null == e.__e || m(e.__e), e.__ = e.__e = e.__d = void 0;
            }
            function U(e, t, r) {
                return this.constructor(e, r);
            }
            function L(r, n, i) {
                var o, a, s, c;
                t.__ && t.__(r, n), a = (o = "function" == typeof i) ? null : i && i.__k || n.__k, s = [], c = [], I(n, r = (!o && i || n).__k = y(b, null, [
                    r
                ]), a || l, l, void 0 !== n.ownerSVGElement, !o && i ? [
                    i
                ] : a ? null : n.firstChild ? e.call(n.childNodes) : null, s, !o && i ? i : a ? a.__e : n.firstChild, o, c), r.__d = void 0, D(s, r, c);
            }
            function F(e, t) {
                L(e, t, F);
            }
            function B(t, r, n) {
                var i, o, a, s, c = v({}, t.props);
                for(a in t.type && t.type.defaultProps && (s = t.type.defaultProps), r)"key" == a ? i = r[a] : "ref" == a ? o = r[a] : c[a] = void 0 === r[a] && void 0 !== s ? s[a] : r[a];
                return arguments.length > 2 && (c.children = arguments.length > 3 ? e.call(arguments, 2) : n), h(t.type, c, i || t.key, o || t.ref, null);
            }
            e = p.slice, t = {
                __e: function(e, t, r, n) {
                    for(var i, o, a; t = t.__;)if ((i = t.__c) && !i.__) try {
                        if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(e)), a = i.__d), null != i.componentDidCatch && (i.componentDidCatch(e, n || {}), a = i.__d), a) return i.__E = i;
                    } catch (t) {
                        e = t;
                    }
                    throw e;
                }
            }, i = 0, g.prototype.setState = function(e, t) {
                var r;
                r = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v({}, this.state), "function" == typeof e && (e = e(v({}, r), this.props)), e && v(r, e), null != e && this.__v && (t && this._sb.push(t), S(this));
            }, g.prototype.forceUpdate = function(e) {
                this.__v && (this.__e = !0, e && this.__h.push(e), S(this));
            }, g.prototype.render = b, o = [], s = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, c = function(e, t) {
                return e.__v.__b - t.__v.__b;
            }, j.__r = 0, u = 0;
            var H, V, W, K, $ = 0, G = [], Z = [], Y = t, J = Y.__b, X = Y.__r, Q = Y.diffed, ee = Y.__c, te = Y.unmount, re = Y.__;
            function ne(e, t) {
                Y.__h && Y.__h(V, e, $ || t), $ = 0;
                var r = V.__H || (V.__H = {
                    __: [],
                    __h: []
                });
                return e >= r.__.length && r.__.push({
                    __V: Z
                }), r.__[e];
            }
            function ie(e) {
                return $ = 1, oe(me, e);
            }
            function oe(e, t, r) {
                var n = ne(H++, 2);
                if (n.t = e, !n.__c && (n.__ = [
                    r ? r(t) : me(void 0, t),
                    function(e) {
                        var t = n.__N ? n.__N[0] : n.__[0], r = n.t(t, e);
                        t !== r && (n.__N = [
                            r,
                            n.__[1]
                        ], n.__c.setState({}));
                    }
                ], n.__c = V, !V.u)) {
                    var i = function(e, t, r) {
                        if (!n.__c.__H) return !0;
                        var i = n.__c.__H.__.filter(function(e) {
                            return !!e.__c;
                        });
                        if (i.every(function(e) {
                            return !e.__N;
                        })) return !o || o.call(this, e, t, r);
                        var a = !1;
                        return i.forEach(function(e) {
                            if (e.__N) {
                                var t = e.__[0];
                                e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (a = !0);
                            }
                        }), !(!a && n.__c.props === e) && (!o || o.call(this, e, t, r));
                    };
                    V.u = !0;
                    var o = V.shouldComponentUpdate, a = V.componentWillUpdate;
                    V.componentWillUpdate = function(e, t, r) {
                        if (this.__e) {
                            var n = o;
                            o = void 0, i(e, t, r), o = n;
                        }
                        a && a.call(this, e, t, r);
                    }, V.shouldComponentUpdate = i;
                }
                return n.__N || n.__;
            }
            function ae(e, t) {
                var r = ne(H++, 3);
                !Y.__s && ve(r.__H, t) && (r.__ = e, r.i = t, V.__H.__h.push(r));
            }
            function se(e, t) {
                var r = ne(H++, 4);
                !Y.__s && ve(r.__H, t) && (r.__ = e, r.i = t, V.__h.push(r));
            }
            function ce(e, t) {
                var r = ne(H++, 7);
                return ve(r.__H, t) ? (r.__V = e(), r.i = t, r.__h = e, r.__V) : r.__;
            }
            function ue() {
                for(var e; e = G.shift();)if (e.__P && e.__H) try {
                    e.__H.__h.forEach(fe), e.__H.__h.forEach(de), e.__H.__h = [];
                } catch (t) {
                    e.__H.__h = [], Y.__e(t, e.__v);
                }
            }
            Y.__b = function(e) {
                V = null, J && J(e);
            }, Y.__ = function(e, t) {
                e && t.__k && t.__k.__m && (e.__m = t.__k.__m), re && re(e, t);
            }, Y.__r = function(e) {
                X && X(e), H = 0;
                var t = (V = e.__c).__H;
                t && (W === V ? (t.__h = [], V.__h = [], t.__.forEach(function(e) {
                    e.__N && (e.__ = e.__N), e.__V = Z, e.__N = e.i = void 0;
                })) : (t.__h.forEach(fe), t.__h.forEach(de), t.__h = [], H = 0)), W = V;
            }, Y.diffed = function(e) {
                Q && Q(e);
                var t = e.__c;
                t && t.__H && (t.__H.__h.length && (1 !== G.push(t) && K === Y.requestAnimationFrame || ((K = Y.requestAnimationFrame) || pe)(ue)), t.__H.__.forEach(function(e) {
                    e.i && (e.__H = e.i), e.__V !== Z && (e.__ = e.__V), e.i = void 0, e.__V = Z;
                })), W = V = null;
            }, Y.__c = function(e, t) {
                t.some(function(e) {
                    try {
                        e.__h.forEach(fe), e.__h = e.__h.filter(function(e) {
                            return !e.__ || de(e);
                        });
                    } catch (r) {
                        t.some(function(e) {
                            e.__h && (e.__h = []);
                        }), t = [], Y.__e(r, e.__v);
                    }
                }), ee && ee(e, t);
            }, Y.unmount = function(e) {
                te && te(e);
                var t, r = e.__c;
                r && r.__H && (r.__H.__.forEach(function(e) {
                    try {
                        fe(e);
                    } catch (e) {
                        t = e;
                    }
                }), r.__H = void 0, t && Y.__e(t, r.__v));
            };
            var le = "function" == typeof requestAnimationFrame;
            function pe(e) {
                var t, r = function() {
                    clearTimeout(n), le && cancelAnimationFrame(t), setTimeout(e);
                }, n = setTimeout(r, 100);
                le && (t = requestAnimationFrame(r));
            }
            function fe(e) {
                var t = V, r = e.__c;
                "function" == typeof r && (e.__c = void 0, r()), V = t;
            }
            function de(e) {
                var t = V;
                e.__c = e.__(), V = t;
            }
            function ve(e, t) {
                return !e || e.length !== t.length || t.some(function(t, r) {
                    return t !== e[r];
                });
            }
            function me(e, t) {
                return "function" == typeof t ? t(e) : t;
            }
            function ye(e, t) {
                for(var r in t)e[r] = t[r];
                return e;
            }
            function he(e, t) {
                for(var r in e)if ("__source" !== r && !(r in t)) return !0;
                for(var n in t)if ("__source" !== n && e[n] !== t[n]) return !0;
                return !1;
            }
            function be(e, t) {
                this.props = e, this.context = t;
            }
            (be.prototype = new g).isPureReactComponent = !0, be.prototype.shouldComponentUpdate = function(e, t) {
                return he(this.props, e) || he(this.state, t);
            };
            var ge = t.__b;
            t.__b = function(e) {
                e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), ge && ge(e);
            };
            var _e = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911, we = function(e, t) {
                return null == e ? null : P(P(e).map(t));
            }, ke = {
                map: we,
                forEach: we,
                count: function(e) {
                    return e ? P(e).length : 0;
                },
                only: function(e) {
                    var t = P(e);
                    if (1 !== t.length) throw "Children.only";
                    return t[0];
                },
                toArray: P
            }, Se = t.__e;
            t.__e = function(e, t, r, n) {
                if (e.then) {
                    for(var i, o = t; o = o.__;)if ((i = o.__c) && i.__c) return null == t.__e && (t.__e = r.__e, t.__k = r.__k), i.__c(e, t);
                }
                Se(e, t, r, n);
            };
            var je = t.unmount;
            function xe(e, t, r) {
                return e && (e.__c && e.__c.__H && (e.__c.__H.__.forEach(function(e) {
                    "function" == typeof e.__c && e.__c();
                }), e.__c.__H = null), null != (e = ye({}, e)).__c && (e.__c.__P === r && (e.__c.__P = t), e.__c = null), e.__k = e.__k && e.__k.map(function(e) {
                    return xe(e, t, r);
                })), e;
            }
            function Oe(e, t, r) {
                return e && r && (e.__v = null, e.__k = e.__k && e.__k.map(function(e) {
                    return Oe(e, t, r);
                }), e.__c && e.__c.__P === t && (e.__e && r.appendChild(e.__e), e.__c.__e = !0, e.__c.__P = r)), e;
            }
            function Ee() {
                this.__u = 0, this.t = null, this.__b = null;
            }
            function Pe(e) {
                var t = e.__.__c;
                return t && t.__a && t.__a(e);
            }
            function Ae() {
                this.u = null, this.o = null;
            }
            t.unmount = function(e) {
                var t = e.__c;
                t && t.__R && t.__R(), t && 32 & e.__u && (e.type = null), je && je(e);
            }, (Ee.prototype = new g).__c = function(e, t) {
                var r = t.__c, n = this;
                null == n.t && (n.t = []), n.t.push(r);
                var i = Pe(n.__v), o = !1, a = function() {
                    o || (o = !0, r.__R = null, i ? i(s) : s());
                };
                r.__R = a;
                var s = function() {
                    if (!--n.__u) {
                        if (n.state.__a) {
                            var e = n.state.__a;
                            n.__v.__k[0] = Oe(e, e.__c.__P, e.__c.__O);
                        }
                        var t;
                        for(n.setState({
                            __a: n.__b = null
                        }); t = n.t.pop();)t.forceUpdate();
                    }
                };
                n.__u++ || 32 & t.__u || n.setState({
                    __a: n.__b = n.__v.__k[0]
                }), e.then(a, a);
            }, Ee.prototype.componentWillUnmount = function() {
                this.t = [];
            }, Ee.prototype.render = function(e, t) {
                if (this.__b) {
                    if (this.__v.__k) {
                        var r = document.createElement("div"), n = this.__v.__k[0].__c;
                        this.__v.__k[0] = xe(this.__b, r, n.__O = n.__P);
                    }
                    this.__b = null;
                }
                var i = t.__a && y(b, null, e.fallback);
                return i && (i.__u &= -33), [
                    y(b, null, t.__a ? null : e.children),
                    i
                ];
            };
            var ze = function(e, t, r) {
                if (++r[1] === r[0] && e.o.delete(t), e.props.revealOrder && ("t" !== e.props.revealOrder[0] || !e.o.size)) for(r = e.u; r;){
                    for(; r.length > 3;)r.pop()();
                    if (r[1] < r[0]) break;
                    e.u = r = r[2];
                }
            };
            function Ce(e) {
                return this.getChildContext = function() {
                    return e.context;
                }, e.children;
            }
            function Te(e) {
                var t = this, r = e.i;
                t.componentWillUnmount = function() {
                    L(null, t.l), t.l = null, t.i = null;
                }, t.i && t.i !== r && t.componentWillUnmount(), t.l || (t.i = r, t.l = {
                    nodeType: 1,
                    parentNode: r,
                    childNodes: [],
                    appendChild: function(e) {
                        this.childNodes.push(e), t.i.appendChild(e);
                    },
                    insertBefore: function(e, r) {
                        this.childNodes.push(e), t.i.appendChild(e);
                    },
                    removeChild: function(e) {
                        this.childNodes.splice(this.childNodes.indexOf(e) >>> 1, 1), t.i.removeChild(e);
                    }
                }), L(y(Ce, {
                    context: t.context
                }, e.__v), t.l);
            }
            (Ae.prototype = new g).__a = function(e) {
                var t = this, r = Pe(t.__v), n = t.o.get(e);
                return n[0]++, function(i) {
                    var o = function() {
                        t.props.revealOrder ? (n.push(i), ze(t, e, n)) : i();
                    };
                    r ? r(o) : o();
                };
            }, Ae.prototype.render = function(e) {
                this.u = null, this.o = new Map;
                var t = P(e.children);
                e.revealOrder && "b" === e.revealOrder[0] && t.reverse();
                for(var r = t.length; r--;)this.o.set(t[r], this.u = [
                    1,
                    0,
                    this.u
                ]);
                return e.children;
            }, Ae.prototype.componentDidUpdate = Ae.prototype.componentDidMount = function() {
                var e = this;
                this.o.forEach(function(t, r) {
                    ze(e, r, t);
                });
            };
            var Ne = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, Ie = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, De = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, Re = /[A-Z0-9]/g, Me = "undefined" != typeof document, qe = function(e) {
                return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(e);
            };
            function Ue(e, t, r) {
                return null == t.__k && (t.textContent = ""), L(e, t), "function" == typeof r && r(), e ? e.__c : null;
            }
            g.prototype.isReactComponent = {}, [
                "componentWillMount",
                "componentWillReceiveProps",
                "componentWillUpdate"
            ].forEach(function(e) {
                Object.defineProperty(g.prototype, e, {
                    configurable: !0,
                    get: function() {
                        return this["UNSAFE_" + e];
                    },
                    set: function(t) {
                        Object.defineProperty(this, e, {
                            configurable: !0,
                            writable: !0,
                            value: t
                        });
                    }
                });
            });
            var Le = t.event;
            function Fe() {}
            function Be() {
                return this.cancelBubble;
            }
            function He() {
                return this.defaultPrevented;
            }
            t.event = function(e) {
                return Le && (e = Le(e)), e.persist = Fe, e.isPropagationStopped = Be, e.isDefaultPrevented = He, e.nativeEvent = e;
            };
            var Ve, We = {
                enumerable: !1,
                configurable: !0,
                get: function() {
                    return this.class;
                }
            }, Ke = t.vnode;
            t.vnode = function(e) {
                "string" == typeof e.type && function(e) {
                    var t = e.props, r = e.type, n = {};
                    for(var i in t){
                        var o = t[i];
                        if (!("value" === i && "defaultValue" in t && null == o || Me && "children" === i && "noscript" === r || "class" === i || "className" === i)) {
                            var a = i.toLowerCase();
                            "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === o ? o = "" : "translate" === a && "no" === o ? o = !1 : "ondoubleclick" === a ? i = "ondblclick" : "onchange" !== a || "input" !== r && "textarea" !== r || qe(t.type) ? "onfocus" === a ? i = "onfocusin" : "onblur" === a ? i = "onfocusout" : De.test(i) ? i = a : -1 === r.indexOf("-") && Ie.test(i) ? i = i.replace(Re, "-$&").toLowerCase() : null === o && (o = void 0) : a = i = "oninput", "oninput" === a && n[i = a] && (i = "oninputCapture"), n[i] = o;
                        }
                    }
                    "select" == r && n.multiple && Array.isArray(n.value) && (n.value = P(t.children).forEach(function(e) {
                        e.props.selected = -1 != n.value.indexOf(e.props.value);
                    })), "select" == r && null != n.defaultValue && (n.value = P(t.children).forEach(function(e) {
                        e.props.selected = n.multiple ? -1 != n.defaultValue.indexOf(e.props.value) : n.defaultValue == e.props.value;
                    })), t.class && !t.className ? (n.class = t.class, Object.defineProperty(n, "className", We)) : (t.className && !t.class || t.class && t.className) && (n.class = n.className = t.className), e.props = n;
                }(e), e.$$typeof = Ne, Ke && Ke(e);
            };
            var $e = t.__r;
            t.__r = function(e) {
                $e && $e(e), Ve = e.__c;
            };
            var Ge = t.diffed;
            t.diffed = function(e) {
                Ge && Ge(e);
                var t = e.props, r = e.__e;
                null != r && "textarea" === e.type && "value" in t && t.value !== r.value && (r.value = null == t.value ? "" : t.value), Ve = null;
            };
            var Ze = {
                ReactCurrentDispatcher: {
                    current: {
                        readContext: function(e) {
                            return Ve.__n[e.__c].props.value;
                        }
                    }
                }
            };
            function Ye(e) {
                return !!e && e.$$typeof === Ne;
            }
            function Je(e) {
                e();
            }
            function Xe(e) {
                var t, r, n = e.v, i = e.__;
                try {
                    var o = n();
                    return !((t = i) === (r = o) && (0 !== t || 1 / t == 1 / r) || t != t && r != r);
                } catch (e) {
                    return !0;
                }
            }
            var Qe = {
                useState: ie,
                useId: function() {
                    var e = ne(H++, 11);
                    if (!e.__) {
                        for(var t = V.__v; null !== t && !t.__m && null !== t.__;)t = t.__;
                        var r = t.__m || (t.__m = [
                            0,
                            0
                        ]);
                        e.__ = "P" + r[0] + "-" + r[1]++;
                    }
                    return e.__;
                },
                useReducer: oe,
                useEffect: ae,
                useLayoutEffect: se,
                useInsertionEffect: se,
                useTransition: function() {
                    return [
                        !1,
                        Je
                    ];
                },
                useDeferredValue: function(e) {
                    return e;
                },
                useSyncExternalStore: function(e, t) {
                    var r = t(), n = ie({
                        h: {
                            __: r,
                            v: t
                        }
                    }), i = n[0].h, o = n[1];
                    return se(function() {
                        i.__ = r, i.v = t, Xe(i) && o({
                            h: i
                        });
                    }, [
                        e,
                        r,
                        t
                    ]), ae(function() {
                        return Xe(i) && o({
                            h: i
                        }), e(function() {
                            Xe(i) && o({
                                h: i
                            });
                        });
                    }, [
                        e
                    ]), r;
                },
                startTransition: Je,
                useRef: function(e) {
                    return $ = 5, ce(function() {
                        return {
                            current: e
                        };
                    }, []);
                },
                useImperativeHandle: function(e, t, r) {
                    $ = 6, se(function() {
                        return "function" == typeof e ? (e(t()), function() {
                            return e(null);
                        }) : e ? (e.current = t(), function() {
                            return e.current = null;
                        }) : void 0;
                    }, null == r ? r : r.concat(e));
                },
                useMemo: ce,
                useCallback: function(e, t) {
                    return $ = 8, ce(function() {
                        return e;
                    }, t);
                },
                useContext: function(e) {
                    var t = V.context[e.__c], r = ne(H++, 9);
                    return r.c = e, t ? (null == r.__ && (r.__ = !0, t.sub(V)), t.props.value) : e.__;
                },
                useDebugValue: function(e, t) {
                    Y.useDebugValue && Y.useDebugValue(t ? t(e) : e);
                },
                version: "17.0.2",
                Children: ke,
                render: Ue,
                hydrate: function(e, t, r) {
                    return F(e, t), "function" == typeof r && r(), e ? e.__c : null;
                },
                unmountComponentAtNode: function(e) {
                    return !!e.__k && (L(null, e), !0);
                },
                createPortal: function(e, t) {
                    var r = y(Te, {
                        __v: e,
                        i: t
                    });
                    return r.containerInfo = t, r;
                },
                createElement: y,
                createContext: function(e, t) {
                    var r = {
                        __c: t = "__cC" + u++,
                        __: e,
                        Consumer: function(e, t) {
                            return e.children(t);
                        },
                        Provider: function(e) {
                            var r, n;
                            return this.getChildContext || (r = [], (n = {})[t] = this, this.getChildContext = function() {
                                return n;
                            }, this.shouldComponentUpdate = function(e) {
                                this.props.value !== e.value && r.some(function(e) {
                                    e.__e = !0, S(e);
                                });
                            }, this.sub = function(e) {
                                r.push(e);
                                var t = e.componentWillUnmount;
                                e.componentWillUnmount = function() {
                                    r.splice(r.indexOf(e), 1), t && t.call(e);
                                };
                            }), e.children;
                        }
                    };
                    return r.Provider.__ = r.Consumer.contextType = r;
                },
                createFactory: function(e) {
                    return y.bind(null, e);
                },
                cloneElement: function(e) {
                    return Ye(e) ? B.apply(null, arguments) : e;
                },
                createRef: function() {
                    return {
                        current: null
                    };
                },
                Fragment: b,
                isValidElement: Ye,
                isElement: Ye,
                isFragment: function(e) {
                    return Ye(e) && e.type === b;
                },
                findDOMNode: function(e) {
                    return e && (e.base || 1 === e.nodeType && e) || null;
                },
                Component: g,
                PureComponent: be,
                memo: function(e, t) {
                    function r(e) {
                        var r = this.props.ref, n = r == e.ref;
                        return !n && r && (r.call ? r(null) : r.current = null), t ? !t(this.props, e) || !n : he(this.props, e);
                    }
                    function n(t) {
                        return this.shouldComponentUpdate = r, y(e, t);
                    }
                    return n.displayName = "Memo(" + (e.displayName || e.name) + ")", n.prototype.isReactComponent = !0, n.__f = !0, n;
                },
                forwardRef: function(e) {
                    function t(t) {
                        var r = ye({}, t);
                        return delete r.ref, e(r, t.ref || null);
                    }
                    return t.$$typeof = _e, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (e.displayName || e.name) + ")", t;
                },
                flushSync: function(e, t) {
                    return e(t);
                },
                unstable_batchedUpdates: function(e, t) {
                    return e(t);
                },
                StrictMode: b,
                Suspense: Ee,
                SuspenseList: Ae,
                lazy: function(e) {
                    var t, r, n;
                    function i(i) {
                        if (t || (t = e()).then(function(e) {
                            r = e.default || e;
                        }, function(e) {
                            n = e;
                        }), n) throw n;
                        if (!r) throw t;
                        return y(r, i);
                    }
                    return i.displayName = "Lazy", i.__f = !0, i;
                },
                __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: Ze
            }, et = (r(6437), r(2697), r(1359), r(6216), r(6448), r(7089), r(2688)), tt = function(e) {
                var t = e.t;
                return Qe.createElement("svg", {
                    role: "img",
                    "aria-label": t([
                        "close"
                    ]),
                    width: "12",
                    height: "12",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg"
                }, Qe.createElement("title", null, t([
                    "close"
                ])), Qe.createElement("line", {
                    x1: "1",
                    y1: "11",
                    x2: "11",
                    y2: "1",
                    strokeWidth: "1"
                }), Qe.createElement("line", {
                    x1: "1",
                    y1: "1",
                    x2: "11",
                    y2: "11",
                    strokeWidth: "1"
                }));
            };
            function rt(e) {
                return e.split("-").map(function(e) {
                    return e.slice(0, 1).toUpperCase() + e.slice(1);
                }).join(" ");
            }
            function nt(e) {
                return function(e) {
                    if (Array.isArray(e)) return it(e);
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(e) || function(e, t) {
                    if (e) {
                        if ("string" == typeof e) return it(e, t);
                        var r = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? it(e, t) : void 0;
                    }
                }(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function it(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                return n;
            }
            function ot(e) {
                return ot = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, ot(e);
            }
            tt.propTypes = {
                t: r.n(et)().func
            }, r(7575), r(646), r(987), r(3819);
            var at = function(e) {
                for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                var i, o = ot(r[0]);
                i = 0 === r.length ? {} : "string" === o || "number" === o ? Array.prototype.slice.call(r) : r[0];
                for(var a = [], s = e.toString(); s.length > 0;){
                    var c = s.match(/\{(?!\{)([\w\d]+)\}(?!\})/);
                    if (null !== c) {
                        var u = s.substr(0, c.index);
                        s = s.substr(c.index + c[0].length);
                        var l = parseInt(c[1]);
                        a.push(u), l != l ? a.push(i[c[1]]) : a.push(i[l]);
                    } else a.push(s), s = "";
                }
                return a;
            };
            function st(e) {
                if (void 0 !== e && void 0 !== e.lang && "zz" !== e.lang) return e.lang;
                var t = (("string" == typeof window.language ? window.language : null) || document.documentElement.lang || (void 0 !== e && void 0 !== e.languages && void 0 !== e.languages[0] ? e.languages[0] : "en")).toLowerCase(), r = new RegExp("^([\\w]+)-([\\w]+)$").exec(t);
                return null === r ? t : r[1];
            }
            function ct(e, t, r) {
                var n = t;
                Array.isArray(n) || (n = [
                    n
                ]);
                for(var i = e, o = 0; o < n.length; o++){
                    if (void 0 === i) return r;
                    if (void 0 !== n[o] && n[o].endsWith("?")) {
                        var a, s = n[o].slice(0, n[o].length - 1);
                        void 0 !== (a = i instanceof Map ? i.get(s) : i[s]) && "string" == typeof a && (i = a);
                    } else i = i instanceof Map ? i.get(n[o]) : i[n[o]];
                }
                return void 0 === i || "string" != typeof i ? r : "" !== i ? i : void 0;
            }
            function ut(e, t, r, n) {
                var i = n, o = !1;
                "!" === i[0] && (i = i.slice(1), o = !0), Array.isArray(i) || (i = [
                    i
                ]);
                var a = ct(e, [
                    t
                ].concat(nt(i)));
                if (void 0 === a && void 0 !== r && (a = ct(e, [
                    r
                ].concat(nt(i)))), void 0 === a) {
                    if (o) return;
                    return [
                        "[missing translation: ".concat(t, "/").concat(i.join("/"), "]")
                    ];
                }
                for(var s = arguments.length, c = new Array(s > 4 ? s - 4 : 0), u = 4; u < s; u++)c[u - 4] = arguments[u];
                return c.length > 0 ? at.apply(void 0, [
                    a
                ].concat(c)) : a;
            }
            const lt = function(e) {
                var t = e.text, r = e.config;
                if (t instanceof Array || (t = [
                    t
                ]), !0 === r.htmlTexts) {
                    var n = !1;
                    "<" === t[0][0] && (n = !0);
                    var i = t.map(function(e, t) {
                        return "string" == typeof e ? Qe.createElement("span", {
                            key: t,
                            dangerouslySetInnerHTML: {
                                __html: e
                            }
                        }) : e;
                    });
                    return n ? Qe.createElement(Qe.Fragment, null, i) : Qe.createElement("span", null, i);
                }
                return Qe.createElement("span", null, t);
            };
            function pt(e) {
                return pt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, pt(e);
            }
            function ft() {
                return ft = Object.assign ? Object.assign.bind() : function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = arguments[t];
                        for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                    }
                    return e;
                }, ft.apply(this, arguments);
            }
            function dt(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vt(n.key), n);
                }
            }
            function vt(e) {
                var t = function(e, t) {
                    if ("object" != pt(e) || !e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, "string");
                        if ("object" != pt(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == pt(t) ? t : String(t);
            }
            function mt(e, t, r) {
                return t = ht(t), function(e, t) {
                    if (t && ("object" === pt(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(e, yt() ? Reflect.construct(t, r || [], ht(e).constructor) : t.apply(e, r));
            }
            function yt() {
                try {
                    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                } catch (e) {}
                return (yt = function() {
                    return !!e;
                })();
            }
            function ht(e) {
                return ht = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, ht(e);
            }
            function bt(e, t) {
                return bt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                }, bt(e, t);
            }
            var gt = function(e) {
                function t() {
                    return function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), mt(this, t, arguments);
                }
                var r, n;
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && bt(e, t);
                }(t, e), r = t, n = [
                    {
                        key: "render",
                        value: function() {
                            var e, t = this.props, r = t.checked, n = t.onlyRequiredEnabled, i = t.onToggle, o = t.name, a = t.lang, s = t.config, c = t.translations, u = t.title, l = t.description, p = t.visible, f = t.t, d = this.props.required || !1, v = this.props.optOut || !1, m = this.props.purposes || [], y = "service-item-".concat(o), h = "".concat(y, "-title"), b = m.map(function(e) {
                                return f([
                                    "!",
                                    "purposes",
                                    e,
                                    "title?"
                                ]) || rt(e);
                            }).join(", "), g = v ? Qe.createElement("span", {
                                className: "cm-opt-out",
                                title: f([
                                    "service",
                                    "optOut",
                                    "description"
                                ])
                            }, f([
                                "service",
                                "optOut",
                                "title"
                            ])) : "", _ = d ? Qe.createElement("span", {
                                className: "cm-required",
                                title: f([
                                    "service",
                                    "required",
                                    "description"
                                ])
                            }, f([
                                "service",
                                "required",
                                "title"
                            ])) : "";
                            m.length > 0 && (e = Qe.createElement("p", {
                                className: "purposes"
                            }, f([
                                "service",
                                m.length > 1 ? "purposes" : "purpose"
                            ]), ": ", b));
                            var w = l || ut(c, a, "zz", [
                                "!",
                                "description"
                            ]) || f([
                                "!",
                                o,
                                "description?"
                            ]);
                            return Qe.createElement("div", null, Qe.createElement("input", {
                                id: y,
                                className: "cm-list-input" + (d ? " required" : "") + (n ? " half-checked only-required" : ""),
                                "aria-labelledby": "".concat(h),
                                "aria-describedby": "".concat(y, "-description"),
                                disabled: d,
                                checked: r || d,
                                tabIndex: p ? "0" : "-1",
                                type: "checkbox",
                                onChange: function(e) {
                                    i(e.target.checked);
                                }
                            }), Qe.createElement("label", ft({
                                htmlFor: y,
                                className: "cm-list-label"
                            }, d ? {
                                tabIndex: "0"
                            } : {}), Qe.createElement("span", {
                                className: "cm-list-title",
                                id: "".concat(h)
                            }, u || ut(c, a, "zz", [
                                "!",
                                "title"
                            ]) || f([
                                "!",
                                o,
                                "title?"
                            ]) || rt(o)), _, g, Qe.createElement("span", {
                                className: "cm-switch"
                            }, Qe.createElement("div", {
                                className: "slider round active"
                            }))), Qe.createElement("div", {
                                id: "".concat(y, "-description")
                            }, w && Qe.createElement("p", {
                                className: "cm-list-description"
                            }, Qe.createElement(lt, {
                                config: s,
                                text: w
                            })), e));
                        }
                    }
                ], n && dt(r.prototype, n), Object.defineProperty(r, "prototype", {
                    writable: !1
                }), t;
            }(Qe.Component);
            function _t(e) {
                return _t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, _t(e);
            }
            function wt(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kt(n.key), n);
                }
            }
            function kt(e) {
                var t = function(e, t) {
                    if ("object" != _t(e) || !e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, "string");
                        if ("object" != _t(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == _t(t) ? t : String(t);
            }
            function St(e, t, r) {
                return t = xt(t), function(e, t) {
                    if (t && ("object" === _t(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return Ot(e);
                }(e, jt() ? Reflect.construct(t, r || [], xt(e).constructor) : t.apply(e, r));
            }
            function jt() {
                try {
                    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                } catch (e) {}
                return (jt = function() {
                    return !!e;
                })();
            }
            function xt(e) {
                return xt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, xt(e);
            }
            function Ot(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function Et(e, t) {
                return Et = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                }, Et(e, t);
            }
            function Pt() {
                return Pt = Object.assign ? Object.assign.bind() : function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = arguments[t];
                        for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                    }
                    return e;
                }, Pt.apply(this, arguments);
            }
            var At = function(e) {
                var t = e.services, r = e.config, n = e.consents, i = e.lang, o = e.toggle, a = e.visible, s = e.t;
                return t.map(function(e) {
                    var t = n[e.name];
                    return Qe.createElement("li", {
                        key: e.name,
                        className: "cm-service"
                    }, Qe.createElement(gt, Pt({
                        checked: t || e.required,
                        onToggle: function(t) {
                            o([
                                e
                            ], t);
                        },
                        config: r,
                        lang: i,
                        visible: a,
                        t: s
                    }, e)));
                });
            }, zt = function(e) {
                function t(e) {
                    var r;
                    return function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), r = St(this, t, [
                        e
                    ]), e.manager.watch(Ot(r)), r.state = {
                        consents: e.manager.consents
                    }, r;
                }
                var r, n;
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && Et(e, t);
                }(t, e), r = t, n = [
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.props.manager.unwatch(this);
                        }
                    },
                    {
                        key: "update",
                        value: function(e, t, r) {
                            e === this.props.manager && "consents" === t && this.setState({
                                consents: r
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.config, r = e.t, n = e.manager, i = e.lang, o = this.state.consents, a = t.services, s = function(e, t) {
                                e.map(function(e) {
                                    e.required || n.updateConsent(e.name, t);
                                });
                            }, c = Qe.createElement(At, {
                                config: t,
                                lang: i,
                                services: a,
                                t: r,
                                consents: o,
                                toggle: s
                            }), u = a.filter(function(e) {
                                return !e.required;
                            }), l = u.filter(function(e) {
                                return o[e.name];
                            }).length, p = a.filter(function(e) {
                                return e.required;
                            }).length, f = l === u.length;
                            return a.filter(function(e) {
                                return e.required;
                            }).length, Qe.createElement("ul", {
                                className: "cm-services"
                            }, c, !t.hideToggleAll && u.length > 1 && Qe.createElement("li", {
                                className: "cm-service cm-toggle-all"
                            }, Qe.createElement(gt, {
                                name: "disableAll",
                                title: r([
                                    "service",
                                    "disableAll",
                                    "title"
                                ]),
                                description: r([
                                    "service",
                                    "disableAll",
                                    "description"
                                ]),
                                checked: f,
                                config: t,
                                onlyRequiredEnabled: !f && p > 0,
                                onToggle: function(e) {
                                    s(a, e);
                                },
                                lang: i,
                                t: r
                            })));
                        }
                    }
                ], wt(r.prototype, n), Object.defineProperty(r, "prototype", {
                    writable: !1
                }), t;
            }(Qe.Component);
            function Ct(e) {
                return Ct = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, Ct(e);
            }
            function Tt() {
                return Tt = Object.assign ? Object.assign.bind() : function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = arguments[t];
                        for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                    }
                    return e;
                }, Tt.apply(this, arguments);
            }
            function Nt(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, It(n.key), n);
                }
            }
            function It(e) {
                var t = function(e, t) {
                    if ("object" != Ct(e) || !e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, "string");
                        if ("object" != Ct(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == Ct(t) ? t : String(t);
            }
            function Dt(e, t, r) {
                return t = Mt(t), function(e, t) {
                    if (t && ("object" === Ct(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(e, Rt() ? Reflect.construct(t, r || [], Mt(e).constructor) : t.apply(e, r));
            }
            function Rt() {
                try {
                    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                } catch (e) {}
                return (Rt = function() {
                    return !!e;
                })();
            }
            function Mt(e) {
                return Mt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, Mt(e);
            }
            function qt(e, t) {
                return qt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                }, qt(e, t);
            }
            var Ut = function(e) {
                function t(e) {
                    var r;
                    return function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), (r = Dt(this, t, [
                        e
                    ])).state = {
                        servicesVisible: !1
                    }, r;
                }
                var r, n;
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && qt(e, t);
                }(t, e), r = t, n = [
                    {
                        key: "render",
                        value: function() {
                            var e, t = this, r = this.props, n = r.allEnabled, i = r.onlyRequiredEnabled, o = r.allDisabled, a = r.services, s = r.config, c = r.onToggle, u = r.name, l = r.lang, p = r.manager, f = r.consents, d = r.title, v = r.description, m = r.t, y = this.state.servicesVisible, h = this.props.required || !1, b = this.props.purposes || [], g = "purpose-item-".concat(u), _ = "".concat(g, "-title"), w = b.map(function(e) {
                                return m([
                                    "!",
                                    "purposes",
                                    e,
                                    "title?"
                                ]) || rt(e);
                            }).join(", "), k = h ? Qe.createElement("span", {
                                className: "cm-required",
                                title: m([
                                    "!",
                                    "service",
                                    "required",
                                    "description"
                                ]) || ""
                            }, m([
                                "service",
                                "required",
                                "title"
                            ])) : "";
                            b.length > 0 && (e = Qe.createElement("p", {
                                className: "purposes"
                            }, m([
                                "purpose",
                                b.length > 1 ? "purposes" : "purpose"
                            ]), ": ", w));
                            var S = function(e) {
                                e.preventDefault();
                                var r = "false" !== e.currentTarget.getAttribute("aria-expanded");
                                e.currentTarget.setAttribute("aria-expanded", !r), t.setState({
                                    servicesVisible: !y
                                });
                            }, j = Qe.createElement(At, {
                                config: s,
                                lang: l,
                                services: a,
                                toggle: function(e, t) {
                                    e.map(function(e) {
                                        e.required || p.updateConsent(e.name, t);
                                    });
                                },
                                consents: f,
                                visible: y,
                                t: m
                            }), x = v || m([
                                "!",
                                "purposes",
                                u,
                                "description"
                            ]);
                            return Qe.createElement(Qe.Fragment, null, Qe.createElement("input", {
                                id: g,
                                className: "cm-list-input" + (h ? " required" : "") + (n ? "" : i ? " only-required" : " half-checked"),
                                "aria-labelledby": "".concat(_),
                                "aria-describedby": "".concat(g, "-description"),
                                disabled: h,
                                checked: n || !o && !i,
                                type: "checkbox",
                                onChange: function(e) {
                                    c(e.target.checked);
                                }
                            }), Qe.createElement("label", Tt({
                                htmlFor: g,
                                className: "cm-list-label"
                            }, h ? {
                                tabIndex: "0"
                            } : {}), Qe.createElement("span", {
                                className: "cm-list-title",
                                id: "".concat(_)
                            }, d || m([
                                "!",
                                "purposes",
                                u,
                                "title?"
                            ]) || rt(u)), k, Qe.createElement("span", {
                                className: "cm-switch"
                            }, Qe.createElement("div", {
                                className: "slider round active"
                            }))), Qe.createElement("div", {
                                id: "".concat(g, "-description")
                            }, x && Qe.createElement("p", {
                                className: "cm-list-description"
                            }, Qe.createElement(lt, {
                                config: s,
                                text: x
                            })), e), a.length > 0 && Qe.createElement("div", {
                                className: "cm-services"
                            }, Qe.createElement("div", {
                                className: "cm-caret"
                            }, Qe.createElement("a", {
                                href: "#",
                                "aria-haspopup": "true",
                                "aria-expanded": "false",
                                tabIndex: "0",
                                onClick: S,
                                onKeyDown: function(e) {
                                    32 === e.keyCode && S(e);
                                }
                            }, y && Qe.createElement("span", null, "\u2191") || Qe.createElement("span", null, "\u2193"), " ", a.length, " ", m([
                                "purposeItem",
                                a.length > 1 ? "services" : "service"
                            ]))), Qe.createElement("ul", {
                                className: "cm-content" + (y ? " expanded" : "")
                            }, j)));
                        }
                    }
                ], n && Nt(r.prototype, n), Object.defineProperty(r, "prototype", {
                    writable: !1
                }), t;
            }(Qe.Component);
            function Lt(e) {
                return Lt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, Lt(e);
            }
            function Ft(e, t) {
                var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (!r) {
                    if (Array.isArray(e) || (r = function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return Bt(e, t);
                            var r = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Bt(e, t) : void 0;
                        }
                    }(e)) || t && e && "number" == typeof e.length) {
                        r && (e = r);
                        var n = 0, i = function() {};
                        return {
                            s: i,
                            n: function() {
                                return n >= e.length ? {
                                    done: !0
                                } : {
                                    done: !1,
                                    value: e[n++]
                                };
                            },
                            e: function(e) {
                                throw e;
                            },
                            f: i
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var o, a = !0, s = !1;
                return {
                    s: function() {
                        r = r.call(e);
                    },
                    n: function() {
                        var e = r.next();
                        return a = e.done, e;
                    },
                    e: function(e) {
                        s = !0, o = e;
                    },
                    f: function() {
                        try {
                            a || null == r.return || r.return();
                        } finally{
                            if (s) throw o;
                        }
                    }
                };
            }
            function Bt(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                return n;
            }
            function Ht(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Vt(n.key), n);
                }
            }
            function Vt(e) {
                var t = function(e, t) {
                    if ("object" != Lt(e) || !e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, "string");
                        if ("object" != Lt(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == Lt(t) ? t : String(t);
            }
            function Wt(e, t, r) {
                return t = $t(t), function(e, t) {
                    if (t && ("object" === Lt(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return Gt(e);
                }(e, Kt() ? Reflect.construct(t, r || [], $t(e).constructor) : t.apply(e, r));
            }
            function Kt() {
                try {
                    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                } catch (e) {}
                return (Kt = function() {
                    return !!e;
                })();
            }
            function $t(e) {
                return $t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, $t(e);
            }
            function Gt(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function Zt(e, t) {
                return Zt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                }, Zt(e, t);
            }
            var Yt = function(e) {
                function t(e) {
                    var r;
                    return function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), r = Wt(this, t, [
                        e
                    ]), e.manager.watch(Gt(r)), r.state = {
                        consents: e.manager.consents
                    }, r;
                }
                var r, n;
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && Zt(e, t);
                }(t, e), r = t, n = [
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.props.manager.unwatch(this);
                        }
                    },
                    {
                        key: "update",
                        value: function(e, t, r) {
                            e === this.props.manager && "consents" === t && this.setState({
                                consents: r
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e, t = this.props, r = t.config, n = t.t, i = t.manager, o = t.lang, a = this.state.consents, s = r.services, c = {}, u = Ft(s);
                            try {
                                for(u.s(); !(e = u.n()).done;){
                                    var l, p = e.value, f = Ft(p.purposes);
                                    try {
                                        for(f.s(); !(l = f.n()).done;){
                                            var d = l.value;
                                            void 0 === c[d] && (c[d] = []), c[d].push(p);
                                        }
                                    } catch (e) {
                                        f.e(e);
                                    } finally{
                                        f.f();
                                    }
                                }
                            } catch (e) {
                                u.e(e);
                            } finally{
                                u.f();
                            }
                            var v = function(e, t) {
                                e.map(function(e) {
                                    var r, n = Ft(c[e]);
                                    try {
                                        for(n.s(); !(r = n.n()).done;){
                                            var o = r.value;
                                            o.required || i.updateConsent(o.name, t);
                                        }
                                    } catch (e) {
                                        n.e(e);
                                    } finally{
                                        n.f();
                                    }
                                });
                            }, m = function(e) {
                                var t, r = {
                                    allEnabled: !0,
                                    onlyRequiredEnabled: !0,
                                    allDisabled: !0,
                                    allRequired: !0
                                }, n = Ft(e);
                                try {
                                    for(n.s(); !(t = n.n()).done;){
                                        var i = t.value;
                                        i.required || (r.allRequired = !1), a[i.name] ? (i.required || (r.onlyRequiredEnabled = !1), r.allDisabled = !1) : i.required || (r.allEnabled = !1);
                                    }
                                } catch (e) {
                                    n.e(e);
                                } finally{
                                    n.f();
                                }
                                return r.allDisabled && (r.onlyRequiredEnabled = !1), r;
                            }, y = r.purposeOrder || [], h = Object.keys(c).sort(function(e, t) {
                                return y.indexOf(e) - y.indexOf(t);
                            }).map(function(e) {
                                var t = m(c[e]);
                                return Qe.createElement("li", {
                                    key: e,
                                    className: "cm-purpose"
                                }, Qe.createElement(Ut, {
                                    allEnabled: t.allEnabled,
                                    allDisabled: t.allDisabled,
                                    onlyRequiredEnabled: t.onlyRequiredEnabled,
                                    required: t.allRequired,
                                    consents: a,
                                    name: e,
                                    config: r,
                                    lang: o,
                                    manager: i,
                                    onToggle: function(t) {
                                        v([
                                            e
                                        ], t);
                                    },
                                    services: c[e],
                                    t: n
                                }));
                            }), b = Object.keys(c).filter(function(e) {
                                var t, r = Ft(c[e]);
                                try {
                                    for(r.s(); !(t = r.n()).done;)if (!t.value.required) return !0;
                                } catch (e) {
                                    r.e(e);
                                } finally{
                                    r.f();
                                }
                                return !1;
                            }), g = m(s);
                            return Qe.createElement("ul", {
                                className: "cm-purposes"
                            }, h, b.length > 1 && Qe.createElement("li", {
                                className: "cm-purpose cm-toggle-all"
                            }, Qe.createElement(Ut, {
                                name: "disableAll",
                                title: n([
                                    "service",
                                    "disableAll",
                                    "title"
                                ]),
                                description: n([
                                    "service",
                                    "disableAll",
                                    "description"
                                ]),
                                allDisabled: g.allDisabled,
                                allEnabled: g.allEnabled,
                                onlyRequiredEnabled: g.onlyRequiredEnabled,
                                onToggle: function(e) {
                                    v(Object.keys(c), e);
                                },
                                manager: i,
                                consents: a,
                                config: r,
                                lang: o,
                                services: [],
                                t: n
                            })));
                        }
                    }
                ], n && Ht(r.prototype, n), Object.defineProperty(r, "prototype", {
                    writable: !1
                }), t;
            }(Qe.Component);
            function Jt(e) {
                return Jt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, Jt(e);
            }
            function Xt(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Qt(n.key), n);
                }
            }
            function Qt(e) {
                var t = function(e, t) {
                    if ("object" != Jt(e) || !e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, "string");
                        if ("object" != Jt(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == Jt(t) ? t : String(t);
            }
            function er(e, t, r) {
                return t = rr(t), function(e, t) {
                    if (t && ("object" === Jt(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(e, tr() ? Reflect.construct(t, r || [], rr(e).constructor) : t.apply(e, r));
            }
            function tr() {
                try {
                    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                } catch (e) {}
                return (tr = function() {
                    return !!e;
                })();
            }
            function rr(e) {
                return rr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, rr(e);
            }
            function nr(e, t) {
                return nr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                }, nr(e, t);
            }
            var ir = function(e) {
                function t() {
                    return function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), er(this, t, arguments);
                }
                var r, n;
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && nr(e, t);
                }(t, e), r = t, n = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.consentModalRef && this.consentModalRef.focus();
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e, t, r, n = this, i = this.props, o = i.hide, a = i.confirming, s = i.saveAndHide, c = i.acceptAndHide, u = i.declineAndHide, l = i.config, p = i.manager, f = i.lang, d = i.t, v = l.embedded, m = void 0 === l.groupByPurpose || l.groupByPurpose;
                            l.mustConsent || (e = Qe.createElement("button", {
                                title: d([
                                    "close"
                                ]),
                                "aria-label": d([
                                    "close"
                                ]),
                                className: "hide",
                                type: "button",
                                onClick: o,
                                tabIndex: "0",
                                ref: function(e) {
                                    n.consentModalRef = e;
                                }
                            }, Qe.createElement(tt, {
                                t: d
                            }))), l.hideDeclineAll || p.confirmed || (t = Qe.createElement("button", {
                                disabled: a,
                                className: "cm-btn cm-btn-decline cm-btn-danger cn-decline",
                                type: "button",
                                onClick: u
                            }, d([
                                "decline"
                            ])));
                            var y, h, b, g = Qe.createElement("button", {
                                disabled: a,
                                className: "cm-btn cm-btn-success cm-btn-info cm-btn-accept",
                                type: "button",
                                onClick: s
                            }, d([
                                p.confirmed ? "save" : "acceptSelected"
                            ]));
                            l.acceptAll && !p.confirmed && (r = Qe.createElement("button", {
                                disabled: a,
                                className: "cm-btn cm-btn-success cm-btn-accept-all",
                                type: "button",
                                onClick: c
                            }, d([
                                "acceptAll"
                            ]))), void 0 !== l.privacyPolicy ? "string" == typeof l.privacyPolicy ? y = l.privacyPolicy : "object" === Jt(l.privacyPolicy) && (y = l.privacyPolicy[f] || l.privacyPolicy.default) : void 0 !== (y = d([
                                "!",
                                "privacyPolicyUrl"
                            ], {
                                lang: f
                            })) && (y = y.join("")), void 0 !== y && (h = Qe.createElement("a", {
                                key: "ppLink",
                                href: y,
                                target: "_blank",
                                rel: "noopener"
                            }, d([
                                "privacyPolicy",
                                "name"
                            ]))), b = m ? Qe.createElement(Yt, {
                                t: d,
                                config: l,
                                manager: p,
                                lang: f
                            }) : Qe.createElement(zt, {
                                t: d,
                                config: l,
                                manager: p,
                                lang: f
                            });
                            var _ = Qe.createElement("div", {
                                className: "cm-modal cm-klaro"
                            }, Qe.createElement("div", {
                                className: "cm-header"
                            }, e, Qe.createElement("h1", {
                                className: "title"
                            }, Qe.createElement(lt, {
                                config: l,
                                text: d([
                                    "consentModal",
                                    "title"
                                ])
                            })), Qe.createElement("p", null, Qe.createElement(lt, {
                                config: l,
                                text: [
                                    d([
                                        "consentModal",
                                        "description"
                                    ])
                                ].concat(h && [
                                    " "
                                ].concat(d([
                                    "privacyPolicy",
                                    "text"
                                ], {
                                    privacyPolicy: h
                                })) || [])
                            }))), Qe.createElement("div", {
                                className: "cm-body"
                            }, b), Qe.createElement("div", {
                                className: "cm-footer"
                            }, Qe.createElement("div", {
                                className: "cm-footer-buttons"
                            }, t, g, r), !l.disablePoweredBy && Qe.createElement("p", {
                                className: "cm-powered-by"
                            }, Qe.createElement("a", {
                                target: "_blank",
                                href: l.poweredBy || "https://kiprotect.com/klaro",
                                rel: "noopener"
                            }, d([
                                "poweredBy"
                            ])))));
                            return v ? Qe.createElement("div", {
                                id: "cookieScreen",
                                className: "cookie-modal cm-embedded"
                            }, _) : Qe.createElement("div", {
                                id: "cookieScreen",
                                className: "cookie-modal"
                            }, Qe.createElement("div", {
                                className: "cm-bg",
                                onClick: o
                            }), _);
                        }
                    }
                ], Xt(r.prototype, n), Object.defineProperty(r, "prototype", {
                    writable: !1
                }), t;
            }(Qe.Component);
            function or(e) {
                return or = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, or(e);
            }
            function ar(e, t, r) {
                void 0 === r && (r = !0);
                for(var n = Object.keys(t), i = 0; i < n.length; i++){
                    var o = n[i], a = t[o], s = e[o];
                    "string" == typeof a ? (r || void 0 === s) && (e[o] = a) : "object" === or(a) && ("object" === or(s) ? ar(s, a, r) : (r || void 0 === s) && (e[o] = a));
                }
                return e;
            }
            function sr(e) {
                return sr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, sr(e);
            }
            function cr(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                return n;
            }
            function ur(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yr(n.key), n);
                }
            }
            function lr(e, t, r) {
                return t = fr(t), function(e, t) {
                    if (t && ("object" === sr(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return dr(e);
                }(e, pr() ? Reflect.construct(t, r || [], fr(e).constructor) : t.apply(e, r));
            }
            function pr() {
                try {
                    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                } catch (e) {}
                return (pr = function() {
                    return !!e;
                })();
            }
            function fr(e) {
                return fr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, fr(e);
            }
            function dr(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function vr(e, t) {
                return vr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                }, vr(e, t);
            }
            function mr(e, t, r) {
                return (t = yr(t)) in e ? Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = r, e;
            }
            function yr(e) {
                var t = function(e, t) {
                    if ("object" != sr(e) || !e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, "string");
                        if ("object" != sr(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == sr(t) ? t : String(t);
            }
            r(2745);
            var hr = function(e) {
                function t(e) {
                    var r;
                    return function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), mr(dr(r = lr(this, t, [
                        e
                    ])), "executeButtonClicked", function(e, t, n) {
                        var i = r.state.modal, o = 0;
                        e && (o = r.props.manager.changeAll(t));
                        var a = r.props.manager.confirmed;
                        if (r.props.manager.saveAndApplyConsents(n), e && !a && (i || r.props.config.mustConsent)) {
                            var s = function() {
                                r.setState({
                                    confirming: !1
                                }), r.props.hide();
                            };
                            r.setState({
                                confirming: !0
                            }), 0 === o ? s() : setTimeout(s, 800);
                        } else r.props.hide();
                    }), mr(dr(r), "saveAndHide", function() {
                        r.executeButtonClicked(!1, !1, "save");
                    }), mr(dr(r), "acceptAndHide", function() {
                        r.executeButtonClicked(!0, !0, "accept");
                    }), mr(dr(r), "declineAndHide", function() {
                        r.executeButtonClicked(!0, !1, "decline");
                    }), r.state = {
                        modal: e.modal,
                        confirming: !1
                    }, r;
                }
                var r, n;
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && vr(e, t);
                }(t, e), r = t, n = [
                    {
                        key: "componentDidUpdate",
                        value: function(e) {
                            e.modal !== this.props.modal && this.setState({
                                modal: this.props.modal
                            }), this.noticeRef && this.noticeRef.focus();
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e, t, r, n = this, i = this.props, o = i.lang, a = i.config, s = i.show, c = i.manager, u = i.testing, l = i.t, p = this.state, f = p.confirming, d = p.modal, v = a.embedded, m = a.noticeAsModal, y = a.hideLearnMore, h = a.purposeOrder || [], b = (function(e) {
                                for(var t = new Set([]), r = 0; r < e.services.length; r++)for(var n = e.services[r].purposes || [], i = 0; i < n.length; i++)t.add(n[i]);
                                return Array.from(t);
                            })(a).filter(function(e) {
                                return "functional" !== e;
                            }).sort(function(e, t) {
                                return h.indexOf(e) - h.indexOf(t);
                            }), g = b.map(function(e) {
                                return l([
                                    "!",
                                    "purposes",
                                    e,
                                    "title?"
                                ]) || rt(e);
                            });
                            t = 1 === g.length ? g[0] : [].concat((r = g.slice(0, -2), function(e) {
                                if (Array.isArray(e)) return cr(e);
                            }(r) || function(e) {
                                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                            }(r) || function(e, t) {
                                if (e) {
                                    if ("string" == typeof e) return cr(e, t);
                                    var r = Object.prototype.toString.call(e).slice(8, -1);
                                    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? cr(e, t) : void 0;
                                }
                            }(r) || function() {
                                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }()), [
                                g.slice(-2).join(" & ")
                            ]).join(", "), void 0 !== a.privacyPolicy ? "string" == typeof a.privacyPolicy ? e = a.privacyPolicy : "object" === sr(a.privacyPolicy) && (e = a.privacyPolicy[o] || a.privacyPolicy.default) : void 0 !== (e = l([
                                "!",
                                "privacyPolicyUrl"
                            ], {
                                lang: o
                            })) && (e = e.join(""));
                            var _, w = function(e) {
                                e.preventDefault(), n.setState({
                                    modal: !0
                                });
                            };
                            if (c.changed && (_ = Qe.createElement("p", {
                                className: "cn-changes"
                            }, l([
                                "consentNotice",
                                "changeDescription"
                            ]))), !s && !u && !f) return Qe.createElement("div", null);
                            var k, S = (!a.mustConsent || m) && !c.confirmed && !a.noNotice, j = a.hideDeclineAll ? "" : Qe.createElement("button", {
                                className: "cm-btn cm-btn-danger cn-decline",
                                type: "button",
                                onClick: this.declineAndHide
                            }, l([
                                "decline"
                            ])), x = a.acceptAll ? Qe.createElement("button", {
                                className: "cm-btn cm-btn-success",
                                type: "button",
                                onClick: this.acceptAndHide
                            }, l([
                                "ok"
                            ])) : Qe.createElement("button", {
                                className: "cm-btn cm-btn-success",
                                type: "button",
                                onClick: this.saveAndHide
                            }, l([
                                "ok"
                            ])), O = function() {
                                return m ? Qe.createElement("button", {
                                    key: "learnMoreLink",
                                    className: "cm-btn cm-btn-lern-more cm-btn-info",
                                    type: "button",
                                    onClick: w
                                }, l([
                                    "consentNotice",
                                    "learnMore"
                                ])) : Qe.createElement("a", {
                                    key: "learnMoreLink",
                                    className: "cm-link cn-learn-more",
                                    href: "#",
                                    onClick: w
                                }, l([
                                    "consentNotice",
                                    "learnMore"
                                ]));
                            };
                            if (void 0 !== e && (k = Qe.createElement("a", {
                                key: "ppLink",
                                href: e
                            }, l([
                                "privacyPolicy",
                                "name"
                            ]))), d || c.confirmed && !u || !c.confirmed && a.mustConsent) return Qe.createElement(ir, {
                                t: l,
                                lang: o,
                                config: a,
                                hide: function() {
                                    a.mustConsent && !a.acceptAll || (c.confirmed && !u ? n.props.hide() : n.setState({
                                        modal: !1
                                    }), setTimeout(function() {
                                        n.noticeRef && n.noticeRef.focus();
                                    }, 1));
                                },
                                confirming: f,
                                declineAndHide: this.declineAndHide,
                                saveAndHide: this.saveAndHide,
                                acceptAndHide: this.acceptAndHide,
                                manager: c
                            });
                            var E = Qe.createElement("div", {
                                role: "dialog",
                                "aria-describedby": "id-cookie-notice",
                                "aria-labelledby": "id-cookie-title",
                                id: "klaro-cookie-notice",
                                tabIndex: "0",
                                autoFocus: !0,
                                ref: function(e) {
                                    n.noticeRef = e;
                                },
                                className: "cookie-notice ".concat(S || u ? "" : "cookie-notice-hidden", " ").concat(m ? "cookie-modal-notice" : "", " ").concat(v ? "cn-embedded" : "")
                            }, Qe.createElement("div", {
                                className: "cn-body"
                            }, l([
                                "!",
                                "consentNotice",
                                "title"
                            ]) && a.showNoticeTitle && Qe.createElement("h2", {
                                id: "id-cookie-title"
                            }, l([
                                "consentNotice",
                                "title"
                            ])), Qe.createElement("p", {
                                id: "id-cookie-notice"
                            }, Qe.createElement(lt, {
                                config: a,
                                text: l([
                                    "consentNotice",
                                    "description"
                                ], {
                                    purposes: Qe.createElement("strong", {
                                        key: "strong"
                                    }, t),
                                    privacyPolicy: k,
                                    learnMoreLink: O()
                                })
                            })), u && Qe.createElement("p", null, l([
                                "consentNotice",
                                "testing"
                            ])), _, Qe.createElement("div", {
                                className: "cn-ok"
                            }, !y && O(), Qe.createElement("div", {
                                className: "cn-buttons"
                            }, j, x))));
                            return m ? Qe.createElement("div", {
                                id: "cookieScreen",
                                className: "cookie-modal"
                            }, Qe.createElement("div", {
                                className: "cm-bg"
                            }), E) : E;
                        }
                    }
                ], n && ur(r.prototype, n), Object.defineProperty(r, "prototype", {
                    writable: !1
                }), t;
            }(Qe.Component);
            function br(e) {
                return br = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, br(e);
            }
            function gr(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _r(n.key), n);
                }
            }
            function _r(e) {
                var t = function(e, t) {
                    if ("object" != br(e) || !e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, "string");
                        if ("object" != br(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == br(t) ? t : String(t);
            }
            function wr(e, t, r) {
                return t = Sr(t), function(e, t) {
                    if (t && ("object" === br(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return jr(e);
                }(e, kr() ? Reflect.construct(t, r || [], Sr(e).constructor) : t.apply(e, r));
            }
            function kr() {
                try {
                    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                } catch (e) {}
                return (kr = function() {
                    return !!e;
                })();
            }
            function Sr(e) {
                return Sr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, Sr(e);
            }
            function jr(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function xr(e, t) {
                return xr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                }, xr(e, t);
            }
            var Or = function(e) {
                function t(e) {
                    var r;
                    return function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), r = wr(this, t, [
                        e
                    ]), e.manager.watch(jr(r)), r.state = {
                        show: e.show > 0 || !e.manager.confirmed
                    }, r;
                }
                var r, n;
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && xr(e, t);
                }(t, e), r = t, n = [
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.props.manager.unwatch(this);
                        }
                    },
                    {
                        key: "update",
                        value: function(e, t) {
                            e === this.props.manager && "applyConsents" === t && (!this.props.config.embedded && this.props.manager.confirmed ? this.setState({
                                show: !1
                            }) : this.forceUpdate());
                        }
                    },
                    {
                        key: "notifyApi",
                        value: function() {
                            var e = this.props, t = e.api, r = e.modal, n = e.show, i = e.config;
                            if (void 0 !== t) {
                                if (r || n > 0) return;
                                this.props.manager.confirmed || this.props.manager.auxiliaryStore.getWithKey("shown-before") || (t.update(this, "showNotice", {
                                    config: i
                                }), this.props.manager.auxiliaryStore.setWithKey("shown-before", !0));
                            }
                        }
                    },
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.notifyApi();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function(e) {
                            if (e.show !== this.props.show) {
                                this.notifyApi();
                                var t = this.props.show > 0 || !this.props.manager.confirmed;
                                t !== this.state.show && this.setState({
                                    show: t
                                });
                            }
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this, t = this.props, r = t.config, n = t.t, i = t.lang, o = t.testing, a = t.manager, s = t.modal, c = this.state.show, u = r.additionalClass, l = r.embedded, p = r.stylePrefix;
                            return Qe.createElement("div", {
                                lang: i,
                                className: (p || "klaro") + (void 0 !== u ? " " + u : "")
                            }, Qe.createElement(hr, {
                                key: "app-" + this.props.show,
                                t: n,
                                testing: o,
                                show: c,
                                lang: i,
                                modal: s,
                                hide: function() {
                                    l || e.setState({
                                        show: !1
                                    });
                                },
                                config: r,
                                manager: a
                            }));
                        }
                    }
                ], n && gr(r.prototype, n), Object.defineProperty(r, "prototype", {
                    writable: !1
                }), t;
            }(Qe.Component);
            function Er(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                return n;
            }
            const Pr = function(e) {
                var t = e.manager, r = e.style, n = e.config, i = e.t, o = e.lang, a = e.service, s = function(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != r) {
                            var n, i, o, a, s = [], c = !0, u = !1;
                            try {
                                if (o = (r = r.call(e)).next, 0 === t) {
                                    if (Object(r) !== r) return;
                                    c = !1;
                                } else for(; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0);
                            } catch (e) {
                                u = !0, i = e;
                            } finally{
                                try {
                                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return;
                                } finally{
                                    if (u) throw i;
                                }
                            }
                            return s;
                        }
                    }(e, t) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return Er(e, t);
                            var r = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Er(e, t) : void 0;
                        }
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }(ie(0), 2), c = s[0], u = s[1], l = n.additionalClass, p = (n.embedded, n.stylePrefix);
                ae(function() {
                    var e = {
                        update: function() {
                            return u(c + 1);
                        }
                    };
                    return t.watch(e), function() {
                        t.unwatch(e);
                    };
                });
                var f = ut(a.translations || {}, o, "zz", [
                    "!",
                    "title"
                ]) || i([
                    "!",
                    a.name,
                    "title?"
                ]) || rt(a.name);
                return Qe.createElement("div", {
                    lang: o,
                    className: (p || "klaro") + (void 0 !== l ? " " + l : "") + " cm-as-context-notice"
                }, Qe.createElement("div", {
                    className: "context-notice" + (void 0 !== r ? " cm-".concat(r) : "")
                }, Qe.createElement("p", null, i([
                    "contextualConsent",
                    "description"
                ], {
                    title: f
                })), Qe.createElement("p", {
                    className: "cm-buttons"
                }, Qe.createElement("button", {
                    className: "cm-btn cm-btn-success",
                    type: "button",
                    onClick: function() {
                        t.updateConsent(a.name, !0), t.applyConsents(!1, !0, a.name), t.updateConsent(a.name, !1);
                    }
                }, i([
                    "contextualConsent",
                    "acceptOnce"
                ])), null !== t.store.get() ? Qe.createElement("button", {
                    className: "cm-btn cm-btn-success-var",
                    type: "button",
                    onClick: function() {
                        t.updateConsent(a.name, !0), t.confirmed ? (t.saveConsents("contextual-accept"), t.applyConsents(!1, !0, a.name)) : t.applyConsents(!1, !0, a.name);
                    }
                }, i([
                    "contextualConsent",
                    "acceptAlways"
                ])) : ""), null === t.store.get() && n.showDescriptionEmptyStore ? Qe.createElement(Qe.Fragment, null, Qe.createElement("p", {
                    className: "ccn-description-empty-store"
                }, i([
                    "contextualConsent",
                    "descriptionEmptyStore"
                ], {
                    title: f,
                    link: Qe.createElement("a", {
                        key: "modalLink",
                        className: "ccn-modal-link",
                        href: "#",
                        onClick: function(e) {
                            e.preventDefault(), fn(n, !0);
                        }
                    }, i([
                        "contextualConsent",
                        "modalLinkText"
                    ]))
                }))) : ""));
            };
            var Ar = r(2690);
            function zr(e) {
                return zr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, zr(e);
            }
            function Cr(e, t) {
                var r = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(e);
                    t && (n = n.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function Tr(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Cr(Object(r), !0).forEach(function(t) {
                        var n, i, o;
                        n = e, i = t, o = r[t], (i = Ir(i)) in n ? Object.defineProperty(n, i, {
                            value: o,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : n[i] = o;
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Cr(Object(r)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                    });
                }
                return e;
            }
            function Nr(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ir(n.key), n);
                }
            }
            function Ir(e) {
                var t = function(e, t) {
                    if ("object" != zr(e) || !e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, "string");
                        if ("object" != zr(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == zr(t) ? t : String(t);
            }
            r(76);
            var Dr = function() {
                function e(t, r, n) {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), this.url = t, this.id = r, this.opts = Object.assign({}, n);
                }
                var t, r;
                return t = e, r = [
                    {
                        key: "getLocationData",
                        value: function(e) {
                            var t = e.records || {};
                            return {
                                pathname: void 0 === t.savePathname || t.savePathname ? location.pathname : void 0,
                                port: "" !== location.port ? parseInt(location.port) : 0,
                                hostname: location.hostname,
                                protocol: location.protocol.slice(0, location.protocol.length - 1)
                            };
                        }
                    },
                    {
                        key: "getUserData",
                        value: function() {
                            return {
                                client_version: yn(),
                                client_name: "klaro:web"
                            };
                        }
                    },
                    {
                        key: "getBaseConsentData",
                        value: function(e) {
                            return {
                                location_data: this.getLocationData(e),
                                user_data: this.getUserData(e)
                            };
                        }
                    },
                    {
                        key: "update",
                        value: function(e, t, r) {
                            if ("saveConsents" === t) {
                                if ("save" === r.type && 0 === Object.keys(r.changes).length) return;
                                var n = Tr(Tr({}, this.getBaseConsentData(e.config)), {}, {
                                    consent_data: {
                                        consents: r.consents,
                                        changes: "save" === r.type ? r.changes : void 0,
                                        type: r.type,
                                        config: e.config.id
                                    }
                                });
                                this.submitConsentData(n);
                            } else if ("showNotice" === t) {
                                var i = Tr(Tr({}, this.getBaseConsentData(r.config)), {}, {
                                    consent_data: {
                                        consents: {},
                                        changes: {},
                                        type: "show",
                                        config: r.config.id
                                    }
                                });
                                this.submitConsentData(i);
                            }
                        }
                    },
                    {
                        key: "apiRequest",
                        value: function(e, t, r, n) {
                            var i = this;
                            return new Promise(function(o, a) {
                                var s, c, u = new XMLHttpRequest;
                                u.addEventListener("load", function() {
                                    var e = JSON.parse(u.response);
                                    u.status < 200 || u.status >= 300 ? (e.status = u.status, a(e)) : o(e, u.status);
                                }), u.addEventListener("error", function() {
                                    a({
                                        status: 0,
                                        xhr: u
                                    });
                                }), void 0 !== r && ("GET" === e ? t += "?" + (c = r, "?" + Object.keys(c).map(function(e) {
                                    return e + "=" + encodeURIComponent(c[e]);
                                }).join("&")) : s = JSON.stringify(r)), u.open(e, i.url + t), void 0 !== s && u.setRequestHeader("Content-Type", n || "application/json;charset=UTF-8"), u.send(s);
                            });
                        }
                    },
                    {
                        key: "submitConsentData",
                        value: function(e) {
                            return this.apiRequest("POST", "/v1/privacy-managers/" + this.id + "/submit", e, "text/plain;charset=UTF-8");
                        }
                    },
                    {
                        key: "loadConfig",
                        value: function(e) {
                            return this.apiRequest("GET", "/v1/privacy-managers/" + this.id + "/config.json?name=" + e + (this.opts.testing ? "&testing=true" : ""));
                        }
                    },
                    {
                        key: "loadConfigs",
                        value: function() {
                            return this.apiRequest("GET", "/v1/privacy-managers/" + this.id + "/configs.json" + (this.opts.testing ? "&testing=true" : ""));
                        }
                    }
                ], Nr(t.prototype, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e;
            }(), Rr = (r(7132), r(4062), r(5482));
            function Mr(e, t) {
                return function(e) {
                    if (Array.isArray(e)) return e;
                }(e) || function(e, t) {
                    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (null != r) {
                        var n, i, o, a, s = [], c = !0, u = !1;
                        try {
                            if (o = (r = r.call(e)).next, 0 === t) {
                                if (Object(r) !== r) return;
                                c = !1;
                            } else for(; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0);
                        } catch (e) {
                            u = !0, i = e;
                        } finally{
                            try {
                                if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return;
                            } finally{
                                if (u) throw i;
                            }
                        }
                        return s;
                    }
                }(e, t) || qr(e, t) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function qr(e, t) {
                if (e) {
                    if ("string" == typeof e) return Ur(e, t);
                    var r = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ur(e, t) : void 0;
                }
            }
            function Ur(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                return n;
            }
            function Lr(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                return n;
            }
            function Fr(e) {
                for(var t = new Map([]), r = 0, n = Object.keys(e); r < n.length; r++){
                    var i = n[r], o = e[i];
                    "string" == typeof i && ("string" == typeof o || null === o ? t.set(i, o) : t.set(i, Fr(o)));
                }
                return t;
            }
            function Br(e, t, r, n) {
                var i = function(e, t, r) {
                    if (r instanceof Map) {
                        var n = new Map([]);
                        Br(n, r, !0, !1), e.set(t, n);
                    } else e.set(t, r);
                };
                if (!(t instanceof Map && e instanceof Map)) throw new Error("Parameters are not maps!");
                void 0 === r && (r = !0), void 0 === n && (n = !1), n && (e = new e.constructor(e));
                var o, a = function(e, t) {
                    var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!r) {
                        if (Array.isArray(e) || (r = function(e, t) {
                            if (e) {
                                if ("string" == typeof e) return Lr(e, t);
                                var r = Object.prototype.toString.call(e).slice(8, -1);
                                return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Lr(e, t) : void 0;
                            }
                        }(e)) || t && e && "number" == typeof e.length) {
                            r && (e = r);
                            var n = 0, i = function() {};
                            return {
                                s: i,
                                n: function() {
                                    return n >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[n++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: i
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var o, a = !0, s = !1;
                    return {
                        s: function() {
                            r = r.call(e);
                        },
                        n: function() {
                            var e = r.next();
                            return a = e.done, e;
                        },
                        e: function(e) {
                            s = !0, o = e;
                        },
                        f: function() {
                            try {
                                a || null == r.return || r.return();
                            } finally{
                                if (s) throw o;
                            }
                        }
                    };
                }(t.keys());
                try {
                    for(a.s(); !(o = a.n()).done;){
                        var s = o.value, c = t.get(s), u = e.get(s);
                        if (e.has(s)) {
                            if (c instanceof Map && u instanceof Map) e.set(s, Br(u, c, r, n));
                            else {
                                if (!r) continue;
                                i(e, s, c);
                            }
                        } else i(e, s, c);
                    }
                } catch (e) {
                    a.e(e);
                } finally{
                    a.f();
                }
                return e;
            }
            var Hr, Vr = {
                top: {
                    _meta: {
                        incompatibleWith: [
                            "bottom"
                        ]
                    },
                    "notice-top": "20px",
                    "notice-bottom": "auto"
                },
                bottom: {
                    _meta: {
                        incompatibleWith: [
                            "top"
                        ]
                    },
                    "notice-bottom": "20px",
                    "notice-top": "auto"
                },
                left: {
                    _meta: {
                        incompatibleWith: [
                            "wide"
                        ]
                    },
                    "notice-left": "20px",
                    "notice-right": "auto"
                },
                right: {
                    _meta: {
                        incompatibleWith: [
                            "wide"
                        ]
                    },
                    "notice-right": "20px",
                    "notice-left": "auto"
                },
                wide: {
                    "notice-left": "20px",
                    "notice-right": "auto",
                    "notice-max-width": "calc(100vw - 60px)",
                    "notice-position": "fixed"
                },
                light: {
                    "button-text-color": "#fff",
                    dark1: "#fafafa",
                    dark2: "#777",
                    dark3: "#555",
                    light1: "#444",
                    light2: "#666",
                    light3: "#111",
                    green3: "#f00"
                }
            };
            function Wr(e) {
                return Wr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, Wr(e);
            }
            function Kr(e, t) {
                var r = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(e);
                    t && (n = n.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function $r(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Kr(Object(r), !0).forEach(function(t) {
                        var n, i, o;
                        n = e, i = t, o = r[t], i = function(e) {
                            var t = function(e, t) {
                                if ("object" != Wr(e) || !e) return e;
                                var r = e[Symbol.toPrimitive];
                                if (void 0 !== r) {
                                    var n = r.call(e, "string");
                                    if ("object" != Wr(n)) return n;
                                    throw new TypeError("@@toPrimitive must return a primitive value.");
                                }
                                return String(e);
                            }(e);
                            return "symbol" == Wr(t) ? t : String(t);
                        }(i), i in n ? Object.defineProperty(n, i, {
                            value: o,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : n[i] = o;
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Kr(Object(r)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                    });
                }
                return e;
            }
            function Gr(e, t) {
                var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (!r) {
                    if (Array.isArray(e) || (r = Zr(e)) || t && e && "number" == typeof e.length) {
                        r && (e = r);
                        var n = 0, i = function() {};
                        return {
                            s: i,
                            n: function() {
                                return n >= e.length ? {
                                    done: !0
                                } : {
                                    done: !1,
                                    value: e[n++]
                                };
                            },
                            e: function(e) {
                                throw e;
                            },
                            f: i
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var o, a = !0, s = !1;
                return {
                    s: function() {
                        r = r.call(e);
                    },
                    n: function() {
                        var e = r.next();
                        return a = e.done, e;
                    },
                    e: function(e) {
                        s = !0, o = e;
                    },
                    f: function() {
                        try {
                            a || null == r.return || r.return();
                        } finally{
                            if (s) throw o;
                        }
                    }
                };
            }
            function Zr(e, t) {
                if (e) {
                    if ("string" == typeof e) return Yr(e, t);
                    var r = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Yr(e, t) : void 0;
                }
            }
            function Yr(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                return n;
            }
            var Jr = new Map([]), Xr = {}, Qr = {};
            function en(e, t) {
                return (e.elementID || "klaro") + (t ? "-ide" : "");
            }
            function tn(e, t) {
                var r = en(e, t), n = document.getElementById(r);
                return null === n && ((n = document.createElement("div")).id = r, document.body.appendChild(n)), n;
            }
            function rn(e, t) {
                if (void 0 === Xr[e] ? Xr[e] = [
                    t
                ] : Xr[e].push(t), void 0 !== Qr[e]) {
                    var r, n = Gr(Qr[e]);
                    try {
                        for(n.s(); !(r = n.n()).done;){
                            var i = r.value;
                            if (!1 === t.apply(void 0, function(e) {
                                if (Array.isArray(e)) return Yr(e);
                            }(o = i) || function(e) {
                                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                            }(o) || Zr(o) || function() {
                                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }())) break;
                        }
                    } catch (e) {
                        n.e(e);
                    } finally{
                        n.f();
                    }
                }
                var o;
            }
            function nn(e) {
                for(var t = Xr[e], r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                if (void 0 === Qr[e] ? Qr[e] = [
                    n
                ] : Qr[e].push(n), void 0 !== t) {
                    var o, a = Gr(t);
                    try {
                        for(a.s(); !(o = a.n()).done;)if (!0 === o.value.apply(void 0, n)) return !0;
                    } catch (e) {
                        a.e(e);
                    } finally{
                        a.f();
                    }
                }
            }
            function on(e) {
                var t = new Map([]);
                return Br(t, Jr), Br(t, Fr(e.translations || {})), t;
            }
            var an = 1;
            function sn(e, t) {
                if (void 0 !== e) {
                    t = t || {}, nn("render", e = ln(e), t);
                    var r = 0;
                    t.show && (r = an++);
                    var n = tn(e), i = mn(e);
                    void 0 !== t.api && i.watch(t.api), function(e, t, r) {
                        if (void 0 !== e.styling) {
                            var n = Object.assign({}, e.styling);
                            if (void 0 !== n.theme) {
                                var i = n.theme;
                                i instanceof Array || (i = [
                                    i
                                ]), n = {};
                                var o, a = function(e, t) {
                                    var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                    if (!r) {
                                        if (Array.isArray(e) || (r = qr(e))) {
                                            r && (e = r);
                                            var n = 0, i = function() {};
                                            return {
                                                s: i,
                                                n: function() {
                                                    return n >= e.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e[n++]
                                                    };
                                                },
                                                e: function(e) {
                                                    throw e;
                                                },
                                                f: i
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var o, a = !0, s = !1;
                                    return {
                                        s: function() {
                                            r = r.call(e);
                                        },
                                        n: function() {
                                            var e = r.next();
                                            return a = e.done, e;
                                        },
                                        e: function(e) {
                                            s = !0, o = e;
                                        },
                                        f: function() {
                                            try {
                                                a || null == r.return || r.return();
                                            } finally{
                                                if (s) throw o;
                                            }
                                        }
                                    };
                                }(i);
                                try {
                                    for(a.s(); !(o = a.n()).done;){
                                        var s = t[o.value];
                                        if (void 0 !== s) for(var c = 0, u = Object.entries(s); c < u.length; c++){
                                            var l = Mr(u[c], 2), p = l[0], f = l[1];
                                            p.startsWith("_") || (n[p] = f);
                                        }
                                    }
                                } catch (e) {
                                    a.e(e);
                                } finally{
                                    a.f();
                                }
                                for(var d = 0, v = Object.entries(e.styling); d < v.length; d++){
                                    var m = Mr(v[d], 2), y = m[0], h = m[1];
                                    "theme" !== y && (n[y] = h);
                                }
                            }
                            void 0 === r && (r = document.documentElement);
                            for(var b = 0, g = Object.entries(n); b < g.length; b++){
                                var _ = Mr(g[b], 2), w = _[0], k = _[1];
                                r.style.setProperty("--" + w, k);
                            }
                            window.document.documentMode && r === document.documentElement && (0, Rr.N3)(n);
                        }
                    }(e, Vr, n);
                    var o = st(e), a = on(e), s = function() {
                        for(var t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                        return ut.apply(void 0, [
                            a,
                            o,
                            e.fallbackLang || "zz"
                        ].concat(r));
                    }, c = Ue(Qe.createElement(Or, {
                        t: s,
                        lang: o,
                        manager: i,
                        config: e,
                        testing: t.testing,
                        modal: t.modal,
                        api: t.api,
                        show: r
                    }), n);
                    return cn(i, s, o, e, t), c;
                }
            }
            function cn(e, t, r, n, i) {
                var o, a = [], s = Gr(n.services);
                try {
                    for(s.s(); !(o = s.n()).done;){
                        var c, u = o.value, l = e.getConsent(u.name) && e.confirmed, p = Gr(document.querySelectorAll("[data-name='" + u.name + "']"));
                        try {
                            for(p.s(); !(c = p.n()).done;){
                                var f = c.value, d = (0, Rr.RT)(f);
                                if ("placeholder" !== d.type && ("IFRAME" === f.tagName || "DIV" === f.tagName)) {
                                    var v = f.previousElementSibling;
                                    if (null !== v) {
                                        var m = (0, Rr.RT)(v);
                                        "placeholder" === m.type && m.name === u.name || (v = null);
                                    }
                                    if (null === v) {
                                        (v = document.createElement("DIV")).style.maxWidth = f.width + "px", v.style.height = f.height + "px", (0, Rr.X7)({
                                            type: "placeholder",
                                            name: u.name
                                        }, v), l && (v.style.display = "none"), f.parentElement.insertBefore(v, f);
                                        var y = Ue(Qe.createElement(Pr, {
                                            t: t,
                                            lang: r,
                                            manager: e,
                                            config: n,
                                            service: u,
                                            style: d.style,
                                            testing: i.testing,
                                            api: i.api
                                        }), v);
                                        a.push(y);
                                    }
                                    "IFRAME" === f.tagName && (d.src = f.src), void 0 === d["modified-by-klaro"] && void 0 === f.style.display && (d["original-display"] = f.style.display), d["modified-by-klaro"] = "yes", (0, Rr.X7)(d, f), l || (f.src = "", f.style.display = "none");
                                }
                            }
                        } catch (e) {
                            p.e(e);
                        } finally{
                            p.f();
                        }
                    }
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
                return a;
            }
            function un(e) {
                /complete|interactive|loaded/.test(document.readyState) ? e() : window.addEventListener("DOMContentLoaded", e);
            }
            function ln(e) {
                var t = $r({}, e);
                return 2 === t.version || (void 0 !== t.apps && void 0 === t.services && (t.services = t.apps, console.warn("Warning, your configuration file is outdated. Please change `apps` to `services`"), delete t.apps), void 0 !== t.translations && void 0 !== t.translations.apps && void 0 === t.services && (t.translations.services = t.translations.apps, console.warn("Warning, your configuration file is outdated. Please change `apps` to `services` in the `translations` key"), delete t.translations.apps)), t;
            }
            function pn(e) {
                if (void 0 !== window) {
                    var t = (0, Rr.XZ)("klaro"), r = new Map(decodeURI(location.hash.slice(1)).split("&").map(function(e) {
                        return e.split("=");
                    }).map(function(e) {
                        return 1 === e.length ? [
                            e[0],
                            !0
                        ] : e;
                    })), n = r.get("klaro-testing"), i = function(e) {
                        var t = $r($r({}, e), {}, {
                            testing: n
                        });
                        Hr.noAutoLoad || Hr.testing && !t.testing || sn(Hr, t);
                    };
                    if (void 0 !== e) Hr = e, un(function() {
                        return i({});
                    });
                    else if (null !== t) {
                        var o = function(e) {
                            var t = e.getAttribute("data-klaro-id");
                            if (null !== t) return t;
                            var r = /.*\/privacy-managers\/([a-f0-9]+)\/klaro.*\.js/.exec(e.src);
                            return null !== r ? r[1] : null;
                        }(t), a = function(e) {
                            var t = e.getAttribute("data-klaro-api-url");
                            if (null !== t) return t;
                            var r = /(http(?:s)?:\/\/[^/]+)\/v1\/privacy-managers\/([a-f0-9]+)\/klaro.*\.js/.exec(e.src);
                            return null !== r ? r[1] : null;
                        }(t), s = function(e, t) {
                            if (e.has("klaro-config")) return e.get("klaro-config");
                            var r = t.getAttribute("data-klaro-config");
                            return null !== r ? r : "default";
                        }(r, t);
                        if (null !== o) {
                            var c = new Dr(a, o, {
                                testing: n
                            });
                            if (void 0 !== window.klaroApiConfigs) {
                                if (!0 === nn("apiConfigsLoaded", window.klaroApiConfigs, c)) return;
                                var u = window.klaroApiConfigs.find(function(e) {
                                    return e.name === s && ("active" === e.status || n);
                                });
                                void 0 !== u ? (Hr = u, un(function() {
                                    return i({
                                        api: c
                                    });
                                })) : nn("apiConfigsFailed", {});
                            } else c.loadConfig(s).then(function(e) {
                                !0 !== nn("apiConfigsLoaded", [
                                    e
                                ], c) && (Hr = e, un(function() {
                                    return i({
                                        api: c
                                    });
                                }));
                            }).catch(function(e) {
                                console.error(e, "cannot load Klaro configs"), nn("apiConfigsFailed", e);
                            });
                        } else {
                            var l = t.getAttribute("data-klaro-config") || "klaroConfig";
                            void 0 !== (Hr = window[l]) && un(function() {
                                return i({});
                            });
                        }
                    }
                    r.has("klaro-ide") && function(e) {
                        var t = /^(.*)(\/[^/]+)$/.exec(e.src)[1] || "", r = document.createElement("script");
                        r.src = "" !== t ? t + "/ide.js" : "ide.js", r.type = "application/javascript";
                        var n, i = Gr(r.attributes);
                        try {
                            for(i.s(); !(n = i.n()).done;){
                                var o = n.value;
                                r.setAttribute(o.name, o.value);
                            }
                        } catch (e) {
                            i.e(e);
                        } finally{
                            i.f();
                        }
                        document.head.appendChild(r);
                    }(t);
                }
            }
            function fn(e, t, r) {
                return sn(e = e || Hr, {
                    show: !0,
                    modal: t,
                    api: r
                }), !1;
            }
            var dn = {};
            function vn() {
                for(var e in Object.keys(dn))delete dn[e];
            }
            function mn(e) {
                var t = (e = e || Hr).storageName || e.cookieName || "default";
                return void 0 === dn[t] && (dn[t] = new Ar.default(ln(e))), dn[t];
            }
            function yn() {
                return "unknown";
            }
            var hn = Fr({
                ca: {
                    acceptAll: "Accepta-les totes",
                    acceptSelected: "Accepta les escollides",
                    service: {
                        disableAll: {
                            description: "Useu aquest bot\xf3 per a habilitar o deshabilitar totes les aplicacions.",
                            title: "Habilita/deshabilita totes les aplicacions"
                        },
                        optOut: {
                            description: "Aquesta aplicaci\xf3 es carrega per defecte, per\xf2 podeu desactivar-la",
                            title: "(opt-out)"
                        },
                        purpose: "Finalitat",
                        purposes: "Finalitats",
                        required: {
                            description: "Aquesta aplicaci\xf3 es necessita sempre",
                            title: "(necess\xe0ria)"
                        }
                    },
                    close: "Tanca",
                    consentModal: {
                        description: "Aqu\xed podeu veure i personalitzar la informaci\xf3 que recopilem sobre v\xf3s.",
                        privacyPolicy: {
                            name: "pol\xedtica de privadesa",
                            text: "Per a m\xe9s informaci\xf3, consulteu la nostra {privacyPolicy}."
                        },
                        title: "Informaci\xf3 que recopilem"
                    },
                    consentNotice: {
                        changeDescription: "Hi ha hagut canvis des de la vostra darrera visita. Actualitzeu el vostre consentiment.",
                        description: "Recopilem i processem la vostra informaci\xf3 personal amb les seg\xfcents finalitats: {purposes}.",
                        imprint: {
                            name: "Empremta"
                        },
                        learnMore: "Saber-ne m\xe9s",
                        privacyPolicy: {
                            name: "pol\xedtica de privadesa"
                        }
                    },
                    decline: "Rebutja",
                    ok: "Accepta",
                    poweredBy: "Funciona amb Klaro!",
                    purposeItem: {
                        service: "aplicaci\xf3",
                        services: "aplicacions"
                    },
                    save: "Desa"
                },
                cs: {
                    privacyPolicy: {
                        name: "z\xe1sady ochrany soukrom\xed",
                        text: 'Pro dal\u0161\xed informace si p\u0159e\u010Dtete na\u0161e <tr-hint v="privacy policy">{privacyPolicy}</tr-hint>.'
                    },
                    consentModal: {
                        title: "Slu\u017Eby, kter\xe9 bychom r\xe1di vyu\u017Eili",
                        description: "Zde m\u016F\u017Eete posoudit a p\u0159izp\u016Fsobit slu\u017Eby, kter\xe9 bychom r\xe1di na tomto webu pou\u017E\xedvali. M\xe1te to pod kontrolou! Povolte nebo zaka\u017Ete slu\u017Eby, jak uzn\xe1te za vhodn\xe9."
                    },
                    consentNotice: {
                        testing: "Testing mode!",
                        changeDescription: "Od va\u0161\xed posledn\xed n\xe1v\u0161t\u011Bvy do\u0161lo ke zm\u011Bn\xe1m, obnovte pros\xedm sv\u016Fj souhlas.",
                        description: "\u201EDobr\xfd den! M\u016F\u017Eeme povolit n\u011Bkter\xe9 dal\u0161\xed slu\u017Eby pro {purposes}? Sv\u016Fj souhlas m\u016F\u017Eete kdykoliv zm\u011Bnit nebo odvolat.\u201C",
                        "learnMore|capitalize": "Vyberu si"
                    },
                    "\xfa\u010Dely": {
                        functional: {
                            "title|capitalize": "Poskytov\xe1n\xed slu\u017Eeb",
                            description: "Tyto slu\u017Eby jsou nezbytn\xe9 pro spr\xe1vn\xe9 fungov\xe1n\xed tohoto webu. Nelze je zde deaktivovat, proto\u017Ee slu\u017Eba by jinak nefungovala spr\xe1vn\u011B.\n"
                        },
                        performance: {
                            "title|capitalize": "Optimalizace v\xfdkonu",
                            description: "V r\xe1mci t\u011Bchto slu\u017Eeb jsou zpracov\xe1v\xe1ny osobn\xed \xfadaje za \xfa\u010Delem optimalizace slu\u017Eeb, kter\xe9 jsou na tomto webu poskytov\xe1ny.\n"
                        },
                        marketing: {
                            "title|capitalize": "Marketing",
                            description: "V r\xe1mci t\u011Bchto slu\u017Eeb jsou zpracov\xe1v\xe1ny osobn\xed \xfadaje, aby se v\xe1m zobrazoval relevantn\xed obsah o produktech, slu\u017Eb\xe1ch nebo t\xe9matech, kter\xe9 by v\xe1s mohly zaj\xedmat."
                        },
                        advertising: {
                            "title|capitalize": "Reklama",
                            description: "V r\xe1mci t\u011Bchto slu\u017Eeb jsou zpracov\xe1v\xe1ny osobn\xed \xfadaje, aby v\xe1m zobrazovaly personalizovan\xe9 nebo z\xe1jmov\u011B orientovan\xe9 reklamy."
                        }
                    },
                    purposeItem: {
                        service: "Jednoduch\xe1 slu\u017Eba <tr-snip></tr-snip> , kterou nainstaluji do sv\xe9ho po\u010D\xedta\u010De.",
                        services: "N\u011Bkolik jednoduch\xfdch slu\u017Eeb <tr-snip></tr-snip> , kter\xe9 nainstaluji do sv\xe9ho po\u010D\xedta\u010De."
                    },
                    "ok|capitalize": "To je v po\u0159\xe1dku",
                    save: "ulo\u017Eit",
                    "decline|capitalize": "Nep\u0159ij\xedm\xe1m",
                    close: "zav\u0159\xedt",
                    acceptAll: "p\u0159ijmout v\u0161e",
                    acceptSelected: "p\u0159ijmout vybran\xe9",
                    service: {
                        disableAll: {
                            title: "povolit nebo zak\xe1zat v\u0161echny slu\u017Eby",
                            description: "Pomoc\xed tohoto p\u0159ep\xedna\u010De m\u016F\u017Eete povolit nebo zak\xe1zat v\u0161echny slu\u017Eby."
                        },
                        optOut: {
                            title: "(opt-out)",
                            description: "Tato slu\u017Eba se na\u010D\xedt\xe1 ve v\xfdchoz\xedm nastaven\xed (ale m\u016F\u017Eete ji zru\u0161it)"
                        },
                        required: {
                            title: "(v\u017Edy vy\u017Eadov\xe1no)",
                            description: "Tato slu\u017Eba je v\u017Edy vy\u017Eadov\xe1na"
                        },
                        purposes: "Zpracov\xe1n\xed  pro \xfa\u010Dely <tr-snip></tr-snip>",
                        purpose: "Zpracov\xe1n\xed pro \xfa\u010Dely <tr-snip></tr-snip>"
                    },
                    poweredBy: "Realizov\xe1no pomoc\xed Klaro!",
                    contextualConsent: {
                        description: "Chcete na\u010D\xedst extern\xed obsah dod\xe1van\xfd prost\u0159ednictv\xedm {title}?",
                        acceptOnce: "Ano",
                        acceptAlways: "V\u017Edy"
                    }
                },
                da: {
                    acceptAll: "Tillad alle",
                    acceptSelected: "Tillad udvalgte",
                    service: {
                        disableAll: {
                            description: "Brug denne kontakt til at aktivere/deaktivere alle apps.",
                            title: "Aktiver/deaktiver alle applikatione"
                        },
                        optOut: {
                            description: "Denne applikation indl\xe6ses som standard (men du kan deaktivere den)",
                            title: "Opt-Out"
                        },
                        purpose: "Form\xe5l",
                        purposes: "Form\xe5l",
                        required: {
                            description: "Denne applikation er altid n\xf8dvendig",
                            title: "(Altid n\xf8dvendig)"
                        }
                    },
                    close: "Luk",
                    consentModal: {
                        description: "Her kan du se og \xe6ndre, hvilke informationer vi gemmer om dig.",
                        privacyPolicy: {
                            name: "Flere informationer finde du under {privacyPolicy}",
                            text: "databeskyttelseserkl\xe6ring."
                        },
                        title: "Informationer, som vi gemmer"
                    },
                    consentNotice: {
                        changeDescription: "Der har v\xe6ret \xe6ndringer siden dit sidste bes\xf8g. Opdater dit valg.",
                        description: "Vi gemmer og behandler dine personlige oplysninger til f\xf8lgende form\xe5l: {purposes}.",
                        imprint: {
                            name: ""
                        },
                        learnMore: "L\xe6s mere",
                        privacyPolicy: {
                            name: "Datenschutzerkl\xe4rung"
                        }
                    },
                    decline: "Afvis",
                    ok: "Ok",
                    poweredBy: "Realiseret med Klaro!",
                    purposeItem: {
                        service: "",
                        services: ""
                    },
                    save: "Gem"
                },
                de: {
                    acceptAll: "Alle akzeptieren",
                    acceptSelected: "Ausgew\xe4hlte akzeptieren",
                    close: "Schlie\xdfen",
                    consentModal: {
                        description: "Hier k\xf6nnen Sie die Dienste, die wir auf dieser Website nutzen m\xf6chten, bewerten und anpassen. Sie haben das Sagen! Aktivieren oder deaktivieren Sie die Dienste, wie Sie es f\xfcr richtig halten.",
                        privacyPolicy: {
                            name: "Datenschutzerkl\xe4rung",
                            text: "Um mehr zu erfahren, lesen Sie bitte unsere {privacyPolicy}."
                        },
                        title: "Dienste, die wir nutzen m\xf6chten"
                    },
                    consentNotice: {
                        changeDescription: "Seit Ihrem letzten Besuch gab es \xc4nderungen, bitte erneuern Sie Ihre Zustimmung.",
                        title: "Cookie-Einstellungen",
                        description: "Hallo! K\xf6nnten wir bitte einige zus\xe4tzliche Dienste f\xfcr {purposes} aktivieren? Sie k\xf6nnen Ihre Zustimmung sp\xe4ter jederzeit \xe4ndern oder zur\xfcckziehen.",
                        imprint: {
                            name: "Impressum"
                        },
                        learnMore: "Lassen Sie mich w\xe4hlen",
                        privacyPolicy: {
                            name: "Datenschutzerkl\xe4rung"
                        },
                        testing: "Testmodus!"
                    },
                    contextualConsent: {
                        acceptAlways: "Immer",
                        acceptOnce: "Ja",
                        description: "M\xf6chten Sie von {title} bereitgestellte externe Inhalte laden?",
                        descriptionEmptyStore: "Um diesem Dienst dauerhaft zustimmen zu k\xf6nnen, m\xfcssen Sie {title} in den {link} zustimmen.",
                        modalLinkText: "Cookie-Einstellungen"
                    },
                    decline: "Ich lehne ab",
                    ok: "Das ist ok",
                    poweredBy: "Realisiert mit Klaro!",
                    privacyPolicy: {
                        name: "Datenschutzerkl\xe4rung",
                        text: "Um mehr zu erfahren, lesen Sie bitte unsere {privacyPolicy}."
                    },
                    purposeItem: {
                        service: "Dienst",
                        services: "Dienste"
                    },
                    purposes: {
                        advertising: {
                            description: "Diese Dienste verarbeiten pers\xf6nliche Informationen, um Ihnen personalisierte oder interessenbezogene Werbung zu zeigen.",
                            title: "Werbung"
                        },
                        functional: {
                            description: "Diese Dienste sind f\xfcr die korrekte Funktion dieser Website unerl\xe4sslich. Sie k\xf6nnen sie hier nicht deaktivieren, da der Dienst sonst nicht richtig funktionieren w\xfcrde.\n",
                            title: "Dienstbereitstellung"
                        },
                        marketing: {
                            description: "Diese Dienste verarbeiten pers\xf6nliche Daten, um Ihnen relevante Inhalte \xfcber Produkte, Dienstleistungen oder Themen zu zeigen, die Sie interessieren k\xf6nnten.",
                            title: "Marketing"
                        },
                        performance: {
                            description: "Diese Dienste verarbeiten personenbezogene Daten, um den von dieser Website angebotenen Service zu optimieren.\n",
                            title: "Optimierung der Leistung"
                        }
                    },
                    save: "Speichern",
                    service: {
                        disableAll: {
                            description: "Mit diesem Schalter k\xf6nnen Sie alle Dienste aktivieren oder deaktivieren.",
                            title: "Alle Dienste aktivieren oder deaktivieren"
                        },
                        optOut: {
                            description: "Diese Dienste werden standardm\xe4\xdfig geladen (Sie k\xf6nnen sich jedoch abmelden)",
                            title: "(Opt-out)"
                        },
                        purpose: "Zweck",
                        purposes: "Zwecke",
                        required: {
                            description: "Dieser Service ist immer erforderlich",
                            title: "(immer erforderlich)"
                        }
                    }
                },
                el: {
                    acceptAll: "",
                    acceptAll_en: "Accept all",
                    acceptSelected: "",
                    acceptSelected_en: "Accept selected",
                    service: {
                        disableAll: {
                            description: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF\u03BD \u03B4\u03B9\u03B1\u03BA\u03CC\u03C0\u03C4\u03B7 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2/\u03B1\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AD\u03C2.",
                            title: "\u0393\u03B9\u03B1 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AD\u03C2"
                        },
                        optOut: {
                            description: "\u0395\u03AF\u03BD\u03B1\u03B9 \u03C0\u03C1\u03BF\u03BA\u03B1\u03B8\u03BF\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03BF \u03BD\u03B1 \u03C6\u03BF\u03C1\u03C4\u03CE\u03BD\u03B5\u03C4\u03B1\u03B9, \u03AC\u03BB\u03BB\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BB\u03B7\u03C6\u03B8\u03B5\u03AF",
                            title: "(\u03BC\u03B7 \u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF)"
                        },
                        purpose: "\u03A3\u03BA\u03BF\u03C0\u03CC\u03C2",
                        purposes: "\u03A3\u03BA\u03BF\u03C0\u03BF\u03AF",
                        required: {
                            description: "\u0394\u03B5\u03BD \u03B3\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03B5\u03B9 \u03C3\u03C9\u03C3\u03C4\u03AC \u03B7 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03C7\u03C9\u03C1\u03AF\u03C2 \u03B1\u03C5\u03C4\u03CC",
                            title: "(\u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF)"
                        }
                    },
                    close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF",
                    consentModal: {
                        description: "\u0395\u03B4\u03CE \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C2 \u03BD\u03B1 \u03B4\u03B5\u03B9\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03C1\u03C5\u03B8\u03BC\u03AF\u03C3\u03B5\u03B9\u03C2 \u03C4\u03B9\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03C3\u03C5\u03BB\u03BB\u03AD\u03B3\u03BF\u03C5\u03BC\u03B5 \u03C3\u03C7\u03B5\u03C4\u03B9\u03BA\u03AC \u03BC\u03B5 \u03B5\u03C3\u03AD\u03BD\u03B1.",
                        privacyPolicy: {
                            name: "\u03A0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AE \u0391\u03C0\u03BF\u03C1\u03C1\u03AE\u03C4\u03BF\u03C5",
                            text: "\u0393\u03B9\u03B1 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03B9\u03B1\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD {privacyPolicy}."
                        },
                        title: "\u03A0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03C3\u03C5\u03BB\u03BB\u03AD\u03B3\u03BF\u03C5\u03BC\u03B5"
                    },
                    consentNotice: {
                        changeDescription: "\u03A0\u03C1\u03B1\u03B3\u03BC\u03B1\u03C4\u03BF\u03C0\u03BF\u03B9\u03AE\u03B8\u03B7\u03BA\u03B1\u03BD \u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2 \u03BC\u03B5\u03C4\u03AC \u03C4\u03B7\u03BD \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u03C3\u03B1\u03C2 \u03B5\u03C0\u03AF\u03C3\u03BA\u03B5\u03C8\u03B7 \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B1\u03BD\u03B1\u03BD\u03B5\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C3\u03C5\u03B3\u03BA\u03B1\u03C4\u03AC\u03B8\u03B5\u03C3\u03B7 \u03C3\u03B1\u03C2.",
                        description: "\u03A3\u03C5\u03B3\u03BA\u03B5\u03BD\u03C4\u03C1\u03CE\u03BD\u03BF\u03C5\u03BC\u03B5 \u03BA\u03B1\u03B9 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B1\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03AC \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03BB\u03CC\u03B3\u03BF\u03C5\u03C2: {purposes}.",
                        imprint: {
                            name: "",
                            name_en: "imprint"
                        },
                        learnMore: "\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1",
                        privacyPolicy: {
                            name: "\u03A0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AE \u0391\u03C0\u03BF\u03C1\u03C1\u03AE\u03C4\u03BF\u03C5"
                        }
                    },
                    decline: "\u0391\u03C0\u03CC\u03C1\u03C1\u03B9\u03C0\u03C4\u03C9",
                    ok: "OK",
                    poweredBy: "\u03A5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C4\u03BF Klaro!",
                    purposeItem: {
                        service: "",
                        services: ""
                    },
                    save: "\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7"
                },
                en: {
                    acceptAll: "Accept all",
                    acceptSelected: "Accept selected",
                    close: "Close",
                    consentModal: {
                        description: "Here you can assess and customize the services that we'd like to use on this website. You're in charge! Enable or disable services as you see fit.",
                        title: "Services we would like to use"
                    },
                    consentNotice: {
                        changeDescription: "There were changes since your last visit, please renew your consent.",
                        title: "Cookie Consent",
                        description: "Hi! Could we please enable some additional services for {purposes}? You can always change or withdraw your consent later.",
                        learnMore: "Let me choose",
                        testing: "Testing mode!"
                    },
                    contextualConsent: {
                        acceptAlways: "Always",
                        acceptOnce: "Yes",
                        description: "Do you want to load external content supplied by {title}?",
                        descriptionEmptyStore: "To agree to this service permanently, you must accept {title} in the {link}.",
                        modalLinkText: "Consent Manager"
                    },
                    decline: "I decline",
                    ok: "That's ok",
                    poweredBy: "Realized with Klaro!",
                    privacyPolicy: {
                        name: "privacy policy",
                        text: "To learn more, please read our {privacyPolicy}."
                    },
                    purposeItem: {
                        service: "service",
                        services: "services"
                    },
                    purposes: {
                        advertising: {
                            description: "These services process personal information to show you personalized or interest-based advertisements.",
                            title: "Advertising"
                        },
                        functional: {
                            description: "These services are essential for the correct functioning of this website. You cannot disable them here as the service would not work correctly otherwise.\n",
                            title: "Service Provision"
                        },
                        marketing: {
                            description: "These services process personal information to show you relevant content about products, services or topics that you might be interested in.",
                            title: "Marketing"
                        },
                        performance: {
                            description: "These services process personal information to optimize the service that this website offers.\n",
                            title: "Performance Optimization"
                        }
                    },
                    save: "Save",
                    service: {
                        disableAll: {
                            description: "Use this switch to enable or disable all services.",
                            title: "Enable or disable all services"
                        },
                        optOut: {
                            description: "This services is loaded by default (but you can opt out)",
                            title: "(opt-out)"
                        },
                        purpose: "purpose",
                        purposes: "purposes",
                        required: {
                            description: "This services is always required",
                            title: "(always required)"
                        }
                    }
                },
                zh: {
                    acceptAll: "\u7167\u5355\u5168\u6536",
                    acceptSelected: "\u63A5\u53D7\u9009\u62E9",
                    close: "\u5BC6\u5207",
                    consentModal: {
                        description: "\u5728\u8FD9\u91CC\uFF0C\u60A8\u53EF\u4EE5\u8BC4\u4F30\u548C\u5B9A\u5236\u6211\u4EEC\u5E0C\u671B\u5728\u672C\u7F51\u7AD9\u4E0A\u4F7F\u7528\u7684\u670D\u52A1\u3002\u60A8\u662F\u8D1F\u8D23\u4EBA\uFF01\u60A8\u53EF\u4EE5\u6839\u636E\u81EA\u5DF1\u7684\u9700\u8981\u542F\u7528\u6216\u7981\u7528\u670D\u52A1\u3002\u542F\u7528\u6216\u7981\u7528\u60A8\u8BA4\u4E3A\u5408\u9002\u7684\u670D\u52A1\u3002",
                        privacyPolicy: {
                            name: "\u9690\u79C1\u653F\u7B56",
                            text: "\u8981\u4E86\u89E3\u66F4\u591A\uFF0C\u8BF7\u9605\u8BFB\u6211\u4EEC\u7684{privacyPolicy} \u3002"
                        },
                        title: "\u6211\u4EEC\u60F3\u4F7F\u7528\u7684\u670D\u52A1"
                    },
                    consentNotice: {
                        changeDescription: "\u81EA\u4E0A\u6B21\u8BBF\u95EE\u540E\u6709\u53D8\u5316\uFF0C\u8BF7\u66F4\u65B0\u60A8\u7684\u540C\u610F\u3002",
                        description: "\u4F60\u597D\uFF01\u6211\u4EEC\u53EF\u4EE5\u4E3A{purposes} \u542F\u7528\u4E00\u4E9B\u989D\u5916\u7684\u670D\u52A1\u5417\uFF1F\u60A8\u53EF\u4EE5\u968F\u65F6\u66F4\u6539\u6216\u64A4\u56DE\u60A8\u7684\u540C\u610F\u3002",
                        imprint: {
                            name: "\u5370\u8BB0"
                        },
                        learnMore: "\u8BA9\u6211\u6765\u9009",
                        privacyPolicy: {
                            name: "\u9690\u79C1\u653F\u7B56"
                        },
                        testing: "\u6D4B\u8BD5\u6A21\u5F0F\uFF01"
                    },
                    contextualConsent: {
                        acceptAlways: "\u603B\u662F",
                        acceptOnce: "\u662F\u7684\uFF0C\u662F\u7684",
                        description: "\u4F60\u60F3\u52A0\u8F7D\u7531{title} \u63D0\u4F9B\u7684\u5916\u90E8\u5185\u5BB9\u5417\uFF1F"
                    },
                    decline: "\u6211\u62D2\u7EDD",
                    ok: "\u6CA1\u4E8B\u7684",
                    poweredBy: "\u4E0EKlaro\u4E00\u8D77\u5B9E\u73B0!",
                    privacyPolicy: {
                        name: "\u9690\u79C1\u653F\u7B56",
                        text: "\u8981\u4E86\u89E3\u66F4\u591A\uFF0C\u8BF7\u9605\u8BFB\u6211\u4EEC\u7684{privacyPolicy} \u3002"
                    },
                    purposeItem: {
                        service: "\u670D\u52A1",
                        services: "\u670D\u52A1"
                    },
                    purposes: {
                        advertising: {
                            description: "\u8FD9\u4E9B\u670D\u52A1\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5411\u60A8\u5C55\u793A\u4E2A\u6027\u5316\u6216\u57FA\u4E8E\u5174\u8DA3\u7684\u5E7F\u544A\u3002",
                            title: "\u5E7F\u544A\u5BA3\u4F20"
                        },
                        functional: {
                            description: "\u8FD9\u4E9B\u670D\u52A1\u5BF9\u4E8E\u672C\u7F51\u7AD9\u7684\u6B63\u5E38\u8FD0\u884C\u662F\u5FC5\u4E0D\u53EF\u5C11\u7684\u3002\u60A8\u4E0D\u80FD\u5728\u8FD9\u91CC\u7981\u7528\u5B83\u4EEC\uFF0C\u5426\u5219\u670D\u52A1\u5C06\u65E0\u6CD5\u6B63\u5E38\u8FD0\u884C\u3002\n",
                            title: "\u670D\u52A1\u63D0\u4F9B"
                        },
                        marketing: {
                            description: "\u8FD9\u4E9B\u670D\u52A1\u4F1A\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5411\u60A8\u5C55\u793A\u60A8\u53EF\u80FD\u611F\u5174\u8DA3\u7684\u4EA7\u54C1\u3001\u670D\u52A1\u6216\u4E3B\u9898\u7684\u76F8\u5173\u5185\u5BB9\u3002",
                            title: "\u5E02\u573A\u8425\u9500"
                        },
                        performance: {
                            description: "\u8FD9\u4E9B\u670D\u52A1\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u662F\u4E3A\u4E86\u4F18\u5316\u672C\u7F51\u7AD9\u63D0\u4F9B\u7684\u670D\u52A1\u3002\n",
                            title: "\u6027\u80FD\u4F18\u5316"
                        }
                    },
                    save: "\u633D\u6551",
                    service: {
                        disableAll: {
                            description: "\u4F7F\u7528\u6B64\u5F00\u5173\u53EF\u542F\u7528\u6216\u7981\u7528\u6240\u6709\u670D\u52A1\u3002",
                            title: "\u542F\u7528\u6216\u505C\u7528\u6240\u6709\u670D\u52A1"
                        },
                        optOut: {
                            description: "\u8FD9\u4E2A\u670D\u52A1\u662F\u9ED8\u8BA4\u52A0\u8F7D\u7684(\u4F46\u4F60\u53EF\u4EE5\u9009\u62E9\u9000\u51FA)",
                            title: "(\u9009\u62E9\u9000\u51FA)"
                        },
                        purpose: "\u76EE\u7684",
                        purposes: "\u76EE\u7684",
                        required: {
                            description: "\u8FD9\u79CD\u670D\u52A1\u662F\u5FC5\u987B\u7684",
                            title: "(\u603B\u662F\u9700\u8981)"
                        }
                    }
                },
                pt: {
                    acceptAll: "Aceitar todos",
                    acceptSelected: "Aceitar selecionados",
                    close: "Fechar",
                    consentModal: {
                        description: "Aqui voc\xea pode avaliar e personalizar os servi\xe7os que gostar\xedamos de usar neste website. Voc\xea est\xe1 no comando! Habilite ou desabilite os servi\xe7os como julgar conveniente.",
                        privacyPolicy: {
                            name: "pol\xedtica de privacidade",
                            text: "Para saber mais, por favor, leia nossa {privacyPolicy}."
                        },
                        title: "Servi\xe7os que gostar\xedamos de utilizar"
                    },
                    consentNotice: {
                        changeDescription: "Houve mudan\xe7as desde sua \xfaltima visita, queira renovar seu consentimento.",
                        description: "Ol\xe1! Poder\xedamos, por favor, habilitar alguns servi\xe7os adicionais para {purposes}? Voc\xea pode sempre mudar ou retirar seu consentimento mais tarde.",
                        imprint: {
                            name: "imprimir"
                        },
                        learnMore: "Deixe-me escolher",
                        privacyPolicy: {
                            name: "pol\xedtica de privacidade"
                        },
                        testing: "Modo de teste!"
                    },
                    contextualConsent: {
                        acceptAlways: "Sempre",
                        acceptOnce: "Sim",
                        description: "Voc\xea deseja carregar conte\xfado externo fornecido por {title}?"
                    },
                    decline: "Recusar",
                    ok: "Aceito.",
                    poweredBy: "Realizado com Klaro!",
                    privacyPolicy: {
                        name: "pol\xedtica de privacidade",
                        text: "Para saber mais, por favor, leia nossa {privacyPolicy}."
                    },
                    purposeItem: {
                        service: "servi\xe7o",
                        services: "servi\xe7os"
                    },
                    purposes: {
                        advertising: {
                            description: "Esses servi\xe7os processam informa\xe7\xf5es pessoais para mostrar a voc\xea an\xfancios personalizados ou baseados em interesses.",
                            title: "Publicidade"
                        },
                        functional: {
                            description: "Esses servi\xe7os s\xe3o essenciais para o correto funcionamento deste website. Voc\xea n\xe3o pode desativ\xe1-los aqui, pois de outra forma o servi\xe7o n\xe3o funcionaria corretamente.\n",
                            title: "Presta\xe7\xe3o de servi\xe7os"
                        },
                        marketing: {
                            description: "Esses servi\xe7os processam informa\xe7\xf5es pessoais para mostrar a voc\xea conte\xfado relevante sobre produtos, servi\xe7os ou t\xf3picos que possam ser do seu interesse.",
                            title: "Marketing"
                        },
                        performance: {
                            description: "Esses servi\xe7os processam informa\xe7\xf5es pessoais para otimizar o servi\xe7o que este website oferece.\n",
                            title: "Otimiza\xe7\xe3o do desempenho"
                        }
                    },
                    save: "Salvar",
                    service: {
                        disableAll: {
                            description: "Use essa chave para habilitar ou desabilitar todos os servi\xe7os.",
                            title: "Habilitar ou desabilitar todos os servi\xe7os"
                        },
                        optOut: {
                            description: "Estes servi\xe7os s\xe3o carregados por padr\xe3o (mas o voc\xea pode optar por n\xe3o participar).",
                            title: "(opt-out)"
                        },
                        purpose: "Objetivo",
                        purposes: "Objetivos",
                        required: {
                            description: "Esses servi\xe7os s\xe3o sempre necess\xe1rios",
                            title: "(sempre necess\xe1rio)"
                        }
                    }
                },
                es: {
                    acceptAll: "Aceptar todas",
                    acceptSelected: "Aceptar seleccionadas",
                    close: "Cerrar",
                    consentModal: {
                        description: "Aqu\xed puede evaluar y personalizar los servicios que nos gustar\xeda utilizar en este sitio web. \xa1Usted decide! Habilite o deshabilite los servicios como considere oportuno.",
                        privacyPolicy: {
                            name: "pol\xedtica de privacidad",
                            text: "Para saber m\xe1s, por favor lea nuestra {privacyPolicy}."
                        },
                        title: "Servicios que nos gustar\xeda utilizar"
                    },
                    consentNotice: {
                        changeDescription: "Ha habido cambios en las cookies desde su \xfaltima visita. Debe renovar su consentimiento.",
                        description: "\xa1Hola! \xbfPodr\xedamos habilitar algunos servicios adicionales para {purposes}? Siempre podr\xe1 cambiar o retirar su consentimiento m\xe1s tarde.",
                        imprint: {
                            name: "Imprimir"
                        },
                        learnMore: "Quiero elegir",
                        privacyPolicy: {
                            name: "pol\xedtica de privacidad"
                        },
                        testing: "\xa1Modo de prueba!"
                    },
                    contextualConsent: {
                        acceptAlways: "Siempre",
                        acceptOnce: "S\xed",
                        description: "\xbfQuieres cargar el contenido externo suministrado por {title}?"
                    },
                    decline: "Descartar todas",
                    ok: "De acuerdo",
                    poweredBy: "\xa1Realizado con Klaro!",
                    privacyPolicy: {
                        name: "pol\xedtica de privacidad",
                        text: "Para saber m\xe1s, por favor lea nuestra {privacyPolicy}."
                    },
                    purposeItem: {
                        service: "servicio",
                        services: "servicios"
                    },
                    purposes: {
                        advertising: {
                            description: "Estos servicios procesan informaci\xf3n personal para mostrarle anuncios personalizados o basados en intereses.",
                            title: "Publicidad"
                        },
                        functional: {
                            description: "Estos servicios son esenciales para el correcto funcionamiento de este sitio web. No puede desactivarlos ya que la p\xe1gina no funcionar\xeda correctamente.",
                            title: "Prestaci\xf3n de servicios"
                        },
                        marketing: {
                            description: "Estos servicios procesan informaci\xf3n personal para mostrarle contenido relevante sobre productos, servicios o temas que puedan interesarle.",
                            title: "Marketing"
                        },
                        performance: {
                            description: "Estos servicios procesan informaci\xf3n personal para optimizar el servicio que ofrece este sitio.",
                            title: "Optimizaci\xf3n del rendimiento"
                        }
                    },
                    save: "Guardar",
                    service: {
                        disableAll: {
                            description: "Utilice este interruptor para activar o desactivar todos los servicios.",
                            title: "Activar o desactivar todos los servicios"
                        },
                        optOut: {
                            description: "Este servicio est\xe1 habilitado por defecto (pero puede optar por lo contrario)",
                            title: "(desactivar)"
                        },
                        purpose: "Finalidad",
                        purposes: "Finalidades",
                        required: {
                            description: "Este servicio es necesario siempre",
                            title: "(siempre requerido)"
                        }
                    }
                },
                fi: {
                    acceptAll: "",
                    acceptAll_en: "Accept all",
                    acceptSelected: "",
                    acceptSelected_en: "Accept selected",
                    service: {
                        disableAll: {
                            description: "Aktivoi kaikki p\xe4\xe4lle/pois.",
                            title: "Valitse kaikki"
                        },
                        optOut: {
                            description: "Ladataan oletuksena (mutta voit ottaa sen pois p\xe4\xe4lt\xe4)",
                            title: "(ladataan oletuksena)"
                        },
                        purpose: "K\xe4ytt\xf6tarkoitus",
                        purposes: "K\xe4ytt\xf6tarkoitukset",
                        required: {
                            description: "Sivusto vaatii t\xe4m\xe4n aina",
                            title: "(vaaditaan)"
                        }
                    },
                    close: "Sulje",
                    consentModal: {
                        description: "Voit tarkastella ja muokata sinusta ker\xe4\xe4mi\xe4mme tietoja.",
                        privacyPolicy: {
                            name: "tietosuojasivultamme",
                            text: "Voit lukea lis\xe4tietoja {privacyPolicy}."
                        },
                        title: "Ker\xe4\xe4m\xe4mme tiedot"
                    },
                    consentNotice: {
                        changeDescription: "Olemme tehneet muutoksia ehtoihin viime vierailusi j\xe4lkeen, tarkista ehdot.",
                        description: "Ker\xe4\xe4mme ja k\xe4sittelemme henkil\xf6tietoja seuraaviin tarkoituksiin: {purposes}.",
                        imprint: {
                            name: "",
                            name_en: "imprint"
                        },
                        learnMore: "Lue lis\xe4\xe4",
                        privacyPolicy: {
                            name: "tietosuojasivultamme"
                        }
                    },
                    decline: "Hylk\xe4\xe4",
                    ok: "Hyv\xe4ksy",
                    poweredBy: "Palvelun tarjoaa Klaro!",
                    purposeItem: {
                        service: "",
                        services: ""
                    },
                    save: "Tallenna"
                },
                fr: {
                    acceptAll: "Accepter tout",
                    acceptSelected: "Accepter s\xe9lectionn\xe9",
                    close: "Fermer",
                    consentModal: {
                        description: "Vous pouvez ici \xe9valuer et personnaliser les services que nous aimerions utiliser sur ce site. C'est vous qui d\xe9cidez ! Activez ou d\xe9sactivez les services comme bon vous semble.",
                        privacyPolicy: {
                            name: "politique de confidentialit\xe9",
                            text: "Pour en savoir plus, veuillez lire notre {privacyPolicy}."
                        },
                        title: "Services que nous souhaitons utiliser"
                    },
                    consentNotice: {
                        changeDescription: "Il y a eu des changements depuis votre derni\xe8re visite, veuillez renouveler votre consentement.",
                        description: "Bonjour ! Pourrions-nous activer des services suppl\xe9mentaires pour {purposes}? Vous pouvez toujours modifier ou retirer votre consentement plus tard.",
                        imprint: {
                            name: "mentions l\xe9gales"
                        },
                        learnMore: "Laissez-moi choisir",
                        privacyPolicy: {
                            name: "politique de confidentialit\xe9"
                        },
                        testing: "Mode test !"
                    },
                    contextualConsent: {
                        acceptAlways: "Toujours",
                        acceptOnce: "Oui",
                        description: "Vous souhaitez charger un contenu externe fourni par {title}?"
                    },
                    decline: "Je refuse",
                    ok: "C'est bon.",
                    poweredBy: "R\xe9alis\xe9 avec Klaro !",
                    privacyPolicy: {
                        name: "politique de confidentialit\xe9",
                        text: "Pour en savoir plus, veuillez lire notre {privacyPolicy}."
                    },
                    purposeItem: {
                        service: "service",
                        services: "services"
                    },
                    purposes: {
                        advertising: {
                            description: "Ces services traitent les informations personnelles pour vous pr\xe9senter des publicit\xe9s personnalis\xe9es ou bas\xe9es sur des int\xe9r\xeats.",
                            title: "Publicit\xe9"
                        },
                        functional: {
                            description: "Ces services sont essentiels au bon fonctionnement de ce site. Vous ne pouvez pas les d\xe9sactiver ici car le service ne fonctionnerait pas correctement autrement.\n",
                            title: "Prestation de services"
                        },
                        marketing: {
                            description: "Ces services traitent les informations personnelles afin de vous pr\xe9senter un contenu pertinent sur les produits, les services ou les sujets qui pourraient vous int\xe9resser.",
                            title: "Marketing"
                        },
                        performance: {
                            description: "Ces services traitent les informations personnelles afin d'optimiser le service que ce site Web offre.\n",
                            title: "Optimisation de la performance"
                        }
                    },
                    save: "Enregistrer",
                    service: {
                        disableAll: {
                            description: "Utilisez ce commutateur pour activer ou d\xe9sactiver tous les services.",
                            title: "Activer ou d\xe9sactiver tous les services"
                        },
                        optOut: {
                            description: "Ce service est charg\xe9 par d\xe9faut (mais vous pouvez le d\xe9sactiver)",
                            title: "(opt-out)"
                        },
                        purpose: "Objet",
                        purposes: "Fins",
                        required: {
                            description: "Ce service est toujours n\xe9cessaire",
                            title: "(toujours requis)"
                        }
                    }
                },
                gl: {
                    acceptAll: "Aceptar todas",
                    acceptSelected: "Aceptar seleccionadas",
                    close: "Pechar",
                    consentModal: {
                        description: "Aqu\xed pode avaliar e personalizar os servizos que nos gustar\xeda utilizar neste sitio web. \xa1Vostede decide! Habilite ou deshabilite os servicios como lle conve\xf1a.",
                        privacyPolicy: {
                            name: "pol\xedtica de privacidade",
                            text: "Para saber m\xe1is, por favor lea a nosa {privacyPolicy}."
                        },
                        title: "Servizos que nos gustar\xeda utilizar"
                    },
                    consentNotice: {
                        changeDescription: "Houbo cambios nas cookies dende a s\xfaa \xfaltima visita. Debe renovar o seu consentimento.",
                        description: "\xa1Ola! \xbfPoder\xedamos habilitar alg\xfans servizos adicionais para {purposes}? Sempre poder\xe1 cambiar ou retirar o s\xe9u consentimento m\xe1is tarde.",
                        imprint: {
                            name: "Imprimir"
                        },
                        learnMore: "Quero elixir",
                        privacyPolicy: {
                            name: "pol\xedtica de privacidade"
                        },
                        testing: "\xa1Modo de proba!"
                    },
                    decline: "Descartar todas",
                    ok: "De acordo",
                    poweredBy: "\xa1Realizado con Klaro!",
                    privacyPolicy: {
                        name: "pol\xedtica de privacidade",
                        text: "Para saber m\xe1is, por favor lea a nosa {privacyPolicy}."
                    },
                    purposeItem: {
                        service: "servizo",
                        services: "servizos"
                    },
                    purposes: {
                        advertising: {
                            description: "Estes servizos procesan informaci\xf3n persoal para mostrarlle anuncios personalizados ou basados en intereses.",
                            title: "Publicidade"
                        },
                        functional: {
                            description: "Estes servizos son esenciais para o correcto funcionamiento deste sitio web. Non pode desactivalos xa que a p\xe1xina non funcionar\xeda correctamente.",
                            title: "Prestaci\xf3n de servizos"
                        },
                        marketing: {
                            description: "Estes servizos procesan informaci\xf3n persoal para mostrarlle contido relevante sobre produtos, servizos ou temas que poidan interesarlle.",
                            title: "Marketing"
                        },
                        performance: {
                            description: "Estes servizos procesan informaci\xf3n persoal para optimizar o servizo que ofrece este sitio.",
                            title: "Optimizaci\xf3n do rendimento"
                        }
                    },
                    save: "Gardar",
                    service: {
                        disableAll: {
                            description: "Utilice este interruptor para activar ou desactivar todos os servizos.",
                            title: "Activar ou desactivar todos os servizos"
                        },
                        optOut: {
                            description: "Este servizo est\xe1 habilitado por defecto (pero pode optar polo contrario)",
                            title: "(desactivar)"
                        },
                        purpose: "Finalidade",
                        purposes: "Finalidades",
                        required: {
                            description: "Este servizo \xe9 necesario sempre",
                            title: "(sempre requirido)"
                        }
                    }
                },
                hu: {
                    acceptAll: "Mind elfogad",
                    acceptAll_en: "Accept all",
                    acceptSelected: "Kiv\xe1lasztottat elfogad",
                    acceptSelected_en: "Accept selected",
                    service: {
                        disableAll: {
                            description: "Haszn\xe1lja ezt a kapcsol\xf3t az \xf6sszes alkalmaz\xe1s enged\xe9lyez\xe9s\xe9hez/letilt\xe1s\xe1hoz.",
                            title: "\xd6sszes app \xe1tkapcsol\xe1sa"
                        },
                        optOut: {
                            description: "Ez az alkalmaz\xe1s alap\xe9rtelmez\xe9s szerint bet\xf6lt\xf6tt (de ki lehet kapcsolni)",
                            title: "(leiratkoz\xe1s)"
                        },
                        purpose: "C\xe9l",
                        purposes: "C\xe9lok",
                        required: {
                            description: "Ez az alkalmaz\xe1s mindig sz\xfcks\xe9ges",
                            title: "(mindig sz\xfcks\xe9ges)"
                        }
                    },
                    close: "Elvet",
                    consentModal: {
                        description: "Itt l\xe1thatja \xe9s testreszabhatja az \xf6nr\u0151l gy\u0171jt\xf6tt inform\xe1ci\xf3kat.",
                        privacyPolicy: {
                            name: "adatv\xe9delmi ir\xe1nyelveinket",
                            text: "Tov\xe1bbi inform\xe1ci\xf3\xe9rt k\xe9rj\xfck, olvassa el az {privacyPolicy}."
                        },
                        title: "Inform\xe1ci\xf3k, amiket gy\u0171jt\xfcnk"
                    },
                    consentNotice: {
                        changeDescription: "Az utols\xf3 l\xe1togat\xe1s \xf3ta v\xe1ltoz\xe1sok t\xf6rt\xe9ntek, k\xe9rj\xfck, friss\xedtse a hozz\xe1j\xe1rul\xe1s\xe1t.",
                        description: "Szem\xe9lyes adatait \xf6sszegy\u0171jtj\xfck \xe9s feldolgozzuk az al\xe1bbi c\xe9lokra: {purposes}.",
                        imprint: {
                            name: "impresszum",
                            name_en: "imprint"
                        },
                        learnMore: "Tudjon meg t\xf6bbet",
                        privacyPolicy: {
                            name: "adatv\xe9delmi ir\xe1nyelveinket"
                        }
                    },
                    contextualConsent: {
                        acceptAlways: "Mindig",
                        acceptOnce: "Igen",
                        description: "Be akarod t\xf6lteni a {title} \xe1ltal szolg\xe1ltatott k\xfcls\u0151 tartalmakat?"
                    },
                    decline: "Elutas\xedt",
                    ok: "Elfogad",
                    poweredBy: "Powered by Klaro!",
                    purposeItem: {
                        service: "",
                        services: ""
                    },
                    save: "Ment\xe9s"
                },
                hr: {
                    acceptAll: "",
                    acceptAll_en: "Prihvati sve",
                    acceptSelected: "",
                    acceptSelected_en: "Prihvati odabrane",
                    service: {
                        disableAll: {
                            description: "Koristite ovaj prekida\u010D da omogu\u0107ite/onemogu\u0107ite sve aplikacije odjednom.",
                            title: "Izmeijeni sve"
                        },
                        optOut: {
                            description: "Ova aplikacija je u\u010Ditana automatski (ali je mo\u017Eete onemogu\u0107iti)",
                            title: "(onemogu\u0107ite)"
                        },
                        purpose: "Svrha",
                        purposes: "Svrhe",
                        required: {
                            description: "Ova aplikacija je uvijek obavezna",
                            title: "(obavezna)"
                        }
                    },
                    close: "Zatvori",
                    consentModal: {
                        description: "Ovdje mo\u017Eete vidjeti i podesiti informacije koje prikupljamo o Vama.",
                        privacyPolicy: {
                            name: "pravila privatnosti",
                            text: "Za vi\u0161e informacije pro\u010Ditajte na\u0161a {privacyPolicy}."
                        },
                        title: "Informacije koje prikupljamo"
                    },
                    consentNotice: {
                        changeDescription: "Do\u0161lo je do promjena od Va\u0161e posljednjeg posje\u0107ivanja web stranice, molimo Vas da a\u017Eurirate svoja odobrenja.",
                        description: "Mi prikupljamo i procesiramo Va\u0161e osobne podatke radi slijede\u0107eg: {purposes}.",
                        imprint: {
                            name: "",
                            name_en: "imprint"
                        },
                        learnMore: "Saznajte vi\u0161e",
                        privacyPolicy: {
                            name: "pravila privatnosti"
                        }
                    },
                    decline: "Odbij",
                    ok: "U redu",
                    poweredBy: "Pokre\u0107e Klaro!",
                    purposeItem: {
                        service: "",
                        services: ""
                    },
                    save: "Spremi"
                },
                it: {
                    acceptAll: "Accettare tutti",
                    acceptSelected: "Accettare selezionato",
                    close: "Chiudi",
                    consentModal: {
                        description: "Qui pu\xf2 valutare e personalizzare i servizi che vorremmo utilizzare su questo sito web. \xc8 lei il responsabile! Abilitare o disabilitare i servizi come meglio crede.",
                        privacyPolicy: {
                            name: "informativa sulla privacy",
                            text: "Per saperne di pi\xf9, legga la nostra {privacyPolicy}."
                        },
                        title: "Servizi che desideriamo utilizzare"
                    },
                    consentNotice: {
                        changeDescription: "Ci sono stati dei cambiamenti rispetto alla sua ultima visita, la preghiamo di rinnovare il suo consenso.",
                        description: "Salve, possiamo attivare alcuni servizi aggiuntivi per {purposes}? Pu\xf2 sempre modificare o ritirare il suo consenso in un secondo momento.",
                        imprint: {
                            name: "impronta"
                        },
                        learnMore: "Lasciatemi scegliere",
                        privacyPolicy: {
                            name: "informativa sulla privacy"
                        },
                        testing: "Modalit\xe0 di test!"
                    },
                    contextualConsent: {
                        acceptAlways: "Sempre",
                        acceptOnce: "S\xec",
                        description: "Vuole caricare contenuti esterni forniti da {title}?"
                    },
                    decline: "Rifiuto",
                    ok: "Va bene cos\xec",
                    poweredBy: "Realizzato con Klaro!",
                    privacyPolicy: {
                        name: "informativa sulla privacy",
                        text: "Per saperne di pi\xf9, legga la nostra {privacyPolicy}."
                    },
                    purposeItem: {
                        service: "servizio",
                        services: "servizi"
                    },
                    purposes: {
                        advertising: {
                            description: "Questi servizi elaborano le informazioni personali per mostrarle annunci pubblicitari personalizzati o basati su interessi.",
                            title: "Pubblicit\xe0"
                        },
                        functional: {
                            description: "Questi servizi sono essenziali per il corretto funzionamento di questo sito web. Non pu\xf2 disattivarli qui perch\xe9 altrimenti il servizio non funzionerebbe correttamente.\n",
                            title: "Fornitura di servizi"
                        },
                        marketing: {
                            description: "Questi servizi elaborano le informazioni personali per mostrarle contenuti rilevanti su prodotti, servizi o argomenti che potrebbero interessarla.",
                            title: "Marketing"
                        },
                        performance: {
                            description: "Questi servizi elaborano le informazioni personali per ottimizzare il servizio offerto da questo sito web.\n",
                            title: "Ottimizzazione delle prestazioni"
                        }
                    },
                    save: "Salva",
                    service: {
                        disableAll: {
                            description: "Utilizzi questo interruttore per attivare o disattivare tutti i servizi.",
                            title: "Attivare o disattivare tutti i servizi"
                        },
                        optOut: {
                            description: "Questo servizio \xe8 caricato di default (ma \xe8 possibile scegliere di non usufruirne)",
                            title: "(opt-out)"
                        },
                        purpose: "Scopo dell",
                        purposes: "Finalit\xe0",
                        required: {
                            description: "Questo servizio \xe8 sempre richiesto",
                            title: "(sempre richiesto)"
                        }
                    }
                },
                nl: {
                    acceptAll: "Accepteer alle",
                    acceptSelected: "Geselecteerde",
                    close: "Sluit",
                    consentModal: {
                        description: "Hier kunt u de diensten die wij op deze website willen gebruiken beoordelen en aanpassen. U heeft de leiding! Schakel de diensten naar eigen inzicht in of uit.",
                        privacyPolicy: {
                            name: "privacybeleid",
                            text: "Voor meer informatie kunt u ons {privacyPolicy} lezen."
                        },
                        title: "Diensten die we graag willen gebruiken"
                    },
                    consentNotice: {
                        changeDescription: "Er waren veranderingen sinds uw laatste bezoek, gelieve uw toestemming te hernieuwen.",
                        description: "Hallo, kunnen wij u een aantal extra diensten aanbieden voor {purposes}? U kunt uw toestemming later altijd nog wijzigen of intrekken.",
                        imprint: {
                            name: "impressum"
                        },
                        learnMore: "Laat me kiezen",
                        privacyPolicy: {
                            name: "privacybeleid"
                        },
                        testing: "Testmodus!"
                    },
                    contextualConsent: {
                        acceptAlways: "Altijd",
                        acceptOnce: "Ja",
                        description: "Wilt u externe content laden die door {title} wordt aangeleverd ?"
                    },
                    decline: "Ik weiger",
                    ok: "Dat is ok\xe9",
                    poweredBy: "Gerealiseerd met Klaro!",
                    privacyPolicy: {
                        name: "privacybeleid",
                        text: "Voor meer informatie kunt u ons {privacyPolicy} lezen."
                    },
                    purposeItem: {
                        service: "service",
                        services: "diensten"
                    },
                    purposes: {
                        advertising: {
                            description: "Deze diensten verwerken persoonlijke informatie om u gepersonaliseerde of op interesse gebaseerde advertenties te tonen.",
                            title: "Reclame"
                        },
                        functional: {
                            description: "Deze diensten zijn essentieel voor het correct functioneren van deze website. U kunt ze hier niet uitschakelen omdat de dienst anders niet correct zou werken.\n",
                            title: "Dienstverlening"
                        },
                        marketing: {
                            description: "Deze diensten verwerken persoonlijke informatie om u relevante inhoud te tonen over producten, diensten of onderwerpen waarin u ge\xefnteresseerd zou kunnen zijn.",
                            title: "Marketing"
                        },
                        performance: {
                            description: "Deze diensten verwerken persoonlijke informatie om de service die deze website biedt te optimaliseren.\n",
                            title: "Optimalisatie van de prestaties"
                        }
                    },
                    save: "Opslaan",
                    service: {
                        disableAll: {
                            description: "Gebruik deze schakelaar om alle diensten in of uit te schakelen.",
                            title: "Alle diensten in- of uitschakelen"
                        },
                        optOut: {
                            description: "Deze diensten worden standaard geladen (maar u kunt zich afmelden)",
                            title: "(opt-out)"
                        },
                        purpose: "Verwerkingsdoel",
                        purposes: "Verwerkingsdoeleinden",
                        required: {
                            description: "Deze diensten zijn altijd nodig",
                            title: "(altijd nodig)"
                        }
                    }
                },
                no: {
                    acceptAll: "Godtar alle",
                    acceptSelected: "Godtar valgt",
                    service: {
                        disableAll: {
                            description: "Bruk denne for \xe5 skru av/p\xe5 alle apper.",
                            title: "Bytt alle apper"
                        },
                        optOut: {
                            description: "Denne appen er lastet som standard (men du kan skru det av)",
                            title: "(opt-out)"
                        },
                        purpose: "\xc5rsak",
                        purposes: "\xc5rsaker",
                        required: {
                            description: "Denne applikasjonen er alltid p\xe5krevd",
                            title: "(alltid p\xe5krevd)"
                        }
                    },
                    close: "",
                    close_en: "Close",
                    consentModal: {
                        description: "Her kan du se og velge hvilken informasjon vi samler inn om deg.",
                        privacyPolicy: {
                            name: "personvernerkl\xe6ring",
                            text: "For \xe5 l\xe6re mer, vennligst les v\xe5r {privacyPolicy}."
                        },
                        title: "Informasjon vi samler inn"
                    },
                    consentNotice: {
                        changeDescription: "Det har skjedd endringer siden ditt siste bes\xf8k, vennligst oppdater ditt samtykke.",
                        description: "Vi samler inn og prosesserer din personlige informasjon av f\xf8lgende \xe5rsaker: {purposes}.",
                        imprint: {
                            name: "",
                            name_en: "imprint"
                        },
                        learnMore: "L\xe6r mer",
                        privacyPolicy: {
                            name: "personvernerkl\xe6ring"
                        }
                    },
                    decline: "Avsl\xe5",
                    ok: "OK",
                    poweredBy: "Laget med Klaro!",
                    purposeItem: {
                        service: "",
                        services: ""
                    },
                    save: "Opslaan"
                },
                oc: {
                    acceptAll: "Tot acceptar",
                    acceptSelected: "Acceptar \xe7\xf2 seleccionat",
                    close: "Tampar",
                    consentModal: {
                        description: "Aqu\xed pod\xe8tz mesurar e personalizar los servicis que volriam utilizar sus aqueste site web. Av\xe8tz lo darri\xe8r mot ! Activatz o desactivatz segon v\xf2stra causida.",
                        title: "Servicis que volriam utilizar"
                    },
                    consentNotice: {
                        changeDescription: "I agu\xe8t de modificacions dempu\xe8i v\xf2stra darri\xe8ra visita, merc\xe9s de repassar v\xf2stre consentiment.",
                        description: "Adieu\u202F! Poiriam activar mai de servici per {purposes}\u202F? Pod\xe8tz totjorn modificar o tirar v\xf2stre consentiment mai tard.",
                        learnMore: "Me daissar causir",
                        testing: "M\xf2de t\xe8st !"
                    },
                    contextualConsent: {
                        acceptAlways: "Totjorn",
                        acceptOnce: "\xd2c",
                        description: "Vol\xe8tz cargar de contenguts ext\xe8rn provesits per {title}\u202F?"
                    },
                    decline: "Refusi",
                    ok: "Es bon",
                    poweredBy: "Realizat amb Klaro !",
                    privacyPolicy: {
                        name: "politica de confidencialitat",
                        text: "Per ne saber mai, vejatz n\xf2stra {privacyPolicy}."
                    },
                    purposeItem: {
                        service: "servici",
                        services: "servicis"
                    },
                    purposes: {
                        advertising: {
                            description: "Aquestes servicis tractan d\u2019informacions personalas per vos mostrar de reclamas personalizadas o basadas suls inter\xe8sses.",
                            title: "Reclama"
                        },
                        functional: {
                            description: "Aquestes servicis son essencials pel foncionament corr\xe8ct d\u2019aqueste site web. Los pod\xe8tz pas desactivar aqu\xed pr\u2019amor que lo servici foncionari\xe1 pas coma cal autrament.\n",
                            title: "Servici de provision"
                        },
                        marketing: {
                            description: "Aquestes servicis tractan d\u2019informacions personalas per vos mostrar de contenguts a prepaus de produits, de servicis o t\xe8mas que poiri\xe1n vos interessar.",
                            title: "Marketing"
                        },
                        performance: {
                            description: "Aquestes servicis tractan d\u2019informacions per optimizar lo servici qu\u2019aqueste site web prepausa.\n",
                            title: "Optimizacion de las performan\xe7as"
                        }
                    },
                    save: "Salvar",
                    service: {
                        disableAll: {
                            description: "Utilizatz aqueste alternator per activar o desactivar totes los servicis.",
                            title: "Activar o desactivar totes los servicis"
                        },
                        optOut: {
                            description: "Aqueste servici es cargar per defaut (mas lo pod\xe8tz desactivar)",
                            title: "(opt-out)"
                        },
                        purpose: "finalitat",
                        purposes: "finalitat",
                        required: {
                            description: "Aqueste servici es totjorn requesit",
                            title: "(totjorn requesit)"
                        }
                    }
                },
                ro: {
                    acceptAll: "",
                    acceptAll_en: "Accept all",
                    acceptSelected: "",
                    acceptSelected_en: "Accept selected",
                    service: {
                        disableAll: {
                            description: "Utiliza\u021Bi acest switch pentru a activa/dezactiva toate aplica\u021Biile.",
                            title: "Comuta\u021Bi \xeentre toate aplica\u021Biile"
                        },
                        optOut: {
                            description: "Aceast\u0103 aplica\u021Bie este \xeenc\u0103rcat\u0103 \xeen mod implicit (dar pute\u021Bi renun\u021Ba)",
                            title: "(opt-out)"
                        },
                        purpose: "Scop",
                        purposes: "Scopuri",
                        required: {
                            description: "Aceast\u0103 aplica\u021Bie este \xeentotdeauna necesar\u0103",
                            title: "(\xeentotdeauna necesar)"
                        }
                    },
                    close: "",
                    close_en: "Close",
                    consentModal: {
                        description: "Aici pute\u021Bi vedea \u0219i personaliza informa\u021Biile pe care le colect\u0103m despre dvs.",
                        privacyPolicy: {
                            name: "politica privacy",
                            text: "Pentru a afla mai multe, v\u0103 rug\u0103m s\u0103 citi\u021Bi {privacyPolicy}."
                        },
                        title: "Informa\u021Biile pe care le colect\u0103m"
                    },
                    consentNotice: {
                        changeDescription: "Au existat modific\u0103ri de la ultima vizit\u0103, v\u0103 rug\u0103m s\u0103 actualiza\u021Bi consim\u021B\u0103m\xe2ntul.",
                        description: "Colect\u0103m \u0219i proces\u0103m informa\u021Biile dvs. personale \xeen urm\u0103toarele scopuri: {purposes}.",
                        imprint: {
                            name: "",
                            name_en: "imprint"
                        },
                        learnMore: "Afl\u0103 mai multe",
                        privacyPolicy: {
                            name: "politica privacy"
                        }
                    },
                    decline: "Renun\u021B\u0103",
                    ok: "OK",
                    poweredBy: "Realizat de Klaro!",
                    purposeItem: {
                        service: "",
                        services: ""
                    },
                    save: "Salveaz\u0103"
                },
                sr: {
                    acceptAll: "",
                    acceptAll_en: "Accept all",
                    acceptSelected: "",
                    acceptSelected_en: "Accept selected",
                    service: {
                        disableAll: {
                            description: "Koristite ovaj prekida\u010D da omogu\u0107ite/onesposobite sve aplikacije odjednom.",
                            title: "Izmeni sve"
                        },
                        optOut: {
                            description: "Ova aplikacija je u\u010Ditana automatski (ali je mo\u017Eete onesposobiti)",
                            title: "(onesposobite)"
                        },
                        purpose: "Svrha",
                        purposes: "Svrhe",
                        required: {
                            description: "Ova aplikacija je uvek neophodna",
                            title: "(neophodna)"
                        }
                    },
                    close: "Zatvori",
                    consentModal: {
                        description: "Ovde mo\u017Eete videti i podesiti informacije koje prikupljamo o Vama.",
                        privacyPolicy: {
                            name: "politiku privatnosti",
                            text: "Za vi\u0161e informacije pro\u010Ditajte na\u0161u {privacyPolicy}."
                        },
                        title: "Informacije koje prikupljamo"
                    },
                    consentNotice: {
                        changeDescription: "Do\u0161lo je do promena od Va\u0161e poslednje posete, molimo Vas da a\u017Eurirate svoja odobrenja.",
                        description: "Mi prikupljamo i procesiramo Va\u0161e li\u010Dne podatke radi slede\u0107eg: {purposes}.",
                        imprint: {
                            name: "",
                            name_en: "imprint"
                        },
                        learnMore: "Saznajte vi\u0161e",
                        privacyPolicy: {
                            name: "politiku privatnosti"
                        }
                    },
                    decline: "Odbij",
                    ok: "U redu",
                    poweredBy: "Pokre\u0107e Klaro!",
                    purposeItem: {
                        service: "",
                        services: ""
                    },
                    save: "Sa\u010Duvaj"
                },
                sr_cyrl: {
                    consentModal: {
                        title: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043A\u043E\u0458\u0435 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u043C\u043E",
                        description: "\u041E\u0432\u0434\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u0434\u0435\u0442 \u0438 \u043F\u043E\u0434\u0435\u0441\u0438\u0442\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043A\u043E\u0458\u0435 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u043C\u043E \u043E \u0412\u0430\u043C\u0430.\n",
                        privacyPolicy: {
                            name: "\u043F\u043E\u043B\u0438\u0442\u0438\u043A\u0443 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438",
                            text: "\u0417\u0430 \u0432\u0438\u0448\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0458\u0442\u0435 \u043D\u0430\u0448\u0443 {privacyPolicy}.\n"
                        }
                    },
                    consentNotice: {
                        changeDescription: "\u0414\u043E\u0448\u043B\u043E \u0458\u0435 \u0434\u043E \u043F\u0440\u043E\u043C\u0435\u043D\u0430 \u043E\u0434 \u0412\u0430\u0448\u0435 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0458\u0435 \u043F\u043E\u0441\u0435\u0442\u0435, \u043C\u043E\u043B\u0438\u043C\u043E \u0412\u0430\u0441 \u0434\u0430 \u0430\u0436\u0443\u0440\u0438\u0440\u0430\u0442\u0435 \u0441\u0432\u043E\u0458\u0430 \u043E\u0434\u043E\u0431\u0440\u0435\u045A\u0430.",
                        description: "\u041C\u0438 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u043C\u043E \u0438 \u043F\u0440\u043E\u0446\u0435\u0441\u0438\u0440\u0430\u043C\u043E \u0412\u0430\u0448\u0435 \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0440\u0430\u0434\u0438 \u0441\u043B\u0435\u0434\u0435\u045B\u0435\u0433: {purposes}.\n",
                        learnMore: "\u0421\u0430\u0437\u043D\u0430\u0458\u0442\u0435 \u0432\u0438\u0448\u0435",
                        privacyPolicy: {
                            name: "\u043F\u043E\u043B\u0438\u0442\u0438\u043A\u0443 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438"
                        }
                    },
                    ok: "\u0423 \u0440\u0435\u0434\u0443",
                    save: "\u0421\u0430\u0447\u0443\u0432\u0430\u0458",
                    decline: "\u041E\u0434\u0431\u0438\u0458",
                    close: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438",
                    service: {
                        disableAll: {
                            title: "\u0418\u0437\u043C\u0435\u043D\u0438 \u0441\u0432\u0435",
                            description: "\u041A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0435 \u043E\u0432\u0430\u0458 \u043F\u0440\u0435\u043A\u0438\u0434\u0430\u0447 \u0434\u0430 \u043E\u043C\u043E\u0433\u0443\u045B\u0438\u0442\u0435/\u043E\u043D\u0435\u0441\u043F\u043E\u0441\u043E\u0431\u0438\u0442\u0435 \u0441\u0432\u0435 \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0435 \u043E\u0434\u0458\u0435\u0434\u043D\u043E\u043C."
                        },
                        optOut: {
                            title: "(\u043E\u043D\u0435\u0441\u043F\u043E\u0441\u043E\u0431\u0438\u0442\u0435)",
                            description: "\u041E\u0432\u0430 \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0430 \u0458\u0435 \u0443\u0447\u0438\u0442\u0430\u043D\u0430 \u0430\u0443\u0442\u043E\u043C\u0430\u0442\u0441\u043A\u0438 (\u0430\u043B\u0438 \u0458\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u043D\u0435\u0441\u043F\u043E\u0441\u043E\u0431\u0438\u0442\u0438)"
                        },
                        required: {
                            title: "(\u043D\u0435\u043E\u043F\u0445\u043E\u0434\u043D\u0430)",
                            description: "\u041E\u0432\u0430 \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0430 \u0458\u0435 \u0443\u0432\u0435\u043A \u043D\u0435\u043E\u043F\u0445\u043E\u0434\u043D\u0430."
                        },
                        purposes: "\u0421\u0432\u0440\u0445\u0435",
                        purpose: "\u0421\u0432\u0440\u0445\u0430"
                    },
                    poweredBy: "\u041F\u043E\u043A\u0440\u0435\u045B\u0435 \u041A\u043B\u0430\u0440\u043E!"
                },
                sv: {
                    acceptAll: "Acceptera alla",
                    acceptSelected: "Acceptera markerat",
                    service: {
                        disableAll: {
                            description: "Anv\xe4nd detta reglage f\xf6r att aktivera/avaktivera samtliga appar.",
                            title: "\xc4ndra f\xf6r alla appar"
                        },
                        optOut: {
                            description: "Den h\xe4r appen laddas som standardinst\xe4llning (men du kan avaktivera den)",
                            title: "(Avaktivera)"
                        },
                        purpose: "Syfte",
                        purposes: "Syften",
                        required: {
                            description: "Den h\xe4r applikationen kr\xe4vs alltid",
                            title: "(Kr\xe4vs alltid)"
                        }
                    },
                    close: "St\xe4ng",
                    consentModal: {
                        description: "H\xe4r kan du se och anpassa vilken information vi samlar om dig.",
                        privacyPolicy: {
                            name: "Integritetspolicy",
                            text: "F\xf6r att veta mer, l\xe4s v\xe5r {privacyPolicy}."
                        },
                        title: "Information som vi samlar"
                    },
                    consentNotice: {
                        changeDescription: "Det har skett f\xf6r\xe4ndringar sedan ditt senaste bes\xf6k, var god uppdatera ditt medgivande.",
                        description: "Vi samlar och bearbetar din personliga data i f\xf6ljande syften: {purposes}.",
                        imprint: {
                            name: "",
                            name_en: "imprint"
                        },
                        learnMore: "L\xe4s mer",
                        privacyPolicy: {
                            name: "Integritetspolicy"
                        }
                    },
                    decline: "Avb\xf6j",
                    ok: "OK",
                    poweredBy: "K\xf6rs p\xe5 Klaro!",
                    purposeItem: {
                        service: "",
                        services: ""
                    },
                    save: "Spara"
                },
                tr: {
                    acceptAll: "",
                    acceptAll_en: "Accept all",
                    acceptSelected: "",
                    acceptSelected_en: "Accept selected",
                    service: {
                        disableAll: {
                            description: "Toplu a\xe7ma/kapama i\xe7in bu d\xfc\u011Fmeyi kullanabilirsin.",
                            title: "T\xfcm uygulamalar\u0131 a\xe7/kapat"
                        },
                        optOut: {
                            description: "Bu uygulama varsay\u0131landa y\xfcklendi (ancak iptal edebilirsin)",
                            title: "(iste\u011Fe ba\u011Fl\u0131)"
                        },
                        purpose: "Ama\xe7",
                        purposes: "Ama\xe7lar",
                        required: {
                            description: "Bu uygulama her zaman gerekli",
                            title: "(her zaman gerekli)"
                        }
                    },
                    close: "Kapat",
                    consentModal: {
                        description: "Hakk\u0131n\u0131zda toplad\u0131\u011F\u0131m\u0131z bilgileri burada g\xf6rebilir ve \xf6zelle\u015Ftirebilirsiniz.",
                        privacyPolicy: {
                            name: "Gizlilik Politikas\u0131",
                            text: "Daha fazlas\u0131 i\xe7in l\xfctfen {privacyPolicy} sayfam\u0131z\u0131 okuyun."
                        },
                        title: "Saklad\u0131\u011F\u0131m\u0131z bilgiler"
                    },
                    consentNotice: {
                        changeDescription: "Son ziyaretinizden bu yana de\u011Fi\u015Fiklikler oldu, l\xfctfen se\xe7iminizi g\xfcncelleyin.",
                        description: "Ki\u015Fisel bilgilerinizi a\u015Fa\u011F\u0131daki ama\xe7larla sakl\u0131yor ve i\u015Fliyoruz: {purposes}.",
                        imprint: {
                            name: "",
                            name_en: "imprint"
                        },
                        learnMore: "Daha fazla bilgi",
                        privacyPolicy: {
                            name: "Gizlilik Politikas\u0131"
                        }
                    },
                    decline: "Reddet",
                    ok: "Tamam",
                    poweredBy: "Klaro taraf\u0131ndan geli\u015Ftirildi!",
                    purposeItem: {
                        service: "",
                        services: ""
                    },
                    save: "Kaydet"
                },
                pl: {
                    acceptAll: "Zaakceptuj wszystkie",
                    acceptSelected: "Zaakceptuj wybrane",
                    close: "Zamknij",
                    consentModal: {
                        description: "Tutaj mog\u0105 Pa\u0144stwo oceni\u0107 i dostosowa\u0107 us\u0142ugi, kt\xf3re chcieliby\u015Bmy wykorzysta\u0107 na tej stronie. W\u0142\u0105czaj lub wy\u0142\u0105czaj us\u0142ugi wed\u0142ug w\u0142asnego uznania.",
                        privacyPolicy: {
                            name: "polityk\u0105 prywatno\u015Bci",
                            text: "Aby dowiedzie\u0107 si\u0119 wi\u0119cej, prosimy o zapoznanie si\u0119 z nasz\u0105 {privacyPolicy}."
                        },
                        title: "Us\u0142ugi, z kt\xf3rych chcieliby\u015Bmy skorzysta\u0107"
                    },
                    consentNotice: {
                        changeDescription: "Od Twojej ostatniej wizyty nast\u0105pi\u0142y zmiany, prosimy o odnowienie zgody.",
                        description: "Czy mo\u017Cemy w\u0142\u0105czy\u0107 dodatkowe us\u0142ugi dla {purposes}? W ka\u017Cdej chwili mog\u0105 Pa\u0144stwo p\xf3\u017Aniej zmieni\u0107 lub wycofa\u0107 swoj\u0105 zgod\u0119.",
                        imprint: {
                            name: "Imprint"
                        },
                        learnMore: "Pozw\xf3l mi wybra\u0107",
                        privacyPolicy: {
                            name: "polityka prywatno\u015Bci"
                        },
                        testing: "Tryb testowy!"
                    },
                    contextualConsent: {
                        acceptAlways: "Zawsze",
                        acceptOnce: "Tak",
                        description: "Czy chc\u0105 Pa\u0144stwo za\u0142adowa\u0107 tre\u015Bci zewn\u0119trzne dostarczane przez {title}?"
                    },
                    decline: "Odmawiam",
                    ok: "Ok",
                    poweredBy: "Technologia dostarczona przez Klaro",
                    privacyPolicy: {
                        name: "polityka prywatno\u015Bci",
                        text: "Aby dowiedzie\u0107 si\u0119 wi\u0119cej, prosimy o zapoznanie si\u0119 z nasz\u0105 {privacyPolicy}."
                    },
                    purposeItem: {
                        service: "us\u0142uga",
                        services: "us\u0142ugi"
                    },
                    purposes: {
                        advertising: {
                            description: "Us\u0142ugi te przetwarzaj\u0105 dane osobowe w celu pokazania Pa\u0144stwu spersonalizowanych lub opartych na zainteresowaniach reklam.",
                            title: "Reklama"
                        },
                        functional: {
                            description: "Us\u0142ugi te s\u0105 niezb\u0119dne do prawid\u0142owego funkcjonowania niniejszej strony internetowej. Nie mog\u0105 Pa\u0144stwo ich tutaj wy\u0142\u0105czy\u0107, poniewa\u017C w przeciwnym razie strona nie dzia\u0142a\u0142aby prawid\u0142owo.\n",
                            title: "\u015Awiadczenie us\u0142ug"
                        },
                        marketing: {
                            description: "Us\u0142ugi te przetwarzaj\u0105 dane osobowe w celu pokazania Pa\u0144stwu istotnych tre\u015Bci dotycz\u0105cych produkt\xf3w, us\u0142ug lub temat\xf3w, kt\xf3rymi mog\u0105 by\u0107 Pa\u0144stwo zainteresowani.",
                            title: "Marketing"
                        },
                        performance: {
                            description: "Us\u0142ugi te przetwarzaj\u0105 dane osobowe w celu optymalizacji us\u0142ug oferowanych przez t\u0119 stron\u0119.\n",
                            title: "Optymalizacja wydajno\u015Bci"
                        }
                    },
                    save: "Zapisz",
                    service: {
                        disableAll: {
                            description: "Za pomoc\u0105 tego prze\u0142\u0105cznika mo\u017Cna w\u0142\u0105cza\u0107 lub wy\u0142\u0105cza\u0107 wszystkie us\u0142ugi.",
                            title: "W\u0142\u0105cz lub wy\u0142\u0105cz wszystkie us\u0142ugi"
                        },
                        optOut: {
                            description: "Ta us\u0142uga jest domy\u015Blnie za\u0142adowana (ale mog\u0105 Pa\u0144stwo z niej zrezygnowa\u0107)",
                            title: "(opt-out)"
                        },
                        purpose: "Cel",
                        purposes: "Cele",
                        required: {
                            description: "Us\u0142ugi te s\u0105 zawsze wymagane",
                            title: "(zawsze wymagane)"
                        }
                    }
                },
                ru: {
                    acceptAll: "\u041F\u0440\u0438\u043D\u044F\u0442\u044C \u0432\u0441\u0451",
                    acceptSelected: "\u041F\u0440\u0438\u043D\u044F\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435",
                    service: {
                        disableAll: {
                            description: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u044D\u0442\u043E\u0442 \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0430\u0442\u0435\u043B\u044C, \u0447\u0442\u043E\u0431\u044B \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u044C/\u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432\u0441\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F.",
                            title: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432\u0441\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F"
                        },
                        optOut: {
                            description: "\u042D\u0442\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E (\u043D\u043E \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F)",
                            title: "(\u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F)"
                        },
                        purpose: "\u041D\u0430\u043C\u0435\u0440\u0435\u043D\u0438\u0435",
                        purposes: "\u041D\u0430\u043C\u0435\u0440\u0435\u043D\u0438\u044F",
                        required: {
                            description: "\u042D\u0442\u043E \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
                            title: "(\u0432\u0441\u0435\u0433\u0434\u0430 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439)"
                        }
                    },
                    close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
                    consentModal: {
                        description: "\u0417\u0434\u0435\u0441\u044C \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C, \u043A\u0430\u043A\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u0432\u0430\u0441 \u043C\u044B \u0445\u0440\u0430\u043D\u0438\u043C.",
                        privacyPolicy: {
                            name: "\u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435",
                            text: "\u0427\u0442\u043E\u0431\u044B \u0443\u0437\u043D\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u043D\u0430\u0448\u0435 {privacyPolicy}."
                        },
                        title: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u043C\u044B \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u043C"
                    },
                    consentNotice: {
                        changeDescription: "\u0421\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0432\u0438\u0437\u0438\u0442\u0430 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F, \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0432\u043E\u0451 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435.",
                        description: "\u041C\u044B \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u043C \u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u043C \u0432\u0430\u0448\u0443 \u043B\u0438\u0447\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0434\u043B\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0446\u0435\u043B\u0435\u0439: {purposes}.",
                        imprint: {
                            name: "",
                            name_en: "imprint"
                        },
                        learnMore: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C",
                        privacyPolicy: {
                            name: "\u043F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438"
                        }
                    },
                    decline: "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C",
                    ok: "\u041F\u0440\u0438\u043D\u044F\u0442\u044C",
                    poweredBy: "\u0420\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043D\u0430 \u041A\u043B\u0430\u0440\u043E!",
                    purposeItem: {
                        service: "",
                        services: ""
                    },
                    save: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"
                }
            });
            Br(Jr, hn), pn();
        })(), n;
    })());



let $6ecfe6364c17aa07$var$headerEl = document.querySelector(".header");
let $6ecfe6364c17aa07$var$header = new (0, $79d4162018af1528$export$2e2bcd8739ae039)();
$6ecfe6364c17aa07$var$header.init($6ecfe6364c17aa07$var$headerEl);
let $6ecfe6364c17aa07$var$peopleContainers = document.querySelectorAll(".people");
$6ecfe6364c17aa07$var$peopleContainers.forEach((peopleEl)=>{
    let peopleWrapper = new (0, $c7f806b99a3824e3$export$2e2bcd8739ae039)();
    peopleWrapper.init(peopleEl);
});
let $6ecfe6364c17aa07$var$logocardContainers = document.querySelectorAll(".logocard");
$6ecfe6364c17aa07$var$logocardContainers.forEach((logocardEl)=>{
    let logocardWrapper = new (0, $4a365ef086d0c37b$export$2e2bcd8739ae039)();
    logocardWrapper.init(logocardEl);
});
let $6ecfe6364c17aa07$var$accordionContainers = document.querySelectorAll(".accordion");
$6ecfe6364c17aa07$var$accordionContainers.forEach((accordionEl)=>{
    let accordionWrapper = new (0, $b2d227a9647fbef0$export$2e2bcd8739ae039)();
    accordionWrapper.init(accordionEl);
});
let $6ecfe6364c17aa07$var$galleries = document.querySelectorAll(".gallery");
$6ecfe6364c17aa07$var$galleries.forEach((galleryEl)=>{
    let gallery = new (0, $1222a91a1039d3df$export$2e2bcd8739ae039)();
    gallery.init(galleryEl);
});
let $6ecfe6364c17aa07$var$imageStickers = document.querySelectorAll(".image-sticker");
$6ecfe6364c17aa07$var$imageStickers.forEach((imageStickerEl)=>{
    let imageSticker = new (0, $d2e0903d4f69e257$export$2e2bcd8739ae039)();
    imageSticker.init(imageStickerEl);
});
let $6ecfe6364c17aa07$var$textexpands = document.querySelectorAll(".textexpand");
$6ecfe6364c17aa07$var$textexpands.forEach((textexpandEl)=>{
    let textexpand = new (0, $04e9dc7179e5294a$export$2e2bcd8739ae039)();
    textexpand.init(textexpandEl);
});
const $6ecfe6364c17aa07$var$contactRoots = document.querySelectorAll('.contact-details');
$6ecfe6364c17aa07$var$contactRoots.forEach((contactRoot)=>{
    const contactAnimations = new (0, $7c8d4f6c2d917c0b$export$2e2bcd8739ae039)();
    contactAnimations.init(contactRoot);
});
// import FounderVideo from '../components/foundervideo/foundervideo.js'
// import Features from '../components/features/features.js'
// import Mobilemenu from '../components/mobilemenu/mobilemenu.js'
// import Storytelling from '../components/storytelling/storytelling.js'
// import ScrollFadeIn from '../components/scrollfadein/scrollfadein.js'
// import WebGL from '../components/webgl/webgl.js'
// import barba from '@barba/core';
// import { gsap } from "gsap";
// let footerEl = document.querySelector(".footer");
// let footer = new Footer();
// // console.log(footer)
// footer.init(footerEl)
// let accordions = document.querySelectorAll(".accordion");
// accordions.forEach(accordionEl => {
//   let accordion = new Accordion();
//   accordion.init(accordionEl)
// })
let $6ecfe6364c17aa07$var$flipbookEl = document.querySelector(".flipbook");
if ($6ecfe6364c17aa07$var$flipbookEl) {
    let flipbook = new (0, $ba8905e5c0e6f6bd$export$2e2bcd8739ae039)();
    flipbook.init($6ecfe6364c17aa07$var$flipbookEl);
}
let $6ecfe6364c17aa07$var$flipdotdisplayEl = document.querySelector(".flipdotdisplay");
if ($6ecfe6364c17aa07$var$flipdotdisplayEl) {
    let flipdotdisplay = new (0, $ae13e61272ec84ae$export$2e2bcd8739ae039)();
    flipdotdisplay.init($6ecfe6364c17aa07$var$flipdotdisplayEl);
}
// let clocks = document.querySelectorAll(".clock");
// clocks.forEach(clockEl => {
//   let clock = new Clock();
//   clock.init(clockEl)
// })
let $6ecfe6364c17aa07$var$videos = document.querySelectorAll(".simple-video");
$6ecfe6364c17aa07$var$videos.forEach((videoEl)=>{
    let video = new (0, $1fd1f89bcda06d5b$export$2e2bcd8739ae039)();
    video.init(videoEl);
});
// let backbuttons = document.querySelectorAll(".backbutton");
// backbuttons.forEach(backbuttonEl => {
//   let backbutton = new BackButton();
//   backbutton.init(backbuttonEl)
// })
window.setTimeout(()=>{
    document.querySelectorAll('.video-autoplay-wrapper').forEach((videoWrapper)=>{
        const video = videoWrapper.querySelector('.video-autoplay');
        const btn = videoWrapper.querySelector('.toggle-animations');
        if (btn.classList.contains("is-paused")) {
            video.muted = true;
            video.play().catch((error)=>{
                console.error('Autoplay was prevented:', error);
            });
        }
    });
}, 4000);
document.querySelectorAll('.video-autoplay-wrapper').forEach((videoWrapper)=>{
    const video = videoWrapper.querySelector('.video-autoplay');
    const btn = videoWrapper.querySelector('.toggle-animations');
    btn.addEventListener('click', ()=>{
        if (video.paused) {
            video.play();
            btn.classList.remove('is-paused');
        } else {
            video.pause();
            btn.classList.add('is-paused');
        }
    });
});
if (document.querySelector(".work-has-filter")) {
    let workFilter = new (0, $68f1e2c9bce2a35c$export$2e2bcd8739ae039)();
    let workFilterEl = document.querySelector(".work-has-filter");
    workFilter.init(workFilterEl);
}
let $6ecfe6364c17aa07$var$Eventlists = document.querySelectorAll(".eventlist");
$6ecfe6364c17aa07$var$Eventlists.forEach((eventlistEl)=>{
    let eventlist = new (0, $5c8b08acfd85dadb$export$2e2bcd8739ae039)();
    eventlist.init(eventlistEl);
});
// or we can import Klaro with styles:
// import * as Klaro from "klaro";
// we define a minimal configuration
const $6ecfe6364c17aa07$var$config = {
    translations: {
        en: {
            gtm: {
                title: "Google Tag Manager / Google Analytics",
                description: 'Analytics cookies help us to understand how our visitors use our website. (Provider: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland, https://policies.google.com/privacy)'
            },
            consentNotice: {
                description: 'Analytics help us understand how our visitors use our website to improve your user experience. Find out more about the use of Google Analytics / Google Tag Manager in our <a href="./datenschutz" target="_blank" rel="noopener noreferrer">privacy policy</a>.',
                learnMore: 'Change settings'
            },
            purposes: {
                analytics: "Analytics"
            }
        },
        de: {
            gtm: {
                title: "Google Tag Manager / Google Analytics",
                description: 'Statistik Cookies helfen uns zu verstehen, wie unsere Besucher unsere Website nutzen. (Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland, https://policies.google.com/privacy)'
            },
            consentNotice: {
                description: 'Statistiken helfen uns zu verstehen, wie unsere Besucher unsere Website nutzen um dein Nutzererlebnis zu verbessern. Mehr \xfcber die Verwendung von Google Analytics / Google Tag Manager in unserer <a href="./datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzerkl\xe4rung</a>.',
                learnMore: 'Einstellungen anpassen'
            },
            purposes: {
                analytics: "Analytics"
            }
        }
    },
    htmlTexts: true,
    acceptAll: true,
    privacyPolicy: './datenschutz',
    services: [
        {
            name: 'gtm',
            title: 'Google Tag Manager & Google Analytics',
            purposes: [
                'analytics'
            ],
            cookies: [
                '_ga',
                '_gid',
                '_gat',
                'dc_gtm_*'
            ],
            required: false,
            optOut: false,
            // onlyOnce: true,
            onAccept: ()=>{
                const script = document.createElement('script');
                script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-KV9RPPW'; // <- GTM-ID
                script.async = true;
                document.head.appendChild(script);
            // console.log('Analytics loaded');
            }
        }
    ]
};
window.klaro = $7edcc86b8e795c8a$exports;
window.klaroConfig = $6ecfe6364c17aa07$var$config;
$7edcc86b8e795c8a$exports.setup($6ecfe6364c17aa07$var$config);

})();
//# sourceMappingURL=app.js.map
